/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
const SELECTORS = {
  QUIZ_SECTION: "quiz-section",
  QUESTION_PAGE: "question-step",
  CURRENT_PAGE: "current-step",
  TOTAL_PAGES: "total-steps",
  PROGRESS_FILL: "progress-fill",
  QUESTION_TITLE: ".question-title, .radio-question-title, .rating-question-title, .slider-question-title, .multi-input-question-title, .info-page-title, .loading-page-title",
  QUESTION_SUBTITLE: ".question-subtitle, .radio-question-subtitle, .rating-question-subtitle, .slider-question-subtitle, .multi-input-question-subtitle, .info-page-subtitle, .loading-page-subtitle",
  QUESTION_MESSAGE: ".question-message, .radio-question-message, .rating-question-message, .slider-question-message, .multi-input-question-text, .multi-input-question-message, .info-page-content, .loading-page-content",
  INPUT_LABEL: ".input-label, .number-input-label",
  PLACEHOLDER_INPUTS: "input[placeholder], textarea[placeholder]",
  ALL_INPUTS: "input, textarea, select",
  SLIDER_VALUE_DISPLAY: ".slider-value-display",
  STAR: ".star",
  STAR_RATING: ".star-rating",
  CHECKED_RADIO_INPUT: 'input[type="radio"]:checked',
  CHECKED_CHECKBOX_INPUT: 'input[type="checkbox"]:checked',
  SELECTED_BUTTON: "button.inline-button.selected",
  BUTTON_INPUT: "button.inline-button",
  CHECKBOX_INPUT: 'input[type="checkbox"]',
  RADIO_INPUT: 'input[type="radio"]',
  SLIDER_INPUT: 'input[type="range"]',
  TEXT_INPUTS_SELECTOR: 'input[type="text"], input[type="email"], input[type="number"], textarea, select',
  HIDDEN_INPUT: 'input[type="hidden"]',
  HEADING_3: "h3",
  HEADING_4: "h4",
  ALL_HEADINGS: "h1, h2, h3, h4, h5, h6",
  DATA_QUESTION_TEXT: "[data-question-text]",
  DATA_BLOCK_CUSTOM_ID: "[data-block-custom-id]",
  RATING_QUESTION_CONTAINER: ".rating-question",
  SLIDER_QUESTION_CONTAINER: ".slider-question",
  MULTI_INPUT_QUESTION_CONTAINER: ".multi-input-question",
  RADIO_QUESTION_CONTAINER: ".radio-question",
  RADIO_OPTION_OTHER_WRAPPER: ".radio-option-other-wrapper",
  OTHER_INPUT: ".other-input",
  OTHER_INPUT_SELECTOR: 'input[data-is-other="true"]',
  VALIDATION_ERROR: ".quiz-validation-error",
  QUIZ_OPTION_BTN: ".quiz-option-btn",
  FALLBACK_QUESTION_CONTAINER: '.question-step, .question-page, [class*="question"]'
};
const SELECTOR_FUNCTIONS = {
  DATA_BLOCK_ID: (blockId) => `[data-blockId="${blockId}"]`,
  DATA_BLOCK_ID_SELECTOR: (blockId) => `[data-block-id="${blockId}"]`
};
const SELECTOR_COMPOSITES = {
  RADIO_QUESTION_INPUTS: (radioQuestionSelector) => `${radioQuestionSelector} input[type="radio"]`,
  MULTI_INPUT_CHECKBOX: (multiInputSelector) => `${multiInputSelector} input[type="checkbox"]`,
  RADIO_INPUTS_EXCLUDING_OTHER: `${SELECTORS.RADIO_INPUT}:not([data-is-other="true"])`,
  RADIO_INPUTS_BY_NAME: (name) => `${SELECTORS.RADIO_INPUT}[name="${name}"]`,
  RADIO_INPUTS_IN_QUIZ_SECTION: `[id^="quiz-section-"] ${SELECTORS.RADIO_INPUT}`,
  CHECKBOXES_EXCLUDING_NONE: `${SELECTORS.CHECKBOX_INPUT}:not([data-is-none="true"])`,
  CHECKBOXES_BY_NAME_EXCLUDING_NONE: (name) => `${SELECTORS.CHECKBOX_INPUT}[name="${name}"]:not([data-is-none="true"])`
};
const ID_PREFIXES = {
  QUIZ_SECTION: "quiz-section",
  QUIZ_QUESTIONS: "quiz-questions",
  QUIZ_PROGRESS: "quiz-progress",
  PROGRESS_FILL: "progress-fill",
  PROGRESS_TEXT: "progress-text",
  PROGRESS_PERCENTAGE: "progress-percentage",
  BACK_BTN_TOP_STANDALONE: "back-btn-top-standalone",
  BACK_BTN_CENTER_STANDALONE: "back-btn-center-standalone",
  BACK_BTN_BOTTOM_STANDALONE: "back-btn-bottom-standalone",
  BACK_BTN_PROGRESS_ABOVE: "back-btn-progress-above",
  BACK_BTN_PROGRESS_BELOW: "back-btn-progress-below",
  CONTINUE_BTN_TOP_STANDALONE: "continue-btn-top-standalone",
  CONTINUE_BTN_CENTER_STANDALONE: "continue-btn-center-standalone",
  CONTINUE_BTN_BOTTOM_STANDALONE: "continue-btn-bottom-standalone",
  OTHER_INPUT_WRAPPER: "other-input-wrapper-",
  OTHER_INPUT: "other-input-",
  OTHER_OPTION_WRAPPER: "other-option-wrapper-"
};
const CLASS_NAMES = {
  LOADING_PAGE_STEP: "loading-page-step",
  INFO_PAGE_STEP: "info-page-step",
  CONTINUE_BTN_DEACTIVE: "continue-btn-deactive",
  SELECTED: "selected"
};
const DATA_ATTRIBUTES = {
  STEP: "step",
  TIMER: "timer",
  ENABLE_TIMER: "enableTimer",
  HIDE_BUTTON_DURING_TIMER: "hideButtonDuringTimer",
  QUESTION_ID: "blockId",
  BLOCK_CUSTOM_ID: "blockCustomId",
  NEXT_QUESTION: "nextQuestion",
  NEXT_URL: "nextUrl",
  SUBMIT_TEXT: "data-submit-text",
  NEXT_TEXT: "data-next-text",
  SHOW_PROGRESS: "showProgress",
  REQUIRED: "required",
  QUIZ_ID: "quiz-id",
  VALUE: "value",
  IS_OTHER: "data-is-other",
  IS_NONE: "data-is-none",
  RATING: "rating",
  VALIDATION_ERROR_TEXT: "validationErrorText",
  ENABLE_SUBSCRIPTION_ACTIONS: "data-enable-subscription-actions"
};
const ERROR_MESSAGES$2 = {
  CURRENT_PAGE_ELEMENT_NOT_FOUND: "Current page element not found for quizId:",
  CANNOT_INITIALIZE_PAGE_DISPLAY: "Cannot initialize page display for quizId:",
  INVALID_TARGET_PAGE: "Invalid target page",
  MUST_BE_BETWEEN: "Must be between",
  CANNOT_UPDATE_PROGRESS: "Cannot update progress for quizId:",
  REQUIRED_FIELD_NOT_ANSWERED: "Please answer all required questions before continuing.",
  CANNOT_GO_BACK_FIRST_PAGE: "Cannot go back from first page with no history for quizId:",
  PROGRESS_FILL_ELEMENT_NULL: "Progress fill element is null",
  NO_QUIZ_DATA_FOUND: "No quiz data found for quizId:"
};
const DATA_KEYS = {
  ORIGINAL_TEXT: "originalText",
  ORIGINAL_HTML: "originalHtml",
  ORIGINAL_PLACEHOLDER: "originalPlaceholder"
};
const INPUT_TYPES = {
  CHECKBOX: "checkbox",
  RADIO: "radio"
};
const HTML_PROPERTIES = {
  TEXT_CONTENT: "textContent",
  INNER_HTML: "innerHTML",
  PLACEHOLDER: "placeholder"
};
const DEFAULT_VALUES = {
  SUBMIT_TEXT: "Submit Quiz",
  NEXT_TEXT: "Next →",
  DEFAULT_TIMER_DURATION_SECONDS: "5",
  LOADING_DELAY_MILLISECONDS: 100,
  AUTO_ADVANCE_DELAY_MS: 300,
  MILLISECONDS_PER_SECOND: 1e3
};
const CSS_VALUES = {
  SLIDER_ACTIVE_BORDER_COLOR: "#007bff",
  SLIDER_ACTIVE_BACKGROUND_COLOR: "#f0f7ff",
  SLIDER_DEFAULT_BORDER_COLOR: "#e9ecef",
  SLIDER_DEFAULT_BACKGROUND_COLOR: "#f8f9fa",
  OPACITY_DISABLED: "0.5",
  OPACITY_ENABLED: "1"
};
const SCROLL_BEHAVIOR = {
  SMOOTH: "smooth"
};
const SCROLL_BLOCK = {
  CENTER: "center"
};
const CSS_SELECTOR_PREFIX = {
  CLASS: "."
};
const TEMPLATE_SEPARATORS = {
  SPACE: " ",
  ID_SEPARATOR: "-"
};
const EVENT_NAMES$2 = {
  SLIDER_CHANGED: "slider_changed",
  RATING_SELECTED: "rating_selected"
};
const LOADING_PAGE_TYPE = "loading";
const QUESTION_PAGE_TYPE = "question";
const INFO_PAGE_TYPE = "info";
const NUMERIC_CONSTANTS = {
  SLIDER_VISUAL_FEEDBACK_DELAY_MS: 200,
  MIN_PERCENTAGE: 0,
  MAX_PERCENTAGE: 100,
  DEFAULT_PAGE_INDEX_OFFSET: 1,
  INITIAL_PAGE: 1,
  MIN_PAGE: 1,
  PAGE_INCREMENT: 1,
  PAGE_DECREMENT: 1,
  DEFAULT_MAX_SELECTIONS: 0,
  DEFAULT_FALLBACK_RATING_INDEX: 3,
  DEFAULT_STEP_NUMBER: 0
};
const STRING_VALUES = {
  SLIDER: "slider",
  RATING: "rating",
  RATING_INPUT_ID_PREFIX: "rating-",
  USER_SELECTED: "user_selected",
  VALUE_PERCENT_CSS_VAR: "--value-percent",
  QUIZ_SECTION_PREFIX: "quiz-section-",
  OTHER_SUFFIX: "_other",
  PERCENTAGE_SYMBOL: "%"
};
const DISPLAY_VALUES = {
  BLOCK: "block",
  NONE: "none"
};
const ATTRIBUTE_VALUES = {
  TRUE: "true",
  FALSE: "false"
};
const BOOLEAN_VALUES = {
  TRUE: "true"
};
const CSS_PROPERTIES = {
  DISPLAY: "display",
  IMPORTANT: "important"
};
const HTML_ATTRIBUTES = {
  NAME: "name",
  ID: "id",
  TYPE: "type",
  DISABLED: "disabled",
  DATA_SELECTED: "data-selected",
  PLACEHOLDER_CHOOSE: "Choose...",
  ARIA_DISABLED: "aria-disabled",
  PLACEHOLDER_TYPE_TO_SEARCH: "Type to search...",
  ROWS: "2"
};
const HTML_ENTITIES = {
  AMPERSAND: "&amp;",
  QUOTE: "&quot;",
  APOSTROPHE: "&#39;",
  LESS_THAN: "&lt;",
  GREATER_THAN: "&gt;"
};
const HTML_ATTR_STRINGS = {
  SELECTED: " selected",
  EMPTY_VALUE: ' value=""'
};
const RATING_TEXT_VALUES = ["", "Poor", "Fair", "Good", "Very Good", "Excellent"];
const RATING_CLASS_NAMES = {
  ACTIVE: "active",
  HOVER: "hover"
};
const getTimerKeyPrefix = (quizId) => `${quizId}-`;
const buildRatingInputId = (questionId) => `${STRING_VALUES.RATING_INPUT_ID_PREFIX}${questionId}`;
const buildRatingSelectedTextId = (questionId) => `selected-text-${questionId}`;
const buildSliderId = (questionId) => `slider-${questionId}`;
const buildSliderCurrentValueId = (questionId) => `current-value-${questionId}`;
const buildStarRatingSelector = (questionId) => `[data-${DATA_ATTRIBUTES.QUESTION_ID}="${questionId}"] ${SELECTORS.STAR_RATING}`;
const buildRatingDisplayText = (rating, ratingText) => {
  const starText = rating > 1 ? " stars" : " star";
  return `You rated: ${rating}${starText} (${ratingText})`;
};
const BACK_BUTTON_ID_PREFIXES = [
  ID_PREFIXES.BACK_BTN_TOP_STANDALONE,
  ID_PREFIXES.BACK_BTN_CENTER_STANDALONE,
  ID_PREFIXES.BACK_BTN_BOTTOM_STANDALONE,
  ID_PREFIXES.BACK_BTN_PROGRESS_ABOVE,
  ID_PREFIXES.BACK_BTN_PROGRESS_BELOW
];
const CONTINUE_BUTTON_ID_PREFIXES = [
  ID_PREFIXES.CONTINUE_BTN_TOP_STANDALONE,
  ID_PREFIXES.CONTINUE_BTN_CENTER_STANDALONE,
  ID_PREFIXES.CONTINUE_BTN_BOTTOM_STANDALONE
];
const DOM_EVENT_NAMES = {
  FOCUS: "focus",
  BLUR: "blur",
  INPUT: "input",
  CHANGE: "change",
  MOUSEENTER: "mouseenter",
  MOUSELEAVE: "mouseleave",
  KEYDOWN: "keydown",
  DOM_CONTENT_LOADED: "DOMContentLoaded"
};
const EVENT_TRIGGERS = {
  USER_TYPED: "user_typed"
};
const ELEMENT_SELECTORS = {
  RADIO_QUESTION: '[data-question-type="radio"]',
  CHECKBOX_QUESTION: '[data-question-type="checkbox"]',
  CONTINUE_BTN: '[data-button-type="continue"]',
  SLIDER_INPUT_RANGE: 'input[type="range"]',
  MULTI_INPUT_QUESTION: '[data-question-type="multi-input"]',
  MAX_COUNT: "[data-max-count]",
  SELECTION_COUNT: "[data-selection-count]",
  COUNT_TEXT: "[data-count-text]",
  LABEL: "label"
};
const MULTI_INPUT_PLACEHOLDER_PREFIX = "[input:";
const MULTI_INPUT_CONSTANTS = {
  INPUT_PLACEHOLDER_PREFIX: MULTI_INPUT_PLACEHOLDER_PREFIX,
  INPUT_PLACEHOLDER_PREFIX_LENGTH: MULTI_INPUT_PLACEHOLDER_PREFIX.length,
  INPUT_PLACEHOLDER_SUFFIX: "]",
  SEGMENT_SEPARATOR: ":",
  OPTION_SEPARATOR: "|",
  DEFAULT_STORAGE_SCOPE_ENTITY: "entity",
  TEMPLATE_PLACEHOLDER_ID: "{id}",
  TEMPLATE_PLACEHOLDER_NAME: "{name}",
  TEMPLATE_PLACEHOLDER_VALUE: "{value}",
  TEMPLATE_PLACEHOLDER_TEXT: "{text}",
  TEMPLATE_PLACEHOLDER_REGEX_PATTERN: "\\{",
  TEMPLATE_PLACEHOLDER_REGEX_SUFFIX: "\\}",
  SET_TIMEOUT_IMMEDIATE_DELAY: 0,
  MESSAGE_ELEMENT_INDEX: 1,
  LAST_ELEMENT_OFFSET: 1,
  MULTI_SELECT_VALUE: "multi select",
  MULTI_SELECT_SEPARATOR: ",",
  DATASET_TRUE_VALUE: "true",
  BUTTON_TYPE_ATTRIBUTE: 'type="button"'
};
const INPUT_TYPE_VALUES = {
  TEXT: "text",
  EMAIL: "email",
  TEL: "tel",
  URL: "url",
  SEARCH: "search",
  PASSWORD: "password",
  NUMBER: "number",
  RANGE: "range",
  RADIO: "radio",
  BUTTON: "button",
  CHECKBOX: "checkbox",
  TEXTAREA: "textarea",
  SELECT: "select",
  AUTOCOMPLETE: "autocomplete",
  RATING: "rating"
};
const QUESTION_TYPE_VALUES = {
  CHECKBOX: "checkbox",
  TEXT: "text",
  MULTI_INPUT: "multi-input"
};
const IMMEDIATE_SAVE_QUESTION_TYPES = [
  INPUT_TYPE_VALUES.RADIO,
  INPUT_TYPE_VALUES.CHECKBOX,
  INPUT_TYPE_VALUES.RANGE,
  INPUT_TYPE_VALUES.SELECT,
  INPUT_TYPE_VALUES.RATING,
  QUESTION_TYPE_VALUES.MULTI_INPUT
];
const INPUT_TYPE_ARRAYS = {
  TEXT_INPUT_TYPES: [
    "text",
    INPUT_TYPE_VALUES.EMAIL,
    INPUT_TYPE_VALUES.NUMBER,
    INPUT_TYPE_VALUES.TEXTAREA
  ],
  INPUT_EVENT_TYPES: [
    INPUT_TYPE_VALUES.TEXT,
    INPUT_TYPE_VALUES.EMAIL,
    INPUT_TYPE_VALUES.TEL,
    INPUT_TYPE_VALUES.URL,
    INPUT_TYPE_VALUES.SEARCH,
    INPUT_TYPE_VALUES.PASSWORD
  ]
};
const SELECTOR_STRINGS = {
  ALL_TRACKABLE_INPUTS: `input[type="text"], input[type="${INPUT_TYPE_VALUES.EMAIL}"], input[type="${INPUT_TYPE_VALUES.NUMBER}"], input[type="${INPUT_TYPE_VALUES.TEL}"], input[type="${INPUT_TYPE_VALUES.URL}"], input[type="${INPUT_TYPE_VALUES.SEARCH}"], input[type="${INPUT_TYPE_VALUES.PASSWORD}"], ${INPUT_TYPE_VALUES.TEXTAREA}, ${INPUT_TYPE_VALUES.SELECT}`,
  QUIZ_SECTION_BY_PREFIX: `[id^="${STRING_VALUES.QUIZ_SECTION_PREFIX}"]`,
  RATING_HIDDEN_INPUTS: `${SELECTORS.RATING_QUESTION_CONTAINER} ${SELECTORS.HIDDEN_INPUT}[id^="${STRING_VALUES.RATING_INPUT_ID_PREFIX}"]`,
  RATING_CHECKED_RADIO: `${SELECTORS.RATING_QUESTION_CONTAINER} ${SELECTORS.CHECKED_RADIO_INPUT}`
};
const SELECTOR_TEMPLATES = {
  QUIZ_SECTION_BY_ID: (quizId) => `#${SELECTORS.QUIZ_SECTION}-${quizId}`,
  CURRENT_PAGE_BY_QUIZ: (quizId, pageNumber) => `#${SELECTORS.QUIZ_SECTION}-${quizId} .${SELECTORS.QUESTION_PAGE}[data-${DATA_ATTRIBUTES.STEP}="${pageNumber}"]`,
  QUIZ_SECTION_BY_DATA_QUIZ_ID: (quizId) => {
    const escapedQuizId = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(quizId) : quizId;
    return `[data-${DATA_ATTRIBUTES.QUIZ_ID}="${escapedQuizId}"]`;
  },
  DATA_VALUE: (value) => {
    const escapedValue = typeof CSS !== "undefined" && CSS.escape ? CSS.escape(value) : value;
    return `[data-${DATA_ATTRIBUTES.VALUE}="${escapedValue}"]`;
  }
};
const DROPDOWN_SELECTION_TYPE = "dropdown";
const KEYBOARD_KEYS = {
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  HOME: "Home",
  END: "End"
};
const HTML_TAGS = {
  INPUT: "input",
  TEXTAREA: "TEXTAREA",
  SELECT: "SELECT"
};
const DATA_ATTR_NAMES = {
  SELECTED: "data-selected",
  INITIALIZED: "initialized",
  QUESTION_TEXT: "questionText",
  ORIGINAL_TEXT: "data-original-text"
};
const DATASET_PROPERTIES = {
  QUIZ_ID: "quizId",
  QUIZ_CONFIG: "quizConfig",
  QUIZ_IDENTIFIER: "quizIdentifier",
  BLOCK_ID: "blockId",
  STORAGE_SCOPE: "storageScope",
  URL_PARAM_TO_ADD_TO_EVENTS: "urlParamToAddToEvents",
  RESET_QUIZ_ON_INIT: "resetQuizOnInit",
  SUBMIT_URL: "submitUrl"
};
const OBJECT_PROPERTIES = {
  DATASET: "dataset",
  LATEST: "latest"
};
const SHOPIFY_EVENTS = {
  QUESTION_SELECT: "shopify:block:select"
};
const SHOPIFY_POST_MESSAGES = {
  SCROLL_TO_TOP: "scrollToTop"
};
const WINDOW_ORIGINS = {
  WILDCARD: "*"
};
const DYNAMIC_CLASS_NAMES = {
  INLINE_INPUT: "inline-input",
  INLINE_BUTTON_GROUP: "inline-button-group",
  INLINE_BUTTON: "inline-button",
  INLINE_BUTTON_SELECTED: "selected"
};
const TEXT_TEMPLATES = {
  SELECTED_COUNT: (count) => `${count} selected`,
  DATALIST_PREFIX: "datalist-",
  INLINE_INPUT_PREFIX: "inline-input-",
  INLINE_INPUT_NAME_PREFIX: "inline_input_",
  ARRAY_JOIN_SEPARATOR: ", ",
  UNDERSCORE_REPLACEMENT: "_"
};
const PLACEHOLDER_SOURCES = {
  LOCAL: "local",
  URL: "url",
  CONFIG: "config"
};
const DEFAULT_SIZE_VALUES = {
  MEDIUM: "medium"
};
const REGEX_PATTERNS = {
  DIGIT_EXTRACTION: /\d+/,
  NEWLINE: /\n/g,
  PLACEHOLDER_REPLACEMENT: new RegExp("(?<!\\{)\\{([^}|]+)(?:\\s*\\|\\s*(\\w+)\\s*)?\\}(?!\\})", "g"),
  SPACE_TO_UNDERSCORE: /\s+/g,
  RADIO_QUESTION_NAME: /^(.+?)_radio_question_/
};
const HTML_REPLACEMENTS = {
  NEWLINE_TO_BR: "<br>"
};
const HTML_TEMPLATES = {
  BUTTON_GROUP_END: "</div>",
  BUTTON_INPUT: '<button type="button" id="{id}" name="{name}" value="{value}" class="inline-button">{text}</button>',
  INPUT_TEXT: '<input type="{type}" id="{id}" name="{name}" class="inline-input {size}" placeholder="{placeholder}" value="{value}">',
  INPUT_EMAIL: '<input type="{type}" id="{id}" name="{name}" class="inline-input {size}" placeholder="{placeholder}" value="{value}">',
  INPUT_NUMBER: '<input type="{type}" id="{id}" name="{name}" class="inline-input {size}" placeholder="{placeholder}" min="{min}" max="{max}" value="{value}">',
  TEXTAREA: '<textarea id="{id}" name="{name}" class="inline-input {size}" placeholder="{placeholder}" rows="3">{value}</textarea>'
};
const NODE_TYPES = {
  ELEMENT_NODE: 1
};
const MUTATION_OBSERVER_TYPES = {
  CHILD_LIST: "childList",
  SUBTREE: "subtree"
};
const DOCUMENT_READY_STATES = {
  LOADING: "loading"
};
const STORAGE_KEYS = {
  QUIZ_ANSWERS: "quiz_answers",
  url_params: "URL_Params",
  CONFIG: "config",
  PROCESSED_ACTIONS: "ZYG_Processed_Actions"
};
const ACTION_TYPES = {
  DISCOUNT: "discount",
  CANCELLATION: "cancellation",
  FREE_GIFT: "free_gift",
  SKIP_CHARGE: "skip_charge",
  CHANGE_CHARGE_DATE: "change_charge_date",
  CHANGE_PRODUCT: "change_product"
};
const API_PATHS = {
  SUBSCRIPTION_DISCOUNT: (subscriptionId) => `subscriptions/${subscriptionId}/discount`,
  SUBSCRIPTION_CANCEL: (subscriptionId) => `subscriptions/${subscriptionId}/support-tickets`,
  SUBSCRIPTION_DATA: (subscriptionId) => `subscriptions/${subscriptionId}`,
  SUBSCRIPTION_FREE_GIFT: (subscriptionId) => `subscriptions/${subscriptionId}/free-gift`,
  SUBSCRIPTION_SKIP_NEXT_CHARGE: (subscriptionId) => `subscriptions/${subscriptionId}/skip-next-charge`,
  SUBSCRIPTION_NEXT_CHARGE: (subscriptionId) => `subscriptions/${subscriptionId}/next-charge`,
  SUBSCRIPTION_PRODUCT: (subscriptionId) => `subscriptions/${subscriptionId}/product`
};
const URL_PARAM_NAMES = {
  SUBSCRIPTION_ID: "subscription_id",
  DISCOUNT_CODE: "discount_code",
  SHOPIFY_CUSTOMER_ID: "shopify_customer_id",
  CANCELLATION_REASON: "cancellation_reason",
  FREE_GIFT_VARIANT_ID: "free_gift_variant_id",
  FREE_GIFT_QUANTITY: "free_gift_quantity",
  SKIP_NEXT_CHARGE: "skip_next_charge",
  NEW_NEXT_CHARGE_DATE: "new_next_charge_date",
  NUM_OF_DAYS: "num_of_days",
  NEW_PRODUCT_VARIANT_ID: "new_product_variant_id"
};
const HTTP_METHODS = {
  POST: "POST"
};
const HTTP_HEADERS = {
  CONTENT_TYPE: "Content-Type"
};
const CONTENT_TYPES = {
  APPLICATION_JSON: "application/json"
};
const FETCH_OPTIONS = {
  KEEPALIVE: true
};
const SUBMIT_LOADING = {
  CSS_CLASS: "quiz-btn-submitting",
  DOTS_HTML: '<span class="quiz-loading-dots"><span>.</span><span>.</span><span>.</span></span>',
  NAVIGATION_CLEANUP_TIMEOUT_MS: 3e3
};
const DEFAULT_FALLBACK_VALUES = {
  UNKNOWN_PAGE_ID: "unknown"
};
const QUIZ_STORAGE = {
  STORAGE_KEY: "quiz_answers",
  SAVE_DEBOUNCE_MS: 300
};
const STORAGE_FIELD_NAMES = {
  ID: "ID",
  ENTITY_ID: "id",
  QUIZ_ID: "quiz_id",
  COMPLETED_AT: "completedAt"
};
const STORAGE_DEFAULTS = {
  DEFAULT_ENTITY_INDEX: 0,
  EMPTY_ENTITIES_ARRAY_LENGTH: 0,
  FIRST_ENTITY_INDEX: 0,
  MIN_GLOBAL_OBJECT_KEYS: 1,
  MIN_ENTITY_OBJECT_KEYS: 2
};
const STORAGE_TARGET_TYPES = {
  GLOBAL: "global",
  ENTITY: "entity"
};
const STORAGE_MAGIC_VALUES = {
  QUIZ_SECTION_PREFIX: "quiz-section-",
  DATA_QUESTION_TYPE_ATTRIBUTE: "data-question-type",
  DATA_QUESTION_TYPE_SELECTOR: "[data-question-type]",
  INPUT_SELECTOR: "input, select, textarea",
  CHECKBOX_SELECTOR_TEMPLATE: 'input[type="checkbox"][name="{name}"]:checked',
  CHECKBOX_NAME_PLACEHOLDER: "{name}",
  QUESTION_TYPE_MULTI_INPUT: "multi-input"
};
const CONTENT_TYPE_JSON = "application/json";
const HEADER_CONTENT_TYPE = "Content-Type";
const HTTP_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH"
};
const HEADER_SHOPIFY_HMAC = "X-Shopify-Hmac-SHA256";
const HEADER_ZYG_STOREFRONT_HMAC = "X-Zyg-Storefront-Hmac-SHA256";
const authHeaders = (secret) => ({
  [HEADER_CONTENT_TYPE]: CONTENT_TYPE_JSON,
  [HEADER_SHOPIFY_HMAC]: secret,
  [HEADER_ZYG_STOREFRONT_HMAC]: secret
});
async function post(url, body, secret) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: authHeaders(secret),
      body: JSON.stringify(body),
      mode: "cors"
    });
    if (!response.ok) {
      console.error(`POST request failed: ${response.status} ${response.statusText}`, {
        url,
        status: response.status
      });
      return void 0;
    }
    const text = await response.text();
    return text.length > 0 ? JSON.parse(text) : void 0;
  } catch (error) {
    console.error("POST request failed:", error);
    return void 0;
  }
}
async function get(url, secret) {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: authHeaders(secret),
      mode: "cors"
    });
    if (!response.ok) {
      console.error(`GET request failed: ${response.status} ${response.statusText}`, {
        url,
        status: response.status
      });
      return void 0;
    }
    const text = await response.text();
    return text.length > 0 ? JSON.parse(text) : void 0;
  } catch (error) {
    console.error("GET request failed:", error);
    return void 0;
  }
}
async function requestPost(body) {
  if (typeof window.zygRequestPostInternal !== "function") {
    console.error("request is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestPostInternal("", body);
  } catch (error) {
    console.error("Backend request failed:", error);
    return void 0;
  }
}
async function requestGet(url) {
  if (typeof window.zygRequestGetInternal !== "function") {
    console.error("request is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestGetInternal(url);
  } catch (error) {
    console.error("Backend request failed:", error);
    return void 0;
  }
}
async function requestPostToPath(path, body) {
  if (typeof window.zygRequestPostInternal !== "function") {
    console.error("requestPostToPath is not defined");
    return void 0;
  }
  try {
    return await window.zygRequestPostInternal(path, body);
  } catch (error) {
    console.error("Backend POST request failed:", error);
    return void 0;
  }
}
window.zygGet = get;
window.zygPost = post;
window.zygRequestPost = requestPost;
window.zygRequestGet = requestGet;
window.zygRequestPostToPath = requestPostToPath;
async function backendPost(path, body, errorMessage) {
  const response = await window.zygRequestPostToPath(path, body);
  if (!response) {
    return { success: false, error: errorMessage };
  }
  return { success: response.success, data: response, error: response.error || void 0 };
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = { randomUUID };
function v4(options, buf, offset) {
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random ?? options.rng?.() ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const ALLOWED_PROTOCOLS = ["https:"];
const NAVIGATE_ERRORS = {
  INVALID_URL: "Invalid URL:",
  BLOCKED_PROTOCOL: "Blocked navigation to disallowed protocol:",
  BLOCKED_CROSS_ORIGIN: "Blocked cross-origin navigation to:"
};
const generateId$1 = () => {
  return v4();
};
const stringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    console.error("Error stringifying data:", error);
    return void 0;
  }
};
const isDefined = (value) => value != null;
const isNotEmpty = (value) => {
  return value != null && value.trim() !== "";
};
const navigateToUrl = (url) => {
  try {
    const absoluteUrl = new URL(url, window.location.origin);
    if (!ALLOWED_PROTOCOLS.includes(absoluteUrl.protocol)) {
      console.error(NAVIGATE_ERRORS.BLOCKED_PROTOCOL, url);
      return false;
    }
    if (absoluteUrl.origin !== window.location.origin) {
      console.error(NAVIGATE_ERRORS.BLOCKED_CROSS_ORIGIN, url);
      return false;
    }
    window.location.href = absoluteUrl.href;
    return true;
  } catch {
    console.error(NAVIGATE_ERRORS.INVALID_URL, url);
    return false;
  }
};
function isHTMLElementLike(element) {
  if (element == null) {
    return false;
  }
  if (element instanceof HTMLElement) {
    return true;
  }
  return typeof element === "object" && ("textContent" in element || "style" in element || "dataset" in element || "classList" in element);
}
function setElementDisplay(element, display) {
  if (isHTMLElementLike(element) && element.style) {
    element.style.display = display;
  }
}
function hide(element) {
  if (isHTMLElementLike(element) && element.style) {
    element.style.setProperty("display", "none");
  }
}
function show(element) {
  if (isHTMLElementLike(element) && element.style) {
    element.style.removeProperty("display");
  }
}
function toggle(element, condition) {
  if (condition) {
    show(element);
  } else {
    hide(element);
  }
}
const parseIntOrZero = (value) => parseInt(value || "0", 10) || 0;
const boolToString = (value) => value ? "true" : "false";
const buildSectionUrl = (sectionId) => `${window.location.pathname}?sections=${sectionId}`;
const URL_PARAMS_STORAGE_KEY = "URL_Params";
function getUrlParam(paramName) {
  try {
    const stored = localStorage.getItem(URL_PARAMS_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed.latest?.[paramName]) {
        return parsed.latest[paramName];
      }
    }
  } catch (error) {
    console.error("Error getting URL parameter from localStorage:", error);
  }
  return new URLSearchParams(window.location.search).get(paramName) || void 0;
}
function collectElements(elementIds, parentSelector, childSelector) {
  const seen = /* @__PURE__ */ new Set();
  const result = [];
  const addUnique = (el) => {
    if (!seen.has(el)) {
      seen.add(el);
      result.push(el);
    }
  };
  elementIds.forEach((id) => {
    const el = document.getElementById(id);
    if (isHTMLElementLike(el)) {
      addUnique(el);
    }
  });
  if (parentSelector && childSelector) {
    const parent = document.querySelector(parentSelector);
    if (parent) {
      Array.from(parent.querySelectorAll(childSelector)).filter((el) => isHTMLElementLike(el)).forEach(addUnique);
    }
  }
  return result;
}
function onDOMReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback);
  } else {
    callback();
  }
}
const STORE_CONFIG_PATH = (domain) => `store-config/${encodeURIComponent(domain)}`;
const URL_PARAM_UTM_CAMPAIGN = "utm_campaign";
const QUERY_PARAM_PATH = "path";
function buildStoreConfigUrl(domain) {
  const params = new URLSearchParams();
  params.set(QUERY_PARAM_PATH, window.location.pathname);
  const utmCampaign = getUrlParam(URL_PARAM_UTM_CAMPAIGN);
  if (utmCampaign) {
    params.set(URL_PARAM_UTM_CAMPAIGN, utmCampaign);
  }
  return `${STORE_CONFIG_PATH(domain)}?${params.toString()}`;
}
async function getStoreConfig(domain) {
  return await window.zygRequestGet(buildStoreConfigUrl(domain));
}
async function loadStoreConfig(domain) {
  try {
    window.zygStoreConfig = await getStoreConfig(domain);
  } catch (error) {
    console.error("[zyg] Failed to load store config:", error);
  }
}
const SCRIPT_SELECTOR = "script[data-zyg-store-config]";
function autoInit() {
  const script = document.querySelector(SCRIPT_SELECTOR);
  const domain = script?.dataset.domain;
  if (!domain) {
    return;
  }
  onDOMReady(() => void loadStoreConfig(domain));
}
autoInit();
window.zygGetStoreConfig = getStoreConfig;
window.quizStates = window.quizStates || {};
function getQuizState(quizId) {
  return window.quizStates[quizId] || null;
}
const requireQuizState = getQuizState;
function extractQuizId(quizElement) {
  if (isNotEmpty(quizElement.dataset?.[DATASET_PROPERTIES.QUIZ_ID])) {
    return (quizElement.dataset?.[DATASET_PROPERTIES.QUIZ_ID] || "").trim();
  }
  return quizElement.id?.replace(STRING_VALUES.QUIZ_SECTION_PREFIX, "") || "";
}
function getQuizDataFromElement(element) {
  const quizElement = typeof element.closest === "function" ? element.closest(SELECTOR_STRINGS.QUIZ_SECTION_BY_PREFIX) : null;
  if (!quizElement) {
    console.error("Quiz element not found for element:", element);
    return null;
  }
  const quizId = extractQuizId(quizElement);
  return { quizId, state: getQuizState(quizId) };
}
function findQuizElement(quizId) {
  const idSelector = `${SELECTORS.QUIZ_SECTION}-${quizId}`;
  const quizElementById = document.getElementById(idSelector);
  if (quizElementById) {
    return quizElementById;
  }
  const dataSelector = SELECTOR_TEMPLATES.QUIZ_SECTION_BY_DATA_QUIZ_ID(quizId);
  const quizElementByData = document.querySelector(dataSelector);
  if (!quizElementByData) {
    console.warn(
      `[findQuizElement] Quiz element not found for quizId: ${quizId}. Tried: #${idSelector} and ${dataSelector}`
    );
  }
  return quizElementByData || void 0;
}
function getQuizElement(quizId) {
  const element = findQuizElement(quizId);
  return element || null;
}
function extractDatasetAttribute(element, attributeName, functionName, quizId) {
  if (!element) {
    console.warn(`[${functionName}] Element not found for quizId: ${quizId}`);
    return void 0;
  }
  if (!(attributeName in (element[OBJECT_PROPERTIES.DATASET] || {}))) {
    console.warn(
      `[${functionName}] ${attributeName} not found in dataset for quizId: ${quizId}. Available dataset keys:`,
      Object.keys(element[OBJECT_PROPERTIES.DATASET] || {})
    );
    return void 0;
  }
  const value = element.dataset[attributeName];
  return value || void 0;
}
function extractPageId(currentPageEl, fallback = DEFAULT_FALLBACK_VALUES.UNKNOWN_PAGE_ID) {
  return currentPageEl?.dataset?.[DATASET_PROPERTIES.BLOCK_ID] || fallback;
}
function extractBlockIdWithFn(quizId, getCurrentPageElementFn) {
  const currentPageEl = getCurrentPageElementFn(quizId);
  return extractDatasetAttribute(
    currentPageEl,
    DATASET_PROPERTIES.BLOCK_ID,
    "extractBlockId",
    quizId
  );
}
function extractQuizIdentifier(quizId) {
  const quizElement = findQuizElement(quizId);
  return extractDatasetAttribute(
    quizElement || null,
    DATASET_PROPERTIES.QUIZ_IDENTIFIER,
    "extractQuizIdentifier",
    quizId
  );
}
function getUrlParamNameFromQuizElement(quizId) {
  const quizElement = findQuizElement(quizId);
  if (quizElement) {
    const urlParamName = quizElement.dataset?.[DATASET_PROPERTIES.URL_PARAM_TO_ADD_TO_EVENTS];
    return isNotEmpty(urlParamName) ? urlParamName?.trim() : void 0;
  }
  return void 0;
}
function getStorageScopeWithFallback(elements, fallback) {
  for (const element of elements) {
    const storageScope = element?.dataset?.[DATASET_PROPERTIES.STORAGE_SCOPE];
    if (storageScope) {
      return storageScope;
    }
  }
  return fallback;
}
function getCurrentPageElement(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2) {
    return null;
  }
  const quizElement = findQuizElement(quizId);
  if (!quizElement) {
    return null;
  }
  return quizElement.querySelector(
    `.${SELECTORS.QUESTION_PAGE}[data-${DATA_ATTRIBUTES.STEP}="${state2.currentPage}"]`
  );
}
function togglePageVisibility(pageElement, show2) {
  setElementDisplay(pageElement, show2 ? DISPLAY_VALUES.BLOCK : DISPLAY_VALUES.NONE);
}
function requireCurrentPageElement(quizId) {
  const currentPageEl = getCurrentPageElement(quizId);
  if (!currentPageEl) {
    console.error(`${ERROR_MESSAGES$2.CURRENT_PAGE_ELEMENT_NOT_FOUND} ${quizId}`);
    return null;
  }
  return currentPageEl;
}
function getPageIndex(state2) {
  return state2 ? state2.currentPage - NUMERIC_CONSTANTS.DEFAULT_PAGE_INDEX_OFFSET : 0;
}
function readUrlParams(functionName) {
  try {
    const urlParamsString = localStorage.getItem(STORAGE_KEYS.url_params);
    if (!urlParamsString) {
      return null;
    }
    return JSON.parse(urlParamsString);
  } catch (error) {
    console.error(`[${functionName}] Failed to parse URL params from localStorage:`, error);
    return null;
  }
}
function getUrlParamValue(keyName) {
  const urlParams = readUrlParams("getUrlParamValue");
  if (!urlParams) {
    console.warn(`[getUrlParamValue] URL params not found in localStorage for key: ${keyName}`);
    return void 0;
  }
  const value = urlParams[keyName] ?? urlParams[OBJECT_PROPERTIES.LATEST]?.[keyName] ?? void 0;
  return value;
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var validator$1 = { exports: {} };
var toDate = { exports: {} };
var assertString = { exports: {} };
var hasRequiredAssertString;
function requireAssertString() {
  if (hasRequiredAssertString) return assertString.exports;
  hasRequiredAssertString = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = assertString2;
    function assertString2(input) {
      if (input === void 0 || input === null) throw new TypeError("Expected a string but received a ".concat(input));
      if (input.constructor.name !== "String") throw new TypeError("Expected a string but received a ".concat(input.constructor.name));
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(assertString, assertString.exports);
  return assertString.exports;
}
var hasRequiredToDate;
function requireToDate() {
  if (hasRequiredToDate) return toDate.exports;
  hasRequiredToDate = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = toDate2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function toDate2(date) {
      (0, _assertString.default)(date);
      date = Date.parse(date);
      return !isNaN(date) ? new Date(date) : null;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(toDate, toDate.exports);
  return toDate.exports;
}
var toFloat = { exports: {} };
var isFloat = {};
var nullUndefinedCheck = { exports: {} };
var hasRequiredNullUndefinedCheck;
function requireNullUndefinedCheck() {
  if (hasRequiredNullUndefinedCheck) return nullUndefinedCheck.exports;
  hasRequiredNullUndefinedCheck = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isNullOrUndefined;
    function isNullOrUndefined(value) {
      return value === null || value === void 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(nullUndefinedCheck, nullUndefinedCheck.exports);
  return nullUndefinedCheck.exports;
}
var alpha = {};
var hasRequiredAlpha;
function requireAlpha() {
  if (hasRequiredAlpha) return alpha;
  hasRequiredAlpha = 1;
  Object.defineProperty(alpha, "__esModule", {
    value: true
  });
  alpha.farsiLocales = alpha.englishLocales = alpha.dotDecimal = alpha.decimal = alpha.commaDecimal = alpha.bengaliLocales = alpha.arabicLocales = alpha.alphanumeric = alpha.alpha = void 0;
  var alpha$1 = alpha.alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/,
    "ta-IN": /^[\u0B80-\u0BFF]+$/i,
    "te-IN": /^[\u0C00-\u0C7F]+$/i,
    "kn-IN": /^[\u0C80-\u0CFF]+$/i,
    "ml-IN": /^[\u0D00-\u0D7F]+$/i,
    "gu-IN": /^[\u0A80-\u0AFF]+$/i,
    "pa-IN": /^[\u0A00-\u0A7F]+$/i,
    "or-IN": /^[\u0B00-\u0B7F]+$/i
  };
  var alphanumeric = alpha.alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/,
    "ta-IN": /^[0-9\u0B80-\u0BFF.]+$/i,
    "te-IN": /^[0-9\u0C00-\u0C7F.]+$/i,
    "kn-IN": /^[0-9\u0C80-\u0CFF.]+$/i,
    "ml-IN": /^[0-9\u0D00-\u0D7F.]+$/i,
    "gu-IN": /^[0-9\u0A80-\u0AFF.]+$/i,
    "pa-IN": /^[0-9\u0A00-\u0A7F.]+$/i,
    "or-IN": /^[0-9\u0B00-\u0B7F.]+$/i
  };
  var decimal = alpha.decimal = {
    "en-US": ".",
    ar: "٫"
  };
  var englishLocales = alpha.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"];
  for (var locale, i = 0; i < englishLocales.length; i++) {
    locale = "en-".concat(englishLocales[i]);
    alpha$1[locale] = alpha$1["en-US"];
    alphanumeric[locale] = alphanumeric["en-US"];
    decimal[locale] = decimal["en-US"];
  }
  var arabicLocales = alpha.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"];
  for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
    _locale = "ar-".concat(arabicLocales[_i]);
    alpha$1[_locale] = alpha$1.ar;
    alphanumeric[_locale] = alphanumeric.ar;
    decimal[_locale] = decimal.ar;
  }
  var farsiLocales = alpha.farsiLocales = ["IR", "AF"];
  for (var _locale2, _i2 = 0; _i2 < farsiLocales.length; _i2++) {
    _locale2 = "fa-".concat(farsiLocales[_i2]);
    alphanumeric[_locale2] = alphanumeric.fa;
    decimal[_locale2] = decimal.ar;
  }
  var bengaliLocales = alpha.bengaliLocales = ["BD", "IN"];
  for (var _locale3, _i3 = 0; _i3 < bengaliLocales.length; _i3++) {
    _locale3 = "bn-".concat(bengaliLocales[_i3]);
    alpha$1[_locale3] = alpha$1.bn;
    alphanumeric[_locale3] = alphanumeric.bn;
    decimal[_locale3] = decimal["en-US"];
  }
  var dotDecimal = alpha.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"];
  var commaDecimal = alpha.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "gu-IN", "hi-IN", "hu-HU", "id-ID", "it-IT", "kk-KZ", "kn-IN", "ku-IQ", "ml-IN", "nb-NO", "nl-NL", "nn-NO", "or-IN", "pa-IN", "pl-PL", "pt-PT", "ru-RU", "si-LK", "sl-SI", "sr-RS", "sr-RS@latin", "sv-SE", "ta-IN", "te-IN", "tr-TR", "uk-UA", "vi-VN"];
  for (var _i4 = 0; _i4 < dotDecimal.length; _i4++) {
    decimal[dotDecimal[_i4]] = decimal["en-US"];
  }
  for (var _i5 = 0; _i5 < commaDecimal.length; _i5++) {
    decimal[commaDecimal[_i5]] = ",";
  }
  alpha$1["fr-CA"] = alpha$1["fr-FR"];
  alphanumeric["fr-CA"] = alphanumeric["fr-FR"];
  alpha$1["pt-BR"] = alpha$1["pt-PT"];
  alphanumeric["pt-BR"] = alphanumeric["pt-PT"];
  decimal["pt-BR"] = decimal["pt-PT"];
  alpha$1["pl-Pl"] = alpha$1["pl-PL"];
  alphanumeric["pl-Pl"] = alphanumeric["pl-PL"];
  decimal["pl-Pl"] = decimal["pl-PL"];
  alpha$1["fa-AF"] = alpha$1.fa;
  return alpha;
}
var hasRequiredIsFloat;
function requireIsFloat() {
  if (hasRequiredIsFloat) return isFloat;
  hasRequiredIsFloat = 1;
  Object.defineProperty(isFloat, "__esModule", {
    value: true
  });
  isFloat.default = isFloat$1;
  isFloat.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  var _nullUndefinedCheck = _interopRequireDefault(/* @__PURE__ */ requireNullUndefinedCheck());
  var _alpha = /* @__PURE__ */ requireAlpha();
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function isFloat$1(str, options) {
    (0, _assertString.default)(str);
    options = options || {};
    var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (str === "" || str === "." || str === "," || str === "-" || str === "+") {
      return false;
    }
    var value = parseFloat(str.replace(",", "."));
    return float.test(str) && (!options.hasOwnProperty("min") || (0, _nullUndefinedCheck.default)(options.min) || value >= options.min) && (!options.hasOwnProperty("max") || (0, _nullUndefinedCheck.default)(options.max) || value <= options.max) && (!options.hasOwnProperty("lt") || (0, _nullUndefinedCheck.default)(options.lt) || value < options.lt) && (!options.hasOwnProperty("gt") || (0, _nullUndefinedCheck.default)(options.gt) || value > options.gt);
  }
  isFloat.locales = Object.keys(_alpha.decimal);
  return isFloat;
}
var hasRequiredToFloat;
function requireToFloat() {
  if (hasRequiredToFloat) return toFloat.exports;
  hasRequiredToFloat = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = toFloat2;
    var _isFloat = _interopRequireDefault(/* @__PURE__ */ requireIsFloat());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function toFloat2(str) {
      if (!(0, _isFloat.default)(str)) return NaN;
      return parseFloat(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(toFloat, toFloat.exports);
  return toFloat.exports;
}
var toInt = { exports: {} };
var hasRequiredToInt;
function requireToInt() {
  if (hasRequiredToInt) return toInt.exports;
  hasRequiredToInt = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = toInt2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function toInt2(str, radix) {
      (0, _assertString.default)(str);
      return parseInt(str, radix || 10);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(toInt, toInt.exports);
  return toInt.exports;
}
var toBoolean = { exports: {} };
var hasRequiredToBoolean;
function requireToBoolean() {
  if (hasRequiredToBoolean) return toBoolean.exports;
  hasRequiredToBoolean = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = toBoolean2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function toBoolean2(str, strict) {
      (0, _assertString.default)(str);
      if (strict) {
        return str === "1" || /^true$/i.test(str);
      }
      return str !== "0" && !/^false$/i.test(str) && str !== "";
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(toBoolean, toBoolean.exports);
  return toBoolean.exports;
}
var equals = { exports: {} };
var hasRequiredEquals;
function requireEquals() {
  if (hasRequiredEquals) return equals.exports;
  hasRequiredEquals = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = equals2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function equals2(str, comparison) {
      (0, _assertString.default)(str);
      return str === comparison;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(equals, equals.exports);
  return equals.exports;
}
var contains = { exports: {} };
var toString$1 = { exports: {} };
var hasRequiredToString;
function requireToString() {
  if (hasRequiredToString) return toString$1.exports;
  hasRequiredToString = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = toString2;
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function toString2(input) {
      if (_typeof(input) === "object" && input !== null) {
        if (typeof input.toString === "function") {
          input = input.toString();
        } else {
          input = "[object Object]";
        }
      } else if (input === null || typeof input === "undefined" || isNaN(input) && !input.length) {
        input = "";
      }
      return String(input);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(toString$1, toString$1.exports);
  return toString$1.exports;
}
var merge = { exports: {} };
var hasRequiredMerge;
function requireMerge() {
  if (hasRequiredMerge) return merge.exports;
  hasRequiredMerge = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = merge2;
    function merge2() {
      var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var defaults = arguments.length > 1 ? arguments[1] : void 0;
      for (var key in defaults) {
        if (typeof obj[key] === "undefined") {
          obj[key] = defaults[key];
        }
      }
      return obj;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(merge, merge.exports);
  return merge.exports;
}
var hasRequiredContains;
function requireContains() {
  if (hasRequiredContains) return contains.exports;
  hasRequiredContains = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = contains2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _toString = _interopRequireDefault(/* @__PURE__ */ requireToString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var defaultContainsOptions = {
      ignoreCase: false,
      minOccurrences: 1
    };
    function contains2(str, elem, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultContainsOptions);
      if (options.ignoreCase) {
        return str.toLowerCase().split((0, _toString.default)(elem).toLowerCase()).length > options.minOccurrences;
      }
      return str.split((0, _toString.default)(elem)).length > options.minOccurrences;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(contains, contains.exports);
  return contains.exports;
}
var matches = { exports: {} };
var hasRequiredMatches;
function requireMatches() {
  if (hasRequiredMatches) return matches.exports;
  hasRequiredMatches = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = matches2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function matches2(str, pattern, modifiers) {
      (0, _assertString.default)(str);
      if (Object.prototype.toString.call(pattern) !== "[object RegExp]") {
        pattern = new RegExp(pattern, modifiers);
      }
      return !!str.match(pattern);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(matches, matches.exports);
  return matches.exports;
}
var isEmail = { exports: {} };
var checkHost = { exports: {} };
var hasRequiredCheckHost;
function requireCheckHost() {
  if (hasRequiredCheckHost) return checkHost.exports;
  hasRequiredCheckHost = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = checkHost2;
    function isRegExp(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    }
    function checkHost2(host, matches2) {
      for (var i = 0; i < matches2.length; i++) {
        var match = matches2[i];
        if (host === match || isRegExp(match) && match.test(host)) {
          return true;
        }
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(checkHost, checkHost.exports);
  return checkHost.exports;
}
var isByteLength = { exports: {} };
var hasRequiredIsByteLength;
function requireIsByteLength() {
  if (hasRequiredIsByteLength) return isByteLength.exports;
  hasRequiredIsByteLength = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isByteLength2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isByteLength2(str, options) {
      (0, _assertString.default)(str);
      var min;
      var max;
      if (_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
      } else {
        min = arguments[1];
        max = arguments[2];
      }
      var len = encodeURI(str).split(/%..|./).length - 1;
      return len >= min && (typeof max === "undefined" || len <= max);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isByteLength, isByteLength.exports);
  return isByteLength.exports;
}
var isFQDN = { exports: {} };
var hasRequiredIsFQDN;
function requireIsFQDN() {
  if (hasRequiredIsFQDN) return isFQDN.exports;
  hasRequiredIsFQDN = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isFQDN2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_fqdn_options = {
      require_tld: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_numeric_tld: false,
      allow_wildcard: false,
      ignore_max_length: false
    };
    function isFQDN2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_fqdn_options);
      if (options.allow_trailing_dot && str[str.length - 1] === ".") {
        str = str.substring(0, str.length - 1);
      }
      if (options.allow_wildcard === true && str.indexOf("*.") === 0) {
        str = str.substring(2);
      }
      var parts = str.split(".");
      var tld = parts[parts.length - 1];
      if (options.require_tld) {
        if (parts.length < 2) {
          return false;
        }
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
          return false;
        }
        if (/\s/.test(tld)) {
          return false;
        }
      }
      if (!options.allow_numeric_tld && /^\d+$/.test(tld)) {
        return false;
      }
      return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) {
          return false;
        }
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) {
          return false;
        }
        if (/[\uff01-\uff5e]/.test(part)) {
          return false;
        }
        if (/^-|-$/.test(part)) {
          return false;
        }
        if (!options.allow_underscores && /_/.test(part)) {
          return false;
        }
        return true;
      });
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isFQDN, isFQDN.exports);
  return isFQDN.exports;
}
var isIP = { exports: {} };
var hasRequiredIsIP;
function requireIsIP() {
  if (hasRequiredIsIP) return isIP.exports;
  hasRequiredIsIP = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isIP2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    var IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
    var IPv4AddressFormat = "(".concat(IPv4SegmentFormat, "[.]){3}").concat(IPv4SegmentFormat);
    var IPv4AddressRegExp = new RegExp("^".concat(IPv4AddressFormat, "$"));
    var IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
    var IPv6AddressRegExp = new RegExp("^(" + "(?:".concat(IPv6SegmentFormat, ":){7}(?:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){6}(?:").concat(IPv4AddressFormat, "|:").concat(IPv6SegmentFormat, "|:)|") + "(?:".concat(IPv6SegmentFormat, ":){5}(?::").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){4}(?:(:").concat(IPv6SegmentFormat, "){0,1}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){3}(?:(:").concat(IPv6SegmentFormat, "){0,2}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){2}(?:(:").concat(IPv6SegmentFormat, "){0,3}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat(IPv6SegmentFormat, ":){1}(?:(:").concat(IPv6SegmentFormat, "){0,4}:").concat(IPv4AddressFormat, "|(:").concat(IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat(IPv6SegmentFormat, "){0,5}:").concat(IPv4AddressFormat, "|(?::").concat(IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z.]{1,})?$");
    function isIP2(ipAddress) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(ipAddress);
      var version = (_typeof(options) === "object" ? options.version : arguments[1]) || "";
      if (!version) {
        return isIP2(ipAddress, {
          version: 4
        }) || isIP2(ipAddress, {
          version: 6
        });
      }
      if (version.toString() === "4") {
        return IPv4AddressRegExp.test(ipAddress);
      }
      if (version.toString() === "6") {
        return IPv6AddressRegExp.test(ipAddress);
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isIP, isIP.exports);
  return isIP.exports;
}
var hasRequiredIsEmail;
function requireIsEmail() {
  if (hasRequiredIsEmail) return isEmail.exports;
  hasRequiredIsEmail = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isEmail2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _checkHost = _interopRequireDefault(/* @__PURE__ */ requireCheckHost());
    var _isByteLength = _interopRequireDefault(/* @__PURE__ */ requireIsByteLength());
    var _isFQDN = _interopRequireDefault(/* @__PURE__ */ requireIsFQDN());
    var _isIP = _interopRequireDefault(/* @__PURE__ */ requireIsIP());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_email_options = {
      allow_display_name: false,
      allow_underscores: false,
      require_display_name: false,
      allow_utf8_local_part: true,
      require_tld: true,
      blacklisted_chars: "",
      ignore_max_length: false,
      host_blacklist: [],
      host_whitelist: []
    };
    var splitNameAddress = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i;
    var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
    var gmailUserPart = /^[a-z\d]+$/;
    var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
    var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
    var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
    var defaultMaxEmailLength = 254;
    function validateDisplayName(display_name) {
      var display_name_without_quotes = display_name.replace(/^"(.+)"$/, "$1");
      if (!display_name_without_quotes.trim()) {
        return false;
      }
      var contains_illegal = /[\.";<>]/.test(display_name_without_quotes);
      if (contains_illegal) {
        if (display_name_without_quotes === display_name) {
          return false;
        }
        var all_start_with_back_slash = display_name_without_quotes.split('"').length === display_name_without_quotes.split('\\"').length;
        if (!all_start_with_back_slash) {
          return false;
        }
      }
      return true;
    }
    function isEmail2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_email_options);
      if (options.require_display_name || options.allow_display_name) {
        var display_email = str.match(splitNameAddress);
        if (display_email) {
          var display_name = display_email[1];
          str = str.replace(display_name, "").replace(/(^<|>$)/g, "");
          if (display_name.endsWith(" ")) {
            display_name = display_name.slice(0, -1);
          }
          if (!validateDisplayName(display_name)) {
            return false;
          }
        } else if (options.require_display_name) {
          return false;
        }
      }
      if (!options.ignore_max_length && str.length > defaultMaxEmailLength) {
        return false;
      }
      var parts = str.split("@");
      var domain = parts.pop();
      var lower_domain = domain.toLowerCase();
      if (options.host_blacklist.length > 0 && (0, _checkHost.default)(lower_domain, options.host_blacklist)) {
        return false;
      }
      if (options.host_whitelist.length > 0 && !(0, _checkHost.default)(lower_domain, options.host_whitelist)) {
        return false;
      }
      var user = parts.join("@");
      if (options.domain_specific_validation && (lower_domain === "gmail.com" || lower_domain === "googlemail.com")) {
        user = user.toLowerCase();
        var username = user.split("+")[0];
        if (!(0, _isByteLength.default)(username.replace(/\./g, ""), {
          min: 6,
          max: 30
        })) {
          return false;
        }
        var _user_parts = username.split(".");
        for (var i = 0; i < _user_parts.length; i++) {
          if (!gmailUserPart.test(_user_parts[i])) {
            return false;
          }
        }
      }
      if (options.ignore_max_length === false && (!(0, _isByteLength.default)(user, {
        max: 64
      }) || !(0, _isByteLength.default)(domain, {
        max: 254
      }))) {
        return false;
      }
      if (!(0, _isFQDN.default)(domain, {
        require_tld: options.require_tld,
        ignore_max_length: options.ignore_max_length,
        allow_underscores: options.allow_underscores
      })) {
        if (!options.allow_ip_domain) {
          return false;
        }
        if (!(0, _isIP.default)(domain)) {
          if (!domain.startsWith("[") || !domain.endsWith("]")) {
            return false;
          }
          var noBracketdomain = domain.slice(1, -1);
          if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
            return false;
          }
        }
      }
      if (options.blacklisted_chars) {
        if (user.search(new RegExp("[".concat(options.blacklisted_chars, "]+"), "g")) !== -1) return false;
      }
      if (user[0] === '"' && user[user.length - 1] === '"') {
        user = user.slice(1, user.length - 1);
        return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
      }
      var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
      var user_parts = user.split(".");
      for (var _i = 0; _i < user_parts.length; _i++) {
        if (!pattern.test(user_parts[_i])) {
          return false;
        }
      }
      return true;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isEmail, isEmail.exports);
  return isEmail.exports;
}
var isURL = { exports: {} };
var includesString = { exports: {} };
var hasRequiredIncludesString;
function requireIncludesString() {
  if (hasRequiredIncludesString) return includesString.exports;
  hasRequiredIncludesString = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    var includes = function includes2(str, val) {
      return str.indexOf(val) !== -1;
    };
    exports$1.default = includes;
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(includesString, includesString.exports);
  return includesString.exports;
}
var hasRequiredIsURL;
function requireIsURL() {
  if (hasRequiredIsURL) return isURL.exports;
  hasRequiredIsURL = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isURL2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _checkHost = _interopRequireDefault(/* @__PURE__ */ requireCheckHost());
    var _includesString = _interopRequireDefault(/* @__PURE__ */ requireIncludesString());
    var _isFQDN = _interopRequireDefault(/* @__PURE__ */ requireIsFQDN());
    var _isIP = _interopRequireDefault(/* @__PURE__ */ requireIsIP());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _slicedToArray(r, e) {
      return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
          if (i = (t = t.call(r)).next, 0 === l) ;
          else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(r) {
      if (Array.isArray(r)) return r;
    }
    var default_url_options = {
      protocols: ["http", "https", "ftp"],
      require_tld: true,
      require_protocol: false,
      require_host: true,
      require_port: false,
      require_valid_protocol: true,
      allow_underscores: false,
      allow_trailing_dot: false,
      allow_protocol_relative_urls: false,
      allow_fragments: true,
      allow_query_components: true,
      validate_length: true,
      max_allowed_length: 2084
    };
    var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function isURL2(url, options) {
      (0, _assertString.default)(url);
      if (!url || /[\s<>]/.test(url)) {
        return false;
      }
      if (url.indexOf("mailto:") === 0) {
        return false;
      }
      options = (0, _merge.default)(options, default_url_options);
      if (options.validate_length && url.length > options.max_allowed_length) {
        return false;
      }
      if (!options.allow_fragments && (0, _includesString.default)(url, "#")) {
        return false;
      }
      if (!options.allow_query_components && ((0, _includesString.default)(url, "?") || (0, _includesString.default)(url, "&"))) {
        return false;
      }
      var protocol, auth, host, hostname, port, port_str, split, ipv6;
      split = url.split("#");
      url = split.shift();
      split = url.split("?");
      url = split.shift();
      var protocol_match = url.match(/^([a-z][a-z0-9+\-.]*):/i);
      var had_explicit_protocol = false;
      var cleanUpProtocol = function cleanUpProtocol2(potential_protocol2) {
        had_explicit_protocol = true;
        protocol = potential_protocol2.toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
          return false;
        }
        return url.substring(protocol_match[0].length);
      };
      if (protocol_match) {
        var potential_protocol = protocol_match[1];
        var after_colon = url.substring(protocol_match[0].length);
        var starts_with_slashes = after_colon.slice(0, 2) === "//";
        if (!starts_with_slashes) {
          var first_slash_position = after_colon.indexOf("/");
          var before_slash = first_slash_position === -1 ? after_colon : after_colon.substring(0, first_slash_position);
          var at_position = before_slash.indexOf("@");
          if (at_position !== -1) {
            var before_at = before_slash.substring(0, at_position);
            var valid_auth_regex = /^[a-zA-Z0-9\-_.%:]*$/;
            var is_valid_auth = valid_auth_regex.test(before_at);
            if (is_valid_auth) {
              if (options.require_protocol) {
                return false;
              }
            } else {
              url = cleanUpProtocol(potential_protocol);
              if (url === false) {
                return false;
              }
            }
          } else {
            var looks_like_port = /^[0-9]/.test(after_colon);
            if (looks_like_port) {
              if (options.require_protocol) {
                return false;
              }
            } else {
              url = cleanUpProtocol(potential_protocol);
              if (url === false) {
                return false;
              }
            }
          }
        } else {
          url = cleanUpProtocol(potential_protocol);
          if (url === false) {
            return false;
          }
        }
      } else if (options.require_protocol) {
        return false;
      }
      if (url.slice(0, 2) === "//") {
        if (!had_explicit_protocol && !options.allow_protocol_relative_urls) {
          return false;
        }
        url = url.slice(2);
      }
      if (url === "") {
        return false;
      }
      split = url.split("/");
      url = split.shift();
      if (url === "" && !options.require_host) {
        return true;
      }
      split = url.split("@");
      if (split.length > 1) {
        if (options.disallow_auth) {
          return false;
        }
        if (split[0] === "") {
          return false;
        }
        auth = split.shift();
        if (auth.indexOf(":") >= 0 && auth.split(":").length > 2) {
          return false;
        }
        var _auth$split = auth.split(":"), _auth$split2 = _slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === "" && password === "") {
          return false;
        }
      }
      hostname = split.join("@");
      port_str = null;
      ipv6 = null;
      var ipv6_match = hostname.match(wrapped_ipv6);
      if (ipv6_match) {
        host = "";
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
      } else {
        split = hostname.split(":");
        host = split.shift();
        if (split.length) {
          port_str = split.join(":");
        }
      }
      if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
          return false;
        }
      } else if (options.require_port) {
        return false;
      }
      if (options.host_whitelist) {
        return (0, _checkHost.default)(host, options.host_whitelist);
      }
      if (host === "" && !options.require_host) {
        return true;
      }
      if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
        return false;
      }
      host = host || ipv6;
      if (options.host_blacklist && (0, _checkHost.default)(host, options.host_blacklist)) {
        return false;
      }
      return true;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isURL, isURL.exports);
  return isURL.exports;
}
var isMACAddress = { exports: {} };
var hasRequiredIsMACAddress;
function requireIsMACAddress() {
  if (hasRequiredIsMACAddress) return isMACAddress.exports;
  hasRequiredIsMACAddress = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMACAddress2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var macAddress48 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/;
    var macAddress48NoSeparators = /^([0-9a-fA-F]){12}$/;
    var macAddress48WithDots = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/;
    var macAddress64 = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/;
    var macAddress64NoSeparators = /^([0-9a-fA-F]){16}$/;
    var macAddress64WithDots = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function isMACAddress2(str, options) {
      (0, _assertString.default)(str);
      if (options !== null && options !== void 0 && options.eui) {
        options.eui = String(options.eui);
      }
      if (options !== null && options !== void 0 && options.no_colons || options !== null && options !== void 0 && options.no_separators) {
        if (options.eui === "48") {
          return macAddress48NoSeparators.test(str);
        }
        if (options.eui === "64") {
          return macAddress64NoSeparators.test(str);
        }
        return macAddress48NoSeparators.test(str) || macAddress64NoSeparators.test(str);
      }
      if ((options === null || options === void 0 ? void 0 : options.eui) === "48") {
        return macAddress48.test(str) || macAddress48WithDots.test(str);
      }
      if ((options === null || options === void 0 ? void 0 : options.eui) === "64") {
        return macAddress64.test(str) || macAddress64WithDots.test(str);
      }
      return isMACAddress2(str, {
        eui: "48"
      }) || isMACAddress2(str, {
        eui: "64"
      });
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMACAddress, isMACAddress.exports);
  return isMACAddress.exports;
}
var isIPRange = { exports: {} };
var hasRequiredIsIPRange;
function requireIsIPRange() {
  if (hasRequiredIsIPRange) return isIPRange.exports;
  hasRequiredIsIPRange = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isIPRange2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isIP = _interopRequireDefault(/* @__PURE__ */ requireIsIP());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var subnetMaybe = /^\d{1,3}$/;
    var v4Subnet = 32;
    var v6Subnet = 128;
    function isIPRange2(str) {
      var version = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, _assertString.default)(str);
      var parts = str.split("/");
      if (parts.length !== 2) {
        return false;
      }
      if (!subnetMaybe.test(parts[1])) {
        return false;
      }
      if (parts[1].length > 1 && parts[1].startsWith("0")) {
        return false;
      }
      var isValidIP = (0, _isIP.default)(parts[0], version);
      if (!isValidIP) {
        return false;
      }
      var expectedSubnet = null;
      switch (String(version)) {
        case "4":
          expectedSubnet = v4Subnet;
          break;
        case "6":
          expectedSubnet = v6Subnet;
          break;
        default:
          expectedSubnet = (0, _isIP.default)(parts[0], "6") ? v6Subnet : v4Subnet;
      }
      return parts[1] <= expectedSubnet && parts[1] >= 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isIPRange, isIPRange.exports);
  return isIPRange.exports;
}
var isDate = { exports: {} };
var hasRequiredIsDate;
function requireIsDate() {
  if (hasRequiredIsDate) return isDate.exports;
  hasRequiredIsDate = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isDate2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _slicedToArray(r, e) {
      return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
          if (i = (t = t.call(r)).next, 0 === l) ;
          else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(r) {
      if (Array.isArray(r)) return r;
    }
    function _createForOfIteratorHelper(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
          t && (r = t);
          var _n = 0, F = function F2() {
          };
          return { s: F, n: function n() {
            return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
          }, e: function e2(r2) {
            throw r2;
          }, f: F };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o, a = true, u = false;
      return { s: function s() {
        t = t.call(r);
      }, n: function n() {
        var r2 = t.next();
        return a = r2.done, r2;
      }, e: function e2(r2) {
        u = true, o = r2;
      }, f: function f() {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      } };
    }
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var default_date_options = {
      format: "YYYY/MM/DD",
      delimiters: ["/", "-"],
      strictMode: false
    };
    function isValidFormat(format) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(format);
    }
    function zip(date, format) {
      var zippedArr = [], len = Math.max(date.length, format.length);
      for (var i = 0; i < len; i++) {
        zippedArr.push([date[i], format[i]]);
      }
      return zippedArr;
    }
    function isDate2(input, options) {
      if (typeof options === "string") {
        options = (0, _merge.default)({
          format: options
        }, default_date_options);
      } else {
        options = (0, _merge.default)(options, default_date_options);
      }
      if (typeof input === "string" && isValidFormat(options.format)) {
        if (options.strictMode && input.length !== options.format.length) return false;
        var formatDelimiter = options.delimiters.find(function(delimiter) {
          return options.format.indexOf(delimiter) !== -1;
        });
        var dateDelimiter = options.strictMode ? formatDelimiter : options.delimiters.find(function(delimiter) {
          return input.indexOf(delimiter) !== -1;
        });
        var dateAndFormat = zip(input.split(dateDelimiter), options.format.toLowerCase().split(formatDelimiter));
        var dateObj = {};
        var _iterator = _createForOfIteratorHelper(dateAndFormat), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var _step$value = _slicedToArray(_step.value, 2), dateWord = _step$value[0], formatWord = _step$value[1];
            if (!dateWord || !formatWord || dateWord.length !== formatWord.length) {
              return false;
            }
            dateObj[formatWord.charAt(0)] = dateWord;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var fullYear = dateObj.y;
        if (fullYear.startsWith("-")) {
          return false;
        }
        if (dateObj.y.length === 2) {
          var parsedYear = parseInt(dateObj.y, 10);
          if (isNaN(parsedYear)) {
            return false;
          }
          var currentYearLastTwoDigits = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          if (parsedYear < currentYearLastTwoDigits) {
            fullYear = "20".concat(dateObj.y);
          } else {
            fullYear = "19".concat(dateObj.y);
          }
        }
        var month = dateObj.m;
        if (dateObj.m.length === 1) {
          month = "0".concat(dateObj.m);
        }
        var day = dateObj.d;
        if (dateObj.d.length === 1) {
          day = "0".concat(dateObj.d);
        }
        return new Date("".concat(fullYear, "-").concat(month, "-").concat(day, "T00:00:00.000Z")).getUTCDate() === +dateObj.d;
      }
      if (!options.strictMode) {
        return Object.prototype.toString.call(input) === "[object Date]" && isFinite(input);
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isDate, isDate.exports);
  return isDate.exports;
}
var isTime = { exports: {} };
var hasRequiredIsTime;
function requireIsTime() {
  if (hasRequiredIsTime) return isTime.exports;
  hasRequiredIsTime = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isTime2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_time_options = {
      hourFormat: "hour24",
      mode: "default"
    };
    var formats = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/,
        withOptionalSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9])(?::([0-5][0-9]))?$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/,
        withOptionalSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9])(?::([0-5][0-9]))? (A|P)M$/
      }
    };
    function isTime2(input, options) {
      options = (0, _merge.default)(options, default_time_options);
      if (typeof input !== "string") return false;
      return formats[options.hourFormat][options.mode].test(input);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isTime, isTime.exports);
  return isTime.exports;
}
var isBoolean = { exports: {} };
var includesArray = { exports: {} };
var hasRequiredIncludesArray;
function requireIncludesArray() {
  if (hasRequiredIncludesArray) return includesArray.exports;
  hasRequiredIncludesArray = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    var includes = function includes2(arr, val) {
      return arr.some(function(arrVal) {
        return val === arrVal;
      });
    };
    exports$1.default = includes;
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(includesArray, includesArray.exports);
  return includesArray.exports;
}
var hasRequiredIsBoolean;
function requireIsBoolean() {
  if (hasRequiredIsBoolean) return isBoolean.exports;
  hasRequiredIsBoolean = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBoolean2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _includesArray = _interopRequireDefault(/* @__PURE__ */ requireIncludesArray());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var defaultOptions = {
      loose: false
    };
    var strictBooleans = ["true", "false", "1", "0"];
    var looseBooleans = [].concat(strictBooleans, ["yes", "no"]);
    function isBoolean2(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOptions;
      (0, _assertString.default)(str);
      if (options.loose) {
        return (0, _includesArray.default)(looseBooleans, str.toLowerCase());
      }
      return (0, _includesArray.default)(strictBooleans, str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBoolean, isBoolean.exports);
  return isBoolean.exports;
}
var isLocale = { exports: {} };
var hasRequiredIsLocale;
function requireIsLocale() {
  if (hasRequiredIsLocale) return isLocale.exports;
  hasRequiredIsLocale = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLocale2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var extlang = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})";
    var language = "(([a-zA-Z]{2,3}(-".concat(extlang, ")?)|([a-zA-Z]{5,8}))");
    var script = "([A-Za-z]{4})";
    var region = "([A-Za-z]{2}|\\d{3})";
    var variant = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))";
    var singleton = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])";
    var extension = "(".concat(singleton, "(-[A-Za-z0-9]{2,8})+)");
    var privateuse = "(x(-[A-Za-z0-9]{1,8})+)";
    var irregular = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))";
    var regular = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))";
    var grandfathered = "(".concat(irregular, "|").concat(regular, ")");
    var delimiter = "(-|_)";
    var langtag = "".concat(language, "(").concat(delimiter).concat(script, ")?(").concat(delimiter).concat(region, ")?(").concat(delimiter).concat(variant, ")*(").concat(delimiter).concat(extension, ")*(").concat(delimiter).concat(privateuse, ")?");
    var languageTagRegex = new RegExp("(^".concat(privateuse, "$)|(^").concat(grandfathered, "$)|(^").concat(langtag, "$)"));
    function isLocale2(str) {
      (0, _assertString.default)(str);
      return languageTagRegex.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLocale, isLocale.exports);
  return isLocale.exports;
}
var isAbaRouting = { exports: {} };
var hasRequiredIsAbaRouting;
function requireIsAbaRouting() {
  if (hasRequiredIsAbaRouting) return isAbaRouting.exports;
  hasRequiredIsAbaRouting = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isAbaRouting2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var isRoutingReg = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function isAbaRouting2(str) {
      (0, _assertString.default)(str);
      if (!isRoutingReg.test(str)) return false;
      var checkSumVal = 0;
      for (var i = 0; i < str.length; i++) {
        if (i % 3 === 0) checkSumVal += str[i] * 3;
        else if (i % 3 === 1) checkSumVal += str[i] * 7;
        else checkSumVal += str[i] * 1;
      }
      return checkSumVal % 10 === 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isAbaRouting, isAbaRouting.exports);
  return isAbaRouting.exports;
}
var isAlpha = {};
var hasRequiredIsAlpha;
function requireIsAlpha() {
  if (hasRequiredIsAlpha) return isAlpha;
  hasRequiredIsAlpha = 1;
  Object.defineProperty(isAlpha, "__esModule", {
    value: true
  });
  isAlpha.default = isAlpha$1;
  isAlpha.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  var _alpha = /* @__PURE__ */ requireAlpha();
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function isAlpha$1(_str) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, _assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
      if (ignore instanceof RegExp) {
        str = str.replace(ignore, "");
      } else if (typeof ignore === "string") {
        str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      } else {
        throw new Error("ignore should be instance of a String or RegExp");
      }
    }
    if (locale in _alpha.alpha) {
      return _alpha.alpha[locale].test(str);
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
  }
  isAlpha.locales = Object.keys(_alpha.alpha);
  return isAlpha;
}
var isAlphanumeric = {};
var hasRequiredIsAlphanumeric;
function requireIsAlphanumeric() {
  if (hasRequiredIsAlphanumeric) return isAlphanumeric;
  hasRequiredIsAlphanumeric = 1;
  Object.defineProperty(isAlphanumeric, "__esModule", {
    value: true
  });
  isAlphanumeric.default = isAlphanumeric$1;
  isAlphanumeric.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  var _alpha = /* @__PURE__ */ requireAlpha();
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  function isAlphanumeric$1(_str) {
    var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, _assertString.default)(_str);
    var str = _str;
    var ignore = options.ignore;
    if (ignore) {
      if (ignore instanceof RegExp) {
        str = str.replace(ignore, "");
      } else if (typeof ignore === "string") {
        str = str.replace(new RegExp("[".concat(ignore.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      } else {
        throw new Error("ignore should be instance of a String or RegExp");
      }
    }
    if (locale in _alpha.alphanumeric) {
      return _alpha.alphanumeric[locale].test(str);
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
  }
  isAlphanumeric.locales = Object.keys(_alpha.alphanumeric);
  return isAlphanumeric;
}
var isNumeric = { exports: {} };
var hasRequiredIsNumeric;
function requireIsNumeric() {
  if (hasRequiredIsNumeric) return isNumeric.exports;
  hasRequiredIsNumeric = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isNumeric2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _alpha = /* @__PURE__ */ requireAlpha();
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var numericNoSymbols = /^[0-9]+$/;
    function isNumeric2(str, options) {
      (0, _assertString.default)(str);
      if (options && options.no_symbols) {
        return numericNoSymbols.test(str);
      }
      return new RegExp("^[+-]?([0-9]*[".concat((options || {}).locale ? _alpha.decimal[options.locale] : ".", "])?[0-9]+$")).test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isNumeric, isNumeric.exports);
  return isNumeric.exports;
}
var isPassportNumber = {};
var hasRequiredIsPassportNumber;
function requireIsPassportNumber() {
  if (hasRequiredIsPassportNumber) return isPassportNumber;
  hasRequiredIsPassportNumber = 1;
  Object.defineProperty(isPassportNumber, "__esModule", {
    value: true
  });
  isPassportNumber.default = isPassportNumber$1;
  isPassportNumber.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var passportRegexByCountryCode = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$|^[A-Z]\d{6}[A-Z]{2}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$|^[A-Z]\d{8}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  isPassportNumber.locales = Object.keys(passportRegexByCountryCode);
  function isPassportNumber$1(str, countryCode) {
    (0, _assertString.default)(str);
    var normalizedStr = str.replace(/\s/g, "").toUpperCase();
    return countryCode.toUpperCase() in passportRegexByCountryCode && passportRegexByCountryCode[countryCode].test(normalizedStr);
  }
  return isPassportNumber;
}
var isPort = { exports: {} };
var isInt = { exports: {} };
var hasRequiredIsInt;
function requireIsInt() {
  if (hasRequiredIsInt) return isInt.exports;
  hasRequiredIsInt = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isInt2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _nullUndefinedCheck = _interopRequireDefault(/* @__PURE__ */ requireNullUndefinedCheck());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
    var intLeadingZeroes = /^[-+]?[0-9]+$/;
    function isInt2(str, options) {
      (0, _assertString.default)(str);
      options = options || {};
      var regex = options.allow_leading_zeroes === false ? int : intLeadingZeroes;
      var minCheckPassed = !options.hasOwnProperty("min") || (0, _nullUndefinedCheck.default)(options.min) || str >= options.min;
      var maxCheckPassed = !options.hasOwnProperty("max") || (0, _nullUndefinedCheck.default)(options.max) || str <= options.max;
      var ltCheckPassed = !options.hasOwnProperty("lt") || (0, _nullUndefinedCheck.default)(options.lt) || str < options.lt;
      var gtCheckPassed = !options.hasOwnProperty("gt") || (0, _nullUndefinedCheck.default)(options.gt) || str > options.gt;
      return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isInt, isInt.exports);
  return isInt.exports;
}
var hasRequiredIsPort;
function requireIsPort() {
  if (hasRequiredIsPort) return isPort.exports;
  hasRequiredIsPort = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isPort2;
    var _isInt = _interopRequireDefault(/* @__PURE__ */ requireIsInt());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isPort2(str) {
      return (0, _isInt.default)(str, {
        allow_leading_zeroes: false,
        min: 0,
        max: 65535
      });
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isPort, isPort.exports);
  return isPort.exports;
}
var isLowercase = { exports: {} };
var hasRequiredIsLowercase;
function requireIsLowercase() {
  if (hasRequiredIsLowercase) return isLowercase.exports;
  hasRequiredIsLowercase = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLowercase2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isLowercase2(str) {
      (0, _assertString.default)(str);
      return str === str.toLowerCase();
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLowercase, isLowercase.exports);
  return isLowercase.exports;
}
var isUppercase = { exports: {} };
var hasRequiredIsUppercase;
function requireIsUppercase() {
  if (hasRequiredIsUppercase) return isUppercase.exports;
  hasRequiredIsUppercase = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isUppercase2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isUppercase2(str) {
      (0, _assertString.default)(str);
      return str === str.toUpperCase();
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isUppercase, isUppercase.exports);
  return isUppercase.exports;
}
var isIMEI = { exports: {} };
var hasRequiredIsIMEI;
function requireIsIMEI() {
  if (hasRequiredIsIMEI) return isIMEI.exports;
  hasRequiredIsIMEI = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isIMEI2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var imeiRegexWithoutHyphens = /^[0-9]{15}$/;
    var imeiRegexWithHyphens = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function isIMEI2(str, options) {
      (0, _assertString.default)(str);
      options = options || {};
      var imeiRegex = imeiRegexWithoutHyphens;
      if (options.allow_hyphens) {
        imeiRegex = imeiRegexWithHyphens;
      }
      if (!imeiRegex.test(str)) {
        return false;
      }
      str = str.replace(/-/g, "");
      var sum = 0, mul = 2, l = 14;
      for (var i = 0; i < l; i++) {
        var digit = str.substring(l - i - 1, l - i);
        var tp = parseInt(digit, 10) * mul;
        if (tp >= 10) {
          sum += tp % 10 + 1;
        } else {
          sum += tp;
        }
        if (mul === 1) {
          mul += 1;
        } else {
          mul -= 1;
        }
      }
      var chk = (10 - sum % 10) % 10;
      if (chk !== parseInt(str.substring(14, 15), 10)) {
        return false;
      }
      return true;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isIMEI, isIMEI.exports);
  return isIMEI.exports;
}
var isAscii = { exports: {} };
var hasRequiredIsAscii;
function requireIsAscii() {
  if (hasRequiredIsAscii) return isAscii.exports;
  hasRequiredIsAscii = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isAscii2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var ascii = /^[\x00-\x7F]+$/;
    function isAscii2(str) {
      (0, _assertString.default)(str);
      return ascii.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isAscii, isAscii.exports);
  return isAscii.exports;
}
var isFullWidth = {};
var hasRequiredIsFullWidth;
function requireIsFullWidth() {
  if (hasRequiredIsFullWidth) return isFullWidth;
  hasRequiredIsFullWidth = 1;
  Object.defineProperty(isFullWidth, "__esModule", {
    value: true
  });
  isFullWidth.default = isFullWidth$1;
  isFullWidth.fullWidth = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var fullWidth = isFullWidth.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function isFullWidth$1(str) {
    (0, _assertString.default)(str);
    return fullWidth.test(str);
  }
  return isFullWidth;
}
var isHalfWidth = {};
var hasRequiredIsHalfWidth;
function requireIsHalfWidth() {
  if (hasRequiredIsHalfWidth) return isHalfWidth;
  hasRequiredIsHalfWidth = 1;
  Object.defineProperty(isHalfWidth, "__esModule", {
    value: true
  });
  isHalfWidth.default = isHalfWidth$1;
  isHalfWidth.halfWidth = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var halfWidth = isHalfWidth.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function isHalfWidth$1(str) {
    (0, _assertString.default)(str);
    return halfWidth.test(str);
  }
  return isHalfWidth;
}
var isVariableWidth = { exports: {} };
var hasRequiredIsVariableWidth;
function requireIsVariableWidth() {
  if (hasRequiredIsVariableWidth) return isVariableWidth.exports;
  hasRequiredIsVariableWidth = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isVariableWidth2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isFullWidth = /* @__PURE__ */ requireIsFullWidth();
    var _isHalfWidth = /* @__PURE__ */ requireIsHalfWidth();
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isVariableWidth2(str) {
      (0, _assertString.default)(str);
      return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isVariableWidth, isVariableWidth.exports);
  return isVariableWidth.exports;
}
var isMultibyte = { exports: {} };
var hasRequiredIsMultibyte;
function requireIsMultibyte() {
  if (hasRequiredIsMultibyte) return isMultibyte.exports;
  hasRequiredIsMultibyte = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMultibyte2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var multibyte = /[^\x00-\x7F]/;
    function isMultibyte2(str) {
      (0, _assertString.default)(str);
      return multibyte.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMultibyte, isMultibyte.exports);
  return isMultibyte.exports;
}
var isSemVer = { exports: {} };
var multilineRegex = { exports: {} };
var hasRequiredMultilineRegex;
function requireMultilineRegex() {
  if (hasRequiredMultilineRegex) return multilineRegex.exports;
  hasRequiredMultilineRegex = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = multilineRegexp;
    function multilineRegexp(parts, flags) {
      var regexpAsStringLiteral = parts.join("");
      return new RegExp(regexpAsStringLiteral, flags);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(multilineRegex, multilineRegex.exports);
  return multilineRegex.exports;
}
var hasRequiredIsSemVer;
function requireIsSemVer() {
  if (hasRequiredIsSemVer) return isSemVer.exports;
  hasRequiredIsSemVer = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isSemVer2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _multilineRegex = _interopRequireDefault(/* @__PURE__ */ requireMultilineRegex());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var semanticVersioningRegex = (0, _multilineRegex.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
    function isSemVer2(str) {
      (0, _assertString.default)(str);
      return semanticVersioningRegex.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isSemVer, isSemVer.exports);
  return isSemVer.exports;
}
var isSurrogatePair = { exports: {} };
var hasRequiredIsSurrogatePair;
function requireIsSurrogatePair() {
  if (hasRequiredIsSurrogatePair) return isSurrogatePair.exports;
  hasRequiredIsSurrogatePair = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isSurrogatePair2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function isSurrogatePair2(str) {
      (0, _assertString.default)(str);
      return surrogatePair.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isSurrogatePair, isSurrogatePair.exports);
  return isSurrogatePair.exports;
}
var isDecimal = { exports: {} };
var hasRequiredIsDecimal;
function requireIsDecimal() {
  if (hasRequiredIsDecimal) return isDecimal.exports;
  hasRequiredIsDecimal = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isDecimal2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _includesArray = _interopRequireDefault(/* @__PURE__ */ requireIncludesArray());
    var _alpha = /* @__PURE__ */ requireAlpha();
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function decimalRegExp(options) {
      var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? "" : "?", "$"));
      return regExp;
    }
    var default_decimal_options = {
      force_decimal: false,
      decimal_digits: "1,",
      locale: "en-US"
    };
    var blacklist2 = ["", "-", "+"];
    function isDecimal2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_decimal_options);
      if (options.locale in _alpha.decimal) {
        return !(0, _includesArray.default)(blacklist2, str.replace(/ /g, "")) && decimalRegExp(options).test(str);
      }
      throw new Error("Invalid locale '".concat(options.locale, "'"));
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isDecimal, isDecimal.exports);
  return isDecimal.exports;
}
var isHexadecimal = { exports: {} };
var hasRequiredIsHexadecimal;
function requireIsHexadecimal() {
  if (hasRequiredIsHexadecimal) return isHexadecimal.exports;
  hasRequiredIsHexadecimal = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isHexadecimal2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var hexadecimal = /^(0x|0h)?[0-9A-F]+$/i;
    function isHexadecimal2(str) {
      (0, _assertString.default)(str);
      return hexadecimal.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isHexadecimal, isHexadecimal.exports);
  return isHexadecimal.exports;
}
var isOctal = { exports: {} };
var hasRequiredIsOctal;
function requireIsOctal() {
  if (hasRequiredIsOctal) return isOctal.exports;
  hasRequiredIsOctal = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isOctal2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var octal = /^(0o)?[0-7]+$/i;
    function isOctal2(str) {
      (0, _assertString.default)(str);
      return octal.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isOctal, isOctal.exports);
  return isOctal.exports;
}
var isDivisibleBy = { exports: {} };
var hasRequiredIsDivisibleBy;
function requireIsDivisibleBy() {
  if (hasRequiredIsDivisibleBy) return isDivisibleBy.exports;
  hasRequiredIsDivisibleBy = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isDivisibleBy2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _toFloat = _interopRequireDefault(/* @__PURE__ */ requireToFloat());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isDivisibleBy2(str, num) {
      (0, _assertString.default)(str);
      return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isDivisibleBy, isDivisibleBy.exports);
  return isDivisibleBy.exports;
}
var isHexColor = { exports: {} };
var hasRequiredIsHexColor;
function requireIsHexColor() {
  if (hasRequiredIsHexColor) return isHexColor.exports;
  hasRequiredIsHexColor = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isHexColor2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function isHexColor2(str) {
      (0, _assertString.default)(str);
      return hexcolor.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isHexColor, isHexColor.exports);
  return isHexColor.exports;
}
var isRgbColor = { exports: {} };
var hasRequiredIsRgbColor;
function requireIsRgbColor() {
  if (hasRequiredIsRgbColor) return isRgbColor.exports;
  hasRequiredIsRgbColor = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isRgbColor2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    var rgbColor = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/;
    var rgbaColor = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d\d?|1(\.0)?|0(\.0)?)\)$/;
    var rgbColorPercent = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/;
    var rgbaColorPercent = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d\d?|1(\.0)?|0(\.0)?)\)$/;
    var startsWithRgb = /^rgba?/;
    function isRgbColor2(str, options) {
      (0, _assertString.default)(str);
      var allowSpaces = false;
      var includePercentValues = true;
      if (_typeof(options) !== "object") {
        if (arguments.length >= 2) {
          includePercentValues = arguments[1];
        }
      } else {
        allowSpaces = options.allowSpaces !== void 0 ? options.allowSpaces : allowSpaces;
        includePercentValues = options.includePercentValues !== void 0 ? options.includePercentValues : includePercentValues;
      }
      if (allowSpaces) {
        if (!startsWithRgb.test(str)) {
          return false;
        }
        str = str.replace(/\s/g, "");
      }
      if (!includePercentValues) {
        return rgbColor.test(str) || rgbaColor.test(str);
      }
      return rgbColor.test(str) || rgbaColor.test(str) || rgbColorPercent.test(str) || rgbaColorPercent.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isRgbColor, isRgbColor.exports);
  return isRgbColor.exports;
}
var isHSL = { exports: {} };
var hasRequiredIsHSL;
function requireIsHSL() {
  if (hasRequiredIsHSL) return isHSL.exports;
  hasRequiredIsHSL = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isHSL2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var hslComma = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i;
    var hslSpace = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function isHSL2(str) {
      (0, _assertString.default)(str);
      var strippedStr = str.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      if (strippedStr.indexOf(",") !== -1) {
        return hslComma.test(strippedStr);
      }
      return hslSpace.test(strippedStr);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isHSL, isHSL.exports);
  return isHSL.exports;
}
var isISRC = { exports: {} };
var hasRequiredIsISRC;
function requireIsISRC() {
  if (hasRequiredIsISRC) return isISRC.exports;
  hasRequiredIsISRC = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISRC2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function isISRC2(str) {
      (0, _assertString.default)(str);
      return isrc.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISRC, isISRC.exports);
  return isISRC.exports;
}
var isIBAN = {};
var hasRequiredIsIBAN;
function requireIsIBAN() {
  if (hasRequiredIsIBAN) return isIBAN;
  hasRequiredIsIBAN = 1;
  Object.defineProperty(isIBAN, "__esModule", {
    value: true
  });
  isIBAN.default = isIBAN$1;
  isIBAN.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  var _includesArray = _interopRequireDefault(/* @__PURE__ */ requireIncludesArray());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var ibanRegexThroughCountryCode = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
  };
  function hasOnlyValidCountryCodes(countryCodeArray) {
    var countryCodeArrayFilteredWithObjectIbanCode = countryCodeArray.filter(function(countryCode) {
      return !(countryCode in ibanRegexThroughCountryCode);
    });
    if (countryCodeArrayFilteredWithObjectIbanCode.length > 0) {
      return false;
    }
    return true;
  }
  function hasValidIbanFormat(str, options) {
    var strippedStr = str.replace(/[\s\-]+/gi, "").toUpperCase();
    var isoCountryCode = strippedStr.slice(0, 2).toUpperCase();
    var isoCountryCodeInIbanRegexCodeObject = isoCountryCode in ibanRegexThroughCountryCode;
    if (options.whitelist) {
      if (!hasOnlyValidCountryCodes(options.whitelist)) {
        return false;
      }
      var isoCountryCodeInWhiteList = (0, _includesArray.default)(options.whitelist, isoCountryCode);
      if (!isoCountryCodeInWhiteList) {
        return false;
      }
    }
    if (options.blacklist) {
      var isoCountryCodeInBlackList = (0, _includesArray.default)(options.blacklist, isoCountryCode);
      if (isoCountryCodeInBlackList) {
        return false;
      }
    }
    return isoCountryCodeInIbanRegexCodeObject && ibanRegexThroughCountryCode[isoCountryCode].test(strippedStr);
  }
  function hasValidIbanChecksum(str) {
    var strippedStr = str.replace(/[^A-Z0-9]+/gi, "").toUpperCase();
    var rearranged = strippedStr.slice(4) + strippedStr.slice(0, 4);
    var alphaCapsReplacedWithDigits = rearranged.replace(/[A-Z]/g, function(char) {
      return char.charCodeAt(0) - 55;
    });
    var remainder = alphaCapsReplacedWithDigits.match(/\d{1,7}/g).reduce(function(acc, value) {
      return Number(acc + value) % 97;
    }, "");
    return remainder === 1;
  }
  function isIBAN$1(str) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    (0, _assertString.default)(str);
    return hasValidIbanFormat(str, options) && hasValidIbanChecksum(str);
  }
  isIBAN.locales = Object.keys(ibanRegexThroughCountryCode);
  return isIBAN;
}
var isBIC = { exports: {} };
var isISO31661Alpha2 = {};
var hasRequiredIsISO31661Alpha2;
function requireIsISO31661Alpha2() {
  if (hasRequiredIsISO31661Alpha2) return isISO31661Alpha2;
  hasRequiredIsISO31661Alpha2 = 1;
  Object.defineProperty(isISO31661Alpha2, "__esModule", {
    value: true
  });
  isISO31661Alpha2.CountryCodes = void 0;
  isISO31661Alpha2.default = isISO31661Alpha2$1;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var validISO31661Alpha2CountriesCodes = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
  function isISO31661Alpha2$1(str) {
    (0, _assertString.default)(str);
    return validISO31661Alpha2CountriesCodes.has(str.toUpperCase());
  }
  isISO31661Alpha2.CountryCodes = validISO31661Alpha2CountriesCodes;
  return isISO31661Alpha2;
}
var hasRequiredIsBIC;
function requireIsBIC() {
  if (hasRequiredIsBIC) return isBIC.exports;
  hasRequiredIsBIC = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBIC2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isISO31661Alpha = /* @__PURE__ */ requireIsISO31661Alpha2();
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var isBICReg = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function isBIC2(str) {
      (0, _assertString.default)(str);
      var countryCode = str.slice(4, 6).toUpperCase();
      if (!_isISO31661Alpha.CountryCodes.has(countryCode) && countryCode !== "XK") {
        return false;
      }
      return isBICReg.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBIC, isBIC.exports);
  return isBIC.exports;
}
var isMD5 = { exports: {} };
var hasRequiredIsMD5;
function requireIsMD5() {
  if (hasRequiredIsMD5) return isMD5.exports;
  hasRequiredIsMD5 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMD52;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var md5 = /^[a-f0-9]{32}$/;
    function isMD52(str) {
      (0, _assertString.default)(str);
      return md5.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMD5, isMD5.exports);
  return isMD5.exports;
}
var isHash = { exports: {} };
var hasRequiredIsHash;
function requireIsHash() {
  if (hasRequiredIsHash) return isHash.exports;
  hasRequiredIsHash = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isHash2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var lengths = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function isHash2(str, algorithm) {
      (0, _assertString.default)(str);
      var hash = new RegExp("^[a-fA-F0-9]{".concat(lengths[algorithm], "}$"));
      return hash.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isHash, isHash.exports);
  return isHash.exports;
}
var isJWT = { exports: {} };
var isBase64 = { exports: {} };
var hasRequiredIsBase64;
function requireIsBase64() {
  if (hasRequiredIsBase64) return isBase64.exports;
  hasRequiredIsBase64 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBase642;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var base64WithPadding = /^[A-Za-z0-9+/]+={0,2}$/;
    var base64WithoutPadding = /^[A-Za-z0-9+/]+$/;
    var base64UrlWithPadding = /^[A-Za-z0-9_-]+={0,2}$/;
    var base64UrlWithoutPadding = /^[A-Za-z0-9_-]+$/;
    function isBase642(str, options) {
      var _options;
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, {
        urlSafe: false,
        padding: !((_options = options) !== null && _options !== void 0 && _options.urlSafe)
      });
      if (str === "") return true;
      if (options.padding && str.length % 4 !== 0) return false;
      var regex;
      if (options.urlSafe) {
        regex = options.padding ? base64UrlWithPadding : base64UrlWithoutPadding;
      } else {
        regex = options.padding ? base64WithPadding : base64WithoutPadding;
      }
      return (!options.padding || str.length % 4 === 0) && regex.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBase64, isBase64.exports);
  return isBase64.exports;
}
var hasRequiredIsJWT;
function requireIsJWT() {
  if (hasRequiredIsJWT) return isJWT.exports;
  hasRequiredIsJWT = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isJWT2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isBase = _interopRequireDefault(/* @__PURE__ */ requireIsBase64());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isJWT2(str) {
      (0, _assertString.default)(str);
      var dotSplit = str.split(".");
      var len = dotSplit.length;
      if (len !== 3) {
        return false;
      }
      return dotSplit.reduce(function(acc, currElem) {
        return acc && (0, _isBase.default)(currElem, {
          urlSafe: true
        });
      }, true);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isJWT, isJWT.exports);
  return isJWT.exports;
}
var isJSON = { exports: {} };
var hasRequiredIsJSON;
function requireIsJSON() {
  if (hasRequiredIsJSON) return isJSON.exports;
  hasRequiredIsJSON = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isJSON2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _includesArray = _interopRequireDefault(/* @__PURE__ */ requireIncludesArray());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    var default_json_options = {
      allow_primitives: false
    };
    function isJSON2(str, options) {
      (0, _assertString.default)(str);
      try {
        options = (0, _merge.default)(options, default_json_options);
        var primitives = [];
        if (options.allow_primitives) {
          primitives = [null, false, true];
        }
        var obj = JSON.parse(str);
        return (0, _includesArray.default)(primitives, obj) || !!obj && _typeof(obj) === "object";
      } catch (e) {
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isJSON, isJSON.exports);
  return isJSON.exports;
}
var isEmpty = { exports: {} };
var hasRequiredIsEmpty;
function requireIsEmpty() {
  if (hasRequiredIsEmpty) return isEmpty.exports;
  hasRequiredIsEmpty = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isEmpty2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_is_empty_options = {
      ignore_whitespace: false
    };
    function isEmpty2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_is_empty_options);
      return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isEmpty, isEmpty.exports);
  return isEmpty.exports;
}
var isLength = { exports: {} };
var hasRequiredIsLength;
function requireIsLength() {
  if (hasRequiredIsLength) return isLength.exports;
  hasRequiredIsLength = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLength2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isLength2(str, options) {
      (0, _assertString.default)(str);
      var min;
      var max;
      if (_typeof(options) === "object") {
        min = options.min || 0;
        max = options.max;
      } else {
        min = arguments[1] || 0;
        max = arguments[2];
      }
      var presentationSequences = str.match(/[^\uFE0F\uFE0E][\uFE0F\uFE0E]/g) || [];
      var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
      var len = str.length - presentationSequences.length - surrogatePairs.length;
      var isInsideRange = len >= min && (typeof max === "undefined" || len <= max);
      if (isInsideRange && Array.isArray(options === null || options === void 0 ? void 0 : options.discreteLengths)) {
        return options.discreteLengths.some(function(discreteLen) {
          return discreteLen === len;
        });
      }
      return isInsideRange;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLength, isLength.exports);
  return isLength.exports;
}
var isULID = { exports: {} };
var hasRequiredIsULID;
function requireIsULID() {
  if (hasRequiredIsULID) return isULID.exports;
  hasRequiredIsULID = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isULID2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isULID2(str) {
      (0, _assertString.default)(str);
      return /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isULID, isULID.exports);
  return isULID.exports;
}
var isUUID = { exports: {} };
var hasRequiredIsUUID;
function requireIsUUID() {
  if (hasRequiredIsUUID) return isUUID.exports;
  hasRequiredIsUUID = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isUUID2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var uuid = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      loose: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function isUUID2(str, version) {
      (0, _assertString.default)(str);
      if (version === void 0 || version === null) {
        version = "all";
      }
      return version in uuid ? uuid[version].test(str) : false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isUUID, isUUID.exports);
  return isUUID.exports;
}
var isMongoId = { exports: {} };
var hasRequiredIsMongoId;
function requireIsMongoId() {
  if (hasRequiredIsMongoId) return isMongoId.exports;
  hasRequiredIsMongoId = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMongoId2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isHexadecimal = _interopRequireDefault(/* @__PURE__ */ requireIsHexadecimal());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isMongoId2(str) {
      (0, _assertString.default)(str);
      return (0, _isHexadecimal.default)(str) && str.length === 24;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMongoId, isMongoId.exports);
  return isMongoId.exports;
}
var isAfter = { exports: {} };
var hasRequiredIsAfter;
function requireIsAfter() {
  if (hasRequiredIsAfter) return isAfter.exports;
  hasRequiredIsAfter = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isAfter2;
    var _toDate = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isAfter2(date, options) {
      var comparisonDate = (_typeof(options) === "object" ? options.comparisonDate : options) || Date().toString();
      var comparison = (0, _toDate.default)(comparisonDate);
      var original = (0, _toDate.default)(date);
      return !!(original && comparison && original > comparison);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isAfter, isAfter.exports);
  return isAfter.exports;
}
var isBefore = { exports: {} };
var hasRequiredIsBefore;
function requireIsBefore() {
  if (hasRequiredIsBefore) return isBefore.exports;
  hasRequiredIsBefore = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBefore2;
    var _toDate = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isBefore2(date, options) {
      var comparisonDate = (_typeof(options) === "object" ? options.comparisonDate : options) || Date().toString();
      var comparison = (0, _toDate.default)(comparisonDate);
      var original = (0, _toDate.default)(date);
      return !!(original && comparison && original < comparison);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBefore, isBefore.exports);
  return isBefore.exports;
}
var isIn = { exports: {} };
var hasRequiredIsIn;
function requireIsIn() {
  if (hasRequiredIsIn) return isIn.exports;
  hasRequiredIsIn = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isIn2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _toString = _interopRequireDefault(/* @__PURE__ */ requireToString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    function isIn2(str, options) {
      (0, _assertString.default)(str);
      var i;
      if (Object.prototype.toString.call(options) === "[object Array]") {
        var array = [];
        for (i in options) {
          if ({}.hasOwnProperty.call(options, i)) {
            array[i] = (0, _toString.default)(options[i]);
          }
        }
        return array.indexOf(str) >= 0;
      } else if (_typeof(options) === "object") {
        return options.hasOwnProperty(str);
      } else if (options && typeof options.indexOf === "function") {
        return options.indexOf(str) >= 0;
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isIn, isIn.exports);
  return isIn.exports;
}
var isLuhnNumber = { exports: {} };
var hasRequiredIsLuhnNumber;
function requireIsLuhnNumber() {
  if (hasRequiredIsLuhnNumber) return isLuhnNumber.exports;
  hasRequiredIsLuhnNumber = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLuhnNumber2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isLuhnNumber2(str) {
      (0, _assertString.default)(str);
      var sanitized = str.replace(/[- ]+/g, "");
      var sum = 0;
      var digit;
      var tmpNum;
      var shouldDouble;
      for (var i = sanitized.length - 1; i >= 0; i--) {
        digit = sanitized.substring(i, i + 1);
        tmpNum = parseInt(digit, 10);
        if (shouldDouble) {
          tmpNum *= 2;
          if (tmpNum >= 10) {
            sum += tmpNum % 10 + 1;
          } else {
            sum += tmpNum;
          }
        } else {
          sum += tmpNum;
        }
        shouldDouble = !shouldDouble;
      }
      return !!(sum % 10 === 0 ? sanitized : false);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLuhnNumber, isLuhnNumber.exports);
  return isLuhnNumber.exports;
}
var isCreditCard = { exports: {} };
var hasRequiredIsCreditCard;
function requireIsCreditCard() {
  if (hasRequiredIsCreditCard) return isCreditCard.exports;
  hasRequiredIsCreditCard = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isCreditCard2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _isLuhnNumber = _interopRequireDefault(/* @__PURE__ */ requireIsLuhnNumber());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var cards = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    };
    var allCards = (function() {
      var tmpCardsArray = [];
      for (var cardProvider in cards) {
        if (cards.hasOwnProperty(cardProvider)) {
          tmpCardsArray.push(cards[cardProvider]);
        }
      }
      return tmpCardsArray;
    })();
    function isCreditCard2(card) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(card);
      var provider = options.provider;
      var sanitized = card.replace(/[- ]+/g, "");
      if (provider && provider.toLowerCase() in cards) {
        if (!cards[provider.toLowerCase()].test(sanitized)) {
          return false;
        }
      } else if (provider && !(provider.toLowerCase() in cards)) {
        throw new Error("".concat(provider, " is not a valid credit card provider."));
      } else if (!allCards.some(function(cardProvider) {
        return cardProvider.test(sanitized);
      })) {
        return false;
      }
      return (0, _isLuhnNumber.default)(card);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isCreditCard, isCreditCard.exports);
  return isCreditCard.exports;
}
var isIdentityCard = { exports: {} };
var hasRequiredIsIdentityCard;
function requireIsIdentityCard() {
  if (hasRequiredIsIdentityCard) return isIdentityCard.exports;
  hasRequiredIsIdentityCard = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isIdentityCard2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _includesArray = _interopRequireDefault(/* @__PURE__ */ requireIncludesArray());
    var _isInt = _interopRequireDefault(/* @__PURE__ */ requireIsInt());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var validators2 = {
      PL: function PL(str) {
        (0, _assertString.default)(str);
        var weightOfDigits = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (str != null && str.length === 11 && (0, _isInt.default)(str, {
          allow_leading_zeroes: true
        })) {
          var digits = str.split("").slice(0, -1);
          var sum = digits.reduce(function(acc, digit, index) {
            return acc + Number(digit) * weightOfDigits[index + 1];
          }, 0);
          var modulo = sum % 10;
          var lastDigit = Number(str.charAt(str.length - 1));
          if (modulo === 0 && lastDigit === 0 || lastDigit === 10 - modulo) {
            return true;
          }
        }
        return false;
      },
      ES: function ES(str) {
        (0, _assertString.default)(str);
        var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
        var charsValue = {
          X: 0,
          Y: 1,
          Z: 2
        };
        var controlDigits = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
        var sanitized = str.trim().toUpperCase();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function(char) {
          return charsValue[char];
        });
        return sanitized.endsWith(controlDigits[number % 23]);
      },
      FI: function FI(str) {
        (0, _assertString.default)(str);
        if (str.length !== 11) {
          return false;
        }
        if (!str.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/)) {
          return false;
        }
        var checkDigits = "0123456789ABCDEFHJKLMNPRSTUVWXY";
        var idAsNumber = parseInt(str.slice(0, 6), 10) * 1e3 + parseInt(str.slice(7, 10), 10);
        var remainder = idAsNumber % 31;
        var checkDigit = checkDigits[remainder];
        return checkDigit === str.slice(10, 11);
      },
      IN: function IN(str) {
        var DNI = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/;
        var d = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
        var p = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]];
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var c = 0;
        var invertedArray = sanitized.replace(/\s/g, "").split("").map(Number).reverse();
        invertedArray.forEach(function(val, i) {
          c = d[c][p[i % 8][val]];
        });
        return c === 0;
      },
      IR: function IR(str) {
        if (!str.match(/^\d{10}$/)) return false;
        str = "0000".concat(str).slice(str.length - 6);
        if (parseInt(str.slice(3, 9), 10) === 0) return false;
        var lastNumber = parseInt(str.slice(9, 10), 10);
        var sum = 0;
        for (var i = 0; i < 9; i++) {
          sum += parseInt(str.slice(i, i + 1), 10) * (10 - i);
        }
        sum %= 11;
        return sum < 2 && lastNumber === sum || sum >= 2 && lastNumber === 11 - sum;
      },
      IT: function IT(str) {
        if (str.length !== 9) return false;
        if (str === "CA00000AA") return false;
        return str.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      },
      NO: function NO(str) {
        var sanitized = str.trim();
        if (isNaN(Number(sanitized))) return false;
        if (sanitized.length !== 11) return false;
        if (sanitized === "00000000000") return false;
        var f = sanitized.split("").map(Number);
        var k1 = (11 - (3 * f[0] + 7 * f[1] + 6 * f[2] + 1 * f[3] + 8 * f[4] + 9 * f[5] + 4 * f[6] + 5 * f[7] + 2 * f[8]) % 11) % 11;
        var k2 = (11 - (5 * f[0] + 4 * f[1] + 3 * f[2] + 2 * f[3] + 7 * f[4] + 6 * f[5] + 5 * f[6] + 4 * f[7] + 3 * f[8] + 2 * k1) % 11) % 11;
        if (k1 !== f[9] || k2 !== f[10]) return false;
        return true;
      },
      TH: function TH(str) {
        if (!str.match(/^[1-8]\d{12}$/)) return false;
        var sum = 0;
        for (var i = 0; i < 12; i++) {
          sum += parseInt(str[i], 10) * (13 - i);
        }
        return str[12] === ((11 - sum % 11) % 10).toString();
      },
      LK: function LK(str) {
        var old_nic = /^[1-9]\d{8}[vx]$/i;
        var new_nic = /^[1-9]\d{11}$/i;
        if (str.length === 10 && old_nic.test(str)) return true;
        else if (str.length === 12 && new_nic.test(str)) return true;
        return false;
      },
      "he-IL": function heIL(str) {
        var DNI = /^\d{9}$/;
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        var id = sanitized;
        var sum = 0, incNum;
        for (var i = 0; i < id.length; i++) {
          incNum = Number(id[i]) * (i % 2 + 1);
          sum += incNum > 9 ? incNum - 9 : incNum;
        }
        return sum % 10 === 0;
      },
      "ar-LY": function arLY(str) {
        var NIN = /^(1|2)\d{11}$/;
        var sanitized = str.trim();
        if (!NIN.test(sanitized)) {
          return false;
        }
        return true;
      },
      "ar-TN": function arTN(str) {
        var DNI = /^\d{8}$/;
        var sanitized = str.trim();
        if (!DNI.test(sanitized)) {
          return false;
        }
        return true;
      },
      "zh-CN": function zhCN(str) {
        var provincesAndCities = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ];
        var powers = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"];
        var parityBit = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
        var checkAddressCode = function checkAddressCode2(addressCode) {
          return (0, _includesArray.default)(provincesAndCities, addressCode);
        };
        var checkBirthDayCode = function checkBirthDayCode2(birDayCode) {
          var yyyy = parseInt(birDayCode.substring(0, 4), 10);
          var mm = parseInt(birDayCode.substring(4, 6), 10);
          var dd = parseInt(birDayCode.substring(6), 10);
          var xdata = new Date(yyyy, mm - 1, dd);
          if (xdata > /* @__PURE__ */ new Date()) {
            return false;
          } else if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
            return true;
          }
          return false;
        };
        var getParityBit = function getParityBit2(idCardNo) {
          var id17 = idCardNo.substring(0, 17);
          var power = 0;
          for (var i = 0; i < 17; i++) {
            power += parseInt(id17.charAt(i), 10) * parseInt(powers[i], 10);
          }
          var mod = power % 11;
          return parityBit[mod];
        };
        var checkParityBit = function checkParityBit2(idCardNo) {
          return getParityBit(idCardNo) === idCardNo.charAt(17).toUpperCase();
        };
        var check15IdCardNo = function check15IdCardNo2(idCardNo) {
          var check = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(idCardNo);
          if (!check) return false;
          var addressCode = idCardNo.substring(0, 2);
          check = checkAddressCode(addressCode);
          if (!check) return false;
          var birDayCode = "19".concat(idCardNo.substring(6, 12));
          check = checkBirthDayCode(birDayCode);
          if (!check) return false;
          return true;
        };
        var check18IdCardNo = function check18IdCardNo2(idCardNo) {
          var check = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(idCardNo);
          if (!check) return false;
          var addressCode = idCardNo.substring(0, 2);
          check = checkAddressCode(addressCode);
          if (!check) return false;
          var birDayCode = idCardNo.substring(6, 14);
          check = checkBirthDayCode(birDayCode);
          if (!check) return false;
          return checkParityBit(idCardNo);
        };
        var checkIdCardNo = function checkIdCardNo2(idCardNo) {
          var check = /^\d{15}|(\d{17}(\d|x|X))$/.test(idCardNo);
          if (!check) return false;
          if (idCardNo.length === 15) {
            return check15IdCardNo(idCardNo);
          }
          return check18IdCardNo(idCardNo);
        };
        return checkIdCardNo(str);
      },
      "zh-HK": function zhHK(str) {
        str = str.trim();
        var regexHKID = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/;
        var regexIsDigit = /^[0-9]$/;
        str = str.toUpperCase();
        if (!regexHKID.test(str)) return false;
        str = str.replace(/\[|\]|\(|\)/g, "");
        if (str.length === 8) str = "3".concat(str);
        var checkSumVal = 0;
        for (var i = 0; i <= 7; i++) {
          var convertedChar = void 0;
          if (!regexIsDigit.test(str[i])) convertedChar = (str[i].charCodeAt(0) - 55) % 11;
          else convertedChar = str[i];
          checkSumVal += convertedChar * (9 - i);
        }
        checkSumVal %= 11;
        var checkSumConverted;
        if (checkSumVal === 0) checkSumConverted = "0";
        else if (checkSumVal === 1) checkSumConverted = "A";
        else checkSumConverted = String(11 - checkSumVal);
        if (checkSumConverted === str[str.length - 1]) return true;
        return false;
      },
      "zh-TW": function zhTW(str) {
        var ALPHABET_CODES = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        };
        var sanitized = str.trim().toUpperCase();
        if (!/^[A-Z][0-9]{9}$/.test(sanitized)) return false;
        return Array.from(sanitized).reduce(function(sum, number, index) {
          if (index === 0) {
            var code = ALPHABET_CODES[number];
            return code % 10 * 9 + Math.floor(code / 10);
          }
          if (index === 9) {
            return (10 - sum % 10 - Number(number)) % 10 === 0;
          }
          return sum + Number(number) * (9 - index);
        }, 0);
      },
      PK: function PK(str) {
        var CNIC = /^[1-7][0-9]{4}-[0-9]{7}-[1-9]$/;
        var sanitized = str.trim();
        return CNIC.test(sanitized);
      }
    };
    function isIdentityCard2(str, locale) {
      (0, _assertString.default)(str);
      if (locale in validators2) {
        return validators2[locale](str);
      } else if (locale === "any") {
        for (var key in validators2) {
          if (validators2.hasOwnProperty(key)) {
            var validator2 = validators2[key];
            if (validator2(str)) {
              return true;
            }
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isIdentityCard, isIdentityCard.exports);
  return isIdentityCard.exports;
}
var isEAN = { exports: {} };
var hasRequiredIsEAN;
function requireIsEAN() {
  if (hasRequiredIsEAN) return isEAN.exports;
  hasRequiredIsEAN = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isEAN2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var LENGTH_EAN_8 = 8;
    var LENGTH_EAN_14 = 14;
    var validEanRegex = /^(\d{8}|\d{13}|\d{14})$/;
    function getPositionWeightThroughLengthAndIndex(length, index) {
      if (length === LENGTH_EAN_8 || length === LENGTH_EAN_14) {
        return index % 2 === 0 ? 3 : 1;
      }
      return index % 2 === 0 ? 1 : 3;
    }
    function calculateCheckDigit(ean) {
      var checksum = ean.slice(0, -1).split("").map(function(char, index) {
        return Number(char) * getPositionWeightThroughLengthAndIndex(ean.length, index);
      }).reduce(function(acc, partialSum) {
        return acc + partialSum;
      }, 0);
      var remainder = 10 - checksum % 10;
      return remainder < 10 ? remainder : 0;
    }
    function isEAN2(str) {
      (0, _assertString.default)(str);
      var actualCheckDigit = Number(str.slice(-1));
      return validEanRegex.test(str) && actualCheckDigit === calculateCheckDigit(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isEAN, isEAN.exports);
  return isEAN.exports;
}
var isISIN = { exports: {} };
var hasRequiredIsISIN;
function requireIsISIN() {
  if (hasRequiredIsISIN) return isISIN.exports;
  hasRequiredIsISIN = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISIN2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function isISIN2(str) {
      (0, _assertString.default)(str);
      if (!isin.test(str)) {
        return false;
      }
      var double = true;
      var sum = 0;
      for (var i = str.length - 2; i >= 0; i--) {
        if (str[i] >= "A" && str[i] <= "Z") {
          var value = str[i].charCodeAt(0) - 55;
          var lo = value % 10;
          var hi = Math.trunc(value / 10);
          for (var _i = 0, _arr = [lo, hi]; _i < _arr.length; _i++) {
            var digit = _arr[_i];
            if (double) {
              if (digit >= 5) {
                sum += 1 + (digit - 5) * 2;
              } else {
                sum += digit * 2;
              }
            } else {
              sum += digit;
            }
            double = !double;
          }
        } else {
          var _digit = str[i].charCodeAt(0) - "0".charCodeAt(0);
          if (double) {
            if (_digit >= 5) {
              sum += 1 + (_digit - 5) * 2;
            } else {
              sum += _digit * 2;
            }
          } else {
            sum += _digit;
          }
          double = !double;
        }
      }
      var check = Math.trunc((sum + 9) / 10) * 10 - sum;
      return +str[str.length - 1] === check;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISIN, isISIN.exports);
  return isISIN.exports;
}
var isISBN = { exports: {} };
var hasRequiredIsISBN;
function requireIsISBN() {
  if (hasRequiredIsISBN) return isISBN.exports;
  hasRequiredIsISBN = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISBN2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var possibleIsbn10 = /^(?:[0-9]{9}X|[0-9]{10})$/;
    var possibleIsbn13 = /^(?:[0-9]{13})$/;
    var factor = [1, 3];
    function isISBN2(isbn, options) {
      (0, _assertString.default)(isbn);
      var version = String((options === null || options === void 0 ? void 0 : options.version) || options);
      if (!(options !== null && options !== void 0 && options.version || options)) {
        return isISBN2(isbn, {
          version: 10
        }) || isISBN2(isbn, {
          version: 13
        });
      }
      var sanitizedIsbn = isbn.replace(/[\s-]+/g, "");
      var checksum = 0;
      if (version === "10") {
        if (!possibleIsbn10.test(sanitizedIsbn)) {
          return false;
        }
        for (var i = 0; i < version - 1; i++) {
          checksum += (i + 1) * sanitizedIsbn.charAt(i);
        }
        if (sanitizedIsbn.charAt(9) === "X") {
          checksum += 10 * 10;
        } else {
          checksum += 10 * sanitizedIsbn.charAt(9);
        }
        if (checksum % 11 === 0) {
          return true;
        }
      } else if (version === "13") {
        if (!possibleIsbn13.test(sanitizedIsbn)) {
          return false;
        }
        for (var _i = 0; _i < 12; _i++) {
          checksum += factor[_i % 2] * sanitizedIsbn.charAt(_i);
        }
        if (sanitizedIsbn.charAt(12) - (10 - checksum % 10) % 10 === 0) {
          return true;
        }
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISBN, isISBN.exports);
  return isISBN.exports;
}
var isISSN = { exports: {} };
var hasRequiredIsISSN;
function requireIsISSN() {
  if (hasRequiredIsISSN) return isISSN.exports;
  hasRequiredIsISSN = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISSN2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var issn = "^\\d{4}-?\\d{3}[\\dX]$";
    function isISSN2(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(str);
      var testIssn = issn;
      testIssn = options.require_hyphen ? testIssn.replace("?", "") : testIssn;
      testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, "i");
      if (!testIssn.test(str)) {
        return false;
      }
      var digits = str.replace("-", "").toUpperCase();
      var checksum = 0;
      for (var i = 0; i < digits.length; i++) {
        var digit = digits[i];
        checksum += (digit === "X" ? 10 : +digit) * (8 - i);
      }
      return checksum % 11 === 0;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISSN, isISSN.exports);
  return isISSN.exports;
}
var isTaxID = { exports: {} };
var algorithms = {};
var hasRequiredAlgorithms;
function requireAlgorithms() {
  if (hasRequiredAlgorithms) return algorithms;
  hasRequiredAlgorithms = 1;
  Object.defineProperty(algorithms, "__esModule", {
    value: true
  });
  algorithms.iso7064Check = iso7064Check;
  algorithms.luhnCheck = luhnCheck;
  algorithms.reverseMultiplyAndSum = reverseMultiplyAndSum;
  algorithms.verhoeffCheck = verhoeffCheck;
  function iso7064Check(str) {
    var checkvalue = 10;
    for (var i = 0; i < str.length - 1; i++) {
      checkvalue = (parseInt(str[i], 10) + checkvalue) % 10 === 0 ? 10 * 2 % 11 : (parseInt(str[i], 10) + checkvalue) % 10 * 2 % 11;
    }
    checkvalue = checkvalue === 1 ? 0 : 11 - checkvalue;
    return checkvalue === parseInt(str[10], 10);
  }
  function luhnCheck(str) {
    var checksum = 0;
    var second = false;
    for (var i = str.length - 1; i >= 0; i--) {
      if (second) {
        var product = parseInt(str[i], 10) * 2;
        if (product > 9) {
          checksum += product.toString().split("").map(function(a) {
            return parseInt(a, 10);
          }).reduce(function(a, b) {
            return a + b;
          }, 0);
        } else {
          checksum += product;
        }
      } else {
        checksum += parseInt(str[i], 10);
      }
      second = !second;
    }
    return checksum % 10 === 0;
  }
  function reverseMultiplyAndSum(digits, base) {
    var total = 0;
    for (var i = 0; i < digits.length; i++) {
      total += digits[i] * (base - i);
    }
    return total;
  }
  function verhoeffCheck(str) {
    var d_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]];
    var p_table = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]];
    var str_copy = str.split("").reverse().join("");
    var checksum = 0;
    for (var i = 0; i < str_copy.length; i++) {
      checksum = d_table[checksum][p_table[i % 8][parseInt(str_copy[i], 10)]];
    }
    return checksum === 0;
  }
  return algorithms;
}
var hasRequiredIsTaxID;
function requireIsTaxID() {
  if (hasRequiredIsTaxID) return isTaxID.exports;
  hasRequiredIsTaxID = 1;
  (function(module, exports$1) {
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isTaxID2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var algorithms2 = _interopRequireWildcard(/* @__PURE__ */ requireAlgorithms());
    var _isDate = _interopRequireDefault(/* @__PURE__ */ requireIsDate());
    function _interopRequireWildcard(e, t) {
      if ("function" == typeof WeakMap) var r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
      return (_interopRequireWildcard = function _interopRequireWildcard2(e2, t2) {
        if (!t2 && e2 && e2.__esModule) return e2;
        var o, i, f = { __proto__: null, default: e2 };
        if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return f;
        if (o = t2 ? n : r) {
          if (o.has(e2)) return o.get(e2);
          o.set(e2, f);
        }
        for (var _t in e2) "default" !== _t && {}.hasOwnProperty.call(e2, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e2, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e2[_t]);
        return f;
      })(e, t);
    }
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function bgBgCheck(tin) {
      var century_year = tin.slice(0, 2);
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 40) {
        month -= 40;
        century_year = "20".concat(century_year);
      } else if (month > 20) {
        month -= 20;
        century_year = "18".concat(century_year);
      } else {
        century_year = "19".concat(century_year);
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(century_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var multip_lookup = [2, 4, 8, 5, 10, 9, 7, 3, 6];
      var checksum = 0;
      for (var i = 0; i < multip_lookup.length; i++) {
        checksum += digits[i] * multip_lookup[i];
      }
      checksum = checksum % 11 === 10 ? 0 : checksum % 11;
      return checksum === digits[9];
    }
    function isCanadianSIN(input) {
      var digitsArray = input.split("");
      var even = digitsArray.filter(function(_, idx) {
        return idx % 2;
      }).map(function(i) {
        return Number(i) * 2;
      }).join("").split("");
      var total = digitsArray.filter(function(_, idx) {
        return !(idx % 2);
      }).concat(even).map(function(i) {
        return Number(i);
      }).reduce(function(acc, cur) {
        return acc + cur;
      });
      return total % 10 === 0;
    }
    function csCzCheck(tin) {
      tin = tin.replace(/\W/, "");
      var full_year = parseInt(tin.slice(0, 2), 10);
      if (tin.length === 10) {
        if (full_year < 54) {
          full_year = "20".concat(full_year);
        } else {
          full_year = "19".concat(full_year);
        }
      } else {
        if (tin.slice(6) === "000") {
          return false;
        }
        if (full_year < 54) {
          full_year = "19".concat(full_year);
        } else {
          return false;
        }
      }
      if (full_year.length === 3) {
        full_year = [full_year.slice(0, 2), "0", full_year.slice(2)].join("");
      }
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 50) {
        month -= 50;
      }
      if (month > 20) {
        if (parseInt(full_year, 10) < 2004) {
          return false;
        }
        month -= 20;
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      if (tin.length === 10) {
        if (parseInt(tin, 10) % 11 !== 0) {
          var checkdigit = parseInt(tin.slice(0, 9), 10) % 11;
          if (parseInt(full_year, 10) < 1986 && checkdigit === 10) {
            if (parseInt(tin.slice(9), 10) !== 0) {
              return false;
            }
          } else {
            return false;
          }
        }
      }
      return true;
    }
    function deAtCheck(tin) {
      return algorithms2.luhnCheck(tin);
    }
    function deDeCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var occurrences = [];
      for (var i = 0; i < digits.length - 1; i++) {
        occurrences.push("");
        for (var j = 0; j < digits.length - 1; j++) {
          if (digits[i] === digits[j]) {
            occurrences[i] += j;
          }
        }
      }
      occurrences = occurrences.filter(function(a) {
        return a.length > 1;
      });
      if (occurrences.length !== 2 && occurrences.length !== 3) {
        return false;
      }
      if (occurrences[0].length === 3) {
        var trip_locations = occurrences[0].split("").map(function(a) {
          return parseInt(a, 10);
        });
        var recurrent = 0;
        for (var _i = 0; _i < trip_locations.length - 1; _i++) {
          if (trip_locations[_i] + 1 === trip_locations[_i + 1]) {
            recurrent += 1;
          }
        }
        if (recurrent === 2) {
          return false;
        }
      }
      return algorithms2.iso7064Check(tin);
    }
    function dkDkCheck(tin) {
      tin = tin.replace(/\W/, "");
      var year = parseInt(tin.slice(4, 6), 10);
      var century_digit = tin.slice(6, 7);
      switch (century_digit) {
        case "0":
        case "1":
        case "2":
        case "3":
          year = "19".concat(year);
          break;
        case "4":
        case "9":
          if (year < 37) {
            year = "20".concat(year);
          } else {
            year = "19".concat(year);
          }
          break;
        default:
          if (year < 37) {
            year = "20".concat(year);
          } else if (year > 58) {
            year = "18".concat(year);
          } else {
            return false;
          }
          break;
      }
      if (year.length === 3) {
        year = [year.slice(0, 2), "0", year.slice(2)].join("");
      }
      var date = "".concat(year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      var weight = 4;
      for (var i = 0; i < 9; i++) {
        checksum += digits[i] * weight;
        weight -= 1;
        if (weight === 1) {
          weight = 7;
        }
      }
      checksum %= 11;
      if (checksum === 1) {
        return false;
      }
      return checksum === 0 ? digits[9] === 0 : digits[9] === 11 - checksum;
    }
    function elCyCheck(tin) {
      var digits = tin.slice(0, 8).split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      for (var i = 1; i < digits.length; i += 2) {
        checksum += digits[i];
      }
      for (var _i2 = 0; _i2 < digits.length; _i2 += 2) {
        if (digits[_i2] < 2) {
          checksum += 1 - digits[_i2];
        } else {
          checksum += 2 * (digits[_i2] - 2) + 5;
          if (digits[_i2] > 4) {
            checksum += 2;
          }
        }
      }
      return String.fromCharCode(checksum % 26 + 65) === tin.charAt(8);
    }
    function elGrCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      for (var i = 0; i < 8; i++) {
        checksum += digits[i] * Math.pow(2, 8 - i);
      }
      return checksum % 11 % 10 === digits[8];
    }
    function enIeCheck(tin) {
      var checksum = algorithms2.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
      }), 8);
      if (tin.length === 9 && tin[8] !== "W") {
        checksum += (tin[8].charCodeAt(0) - 64) * 9;
      }
      checksum %= 23;
      if (checksum === 0) {
        return tin[7].toUpperCase() === "W";
      }
      return tin[7].toUpperCase() === String.fromCharCode(64 + checksum);
    }
    var enUsCampusPrefix = {
      andover: ["10", "12"],
      atlanta: ["60", "67"],
      austin: ["50", "53"],
      brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
      cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
      fresno: ["15", "24"],
      internet: ["20", "26", "27", "45", "46", "47"],
      kansas: ["40", "44"],
      memphis: ["94", "95"],
      ogden: ["80", "90"],
      philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
      sba: ["31"]
    };
    function enUsGetPrefixes() {
      var prefixes = [];
      for (var location in enUsCampusPrefix) {
        if (enUsCampusPrefix.hasOwnProperty(location)) {
          prefixes.push.apply(prefixes, _toConsumableArray(enUsCampusPrefix[location]));
        }
      }
      return prefixes;
    }
    function enUsCheck(tin) {
      return enUsGetPrefixes().indexOf(tin.slice(0, 2)) !== -1;
    }
    function esArCheck(tin) {
      var accum = 0;
      var digits = tin.split("");
      var digit = parseInt(digits.pop(), 10);
      for (var i = 0; i < digits.length; i++) {
        accum += digits[9 - i] * (2 + i % 6);
      }
      var verif = 11 - accum % 11;
      if (verif === 11) {
        verif = 0;
      } else if (verif === 10) {
        verif = 9;
      }
      return digit === verif;
    }
    function esEsCheck(tin) {
      var chars = tin.toUpperCase().split("");
      if (isNaN(parseInt(chars[0], 10)) && chars.length > 1) {
        var lead_replace = 0;
        switch (chars[0]) {
          case "Y":
            lead_replace = 1;
            break;
          case "Z":
            lead_replace = 2;
            break;
        }
        chars.splice(0, 1, lead_replace);
      } else {
        while (chars.length < 9) {
          chars.unshift(0);
        }
      }
      var lookup = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
      chars = chars.join("");
      var checksum = parseInt(chars.slice(0, 8), 10) % 23;
      return chars[8] === lookup[checksum];
    }
    function etEeCheck(tin) {
      var full_year = tin.slice(1, 3);
      var century_digit = tin.slice(0, 1);
      switch (century_digit) {
        case "1":
        case "2":
          full_year = "18".concat(full_year);
          break;
        case "3":
        case "4":
          full_year = "19".concat(full_year);
          break;
        default:
          full_year = "20".concat(full_year);
          break;
      }
      var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 0;
      var weight = 1;
      for (var i = 0; i < 10; i++) {
        checksum += digits[i] * weight;
        weight += 1;
        if (weight === 10) {
          weight = 1;
        }
      }
      if (checksum % 11 === 10) {
        checksum = 0;
        weight = 3;
        for (var _i3 = 0; _i3 < 10; _i3++) {
          checksum += digits[_i3] * weight;
          weight += 1;
          if (weight === 10) {
            weight = 1;
          }
        }
        if (checksum % 11 === 10) {
          return digits[10] === 0;
        }
      }
      return checksum % 11 === digits[10];
    }
    function fiFiCheck(tin) {
      var full_year = tin.slice(4, 6);
      var century_symbol = tin.slice(6, 7);
      switch (century_symbol) {
        case "+":
          full_year = "18".concat(full_year);
          break;
        case "-":
          full_year = "19".concat(full_year);
          break;
        default:
          full_year = "20".concat(full_year);
          break;
      }
      var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(tin.slice(0, 2));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var checksum = parseInt(tin.slice(0, 6) + tin.slice(7, 10), 10) % 31;
      if (checksum < 10) {
        return checksum === parseInt(tin.slice(10), 10);
      }
      checksum -= 10;
      var letters_lookup = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
      return letters_lookup[checksum] === tin.slice(10);
    }
    function frBeCheck(tin) {
      if (tin.slice(2, 4) !== "00" || tin.slice(4, 6) !== "00") {
        var date = "".concat(tin.slice(0, 2), "/").concat(tin.slice(2, 4), "/").concat(tin.slice(4, 6));
        if (!(0, _isDate.default)(date, "YY/MM/DD")) {
          return false;
        }
      }
      var checksum = 97 - parseInt(tin.slice(0, 9), 10) % 97;
      var checkdigits = parseInt(tin.slice(9, 11), 10);
      if (checksum !== checkdigits) {
        checksum = 97 - parseInt("2".concat(tin.slice(0, 9)), 10) % 97;
        if (checksum !== checkdigits) {
          return false;
        }
      }
      return true;
    }
    function frFrCheck(tin) {
      tin = tin.replace(/\s/g, "");
      var checksum = parseInt(tin.slice(0, 10), 10) % 511;
      var checkdigits = parseInt(tin.slice(10, 13), 10);
      return checksum === checkdigits;
    }
    function frLuCheck(tin) {
      var date = "".concat(tin.slice(0, 4), "/").concat(tin.slice(4, 6), "/").concat(tin.slice(6, 8));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      if (!algorithms2.luhnCheck(tin.slice(0, 12))) {
        return false;
      }
      return algorithms2.verhoeffCheck("".concat(tin.slice(0, 11)).concat(tin[12]));
    }
    function hrHrCheck(tin) {
      return algorithms2.iso7064Check(tin);
    }
    function huHuCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var checksum = 8;
      for (var i = 1; i < 9; i++) {
        checksum += digits[i] * (i + 1);
      }
      return checksum % 11 === digits[9];
    }
    function itItNameCheck(name) {
      var vowelflag = false;
      var xflag = false;
      for (var i = 0; i < 3; i++) {
        if (!vowelflag && /[AEIOU]/.test(name[i])) {
          vowelflag = true;
        } else if (!xflag && vowelflag && name[i] === "X") {
          xflag = true;
        } else if (i > 0) {
          if (vowelflag && !xflag) {
            if (!/[AEIOU]/.test(name[i])) {
              return false;
            }
          }
          if (xflag) {
            if (!/X/.test(name[i])) {
              return false;
            }
          }
        }
      }
      return true;
    }
    function itItCheck(tin) {
      var chars = tin.toUpperCase().split("");
      if (!itItNameCheck(chars.slice(0, 3))) {
        return false;
      }
      if (!itItNameCheck(chars.slice(3, 6))) {
        return false;
      }
      var number_locations = [6, 7, 9, 10, 12, 13, 14];
      var number_replace = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      };
      for (var _i4 = 0, _number_locations = number_locations; _i4 < _number_locations.length; _i4++) {
        var i = _number_locations[_i4];
        if (chars[i] in number_replace) {
          chars.splice(i, 1, number_replace[chars[i]]);
        }
      }
      var month_replace = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      };
      var month = month_replace[chars[8]];
      var day = parseInt(chars[9] + chars[10], 10);
      if (day > 40) {
        day -= 40;
      }
      if (day < 10) {
        day = "0".concat(day);
      }
      var date = "".concat(chars[6]).concat(chars[7], "/").concat(month, "/").concat(day);
      if (!(0, _isDate.default)(date, "YY/MM/DD")) {
        return false;
      }
      var checksum = 0;
      for (var _i5 = 1; _i5 < chars.length - 1; _i5 += 2) {
        var char_to_int = parseInt(chars[_i5], 10);
        if (isNaN(char_to_int)) {
          char_to_int = chars[_i5].charCodeAt(0) - 65;
        }
        checksum += char_to_int;
      }
      var odd_convert = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      };
      for (var _i6 = 0; _i6 < chars.length - 1; _i6 += 2) {
        var _char_to_int = 0;
        if (chars[_i6] in odd_convert) {
          _char_to_int = odd_convert[chars[_i6]];
        } else {
          var multiplier = parseInt(chars[_i6], 10);
          _char_to_int = 2 * multiplier + 1;
          if (multiplier > 4) {
            _char_to_int += 2;
          }
        }
        checksum += _char_to_int;
      }
      if (String.fromCharCode(65 + checksum % 26) !== chars[15]) {
        return false;
      }
      return true;
    }
    function lvLvCheck(tin) {
      tin = tin.replace(/\W/, "");
      var day = tin.slice(0, 2);
      if (day !== "32") {
        var month = tin.slice(2, 4);
        if (month !== "00") {
          var full_year = tin.slice(4, 6);
          switch (tin[6]) {
            case "0":
              full_year = "18".concat(full_year);
              break;
            case "1":
              full_year = "19".concat(full_year);
              break;
            default:
              full_year = "20".concat(full_year);
              break;
          }
          var date = "".concat(full_year, "/").concat(tin.slice(2, 4), "/").concat(day);
          if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
            return false;
          }
        }
        var checksum = 1101;
        var multip_lookup = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        for (var i = 0; i < tin.length - 1; i++) {
          checksum -= parseInt(tin[i], 10) * multip_lookup[i];
        }
        return parseInt(tin[10], 10) === checksum % 11;
      }
      return true;
    }
    function mtMtCheck(tin) {
      if (tin.length !== 9) {
        var chars = tin.toUpperCase().split("");
        while (chars.length < 8) {
          chars.unshift(0);
        }
        switch (tin[7]) {
          case "A":
          case "P":
            if (parseInt(chars[6], 10) === 0) {
              return false;
            }
            break;
          default: {
            var first_part = parseInt(chars.join("").slice(0, 5), 10);
            if (first_part > 32e3) {
              return false;
            }
            var second_part = parseInt(chars.join("").slice(5, 7), 10);
            if (first_part === second_part) {
              return false;
            }
          }
        }
      }
      return true;
    }
    function nlNlCheck(tin) {
      return algorithms2.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
      }), 9) % 11 === parseInt(tin[8], 10);
    }
    function plPlCheck(tin) {
      if (tin.length === 10) {
        var lookup = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        var _checksum = 0;
        for (var i = 0; i < lookup.length; i++) {
          _checksum += parseInt(tin[i], 10) * lookup[i];
        }
        _checksum %= 11;
        if (_checksum === 10) {
          return false;
        }
        return _checksum === parseInt(tin[9], 10);
      }
      var full_year = tin.slice(0, 2);
      var month = parseInt(tin.slice(2, 4), 10);
      if (month > 80) {
        full_year = "18".concat(full_year);
        month -= 80;
      } else if (month > 60) {
        full_year = "22".concat(full_year);
        month -= 60;
      } else if (month > 40) {
        full_year = "21".concat(full_year);
        month -= 40;
      } else if (month > 20) {
        full_year = "20".concat(full_year);
        month -= 20;
      } else {
        full_year = "19".concat(full_year);
      }
      if (month < 10) {
        month = "0".concat(month);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
      if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      var checksum = 0;
      var multiplier = 1;
      for (var _i7 = 0; _i7 < tin.length - 1; _i7++) {
        checksum += parseInt(tin[_i7], 10) * multiplier % 10;
        multiplier += 2;
        if (multiplier > 10) {
          multiplier = 1;
        } else if (multiplier === 5) {
          multiplier += 2;
        }
      }
      checksum = 10 - checksum % 10;
      return checksum === parseInt(tin[10], 10);
    }
    function ptBrCheck(tin) {
      if (tin.length === 11) {
        var _sum;
        var remainder;
        _sum = 0;
        if (
          // Reject known invalid CPFs
          tin === "11111111111" || tin === "22222222222" || tin === "33333333333" || tin === "44444444444" || tin === "55555555555" || tin === "66666666666" || tin === "77777777777" || tin === "88888888888" || tin === "99999999999" || tin === "00000000000"
        ) return false;
        for (var i = 1; i <= 9; i++) _sum += parseInt(tin.substring(i - 1, i), 10) * (11 - i);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(9, 10), 10)) return false;
        _sum = 0;
        for (var _i8 = 1; _i8 <= 10; _i8++) _sum += parseInt(tin.substring(_i8 - 1, _i8), 10) * (12 - _i8);
        remainder = _sum * 10 % 11;
        if (remainder === 10) remainder = 0;
        if (remainder !== parseInt(tin.substring(10, 11), 10)) return false;
        return true;
      }
      if (
        // Reject know invalid CNPJs
        tin === "00000000000000" || tin === "11111111111111" || tin === "22222222222222" || tin === "33333333333333" || tin === "44444444444444" || tin === "55555555555555" || tin === "66666666666666" || tin === "77777777777777" || tin === "88888888888888" || tin === "99999999999999"
      ) {
        return false;
      }
      var length = tin.length - 2;
      var identifiers = tin.substring(0, length);
      var verificators = tin.substring(length);
      var sum = 0;
      var pos = length - 7;
      for (var _i9 = length; _i9 >= 1; _i9--) {
        sum += identifiers.charAt(length - _i9) * pos;
        pos -= 1;
        if (pos < 2) {
          pos = 9;
        }
      }
      var result = sum % 11 < 2 ? 0 : 11 - sum % 11;
      if (result !== parseInt(verificators.charAt(0), 10)) {
        return false;
      }
      length += 1;
      identifiers = tin.substring(0, length);
      sum = 0;
      pos = length - 7;
      for (var _i0 = length; _i0 >= 1; _i0--) {
        sum += identifiers.charAt(length - _i0) * pos;
        pos -= 1;
        if (pos < 2) {
          pos = 9;
        }
      }
      result = sum % 11 < 2 ? 0 : 11 - sum % 11;
      if (result !== parseInt(verificators.charAt(1), 10)) {
        return false;
      }
      return true;
    }
    function ptPtCheck(tin) {
      var checksum = 11 - algorithms2.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
        return parseInt(a, 10);
      }), 9) % 11;
      if (checksum > 9) {
        return parseInt(tin[8], 10) === 0;
      }
      return checksum === parseInt(tin[8], 10);
    }
    function roRoCheck(tin) {
      if (tin.slice(0, 4) !== "9000") {
        var full_year = tin.slice(1, 3);
        switch (tin[0]) {
          case "1":
          case "2":
            full_year = "19".concat(full_year);
            break;
          case "3":
          case "4":
            full_year = "18".concat(full_year);
            break;
          case "5":
          case "6":
            full_year = "20".concat(full_year);
            break;
        }
        var date = "".concat(full_year, "/").concat(tin.slice(3, 5), "/").concat(tin.slice(5, 7));
        if (date.length === 8) {
          if (!(0, _isDate.default)(date, "YY/MM/DD")) {
            return false;
          }
        } else if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
          return false;
        }
        var digits = tin.split("").map(function(a) {
          return parseInt(a, 10);
        });
        var multipliers = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
        var checksum = 0;
        for (var i = 0; i < multipliers.length; i++) {
          checksum += digits[i] * multipliers[i];
        }
        if (checksum % 11 === 10) {
          return digits[12] === 1;
        }
        return digits[12] === checksum % 11;
      }
      return true;
    }
    function skSkCheck(tin) {
      if (tin.length === 9) {
        tin = tin.replace(/\W/, "");
        if (tin.slice(6) === "000") {
          return false;
        }
        var full_year = parseInt(tin.slice(0, 2), 10);
        if (full_year > 53) {
          return false;
        }
        if (full_year < 10) {
          full_year = "190".concat(full_year);
        } else {
          full_year = "19".concat(full_year);
        }
        var month = parseInt(tin.slice(2, 4), 10);
        if (month > 50) {
          month -= 50;
        }
        if (month < 10) {
          month = "0".concat(month);
        }
        var date = "".concat(full_year, "/").concat(month, "/").concat(tin.slice(4, 6));
        if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
          return false;
        }
      }
      return true;
    }
    function slSiCheck(tin) {
      var checksum = 11 - algorithms2.reverseMultiplyAndSum(tin.split("").slice(0, 7).map(function(a) {
        return parseInt(a, 10);
      }), 8) % 11;
      if (checksum === 10) {
        return parseInt(tin[7], 10) === 0;
      }
      return checksum === parseInt(tin[7], 10);
    }
    function svSeCheck(tin) {
      var tin_copy = tin.slice(0);
      if (tin.length > 11) {
        tin_copy = tin_copy.slice(2);
      }
      var full_year = "";
      var month = tin_copy.slice(2, 4);
      var day = parseInt(tin_copy.slice(4, 6), 10);
      if (tin.length > 11) {
        full_year = tin.slice(0, 4);
      } else {
        full_year = tin.slice(0, 2);
        if (tin.length === 11 && day < 60) {
          var current_year = (/* @__PURE__ */ new Date()).getFullYear().toString();
          var current_century = parseInt(current_year.slice(0, 2), 10);
          current_year = parseInt(current_year, 10);
          if (tin[6] === "-") {
            if (parseInt("".concat(current_century).concat(full_year), 10) > current_year) {
              full_year = "".concat(current_century - 1).concat(full_year);
            } else {
              full_year = "".concat(current_century).concat(full_year);
            }
          } else {
            full_year = "".concat(current_century - 1).concat(full_year);
            if (current_year - parseInt(full_year, 10) < 100) {
              return false;
            }
          }
        }
      }
      if (day > 60) {
        day -= 60;
      }
      if (day < 10) {
        day = "0".concat(day);
      }
      var date = "".concat(full_year, "/").concat(month, "/").concat(day);
      if (date.length === 8) {
        if (!(0, _isDate.default)(date, "YY/MM/DD")) {
          return false;
        }
      } else if (!(0, _isDate.default)(date, "YYYY/MM/DD")) {
        return false;
      }
      return algorithms2.luhnCheck(tin.replace(/\W/, ""));
    }
    function ukUaCheck(tin) {
      var digits = tin.split("").map(function(a) {
        return parseInt(a, 10);
      });
      var multipliers = [-1, 5, 7, 9, 4, 6, 10, 5, 7];
      var checksum = 0;
      for (var i = 0; i < multipliers.length; i++) {
        checksum += digits[i] * multipliers[i];
      }
      return checksum % 11 === 10 ? digits[9] === 0 : digits[9] === checksum % 11;
    }
    var taxIdFormat = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    taxIdFormat["lb-LU"] = taxIdFormat["fr-LU"];
    taxIdFormat["lt-LT"] = taxIdFormat["et-EE"];
    taxIdFormat["nl-BE"] = taxIdFormat["fr-BE"];
    taxIdFormat["fr-CA"] = taxIdFormat["en-CA"];
    var taxIdCheck = {
      "bg-BG": bgBgCheck,
      "cs-CZ": csCzCheck,
      "de-AT": deAtCheck,
      "de-DE": deDeCheck,
      "dk-DK": dkDkCheck,
      "el-CY": elCyCheck,
      "el-GR": elGrCheck,
      "en-CA": isCanadianSIN,
      "en-IE": enIeCheck,
      "en-US": enUsCheck,
      "es-AR": esArCheck,
      "es-ES": esEsCheck,
      "et-EE": etEeCheck,
      "fi-FI": fiFiCheck,
      "fr-BE": frBeCheck,
      "fr-FR": frFrCheck,
      "fr-LU": frLuCheck,
      "hr-HR": hrHrCheck,
      "hu-HU": huHuCheck,
      "it-IT": itItCheck,
      "lv-LV": lvLvCheck,
      "mt-MT": mtMtCheck,
      "nl-NL": nlNlCheck,
      "pl-PL": plPlCheck,
      "pt-BR": ptBrCheck,
      "pt-PT": ptPtCheck,
      "ro-RO": roRoCheck,
      "sk-SK": skSkCheck,
      "sl-SI": slSiCheck,
      "sv-SE": svSeCheck,
      "uk-UA": ukUaCheck
    };
    taxIdCheck["lb-LU"] = taxIdCheck["fr-LU"];
    taxIdCheck["lt-LT"] = taxIdCheck["et-EE"];
    taxIdCheck["nl-BE"] = taxIdCheck["fr-BE"];
    taxIdCheck["fr-CA"] = taxIdCheck["en-CA"];
    var allsymbols = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g;
    var sanitizeRegexes = {
      "de-AT": allsymbols,
      "de-DE": /[\/\\]/g,
      "fr-BE": allsymbols
    };
    sanitizeRegexes["nl-BE"] = sanitizeRegexes["fr-BE"];
    function isTaxID2(str) {
      var locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, _assertString.default)(str);
      var strcopy = str.slice(0);
      if (locale in taxIdFormat) {
        if (locale in sanitizeRegexes) {
          strcopy = strcopy.replace(sanitizeRegexes[locale], "");
        }
        if (!taxIdFormat[locale].test(strcopy)) {
          return false;
        }
        if (locale in taxIdCheck) {
          return taxIdCheck[locale](strcopy);
        }
        return true;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isTaxID, isTaxID.exports);
  return isTaxID.exports;
}
var isMobilePhone = {};
var hasRequiredIsMobilePhone;
function requireIsMobilePhone() {
  if (hasRequiredIsMobilePhone) return isMobilePhone;
  hasRequiredIsMobilePhone = 1;
  Object.defineProperty(isMobilePhone, "__esModule", {
    value: true
  });
  isMobilePhone.default = isMobilePhone$1;
  isMobilePhone.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var phones = {
    "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?([79][1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "ar-QA": /^(\+?974|0)?([3567]\d{7})$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|7|6|5|4)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7[1-9]\d{8}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|53|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?0[79][567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-GT": /^(\+?502)?[2|6|7]\d{7}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+996\s?)?(22[0-9]|50[0-9]|55[0-9]|70[0-9]|75[0-9]|77[0-9]|880|990|995|996|997|998)\s?\d{3}\s?\d{3}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+?244)?9\d{8}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[2-9]\d{7}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38)?0(50|6[36-8]|7[357]|9[1-9])\d{7}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/,
    "mk-MK": /^(\+?389|0)?((?:2[2-9]\d{6}|(?:3[1-4]|4[2-8])\d{6}|500\d{5}|5[2-9]\d{6}|7[0-9][2-9]\d{5}|8[1-9]\d{6}|800\d{5}|8009\d{4}))$/
  };
  phones["en-CA"] = phones["en-US"];
  phones["fr-CA"] = phones["en-CA"];
  phones["fr-BE"] = phones["nl-BE"];
  phones["zh-HK"] = phones["en-HK"];
  phones["zh-MO"] = phones["en-MO"];
  phones["ga-IE"] = phones["en-IE"];
  phones["fr-CH"] = phones["de-CH"];
  phones["it-CH"] = phones["fr-CH"];
  function isMobilePhone$1(str, locale, options) {
    (0, _assertString.default)(str);
    if (options && options.strictMode && !str.startsWith("+")) {
      return false;
    }
    if (Array.isArray(locale)) {
      return locale.some(function(key2) {
        if (phones.hasOwnProperty(key2)) {
          var phone2 = phones[key2];
          if (phone2.test(str)) {
            return true;
          }
        }
        return false;
      });
    } else if (locale in phones) {
      return phones[locale].test(str);
    } else if (!locale || locale === "any") {
      for (var key in phones) {
        if (phones.hasOwnProperty(key)) {
          var phone = phones[key];
          if (phone.test(str)) {
            return true;
          }
        }
      }
      return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
  }
  isMobilePhone.locales = Object.keys(phones);
  return isMobilePhone;
}
var isEthereumAddress = { exports: {} };
var hasRequiredIsEthereumAddress;
function requireIsEthereumAddress() {
  if (hasRequiredIsEthereumAddress) return isEthereumAddress.exports;
  hasRequiredIsEthereumAddress = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isEthereumAddress2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var eth = /^(0x)[0-9a-f]{40}$/i;
    function isEthereumAddress2(str) {
      (0, _assertString.default)(str);
      return eth.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isEthereumAddress, isEthereumAddress.exports);
  return isEthereumAddress.exports;
}
var isCurrency = { exports: {} };
var hasRequiredIsCurrency;
function requireIsCurrency() {
  if (hasRequiredIsCurrency) return isCurrency.exports;
  hasRequiredIsCurrency = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isCurrency2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function currencyRegex(options) {
      var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
      options.digits_after_decimal.forEach(function(digit, index) {
        if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
      });
      var symbol = "(".concat(options.symbol.replace(/\W/, function(m) {
        return "\\".concat(m);
      }), ")").concat(options.require_symbol ? "" : "?"), negative = "-?", whole_dollar_amount_without_sep = "[1-9]\\d*", whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"), valid_whole_dollar_amounts = ["0", whole_dollar_amount_without_sep, whole_dollar_amount_with_sep], whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join("|"), ")?"), decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? "" : "?");
      var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : "");
      if (options.allow_negatives && !options.parens_for_negatives) {
        if (options.negative_sign_after_digits) {
          pattern += negative;
        } else if (options.negative_sign_before_digits) {
          pattern = negative + pattern;
        }
      }
      if (options.allow_negative_sign_placeholder) {
        pattern = "( (?!\\-))?".concat(pattern);
      } else if (options.allow_space_after_symbol) {
        pattern = " ?".concat(pattern);
      } else if (options.allow_space_after_digits) {
        pattern += "( (?!$))?";
      }
      if (options.symbol_after_digits) {
        pattern += symbol;
      } else {
        pattern = symbol + pattern;
      }
      if (options.allow_negatives) {
        if (options.parens_for_negatives) {
          pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
        } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
          pattern = negative + pattern;
        }
      }
      return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
    }
    var default_currency_options = {
      symbol: "$",
      require_symbol: false,
      allow_space_after_symbol: false,
      symbol_after_digits: false,
      allow_negatives: true,
      parens_for_negatives: false,
      negative_sign_before_digits: false,
      negative_sign_after_digits: false,
      allow_negative_sign_placeholder: false,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: true,
      require_decimal: false,
      digits_after_decimal: [2],
      allow_space_after_digits: false
    };
    function isCurrency2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, default_currency_options);
      return currencyRegex(options).test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isCurrency, isCurrency.exports);
  return isCurrency.exports;
}
var isBtcAddress = { exports: {} };
var hasRequiredIsBtcAddress;
function requireIsBtcAddress() {
  if (hasRequiredIsBtcAddress) return isBtcAddress.exports;
  hasRequiredIsBtcAddress = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBtcAddress2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var bech32 = /^(bc1|tb1|bc1p|tb1p)[ac-hj-np-z02-9]{39,58}$/;
    var base58 = /^(1|2|3|m)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function isBtcAddress2(str) {
      (0, _assertString.default)(str);
      return bech32.test(str) || base58.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBtcAddress, isBtcAddress.exports);
  return isBtcAddress.exports;
}
var isISO6346 = {};
var hasRequiredIsISO6346;
function requireIsISO6346() {
  if (hasRequiredIsISO6346) return isISO6346;
  hasRequiredIsISO6346 = 1;
  Object.defineProperty(isISO6346, "__esModule", {
    value: true
  });
  isISO6346.isFreightContainerID = void 0;
  isISO6346.isISO6346 = isISO6346$1;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var isISO6346Str = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/;
  var isDigit = /^[0-9]$/;
  function isISO6346$1(str) {
    (0, _assertString.default)(str);
    str = str.toUpperCase();
    if (!isISO6346Str.test(str)) return false;
    if (str.length === 11) {
      var sum = 0;
      for (var i = 0; i < str.length - 1; i++) {
        if (!isDigit.test(str[i])) {
          var convertedCode = void 0;
          var letterCode = str.charCodeAt(i) - 55;
          if (letterCode < 11) convertedCode = letterCode;
          else if (letterCode >= 11 && letterCode <= 20) convertedCode = 12 + letterCode % 11;
          else if (letterCode >= 21 && letterCode <= 30) convertedCode = 23 + letterCode % 21;
          else convertedCode = 34 + letterCode % 31;
          sum += convertedCode * Math.pow(2, i);
        } else sum += str[i] * Math.pow(2, i);
      }
      var checkSumDigit = sum % 11;
      if (checkSumDigit === 10) checkSumDigit = 0;
      return Number(str[str.length - 1]) === checkSumDigit;
    }
    return true;
  }
  isISO6346.isFreightContainerID = isISO6346$1;
  return isISO6346;
}
var isISO6391 = { exports: {} };
var hasRequiredIsISO6391;
function requireIsISO6391() {
  if (hasRequiredIsISO6391) return isISO6391.exports;
  hasRequiredIsISO6391 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISO63912;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var isISO6391Set = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
    function isISO63912(str) {
      (0, _assertString.default)(str);
      return isISO6391Set.has(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISO6391, isISO6391.exports);
  return isISO6391.exports;
}
var isISO8601 = { exports: {} };
var hasRequiredIsISO8601;
function requireIsISO8601() {
  if (hasRequiredIsISO8601) return isISO8601.exports;
  hasRequiredIsISO8601 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISO86012;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
    var iso8601StrictSeparator = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
    var isValidDate = function isValidDate2(str) {
      var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (ordinalMatch) {
        var oYear = Number(ordinalMatch[1]);
        var oDay = Number(ordinalMatch[2]);
        if (oYear % 4 === 0 && oYear % 100 !== 0 || oYear % 400 === 0) return oDay <= 366;
        return oDay <= 365;
      }
      var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
      var year = match[1];
      var month = match[2];
      var day = match[3];
      var monthString = month ? "0".concat(month).slice(-2) : month;
      var dayString = day ? "0".concat(day).slice(-2) : day;
      var d = new Date("".concat(year, "-").concat(monthString || "01", "-").concat(dayString || "01"));
      if (month && day) {
        return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
      }
      return true;
    };
    function isISO86012(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, _assertString.default)(str);
      var check = options.strictSeparator ? iso8601StrictSeparator.test(str) : iso8601.test(str);
      if (check && options.strict) return isValidDate(str);
      return check;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISO8601, isISO8601.exports);
  return isISO8601.exports;
}
var isRFC3339 = { exports: {} };
var hasRequiredIsRFC3339;
function requireIsRFC3339() {
  if (hasRequiredIsRFC3339) return isRFC3339.exports;
  hasRequiredIsRFC3339 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isRFC33392;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var dateFullYear = /[0-9]{4}/;
    var dateMonth = /(0[1-9]|1[0-2])/;
    var dateMDay = /([12]\d|0[1-9]|3[01])/;
    var timeHour = /([01][0-9]|2[0-3])/;
    var timeMinute = /[0-5][0-9]/;
    var timeSecond = /([0-5][0-9]|60)/;
    var timeSecFrac = /(\.[0-9]+)?/;
    var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
    var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
    var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
    var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
    var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
    var rfc3339 = new RegExp("^".concat(fullDate.source, "[ tT]").concat(fullTime.source, "$"));
    function isRFC33392(str) {
      (0, _assertString.default)(str);
      return rfc3339.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isRFC3339, isRFC3339.exports);
  return isRFC3339.exports;
}
var isISO15924 = {};
var hasRequiredIsISO15924;
function requireIsISO15924() {
  if (hasRequiredIsISO15924) return isISO15924;
  hasRequiredIsISO15924 = 1;
  Object.defineProperty(isISO15924, "__esModule", {
    value: true
  });
  isISO15924.ScriptCodes = void 0;
  isISO15924.default = isISO15924$1;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var validISO15924Codes = /* @__PURE__ */ new Set(["Adlm", "Afak", "Aghb", "Ahom", "Arab", "Aran", "Armi", "Armn", "Avst", "Bali", "Bamu", "Bass", "Batk", "Beng", "Bhks", "Blis", "Bopo", "Brah", "Brai", "Bugi", "Buhd", "Cakm", "Cans", "Cari", "Cham", "Cher", "Chis", "Chrs", "Cirt", "Copt", "Cpmn", "Cprt", "Cyrl", "Cyrs", "Deva", "Diak", "Dogr", "Dsrt", "Dupl", "Egyd", "Egyh", "Egyp", "Elba", "Elym", "Ethi", "Gara", "Geok", "Geor", "Glag", "Gong", "Gonm", "Goth", "Gran", "Grek", "Gujr", "Gukh", "Guru", "Hanb", "Hang", "Hani", "Hano", "Hans", "Hant", "Hatr", "Hebr", "Hira", "Hluw", "Hmng", "Hmnp", "Hrkt", "Hung", "Inds", "Ital", "Jamo", "Java", "Jpan", "Jurc", "Kali", "Kana", "Kawi", "Khar", "Khmr", "Khoj", "Kitl", "Kits", "Knda", "Kore", "Kpel", "Krai", "Kthi", "Lana", "Laoo", "Latf", "Latg", "Latn", "Leke", "Lepc", "Limb", "Lina", "Linb", "Lisu", "Loma", "Lyci", "Lydi", "Mahj", "Maka", "Mand", "Mani", "Marc", "Maya", "Medf", "Mend", "Merc", "Mero", "Mlym", "Modi", "Mong", "Moon", "Mroo", "Mtei", "Mult", "Mymr", "Nagm", "Nand", "Narb", "Nbat", "Newa", "Nkdb", "Nkgb", "Nkoo", "Nshu", "Ogam", "Olck", "Onao", "Orkh", "Orya", "Osge", "Osma", "Ougr", "Palm", "Pauc", "Pcun", "Pelm", "Perm", "Phag", "Phli", "Phlp", "Phlv", "Phnx", "Plrd", "Piqd", "Prti", "Psin", "Qaaa", "Qaab", "Qaac", "Qaad", "Qaae", "Qaaf", "Qaag", "Qaah", "Qaai", "Qaaj", "Qaak", "Qaal", "Qaam", "Qaan", "Qaao", "Qaap", "Qaaq", "Qaar", "Qaas", "Qaat", "Qaau", "Qaav", "Qaaw", "Qaax", "Qaay", "Qaaz", "Qaba", "Qabb", "Qabc", "Qabd", "Qabe", "Qabf", "Qabg", "Qabh", "Qabi", "Qabj", "Qabk", "Qabl", "Qabm", "Qabn", "Qabo", "Qabp", "Qabq", "Qabr", "Qabs", "Qabt", "Qabu", "Qabv", "Qabw", "Qabx", "Ranj", "Rjng", "Rohg", "Roro", "Runr", "Samr", "Sara", "Sarb", "Saur", "Sgnw", "Shaw", "Shrd", "Shui", "Sidd", "Sidt", "Sind", "Sinh", "Sogd", "Sogo", "Sora", "Soyo", "Sund", "Sunu", "Sylo", "Syrc", "Syre", "Syrj", "Syrn", "Tagb", "Takr", "Tale", "Talu", "Taml", "Tang", "Tavt", "Tayo", "Telu", "Teng", "Tfng", "Tglg", "Thaa", "Thai", "Tibt", "Tirh", "Tnsa", "Todr", "Tols", "Toto", "Tutg", "Ugar", "Vaii", "Visp", "Vith", "Wara", "Wcho", "Wole", "Xpeo", "Xsux", "Yezi", "Yiii", "Zanb", "Zinh", "Zmth", "Zsye", "Zsym", "Zxxx", "Zyyy", "Zzzz"]);
  function isISO15924$1(str) {
    (0, _assertString.default)(str);
    return validISO15924Codes.has(str);
  }
  isISO15924.ScriptCodes = validISO15924Codes;
  return isISO15924;
}
var isISO31661Alpha3 = { exports: {} };
var hasRequiredIsISO31661Alpha3;
function requireIsISO31661Alpha3() {
  if (hasRequiredIsISO31661Alpha3) return isISO31661Alpha3.exports;
  hasRequiredIsISO31661Alpha3 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISO31661Alpha32;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var validISO31661Alpha3CountriesCodes = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
    function isISO31661Alpha32(str) {
      (0, _assertString.default)(str);
      return validISO31661Alpha3CountriesCodes.has(str.toUpperCase());
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISO31661Alpha3, isISO31661Alpha3.exports);
  return isISO31661Alpha3.exports;
}
var isISO31661Numeric = { exports: {} };
var hasRequiredIsISO31661Numeric;
function requireIsISO31661Numeric() {
  if (hasRequiredIsISO31661Numeric) return isISO31661Numeric.exports;
  hasRequiredIsISO31661Numeric = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isISO31661Numeric2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var validISO31661NumericCountriesCodes = /* @__PURE__ */ new Set(["004", "008", "010", "012", "016", "020", "024", "028", "031", "032", "036", "040", "044", "048", "050", "051", "052", "056", "060", "064", "068", "070", "072", "074", "076", "084", "086", "090", "092", "096", "100", "104", "108", "112", "116", "120", "124", "132", "136", "140", "144", "148", "152", "156", "158", "162", "166", "170", "174", "175", "178", "180", "184", "188", "191", "192", "196", "203", "204", "208", "212", "214", "218", "222", "226", "231", "232", "233", "234", "238", "239", "242", "246", "248", "250", "254", "258", "260", "262", "266", "268", "270", "275", "276", "288", "292", "296", "300", "304", "308", "312", "316", "320", "324", "328", "332", "334", "336", "340", "344", "348", "352", "356", "360", "364", "368", "372", "376", "380", "384", "388", "392", "398", "400", "404", "408", "410", "414", "417", "418", "422", "426", "428", "430", "434", "438", "440", "442", "446", "450", "454", "458", "462", "466", "470", "474", "478", "480", "484", "492", "496", "498", "499", "500", "504", "508", "512", "516", "520", "524", "528", "531", "533", "534", "535", "540", "548", "554", "558", "562", "566", "570", "574", "578", "580", "581", "583", "584", "585", "586", "591", "598", "600", "604", "608", "612", "616", "620", "624", "626", "630", "634", "638", "642", "643", "646", "652", "654", "659", "660", "662", "663", "666", "670", "674", "678", "682", "686", "688", "690", "694", "702", "703", "704", "705", "706", "710", "716", "724", "728", "729", "732", "740", "744", "748", "752", "756", "760", "762", "764", "768", "772", "776", "780", "784", "788", "792", "795", "796", "798", "800", "804", "807", "818", "826", "831", "832", "833", "834", "840", "850", "854", "858", "860", "862", "876", "882", "887", "894"]);
    function isISO31661Numeric2(str) {
      (0, _assertString.default)(str);
      return validISO31661NumericCountriesCodes.has(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isISO31661Numeric, isISO31661Numeric.exports);
  return isISO31661Numeric.exports;
}
var isISO4217 = {};
var hasRequiredIsISO4217;
function requireIsISO4217() {
  if (hasRequiredIsISO4217) return isISO4217;
  hasRequiredIsISO4217 = 1;
  Object.defineProperty(isISO4217, "__esModule", {
    value: true
  });
  isISO4217.CurrencyCodes = void 0;
  isISO4217.default = isISO4217$1;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var validISO4217CurrencyCodes = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VED", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
  function isISO4217$1(str) {
    (0, _assertString.default)(str);
    return validISO4217CurrencyCodes.has(str.toUpperCase());
  }
  isISO4217.CurrencyCodes = validISO4217CurrencyCodes;
  return isISO4217;
}
var isBase32 = { exports: {} };
var hasRequiredIsBase32;
function requireIsBase32() {
  if (hasRequiredIsBase32) return isBase32.exports;
  hasRequiredIsBase32 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBase322;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var base32 = /^[A-Z2-7]+=*$/;
    var crockfordBase32 = /^[A-HJKMNP-TV-Z0-9]+$/;
    var defaultBase32Options = {
      crockford: false
    };
    function isBase322(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultBase32Options);
      if (options.crockford) {
        return crockfordBase32.test(str);
      }
      var len = str.length;
      if (len % 8 === 0 && base32.test(str)) {
        return true;
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBase32, isBase32.exports);
  return isBase32.exports;
}
var isBase58 = { exports: {} };
var hasRequiredIsBase58;
function requireIsBase58() {
  if (hasRequiredIsBase58) return isBase58.exports;
  hasRequiredIsBase58 = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isBase582;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var base58Reg = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function isBase582(str) {
      (0, _assertString.default)(str);
      if (base58Reg.test(str)) {
        return true;
      }
      return false;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isBase58, isBase58.exports);
  return isBase58.exports;
}
var isDataURI = { exports: {} };
var hasRequiredIsDataURI;
function requireIsDataURI() {
  if (hasRequiredIsDataURI) return isDataURI.exports;
  hasRequiredIsDataURI = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isDataURI2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var validMediaType = /^[a-z]+\/[a-z0-9\-\+\._]+$/i;
    var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
    var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function isDataURI2(str) {
      (0, _assertString.default)(str);
      var data = str.split(",");
      if (data.length < 2) {
        return false;
      }
      var attributes = data.shift().trim().split(";");
      var schemeAndMediaType = attributes.shift();
      if (schemeAndMediaType.slice(0, 5) !== "data:") {
        return false;
      }
      var mediaType = schemeAndMediaType.slice(5);
      if (mediaType !== "" && !validMediaType.test(mediaType)) {
        return false;
      }
      for (var i = 0; i < attributes.length; i++) {
        if (!(i === attributes.length - 1 && attributes[i].toLowerCase() === "base64") && !validAttribute.test(attributes[i])) {
          return false;
        }
      }
      for (var _i = 0; _i < data.length; _i++) {
        if (!validData.test(data[_i])) {
          return false;
        }
      }
      return true;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isDataURI, isDataURI.exports);
  return isDataURI.exports;
}
var isMagnetURI = { exports: {} };
var hasRequiredIsMagnetURI;
function requireIsMagnetURI() {
  if (hasRequiredIsMagnetURI) return isMagnetURI.exports;
  hasRequiredIsMagnetURI = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMagnetURI2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var magnetURIComponent = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function isMagnetURI2(url) {
      (0, _assertString.default)(url);
      if (url.indexOf("magnet:?") !== 0) {
        return false;
      }
      return magnetURIComponent.test(url);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMagnetURI, isMagnetURI.exports);
  return isMagnetURI.exports;
}
var isMailtoURI = { exports: {} };
var trim = { exports: {} };
var rtrim = { exports: {} };
var hasRequiredRtrim;
function requireRtrim() {
  if (hasRequiredRtrim) return rtrim.exports;
  hasRequiredRtrim = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = rtrim2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function rtrim2(str, chars) {
      (0, _assertString.default)(str);
      if (chars) {
        var pattern = new RegExp("[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return str.replace(pattern, "");
      }
      var strIndex = str.length - 1;
      while (/\s/.test(str.charAt(strIndex))) {
        strIndex -= 1;
      }
      return str.slice(0, strIndex + 1);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(rtrim, rtrim.exports);
  return rtrim.exports;
}
var ltrim = { exports: {} };
var hasRequiredLtrim;
function requireLtrim() {
  if (hasRequiredLtrim) return ltrim.exports;
  hasRequiredLtrim = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = ltrim2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function ltrim2(str, chars) {
      (0, _assertString.default)(str);
      var pattern = chars ? new RegExp("^[".concat(chars.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return str.replace(pattern, "");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(ltrim, ltrim.exports);
  return ltrim.exports;
}
var hasRequiredTrim;
function requireTrim() {
  if (hasRequiredTrim) return trim.exports;
  hasRequiredTrim = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = trim2;
    var _rtrim = _interopRequireDefault(/* @__PURE__ */ requireRtrim());
    var _ltrim = _interopRequireDefault(/* @__PURE__ */ requireLtrim());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function trim2(str, chars) {
      return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(trim, trim.exports);
  return trim.exports;
}
var hasRequiredIsMailtoURI;
function requireIsMailtoURI() {
  if (hasRequiredIsMailtoURI) return isMailtoURI.exports;
  hasRequiredIsMailtoURI = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMailtoURI2;
    var _trim = _interopRequireDefault(/* @__PURE__ */ requireTrim());
    var _isEmail = _interopRequireDefault(/* @__PURE__ */ requireIsEmail());
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function _slicedToArray(r, e) {
      return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
          if (i = (t = t.call(r)).next, 0 === l) ;
          else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(r) {
      if (Array.isArray(r)) return r;
    }
    function _createForOfIteratorHelper(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
          t && (r = t);
          var _n = 0, F = function F2() {
          };
          return { s: F, n: function n() {
            return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
          }, e: function e2(r2) {
            throw r2;
          }, f: F };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o, a = true, u = false;
      return { s: function s() {
        t = t.call(r);
      }, n: function n() {
        var r2 = t.next();
        return a = r2.done, r2;
      }, e: function e2(r2) {
        u = true, o = r2;
      }, f: function f() {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      } };
    }
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function parseMailtoQueryString(queryString) {
      var allowedParams = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), query = {
        cc: "",
        bcc: ""
      };
      var isParseFailed = false;
      var queryParams = queryString.split("&");
      if (queryParams.length > 4) {
        return false;
      }
      var _iterator = _createForOfIteratorHelper(queryParams), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var q = _step.value;
          var _q$split = q.split("="), _q$split2 = _slicedToArray(_q$split, 2), key = _q$split2[0], value = _q$split2[1];
          if (key && !allowedParams.has(key)) {
            isParseFailed = true;
            break;
          }
          if (value && (key === "cc" || key === "bcc")) {
            query[key] = value;
          }
          if (key) {
            allowedParams.delete(key);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return isParseFailed ? false : query;
    }
    function isMailtoURI2(url, options) {
      (0, _assertString.default)(url);
      if (url.indexOf("mailto:") !== 0) {
        return false;
      }
      var _url$replace$split = url.replace("mailto:", "").split("?"), _url$replace$split2 = _slicedToArray(_url$replace$split, 2), to = _url$replace$split2[0], _url$replace$split2$ = _url$replace$split2[1], queryString = _url$replace$split2$ === void 0 ? "" : _url$replace$split2$;
      if (!to && !queryString) {
        return true;
      }
      var query = parseMailtoQueryString(queryString);
      if (!query) {
        return false;
      }
      return "".concat(to, ",").concat(query.cc, ",").concat(query.bcc).split(",").every(function(email) {
        email = (0, _trim.default)(email, " ");
        if (email) {
          return (0, _isEmail.default)(email, options);
        }
        return true;
      });
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMailtoURI, isMailtoURI.exports);
  return isMailtoURI.exports;
}
var isMimeType = { exports: {} };
var hasRequiredIsMimeType;
function requireIsMimeType() {
  if (hasRequiredIsMimeType) return isMimeType.exports;
  hasRequiredIsMimeType = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isMimeType2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i;
    var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i;
    var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function isMimeType2(str) {
      (0, _assertString.default)(str);
      return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isMimeType, isMimeType.exports);
  return isMimeType.exports;
}
var isLatLong = { exports: {} };
var hasRequiredIsLatLong;
function requireIsLatLong() {
  if (hasRequiredIsLatLong) return isLatLong.exports;
  hasRequiredIsLatLong = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLatLong2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    var _includesString = _interopRequireDefault(/* @__PURE__ */ requireIncludesString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
    var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
    var latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
    var longDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
    var defaultLatLongOptions = {
      checkDMS: false
    };
    function isLatLong2(str, options) {
      (0, _assertString.default)(str);
      options = (0, _merge.default)(options, defaultLatLongOptions);
      if (!(0, _includesString.default)(str, ",")) return false;
      var pair = str.split(",");
      if (pair[0].startsWith("(") && !pair[1].endsWith(")") || pair[1].endsWith(")") && !pair[0].startsWith("(")) return false;
      if (options.checkDMS) {
        return latDMS.test(pair[0]) && longDMS.test(pair[1]);
      }
      return lat.test(pair[0]) && long.test(pair[1]);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLatLong, isLatLong.exports);
  return isLatLong.exports;
}
var isPostalCode = {};
var hasRequiredIsPostalCode;
function requireIsPostalCode() {
  if (hasRequiredIsPostalCode) return isPostalCode;
  hasRequiredIsPostalCode = 1;
  Object.defineProperty(isPostalCode, "__esModule", {
    value: true
  });
  isPostalCode.default = isPostalCode$1;
  isPostalCode.locales = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var threeDigit = /^\d{3}$/;
  var fourDigit = /^\d{4}$/;
  var fiveDigit = /^\d{5}$/;
  var sixDigit = /^\d{6}$/;
  var patterns = {
    AD: /^AD\d{3}$/,
    AT: fourDigit,
    AU: fourDigit,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BD: /^([1-8][0-9]{3}|9[0-4][0-9]{2})$/,
    BE: fourDigit,
    BG: fourDigit,
    BR: /^\d{5}-?\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: fourDigit,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CO: /^(05|08|11|13|15|17|18|19|20|23|25|27|41|44|47|50|52|54|63|66|68|70|73|76|81|85|86|88|91|94|95|97|99)(\d{4})$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: fiveDigit,
    DK: fourDigit,
    DO: fiveDigit,
    DZ: fiveDigit,
    EE: fiveDigit,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: fiveDigit,
    FR: /^(?:(?:0[1-9]|[1-8]\d|9[0-5])\d{3}|97[1-46]\d{2})$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: fourDigit,
    ID: fiveDigit,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: threeDigit,
    IT: fiveDigit,
    JP: /^\d{3}\-\d{4}$/,
    KE: fiveDigit,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: fourDigit,
    LV: /^LV\-\d{4}$/,
    LK: fiveDigit,
    MG: threeDigit,
    MX: fiveDigit,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: fiveDigit,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: fourDigit,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: fourDigit,
    // https://www.pakpost.gov.pk/postcodes.php
    PK: fiveDigit,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: sixDigit,
    RU: sixDigit,
    SA: fiveDigit,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: sixDigit,
    SI: fourDigit,
    SK: /^\d{3}\s?\d{2}$/,
    TH: fiveDigit,
    TN: fourDigit,
    TW: /^\d{3}(\d{2,3})?$/,
    UA: fiveDigit,
    US: /^\d{5}(-\d{4})?$/,
    ZA: fourDigit,
    ZM: fiveDigit
  };
  isPostalCode.locales = Object.keys(patterns);
  function isPostalCode$1(str, locale) {
    (0, _assertString.default)(str);
    if (locale in patterns) {
      return patterns[locale].test(str);
    } else if (locale === "any") {
      for (var key in patterns) {
        if (patterns.hasOwnProperty(key)) {
          var pattern = patterns[key];
          if (pattern.test(str)) {
            return true;
          }
        }
      }
      return false;
    }
    throw new Error("Invalid locale '".concat(locale, "'"));
  }
  return isPostalCode;
}
var _escape = { exports: {} };
var hasRequired_escape;
function require_escape() {
  if (hasRequired_escape) return _escape.exports;
  hasRequired_escape = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = escape;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function escape(str) {
      (0, _assertString.default)(str);
      return str.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(_escape, _escape.exports);
  return _escape.exports;
}
var _unescape = { exports: {} };
var hasRequired_unescape;
function require_unescape() {
  if (hasRequired_unescape) return _unescape.exports;
  hasRequired_unescape = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = unescape;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function unescape(str) {
      (0, _assertString.default)(str);
      return str.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(_unescape, _unescape.exports);
  return _unescape.exports;
}
var stripLow = { exports: {} };
var blacklist = { exports: {} };
var hasRequiredBlacklist;
function requireBlacklist() {
  if (hasRequiredBlacklist) return blacklist.exports;
  hasRequiredBlacklist = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = blacklist2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function blacklist2(str, chars) {
      (0, _assertString.default)(str);
      return str.replace(new RegExp("[".concat(chars, "]+"), "g"), "");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(blacklist, blacklist.exports);
  return blacklist.exports;
}
var hasRequiredStripLow;
function requireStripLow() {
  if (hasRequiredStripLow) return stripLow.exports;
  hasRequiredStripLow = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = stripLow2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    var _blacklist = _interopRequireDefault(/* @__PURE__ */ requireBlacklist());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function stripLow2(str, keep_new_lines) {
      (0, _assertString.default)(str);
      var chars = keep_new_lines ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, _blacklist.default)(str, chars);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(stripLow, stripLow.exports);
  return stripLow.exports;
}
var whitelist = { exports: {} };
var hasRequiredWhitelist;
function requireWhitelist() {
  if (hasRequiredWhitelist) return whitelist.exports;
  hasRequiredWhitelist = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = whitelist2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function whitelist2(str, chars) {
      (0, _assertString.default)(str);
      return str.replace(new RegExp("[^".concat(chars, "]+"), "g"), "");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(whitelist, whitelist.exports);
  return whitelist.exports;
}
var isWhitelisted = { exports: {} };
var hasRequiredIsWhitelisted;
function requireIsWhitelisted() {
  if (hasRequiredIsWhitelisted) return isWhitelisted.exports;
  hasRequiredIsWhitelisted = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isWhitelisted2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function isWhitelisted2(str, chars) {
      (0, _assertString.default)(str);
      for (var i = str.length - 1; i >= 0; i--) {
        if (chars.indexOf(str[i]) === -1) {
          return false;
        }
      }
      return true;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isWhitelisted, isWhitelisted.exports);
  return isWhitelisted.exports;
}
var normalizeEmail = { exports: {} };
var hasRequiredNormalizeEmail;
function requireNormalizeEmail() {
  if (hasRequiredNormalizeEmail) return normalizeEmail.exports;
  hasRequiredNormalizeEmail = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = normalizeEmail2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var default_normalize_email_options = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: true,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: true,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: true,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: true,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: true,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: true,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: true,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: true,
      // all yandex domains are equal, this explicitly sets the domain to 'yandex.ru'
      yandex_convert_yandexru: true,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: true,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: true
    };
    var icloud_domains = ["icloud.com", "me.com"];
    var outlookdotcom_domains = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"];
    var yahoo_domains = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"];
    var yandex_domains = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
    function dotsReplacer(match) {
      if (match.length > 1) {
        return match;
      }
      return "";
    }
    function normalizeEmail2(email, options) {
      options = (0, _merge.default)(options, default_normalize_email_options);
      var raw_parts = email.split("@");
      var domain = raw_parts.pop();
      var user = raw_parts.join("@");
      var parts = [user, domain];
      parts[1] = parts[1].toLowerCase();
      if (parts[1] === "gmail.com" || parts[1] === "googlemail.com") {
        if (options.gmail_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (options.gmail_remove_dots) {
          parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.gmail_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
        parts[1] = options.gmail_convert_googlemaildotcom ? "gmail.com" : parts[1];
      } else if (icloud_domains.indexOf(parts[1]) >= 0) {
        if (options.icloud_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.icloud_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
        if (options.outlookdotcom_remove_subaddress) {
          parts[0] = parts[0].split("+")[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.outlookdotcom_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
        if (options.yahoo_remove_subaddress) {
          var components = parts[0].split("-");
          parts[0] = components.length > 1 ? components.slice(0, -1).join("-") : components[0];
        }
        if (!parts[0].length) {
          return false;
        }
        if (options.all_lowercase || options.yahoo_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
      } else if (yandex_domains.indexOf(parts[1]) >= 0) {
        if (options.all_lowercase || options.yandex_lowercase) {
          parts[0] = parts[0].toLowerCase();
        }
        parts[1] = options.yandex_convert_yandexru ? "yandex.ru" : parts[1];
      } else if (options.all_lowercase) {
        parts[0] = parts[0].toLowerCase();
      }
      return parts.join("@");
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(normalizeEmail, normalizeEmail.exports);
  return normalizeEmail.exports;
}
var isSlug = { exports: {} };
var hasRequiredIsSlug;
function requireIsSlug() {
  if (hasRequiredIsSlug) return isSlug.exports;
  hasRequiredIsSlug = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isSlug2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function isSlug2(str) {
      (0, _assertString.default)(str);
      return charsetRegex.test(str);
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isSlug, isSlug.exports);
  return isSlug.exports;
}
var isLicensePlate = { exports: {} };
var hasRequiredIsLicensePlate;
function requireIsLicensePlate() {
  if (hasRequiredIsLicensePlate) return isLicensePlate.exports;
  hasRequiredIsLicensePlate = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isLicensePlate2;
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var validators2 = {
      "cs-CZ": function csCZ(str) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(str);
      },
      "de-DE": function deDE(str) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(str);
      },
      "de-LI": function deLI(str) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(str);
      },
      "en-IN": function enIN(str) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(str);
      },
      "en-SG": function enSG(str) {
        return /^[A-Z]{3}[ -]?[\d]{4}[ -]?[A-Z]{1}$/.test(str);
      },
      "es-AR": function esAR(str) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(str);
      },
      "fi-FI": function fiFI(str) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(str);
      },
      "hu-HU": function huHU(str) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(str);
      },
      "pt-BR": function ptBR(str) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(str);
      },
      "pt-PT": function ptPT(str) {
        return /^(([A-Z]{2}[ -·]?[0-9]{2}[ -·]?[0-9]{2})|([0-9]{2}[ -·]?[A-Z]{2}[ -·]?[0-9]{2})|([0-9]{2}[ -·]?[0-9]{2}[ -·]?[A-Z]{2})|([A-Z]{2}[ -·]?[0-9]{2}[ -·]?[A-Z]{2}))$/.test(str);
      },
      "sq-AL": function sqAL(str) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(str);
      },
      "sv-SE": function svSE(str) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(str.trim());
      },
      "en-PK": function enPK(str) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(str.trim());
      }
    };
    function isLicensePlate2(str, locale) {
      (0, _assertString.default)(str);
      if (locale in validators2) {
        return validators2[locale](str);
      } else if (locale === "any") {
        for (var key in validators2) {
          var validator2 = validators2[key];
          if (validator2(str)) {
            return true;
          }
        }
        return false;
      }
      throw new Error("Invalid locale '".concat(locale, "'"));
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isLicensePlate, isLicensePlate.exports);
  return isLicensePlate.exports;
}
var isStrongPassword = { exports: {} };
var hasRequiredIsStrongPassword;
function requireIsStrongPassword() {
  if (hasRequiredIsStrongPassword) return isStrongPassword.exports;
  hasRequiredIsStrongPassword = 1;
  (function(module, exports$1) {
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = isStrongPassword2;
    var _merge = _interopRequireDefault(/* @__PURE__ */ requireMerge());
    var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var upperCaseRegex = /^[A-Z]$/;
    var lowerCaseRegex = /^[a-z]$/;
    var numberRegex = /^[0-9]$/;
    var symbolRegex = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/;
    var defaultOptions = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: false,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function countChars(str) {
      var result = {};
      Array.from(str).forEach(function(char) {
        var curVal = result[char];
        if (curVal) {
          result[char] += 1;
        } else {
          result[char] = 1;
        }
      });
      return result;
    }
    function analyzePassword(password) {
      var charMap = countChars(password);
      var analysis = {
        length: password.length,
        uniqueChars: Object.keys(charMap).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      Object.keys(charMap).forEach(function(char) {
        if (upperCaseRegex.test(char)) {
          analysis.uppercaseCount += charMap[char];
        } else if (lowerCaseRegex.test(char)) {
          analysis.lowercaseCount += charMap[char];
        } else if (numberRegex.test(char)) {
          analysis.numberCount += charMap[char];
        } else if (symbolRegex.test(char)) {
          analysis.symbolCount += charMap[char];
        }
      });
      return analysis;
    }
    function scorePassword(analysis, scoringOptions) {
      var points = 0;
      points += analysis.uniqueChars * scoringOptions.pointsPerUnique;
      points += (analysis.length - analysis.uniqueChars) * scoringOptions.pointsPerRepeat;
      if (analysis.lowercaseCount > 0) {
        points += scoringOptions.pointsForContainingLower;
      }
      if (analysis.uppercaseCount > 0) {
        points += scoringOptions.pointsForContainingUpper;
      }
      if (analysis.numberCount > 0) {
        points += scoringOptions.pointsForContainingNumber;
      }
      if (analysis.symbolCount > 0) {
        points += scoringOptions.pointsForContainingSymbol;
      }
      return points;
    }
    function isStrongPassword2(str) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, _assertString.default)(str);
      var analysis = analyzePassword(str);
      options = (0, _merge.default)(options || {}, defaultOptions);
      if (options.returnScore) {
        return scorePassword(analysis, options);
      }
      return analysis.length >= options.minLength && analysis.lowercaseCount >= options.minLowercase && analysis.uppercaseCount >= options.minUppercase && analysis.numberCount >= options.minNumbers && analysis.symbolCount >= options.minSymbols;
    }
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(isStrongPassword, isStrongPassword.exports);
  return isStrongPassword.exports;
}
var isVAT = {};
var hasRequiredIsVAT;
function requireIsVAT() {
  if (hasRequiredIsVAT) return isVAT;
  hasRequiredIsVAT = 1;
  function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
      return typeof o2;
    } : function(o2) {
      return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
    }, _typeof(o);
  }
  Object.defineProperty(isVAT, "__esModule", {
    value: true
  });
  isVAT.default = isVAT$1;
  isVAT.vatMatchers = void 0;
  var _assertString = _interopRequireDefault(/* @__PURE__ */ requireAssertString());
  var algorithms2 = _interopRequireWildcard(/* @__PURE__ */ requireAlgorithms());
  function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard2(e2, t2) {
      if (!t2 && e2 && e2.__esModule) return e2;
      var o, i, f = { __proto__: null, default: e2 };
      if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return f;
      if (o = t2 ? n : r) {
        if (o.has(e2)) return o.get(e2);
        o.set(e2, f);
      }
      for (var _t in e2) "default" !== _t && {}.hasOwnProperty.call(e2, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e2, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e2[_t]);
      return f;
    })(e, t);
  }
  function _interopRequireDefault(e) {
    return e && e.__esModule ? e : { default: e };
  }
  var AU = function AU2(str) {
    var match = str.match(/^(AU)?(\d{11})$/);
    if (!match) {
      return false;
    }
    var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    str = str.replace(/^AU/, "");
    var ABN = (parseInt(str.slice(0, 1), 10) - 1).toString() + str.slice(1);
    var total = 0;
    for (var i = 0; i < 11; i++) {
      total += weights[i] * ABN.charAt(i);
    }
    return total !== 0 && total % 89 === 0;
  };
  var CH = function CH2(str) {
    var hasValidCheckNumber = function hasValidCheckNumber2(digits) {
      var lastDigit = digits.pop();
      var weights = [5, 4, 3, 2, 7, 6, 5, 4];
      var calculatedCheckNumber = (11 - digits.reduce(function(acc, el, idx) {
        return acc + el * weights[idx];
      }, 0) % 11) % 11;
      return lastDigit === calculatedCheckNumber;
    };
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(str) && hasValidCheckNumber(str.match(/\d/g).map(function(el) {
      return +el;
    }));
  };
  var PT = function PT2(str) {
    var match = str.match(/^(PT)?(\d{9})$/);
    if (!match) {
      return false;
    }
    var tin = match[2];
    var checksum = 11 - algorithms2.reverseMultiplyAndSum(tin.split("").slice(0, 8).map(function(a) {
      return parseInt(a, 10);
    }), 9) % 11;
    if (checksum > 9) {
      return parseInt(tin[8], 10) === 0;
    }
    return checksum === parseInt(tin[8], 10);
  };
  var vatMatchers = isVAT.vatMatchers = {
    /**
     * European Union VAT identification numbers
     */
    AT: function AT(str) {
      return /^(AT)?U\d{8}$/.test(str);
    },
    BE: function BE(str) {
      return /^(BE)?\d{10}$/.test(str);
    },
    BG: function BG(str) {
      return /^(BG)?\d{9,10}$/.test(str);
    },
    HR: function HR(str) {
      return /^(HR)?\d{11}$/.test(str);
    },
    CY: function CY(str) {
      return /^(CY)?\w{9}$/.test(str);
    },
    CZ: function CZ(str) {
      return /^(CZ)?\d{8,10}$/.test(str);
    },
    DK: function DK(str) {
      return /^(DK)?\d{8}$/.test(str);
    },
    EE: function EE(str) {
      return /^(EE)?\d{9}$/.test(str);
    },
    FI: function FI(str) {
      return /^(FI)?\d{8}$/.test(str);
    },
    FR: function FR(str) {
      return /^(FR)([A-Z0-9]{2}\d{9})$/.test(str);
    },
    DE: function DE(str) {
      return /^(DE)?\d{9}$/.test(str);
    },
    EL: function EL(str) {
      return /^(EL)?\d{9}$/.test(str);
    },
    HU: function HU(str) {
      return /^(HU)?\d{8}$/.test(str);
    },
    IE: function IE(str) {
      return /^(IE)?\d{7}\w{1}(W)?$/.test(str);
    },
    IT: function IT(str) {
      return /^(IT)?\d{11}$/.test(str);
    },
    LV: function LV(str) {
      return /^(LV)?\d{11}$/.test(str);
    },
    LT: function LT(str) {
      return /^(LT)?\d{9,12}$/.test(str);
    },
    LU: function LU(str) {
      return /^(LU)?\d{8}$/.test(str);
    },
    MT: function MT(str) {
      return /^(MT)?\d{8}$/.test(str);
    },
    NL: function NL(str) {
      return /^(NL)?\d{9}B\d{2}$/.test(str);
    },
    PL: function PL(str) {
      return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(str);
    },
    PT,
    RO: function RO(str) {
      return /^(RO)?\d{2,10}$/.test(str);
    },
    SK: function SK(str) {
      return /^(SK)?\d{10}$/.test(str);
    },
    SI: function SI(str) {
      return /^(SI)?\d{8}$/.test(str);
    },
    ES: function ES(str) {
      return /^(ES)?\w\d{7}[A-Z]$/.test(str);
    },
    SE: function SE(str) {
      return /^(SE)?\d{12}$/.test(str);
    },
    /**
     * VAT numbers of non-EU countries
     */
    AL: function AL(str) {
      return /^(AL)?\w{9}[A-Z]$/.test(str);
    },
    MK: function MK(str) {
      return /^(MK)?\d{13}$/.test(str);
    },
    AU,
    BY: function BY(str) {
      return /^(УНП )?\d{9}$/.test(str);
    },
    CA: function CA(str) {
      return /^(CA)?\d{9}$/.test(str);
    },
    IS: function IS(str) {
      return /^(IS)?\d{5,6}$/.test(str);
    },
    IN: function IN(str) {
      return /^(IN)?\d{15}$/.test(str);
    },
    ID: function ID(str) {
      return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(str);
    },
    IL: function IL(str) {
      return /^(IL)?\d{9}$/.test(str);
    },
    KZ: function KZ(str) {
      return /^(KZ)?\d{12}$/.test(str);
    },
    NZ: function NZ(str) {
      return /^(NZ)?\d{9}$/.test(str);
    },
    NG: function NG(str) {
      return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(str);
    },
    NO: function NO(str) {
      return /^(NO)?\d{9}MVA$/.test(str);
    },
    PH: function PH(str) {
      return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(str);
    },
    RU: function RU(str) {
      return /^(RU)?(\d{10}|\d{12})$/.test(str);
    },
    SM: function SM(str) {
      return /^(SM)?\d{5}$/.test(str);
    },
    SA: function SA(str) {
      return /^(SA)?\d{15}$/.test(str);
    },
    RS: function RS(str) {
      return /^(RS)?\d{9}$/.test(str);
    },
    CH,
    TR: function TR(str) {
      return /^(TR)?\d{10}$/.test(str);
    },
    UA: function UA(str) {
      return /^(UA)?\d{12}$/.test(str);
    },
    GB: function GB(str) {
      return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(str);
    },
    UZ: function UZ(str) {
      return /^(UZ)?\d{9}$/.test(str);
    },
    /**
     * VAT numbers of Latin American countries
     */
    AR: function AR(str) {
      return /^(AR)?\d{11}$/.test(str);
    },
    BO: function BO(str) {
      return /^(BO)?\d{7}$/.test(str);
    },
    BR: function BR(str) {
      return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(str);
    },
    CL: function CL(str) {
      return /^(CL)?\d{8}-\d{1}$/.test(str);
    },
    CO: function CO(str) {
      return /^(CO)?\d{10}$/.test(str);
    },
    CR: function CR(str) {
      return /^(CR)?\d{9,12}$/.test(str);
    },
    EC: function EC(str) {
      return /^(EC)?\d{13}$/.test(str);
    },
    SV: function SV(str) {
      return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(str);
    },
    GT: function GT(str) {
      return /^(GT)?\d{7}-\d{1}$/.test(str);
    },
    HN: function HN(str) {
      return /^(HN)?$/.test(str);
    },
    MX: function MX(str) {
      return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(str);
    },
    NI: function NI(str) {
      return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(str);
    },
    PA: function PA(str) {
      return /^(PA)?$/.test(str);
    },
    PY: function PY(str) {
      return /^(PY)?\d{6,8}-\d{1}$/.test(str);
    },
    PE: function PE(str) {
      return /^(PE)?\d{11}$/.test(str);
    },
    DO: function DO(str) {
      return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(str);
    },
    UY: function UY(str) {
      return /^(UY)?\d{12}$/.test(str);
    },
    VE: function VE(str) {
      return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(str);
    }
  };
  function isVAT$1(str, countryCode) {
    (0, _assertString.default)(str);
    (0, _assertString.default)(countryCode);
    if (countryCode in vatMatchers) {
      return vatMatchers[countryCode](str);
    }
    throw new Error("Invalid country code: '".concat(countryCode, "'"));
  }
  return isVAT;
}
var hasRequiredValidator;
function requireValidator() {
  if (hasRequiredValidator) return validator$1.exports;
  hasRequiredValidator = 1;
  (function(module, exports$1) {
    function _typeof(o) {
      "@babel/helpers - typeof";
      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, _typeof(o);
    }
    Object.defineProperty(exports$1, "__esModule", {
      value: true
    });
    exports$1.default = void 0;
    var _toDate = _interopRequireDefault(/* @__PURE__ */ requireToDate());
    var _toFloat = _interopRequireDefault(/* @__PURE__ */ requireToFloat());
    var _toInt = _interopRequireDefault(/* @__PURE__ */ requireToInt());
    var _toBoolean = _interopRequireDefault(/* @__PURE__ */ requireToBoolean());
    var _equals = _interopRequireDefault(/* @__PURE__ */ requireEquals());
    var _contains = _interopRequireDefault(/* @__PURE__ */ requireContains());
    var _matches = _interopRequireDefault(/* @__PURE__ */ requireMatches());
    var _isEmail = _interopRequireDefault(/* @__PURE__ */ requireIsEmail());
    var _isURL = _interopRequireDefault(/* @__PURE__ */ requireIsURL());
    var _isMACAddress = _interopRequireDefault(/* @__PURE__ */ requireIsMACAddress());
    var _isIP = _interopRequireDefault(/* @__PURE__ */ requireIsIP());
    var _isIPRange = _interopRequireDefault(/* @__PURE__ */ requireIsIPRange());
    var _isFQDN = _interopRequireDefault(/* @__PURE__ */ requireIsFQDN());
    var _isDate = _interopRequireDefault(/* @__PURE__ */ requireIsDate());
    var _isTime = _interopRequireDefault(/* @__PURE__ */ requireIsTime());
    var _isBoolean = _interopRequireDefault(/* @__PURE__ */ requireIsBoolean());
    var _isLocale = _interopRequireDefault(/* @__PURE__ */ requireIsLocale());
    var _isAbaRouting = _interopRequireDefault(/* @__PURE__ */ requireIsAbaRouting());
    var _isAlpha = _interopRequireWildcard(/* @__PURE__ */ requireIsAlpha());
    var _isAlphanumeric = _interopRequireWildcard(/* @__PURE__ */ requireIsAlphanumeric());
    var _isNumeric = _interopRequireDefault(/* @__PURE__ */ requireIsNumeric());
    var _isPassportNumber = _interopRequireWildcard(/* @__PURE__ */ requireIsPassportNumber());
    var _isPort = _interopRequireDefault(/* @__PURE__ */ requireIsPort());
    var _isLowercase = _interopRequireDefault(/* @__PURE__ */ requireIsLowercase());
    var _isUppercase = _interopRequireDefault(/* @__PURE__ */ requireIsUppercase());
    var _isIMEI = _interopRequireDefault(/* @__PURE__ */ requireIsIMEI());
    var _isAscii = _interopRequireDefault(/* @__PURE__ */ requireIsAscii());
    var _isFullWidth = _interopRequireDefault(/* @__PURE__ */ requireIsFullWidth());
    var _isHalfWidth = _interopRequireDefault(/* @__PURE__ */ requireIsHalfWidth());
    var _isVariableWidth = _interopRequireDefault(/* @__PURE__ */ requireIsVariableWidth());
    var _isMultibyte = _interopRequireDefault(/* @__PURE__ */ requireIsMultibyte());
    var _isSemVer = _interopRequireDefault(/* @__PURE__ */ requireIsSemVer());
    var _isSurrogatePair = _interopRequireDefault(/* @__PURE__ */ requireIsSurrogatePair());
    var _isInt = _interopRequireDefault(/* @__PURE__ */ requireIsInt());
    var _isFloat = _interopRequireWildcard(/* @__PURE__ */ requireIsFloat());
    var _isDecimal = _interopRequireDefault(/* @__PURE__ */ requireIsDecimal());
    var _isHexadecimal = _interopRequireDefault(/* @__PURE__ */ requireIsHexadecimal());
    var _isOctal = _interopRequireDefault(/* @__PURE__ */ requireIsOctal());
    var _isDivisibleBy = _interopRequireDefault(/* @__PURE__ */ requireIsDivisibleBy());
    var _isHexColor = _interopRequireDefault(/* @__PURE__ */ requireIsHexColor());
    var _isRgbColor = _interopRequireDefault(/* @__PURE__ */ requireIsRgbColor());
    var _isHSL = _interopRequireDefault(/* @__PURE__ */ requireIsHSL());
    var _isISRC = _interopRequireDefault(/* @__PURE__ */ requireIsISRC());
    var _isIBAN = _interopRequireWildcard(/* @__PURE__ */ requireIsIBAN());
    var _isBIC = _interopRequireDefault(/* @__PURE__ */ requireIsBIC());
    var _isMD = _interopRequireDefault(/* @__PURE__ */ requireIsMD5());
    var _isHash = _interopRequireDefault(/* @__PURE__ */ requireIsHash());
    var _isJWT = _interopRequireDefault(/* @__PURE__ */ requireIsJWT());
    var _isJSON = _interopRequireDefault(/* @__PURE__ */ requireIsJSON());
    var _isEmpty = _interopRequireDefault(/* @__PURE__ */ requireIsEmpty());
    var _isLength = _interopRequireDefault(/* @__PURE__ */ requireIsLength());
    var _isByteLength = _interopRequireDefault(/* @__PURE__ */ requireIsByteLength());
    var _isULID = _interopRequireDefault(/* @__PURE__ */ requireIsULID());
    var _isUUID = _interopRequireDefault(/* @__PURE__ */ requireIsUUID());
    var _isMongoId = _interopRequireDefault(/* @__PURE__ */ requireIsMongoId());
    var _isAfter = _interopRequireDefault(/* @__PURE__ */ requireIsAfter());
    var _isBefore = _interopRequireDefault(/* @__PURE__ */ requireIsBefore());
    var _isIn = _interopRequireDefault(/* @__PURE__ */ requireIsIn());
    var _isLuhnNumber = _interopRequireDefault(/* @__PURE__ */ requireIsLuhnNumber());
    var _isCreditCard = _interopRequireDefault(/* @__PURE__ */ requireIsCreditCard());
    var _isIdentityCard = _interopRequireDefault(/* @__PURE__ */ requireIsIdentityCard());
    var _isEAN = _interopRequireDefault(/* @__PURE__ */ requireIsEAN());
    var _isISIN = _interopRequireDefault(/* @__PURE__ */ requireIsISIN());
    var _isISBN = _interopRequireDefault(/* @__PURE__ */ requireIsISBN());
    var _isISSN = _interopRequireDefault(/* @__PURE__ */ requireIsISSN());
    var _isTaxID = _interopRequireDefault(/* @__PURE__ */ requireIsTaxID());
    var _isMobilePhone = _interopRequireWildcard(/* @__PURE__ */ requireIsMobilePhone());
    var _isEthereumAddress = _interopRequireDefault(/* @__PURE__ */ requireIsEthereumAddress());
    var _isCurrency = _interopRequireDefault(/* @__PURE__ */ requireIsCurrency());
    var _isBtcAddress = _interopRequireDefault(/* @__PURE__ */ requireIsBtcAddress());
    var _isISO = /* @__PURE__ */ requireIsISO6346();
    var _isISO2 = _interopRequireDefault(/* @__PURE__ */ requireIsISO6391());
    var _isISO3 = _interopRequireDefault(/* @__PURE__ */ requireIsISO8601());
    var _isRFC = _interopRequireDefault(/* @__PURE__ */ requireIsRFC3339());
    var _isISO4 = _interopRequireDefault(/* @__PURE__ */ requireIsISO15924());
    var _isISO31661Alpha = _interopRequireDefault(/* @__PURE__ */ requireIsISO31661Alpha2());
    var _isISO31661Alpha2 = _interopRequireDefault(/* @__PURE__ */ requireIsISO31661Alpha3());
    var _isISO31661Numeric = _interopRequireDefault(/* @__PURE__ */ requireIsISO31661Numeric());
    var _isISO5 = _interopRequireDefault(/* @__PURE__ */ requireIsISO4217());
    var _isBase = _interopRequireDefault(/* @__PURE__ */ requireIsBase32());
    var _isBase2 = _interopRequireDefault(/* @__PURE__ */ requireIsBase58());
    var _isBase3 = _interopRequireDefault(/* @__PURE__ */ requireIsBase64());
    var _isDataURI = _interopRequireDefault(/* @__PURE__ */ requireIsDataURI());
    var _isMagnetURI = _interopRequireDefault(/* @__PURE__ */ requireIsMagnetURI());
    var _isMailtoURI = _interopRequireDefault(/* @__PURE__ */ requireIsMailtoURI());
    var _isMimeType = _interopRequireDefault(/* @__PURE__ */ requireIsMimeType());
    var _isLatLong = _interopRequireDefault(/* @__PURE__ */ requireIsLatLong());
    var _isPostalCode = _interopRequireWildcard(/* @__PURE__ */ requireIsPostalCode());
    var _ltrim = _interopRequireDefault(/* @__PURE__ */ requireLtrim());
    var _rtrim = _interopRequireDefault(/* @__PURE__ */ requireRtrim());
    var _trim = _interopRequireDefault(/* @__PURE__ */ requireTrim());
    var _escape2 = _interopRequireDefault(/* @__PURE__ */ require_escape());
    var _unescape2 = _interopRequireDefault(/* @__PURE__ */ require_unescape());
    var _stripLow = _interopRequireDefault(/* @__PURE__ */ requireStripLow());
    var _whitelist = _interopRequireDefault(/* @__PURE__ */ requireWhitelist());
    var _blacklist = _interopRequireDefault(/* @__PURE__ */ requireBlacklist());
    var _isWhitelisted = _interopRequireDefault(/* @__PURE__ */ requireIsWhitelisted());
    var _normalizeEmail = _interopRequireDefault(/* @__PURE__ */ requireNormalizeEmail());
    var _isSlug = _interopRequireDefault(/* @__PURE__ */ requireIsSlug());
    var _isLicensePlate = _interopRequireDefault(/* @__PURE__ */ requireIsLicensePlate());
    var _isStrongPassword = _interopRequireDefault(/* @__PURE__ */ requireIsStrongPassword());
    var _isVAT = _interopRequireDefault(/* @__PURE__ */ requireIsVAT());
    function _interopRequireWildcard(e, t) {
      if ("function" == typeof WeakMap) var r = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
      return (_interopRequireWildcard = function _interopRequireWildcard2(e2, t2) {
        if (!t2 && e2 && e2.__esModule) return e2;
        var o, i, f = { __proto__: null, default: e2 };
        if (null === e2 || "object" != _typeof(e2) && "function" != typeof e2) return f;
        if (o = t2 ? n : r) {
          if (o.has(e2)) return o.get(e2);
          o.set(e2, f);
        }
        for (var _t in e2) "default" !== _t && {}.hasOwnProperty.call(e2, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e2, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e2[_t]);
        return f;
      })(e, t);
    }
    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var version = "13.15.23";
    var validator2 = {
      version,
      toDate: _toDate.default,
      toFloat: _toFloat.default,
      toInt: _toInt.default,
      toBoolean: _toBoolean.default,
      equals: _equals.default,
      contains: _contains.default,
      matches: _matches.default,
      isEmail: _isEmail.default,
      isURL: _isURL.default,
      isMACAddress: _isMACAddress.default,
      isIP: _isIP.default,
      isIPRange: _isIPRange.default,
      isFQDN: _isFQDN.default,
      isBoolean: _isBoolean.default,
      isIBAN: _isIBAN.default,
      isBIC: _isBIC.default,
      isAbaRouting: _isAbaRouting.default,
      isAlpha: _isAlpha.default,
      isAlphaLocales: _isAlpha.locales,
      isAlphanumeric: _isAlphanumeric.default,
      isAlphanumericLocales: _isAlphanumeric.locales,
      isNumeric: _isNumeric.default,
      isPassportNumber: _isPassportNumber.default,
      passportNumberLocales: _isPassportNumber.locales,
      isPort: _isPort.default,
      isLowercase: _isLowercase.default,
      isUppercase: _isUppercase.default,
      isAscii: _isAscii.default,
      isFullWidth: _isFullWidth.default,
      isHalfWidth: _isHalfWidth.default,
      isVariableWidth: _isVariableWidth.default,
      isMultibyte: _isMultibyte.default,
      isSemVer: _isSemVer.default,
      isSurrogatePair: _isSurrogatePair.default,
      isInt: _isInt.default,
      isIMEI: _isIMEI.default,
      isFloat: _isFloat.default,
      isFloatLocales: _isFloat.locales,
      isDecimal: _isDecimal.default,
      isHexadecimal: _isHexadecimal.default,
      isOctal: _isOctal.default,
      isDivisibleBy: _isDivisibleBy.default,
      isHexColor: _isHexColor.default,
      isRgbColor: _isRgbColor.default,
      isHSL: _isHSL.default,
      isISRC: _isISRC.default,
      isMD5: _isMD.default,
      isHash: _isHash.default,
      isJWT: _isJWT.default,
      isJSON: _isJSON.default,
      isEmpty: _isEmpty.default,
      isLength: _isLength.default,
      isLocale: _isLocale.default,
      isByteLength: _isByteLength.default,
      isULID: _isULID.default,
      isUUID: _isUUID.default,
      isMongoId: _isMongoId.default,
      isAfter: _isAfter.default,
      isBefore: _isBefore.default,
      isIn: _isIn.default,
      isLuhnNumber: _isLuhnNumber.default,
      isCreditCard: _isCreditCard.default,
      isIdentityCard: _isIdentityCard.default,
      isEAN: _isEAN.default,
      isISIN: _isISIN.default,
      isISBN: _isISBN.default,
      isISSN: _isISSN.default,
      isMobilePhone: _isMobilePhone.default,
      isMobilePhoneLocales: _isMobilePhone.locales,
      isPostalCode: _isPostalCode.default,
      isPostalCodeLocales: _isPostalCode.locales,
      isEthereumAddress: _isEthereumAddress.default,
      isCurrency: _isCurrency.default,
      isBtcAddress: _isBtcAddress.default,
      isISO6346: _isISO.isISO6346,
      isFreightContainerID: _isISO.isFreightContainerID,
      isISO6391: _isISO2.default,
      isISO8601: _isISO3.default,
      isISO15924: _isISO4.default,
      isRFC3339: _isRFC.default,
      isISO31661Alpha2: _isISO31661Alpha.default,
      isISO31661Alpha3: _isISO31661Alpha2.default,
      isISO31661Numeric: _isISO31661Numeric.default,
      isISO4217: _isISO5.default,
      isBase32: _isBase.default,
      isBase58: _isBase2.default,
      isBase64: _isBase3.default,
      isDataURI: _isDataURI.default,
      isMagnetURI: _isMagnetURI.default,
      isMailtoURI: _isMailtoURI.default,
      isMimeType: _isMimeType.default,
      isLatLong: _isLatLong.default,
      ltrim: _ltrim.default,
      rtrim: _rtrim.default,
      trim: _trim.default,
      escape: _escape2.default,
      unescape: _unescape2.default,
      stripLow: _stripLow.default,
      whitelist: _whitelist.default,
      blacklist: _blacklist.default,
      isWhitelisted: _isWhitelisted.default,
      normalizeEmail: _normalizeEmail.default,
      toString,
      isSlug: _isSlug.default,
      isStrongPassword: _isStrongPassword.default,
      isTaxID: _isTaxID.default,
      isDate: _isDate.default,
      isTime: _isTime.default,
      isLicensePlate: _isLicensePlate.default,
      isVAT: _isVAT.default,
      ibanLocales: _isIBAN.locales
    };
    exports$1.default = validator2;
    module.exports = exports$1.default;
    module.exports.default = exports$1.default;
  })(validator$1, validator$1.exports);
  return validator$1.exports;
}
var validatorExports = /* @__PURE__ */ requireValidator();
const validator = /* @__PURE__ */ getDefaultExportFromCjs(validatorExports);
function getAnswerValue(answers, key) {
  return answers?.[key];
}
function replacePlaceholderMatch(match, keyName, source, answers) {
  const trimmedKey = keyName.trim();
  const trimmedSource = source ? source.trim().toLowerCase() : PLACEHOLDER_SOURCES.LOCAL;
  if (trimmedSource === PLACEHOLDER_SOURCES.URL) {
    const urlValue = getUrlParamValueFromStorage(trimmedKey);
    if (isDefined(urlValue)) {
      return String(urlValue);
    }
    return match;
  }
  if (trimmedSource === PLACEHOLDER_SOURCES.CONFIG) {
    const configValue = getConfigValueFromStorage(trimmedKey);
    if (isDefined(configValue)) {
      return String(configValue);
    }
    return match;
  }
  const value = getAnswerValue(answers, trimmedKey);
  if (isDefined(value)) {
    return String(value);
  }
  return match;
}
function replaceDynamicText(text, quizId) {
  if (!text) {
    return "";
  }
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return text;
  }
  let result = text.replace(
    REGEX_PATTERNS.PLACEHOLDER_REPLACEMENT,
    (match, keyName, source) => replacePlaceholderMatch(match, keyName, source, state2.answers)
  );
  if (result.includes("{")) {
    result = replaceTemplateVars(result, quizId);
  }
  return result;
}
function replaceDynamicStrings(text) {
  if (!text) {
    return "";
  }
  let quizData = {};
  try {
    const storedData = localStorage.getItem(STORAGE_KEYS.QUIZ_ANSWERS);
    if (storedData) quizData = JSON.parse(storedData);
  } catch (error) {
    console.warn(
      `Could not parse ${STORAGE_KEYS.QUIZ_ANSWERS} from localStorage:`,
      error
    );
  }
  return text.replace(
    REGEX_PATTERNS.PLACEHOLDER_REPLACEMENT,
    (match, key, source) => replacePlaceholderMatch(match, key, source, quizData.answers)
  );
}
function updateDynamicTextElements(elements, quizId, dataKey, property) {
  elements.forEach((element) => {
    const htmlElement = element;
    const dataset = htmlElement.dataset;
    if (dataset[dataKey]) {
      htmlElement[property] = replaceDynamicText(dataset[dataKey], quizId);
    } else {
      dataset[dataKey] = htmlElement[property];
      htmlElement[property] = replaceDynamicText(
        htmlElement[property],
        quizId
      );
    }
  });
}
function updateDynamicTextInCurrentPage(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2 || state2.totalPages === 0) {
    return;
  }
  const currentPageEl = getCurrentPageElement(quizId);
  if (!isHTMLElementLike(currentPageEl)) {
    return;
  }
  const elementsToUpdate = [
    {
      selector: SELECTORS.QUESTION_TITLE,
      dataKey: DATA_KEYS.ORIGINAL_TEXT,
      property: HTML_PROPERTIES.TEXT_CONTENT
    },
    {
      selector: SELECTORS.QUESTION_SUBTITLE,
      dataKey: DATA_KEYS.ORIGINAL_TEXT,
      property: HTML_PROPERTIES.TEXT_CONTENT
    },
    {
      selector: SELECTORS.QUESTION_MESSAGE,
      dataKey: DATA_KEYS.ORIGINAL_HTML,
      property: HTML_PROPERTIES.INNER_HTML
    },
    {
      selector: SELECTORS.INPUT_LABEL,
      dataKey: DATA_KEYS.ORIGINAL_TEXT,
      property: HTML_PROPERTIES.TEXT_CONTENT
    },
    {
      selector: SELECTORS.PLACEHOLDER_INPUTS,
      dataKey: DATA_KEYS.ORIGINAL_PLACEHOLDER,
      property: HTML_PROPERTIES.PLACEHOLDER
    },
    {
      selector: SELECTORS.ALL_HEADINGS,
      dataKey: DATA_KEYS.ORIGINAL_TEXT,
      property: HTML_PROPERTIES.TEXT_CONTENT
    }
  ];
  elementsToUpdate.forEach(({ selector, dataKey, property }) => {
    updateDynamicTextElements(
      currentPageEl.querySelectorAll(selector),
      quizId,
      dataKey,
      property
    );
  });
}
function getInputType(inputElement) {
  const tagNameLower = inputElement.tagName.toLowerCase();
  return tagNameLower === HTML_TAGS.INPUT.toLowerCase() ? inputElement.type : tagNameLower;
}
function getFieldKey(inputElement) {
  return inputElement.name || inputElement.id;
}
function clearValidationErrorIfNotEmpty(quizId, value) {
  if (value.trim() !== "") {
    hideValidationError(quizId);
  }
}
function setupFocusBlurListeners(input, inputElement, inputType, fieldKey, quizId, pageIndex) {
  const getCurrentValue = () => inputElement.value || "";
  input.addEventListener(DOM_EVENT_NAMES.FOCUS, function() {
    const quizData = createTrackEventsQuizData(quizId);
    trackInputFocus(inputType, fieldKey, quizData, pageIndex, getCurrentValue(), null);
  });
  input.addEventListener(DOM_EVENT_NAMES.BLUR, function() {
    const quizData = createTrackEventsQuizData(quizId);
    trackInputBlur(inputType, fieldKey, quizData, pageIndex, getCurrentValue(), null);
  });
}
function setupTextInputListener(input, inputElement, inputType, fieldKey, quizId, pageIndex) {
  let lastValue = inputElement.value;
  input.addEventListener(DOM_EVENT_NAMES.INPUT, function() {
    const newValue = inputElement.value;
    if (newValue !== lastValue) {
      const quizData = createTrackEventsQuizData(quizId);
      sendTrackingEvent(EVENT_NAMES.INPUT_CHANGED, quizData, {
        input_type: inputType,
        field_key: fieldKey,
        field_value: newValue,
        previous_value: lastValue,
        new_value: newValue,
        question_index: pageIndex,
        event_trigger: EVENT_TRIGGERS.USER_TYPED
      });
      lastValue = newValue;
      clearValidationErrorIfNotEmpty(quizId, newValue);
      updateContinueButtonState(quizId, !validateRequiredFields(quizId));
    }
  });
}
function setupSelectChangeListener(input, inputElement, fieldKey, quizId, pageIndex) {
  input.addEventListener(DOM_EVENT_NAMES.CHANGE, function() {
    const quizData = createTrackEventsQuizData(quizId);
    sendTrackingEvent(EVENT_NAMES.OPTION_SELECTED, quizData, {
      selected_value: inputElement.value,
      selection_type: DROPDOWN_SELECTION_TYPE,
      field_key: fieldKey,
      question_index: pageIndex,
      event_trigger: STRING_VALUES.USER_SELECTED
    });
    clearValidationErrorIfNotEmpty(quizId, inputElement.value);
  });
}
function addInputTracking(input, quizId) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return;
  }
  const inputElement = input;
  const inputType = getInputType(inputElement);
  const fieldKey = getFieldKey(inputElement);
  const pageIndex = getPageIndex(state2);
  setupFocusBlurListeners(input, inputElement, inputType, fieldKey, quizId, pageIndex);
  if (INPUT_TYPE_ARRAYS.TEXT_INPUT_TYPES.includes(
    inputType
  )) {
    setupTextInputListener(
      input,
      inputElement,
      inputType,
      fieldKey,
      quizId,
      pageIndex
    );
  } else if (inputType === INPUT_TYPE_VALUES.SELECT) {
    setupSelectChangeListener(
      input,
      inputElement,
      fieldKey,
      quizId,
      pageIndex
    );
  }
}
function initializeInputTracking(quizId) {
  const quizElement = getQuizElement(quizId);
  if (!quizElement) {
    console.error(`Quiz element not found for quizId: ${quizId}`);
    return;
  }
  const allInputs = quizElement.querySelectorAll(
    SELECTOR_STRINGS.ALL_TRACKABLE_INPUTS
  );
  allInputs.forEach((input) => {
    if (!isHTMLElementLike(input)) {
      return;
    }
    const element = input;
    if (!element.__trackingAttached) {
      addInputTracking(element, quizId);
      element.__trackingAttached = true;
    }
  });
}
function getQuizDataWithErrorHandling(element) {
  const elementQuizData = getQuizDataFromElement(element);
  if (!elementQuizData || !elementQuizData.state) {
    console.error("Quiz data not found for element:", element);
    return null;
  }
  const { quizId, state: state2 } = elementQuizData;
  return { quizId, state: state2, pageIndex: getPageIndex(state2) };
}
function findQuestionContainer(radioInput) {
  if (typeof radioInput.closest !== "function") {
    return null;
  }
  let container = radioInput.closest(
    ELEMENT_SELECTORS.RADIO_QUESTION
  );
  if (!container) {
    container = radioInput.closest(
      `.${SELECTORS.QUESTION_PAGE}`
    );
  }
  if (!container) {
    const nameMatch = radioInput.name.match(REGEX_PATTERNS.RADIO_QUESTION_NAME);
    if (nameMatch) {
      const quizId = nameMatch[1];
      container = radioInput.closest(
        `${SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)} .${SELECTORS.QUESTION_PAGE}`
      );
    }
  }
  if (!container) {
    container = radioInput.closest(
      SELECTORS.FALLBACK_QUESTION_CONTAINER
    );
  }
  return container;
}
function extractCheckedCheckboxValues(container) {
  return Array.from(container.querySelectorAll(SELECTORS.CHECKED_CHECKBOX_INPUT)).filter(isHTMLElementLike).map((cb) => cb.value);
}
function extractRadioValue(target) {
  const input = target;
  return input.checked ? input.value : null;
}
function handleRadioChange(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractRadioValue);
}
function isRadioQuestionAnswered(pageElement) {
  const radioContainers = pageElement.querySelectorAll(
    SELECTORS.RADIO_QUESTION_CONTAINER
  );
  if (radioContainers.length === 0) {
    return false;
  }
  return Array.from(radioContainers).some((container) => {
    return isDefined(container.querySelector(SELECTORS.CHECKED_RADIO_INPUT)) || isDefined(container.querySelector(SELECTORS.CHECKED_CHECKBOX_INPUT));
  });
}
function clearLabelHighlighting(container) {
  container.querySelectorAll(ELEMENT_SELECTORS.LABEL).forEach((label) => {
    label.removeAttribute(DATA_ATTR_NAMES.SELECTED);
  });
}
function hasContinueButton(quizElement) {
  return isDefined(quizElement) && typeof quizElement.querySelectorAll === "function" && quizElement.querySelectorAll(ELEMENT_SELECTORS.CONTINUE_BTN).length > 0;
}
function handleRadioSelection(radioInput, quizId, pageIndex) {
  saveAnswerWithContext(
    quizId,
    radioInput,
    radioInput.value,
    INPUT_TYPE_VALUES.RADIO,
    radioInput.name
  );
  const trackEventsQuizData = createTrackEventsQuizData(quizId);
  trackOptionSelection(
    INPUT_TYPES.RADIO,
    radioInput.value,
    radioInput.name,
    trackEventsQuizData,
    pageIndex,
    null
  );
  hideValidationError(quizId);
  const quizElement = typeof radioInput.closest === "function" ? radioInput.closest(`[id^="${STRING_VALUES.QUIZ_SECTION_PREFIX}"]`) : null;
  if (!hasContinueButton(quizElement)) {
    setTimeout(() => {
      if (window.nextPage) {
        window.nextPage(quizId);
      }
    }, DEFAULT_VALUES.AUTO_ADVANCE_DELAY_MS);
  }
}
function updateRadioHighlighting() {
  const questionContainer = findQuestionContainer(this);
  if (!questionContainer) {
    console.error("Question container not found for radio input:", this);
    return;
  }
  const quizData = getQuizDataWithErrorHandling(this);
  if (!quizData) {
    return;
  }
  const { quizId, pageIndex } = quizData;
  clearLabelHighlighting(questionContainer);
  if (this.checked) {
    const closestLabel = typeof this.closest === "function" ? this.closest(ELEMENT_SELECTORS.LABEL) : null;
    closestLabel?.setAttribute(
      DATA_ATTR_NAMES.SELECTED,
      BOOLEAN_VALUES.TRUE
    );
    handleRadioSelection(this, quizId, pageIndex);
  }
}
function getMaxSelections(container) {
  const maxSelectionsElement = container.querySelector(ELEMENT_SELECTORS.MAX_COUNT);
  if (!maxSelectionsElement) {
    return NUMERIC_CONSTANTS.DEFAULT_MAX_SELECTIONS;
  }
  const match = maxSelectionsElement.textContent?.match(
    REGEX_PATTERNS.DIGIT_EXTRACTION
  )?.[0];
  return match ? parseInt(match, 10) : NUMERIC_CONSTANTS.DEFAULT_MAX_SELECTIONS;
}
function updateCheckboxLabelHighlighting(checkboxInput, isChecked) {
  const closestLabel = typeof checkboxInput.closest === "function" ? checkboxInput.closest(ELEMENT_SELECTORS.LABEL) : null;
  if (!closestLabel) {
    return;
  }
  if (isChecked) {
    closestLabel.setAttribute(
      DATA_ATTR_NAMES.SELECTED,
      BOOLEAN_VALUES.TRUE
    );
  } else {
    closestLabel.removeAttribute(DATA_ATTR_NAMES.SELECTED);
  }
}
function updateSelectionCountDisplay(container, count) {
  const selectionCount = container.querySelector(ELEMENT_SELECTORS.SELECTION_COUNT);
  const countText = selectionCount?.querySelector(ELEMENT_SELECTORS.COUNT_TEXT);
  if (countText) {
    countText.textContent = TEXT_TEMPLATES.SELECTED_COUNT(count);
  }
}
function updateCheckboxDisabledState(container, maxSelections, currentSelectedCount) {
  if (maxSelections === 0) {
    return;
  }
  const allCheckboxes = container.querySelectorAll(SELECTORS.CHECKBOX_INPUT);
  allCheckboxes.forEach((checkbox) => {
    if (!isHTMLElementLike(checkbox)) {
      return;
    }
    const checkboxInput = checkbox;
    const checkboxLabel = typeof checkboxInput.closest === "function" ? checkboxInput.closest(ELEMENT_SELECTORS.LABEL) : null;
    if (!checkboxInput.checked && currentSelectedCount >= maxSelections) {
      checkboxInput.disabled = true;
      if (isHTMLElementLike(checkboxLabel) && checkboxLabel.style) {
        checkboxLabel.style.opacity = CSS_VALUES.OPACITY_DISABLED;
      }
    } else {
      checkboxInput.disabled = false;
      if (isHTMLElementLike(checkboxLabel) && checkboxLabel.style) {
        checkboxLabel.style.opacity = CSS_VALUES.OPACITY_ENABLED;
      }
    }
  });
}
function isNoneOption(checkbox) {
  return typeof checkbox.hasAttribute === "function" && checkbox.hasAttribute(DATA_ATTRIBUTES.IS_NONE);
}
function handleNoneExclusivity(checkbox, container) {
  if (!checkbox.checked) return;
  const isNone = isNoneOption(checkbox);
  const checkboxName = checkbox.name;
  if (isNone) {
    container.querySelectorAll(
      SELECTOR_COMPOSITES.CHECKBOXES_BY_NAME_EXCLUDING_NONE(checkboxName)
    ).forEach((otherCheckbox) => {
      if (!isHTMLElementLike(otherCheckbox)) return;
      const input = otherCheckbox;
      if (input.checked) {
        input.checked = false;
        const label = typeof input.closest === "function" ? input.closest(ELEMENT_SELECTORS.LABEL) : null;
        label?.removeAttribute(DATA_ATTR_NAMES.SELECTED);
        if (input.hasAttribute(DATA_ATTRIBUTES.IS_OTHER)) {
          const otherWrapper = container.querySelector(
            SELECTORS.RADIO_OPTION_OTHER_WRAPPER
          );
          if (otherWrapper?.id) {
            const blockId = otherWrapper.id.replace(
              ID_PREFIXES.OTHER_OPTION_WRAPPER,
              ""
            );
            hideOtherInput(blockId);
          }
        }
      }
    });
  } else {
    const noneCheckbox = container.querySelector(
      `${SELECTORS.CHECKBOX_INPUT}[name="${checkboxName}"][data-is-none="true"]`
    );
    if (noneCheckbox?.checked) {
      noneCheckbox.checked = false;
      const noneLabel = typeof noneCheckbox.closest === "function" ? noneCheckbox.closest(ELEMENT_SELECTORS.LABEL) : null;
      noneLabel?.removeAttribute(DATA_ATTR_NAMES.SELECTED);
    }
  }
}
function updateCheckboxHighlighting() {
  const questionContainer = typeof this.closest === "function" ? this.closest(ELEMENT_SELECTORS.MULTI_INPUT_QUESTION) || this.closest(SELECTORS.RADIO_QUESTION_CONTAINER) : null;
  if (!questionContainer) {
    console.error("Question container not found for checkbox input:", this);
    return;
  }
  handleNoneExclusivity(this, questionContainer);
  const maxSelections = getMaxSelections(questionContainer);
  const selectedValues = extractCheckedCheckboxValues(questionContainer);
  if (this.checked && maxSelections > 0 && selectedValues.length > maxSelections) {
    this.checked = false;
    const currentSelectedCount2 = extractCheckedCheckboxValues(questionContainer).length;
    updateCheckboxDisabledState(questionContainer, maxSelections, currentSelectedCount2);
    return;
  }
  const currentSelectedCount = selectedValues.length;
  updateCheckboxLabelHighlighting(this, this.checked);
  const quizData = getQuizDataWithErrorHandling(this);
  if (!quizData) {
    return;
  }
  const { quizId, pageIndex } = quizData;
  saveAnswerWithContext(
    quizId,
    this,
    selectedValues,
    INPUT_TYPE_VALUES.CHECKBOX,
    this.name
  );
  const trackEventsQuizData = createTrackEventsQuizData(quizId);
  sendTrackingEvent(EVENT_NAMES.MULTISELECT_CHANGED, trackEventsQuizData, {
    selection_type: INPUT_TYPES.CHECKBOX,
    selected_values: selectedValues,
    field_key: this.name,
    question_index: pageIndex,
    event_trigger: EVENT_PROPERTIES.EVENT_TRIGGER.USER_SELECTED
  });
  hideValidationError(quizId);
  updateSelectionCountDisplay(questionContainer, currentSelectedCount);
  updateCheckboxDisabledState(questionContainer, maxSelections, currentSelectedCount);
}
function initializeInputListeners(inputs, changeHandler) {
  inputs.forEach((input) => {
    if (!isHTMLElementLike(input)) {
      return;
    }
    const inputElement = input;
    if (typeof inputElement.removeEventListener === "function") {
      inputElement.removeEventListener(DOM_EVENT_NAMES.CHANGE, changeHandler);
    }
    if (typeof inputElement.addEventListener === "function") {
      inputElement.addEventListener(DOM_EVENT_NAMES.CHANGE, changeHandler);
    }
    if (inputElement.checked) {
      const label = typeof inputElement.closest === "function" ? inputElement.closest(ELEMENT_SELECTORS.LABEL) : null;
      if (label && typeof label.setAttribute === "function") {
        label.setAttribute(
          DATA_ATTR_NAMES.SELECTED,
          BOOLEAN_VALUES.TRUE
        );
      }
    }
  });
}
function getOtherInputElements(blockId) {
  return {
    wrapper: document.getElementById(
      `${ID_PREFIXES.OTHER_INPUT_WRAPPER}${blockId}`
    ),
    input: document.getElementById(
      `${ID_PREFIXES.OTHER_INPUT}${blockId}`
    )
  };
}
function hideOtherInput(blockId) {
  const { wrapper, input } = getOtherInputElements(blockId);
  setElementDisplay(wrapper, DISPLAY_VALUES.NONE);
  if (input) {
    input.value = "";
  }
}
function showOtherInput(blockId) {
  const { wrapper, input } = getOtherInputElements(blockId);
  setElementDisplay(wrapper, DISPLAY_VALUES.BLOCK);
  setTimeout(() => {
    if (input) {
      input.focus();
    }
  }, DEFAULT_VALUES.LOADING_DELAY_MILLISECONDS);
}
function handleOtherOptionChange(blockId, questionId, isChecked) {
  const otherOptionWrapper = document.getElementById(
    `${ID_PREFIXES.OTHER_OPTION_WRAPPER}${blockId}`
  );
  if (isChecked) {
    showOtherInput(blockId);
    const questionContainer = otherOptionWrapper?.closest(
      SELECTORS.RADIO_QUESTION_CONTAINER
    );
    if (questionContainer) {
      const otherInputSelector = otherOptionWrapper?.querySelector(
        SELECTORS.OTHER_INPUT_SELECTOR
      );
      if (otherInputSelector && "type" in otherInputSelector && otherInputSelector.type !== INPUT_TYPE_VALUES.CHECKBOX) {
        questionContainer.querySelectorAll(SELECTOR_COMPOSITES.RADIO_INPUTS_EXCLUDING_OTHER).forEach((input) => {
          if (input && "checked" in input) {
            input.checked = false;
          }
        });
      }
    }
  } else {
    hideOtherInput(blockId);
  }
}
function saveOtherInputValue(blockId) {
  const { input: otherInput } = getOtherInputElements(blockId);
  if (otherInput) {
    otherInput.dispatchEvent(new Event(DOM_EVENT_NAMES.INPUT, { bubbles: true }));
    otherInput.dispatchEvent(new Event(DOM_EVENT_NAMES.CHANGE, { bubbles: true }));
  }
}
function initializeOtherOptionForRadioQuestions() {
  document.querySelectorAll(SELECTORS.RADIO_OPTION_OTHER_WRAPPER).forEach((wrapper) => {
    if (!wrapper.id) return;
    const blockId = wrapper.id.replace(ID_PREFIXES.OTHER_OPTION_WRAPPER, "");
    const otherInputElement = wrapper.querySelector(SELECTORS.OTHER_INPUT_SELECTOR);
    if (!otherInputElement || typeof otherInputElement.addEventListener !== "function") {
      return;
    }
    const otherInput = otherInputElement;
    const { wrapper: otherInputWrapper } = getOtherInputElements(blockId);
    const questionContainer = wrapper.closest(SELECTORS.RADIO_QUESTION_CONTAINER);
    if (!otherInput || !otherInputWrapper || !questionContainer || !otherInput.id) return;
    const questionId = otherInput.id.replace(STRING_VALUES.OTHER_SUFFIX, "");
    setElementDisplay(otherInputWrapper, DISPLAY_VALUES.NONE);
    if (otherInput.checked) {
      handleOtherOptionChange(blockId, questionId, true);
    }
    otherInput.addEventListener(DOM_EVENT_NAMES.CHANGE, function() {
      handleOtherOptionChange(blockId, questionId, this.checked);
    });
    questionContainer.querySelectorAll(SELECTOR_COMPOSITES.RADIO_INPUTS_BY_NAME(otherInput.name)).forEach((radioInput) => {
      if (!radioInput || typeof radioInput.addEventListener !== "function") {
        return;
      }
      radioInput.addEventListener(
        DOM_EVENT_NAMES.CHANGE,
        function() {
          if (this.hasAttribute(DATA_ATTRIBUTES.IS_OTHER) && this.checked) {
            handleOtherOptionChange(blockId, questionId, true);
          } else if (!this.hasAttribute(DATA_ATTRIBUTES.IS_OTHER) && this.checked) {
            if (otherInput.type === INPUT_TYPE_VALUES.CHECKBOX) {
              if (!otherInput.checked) {
                hideOtherInput(blockId);
              }
            } else {
              hideOtherInput(blockId);
            }
          }
        }
      );
    });
  });
  document.querySelectorAll(SELECTORS.OTHER_INPUT).forEach((input) => {
    if (!input) {
      return;
    }
    const inputElement = input;
    if (typeof inputElement.addEventListener !== "function" || !inputElement.id || !inputElement.tagName || inputElement.tagName !== "INPUT") {
      return;
    }
    inputElement.addEventListener(DOM_EVENT_NAMES.INPUT, function() {
      saveOtherInputValue(inputElement.id.replace(ID_PREFIXES.OTHER_INPUT, ""));
    });
  });
}
function initializeRadioQuestions() {
  let radioInputs = document.querySelectorAll(
    SELECTOR_COMPOSITES.RADIO_QUESTION_INPUTS(
      ELEMENT_SELECTORS.RADIO_QUESTION
    )
  );
  if (radioInputs.length === 0) {
    radioInputs = document.querySelectorAll(
      SELECTOR_COMPOSITES.RADIO_INPUTS_IN_QUIZ_SECTION
    );
  }
  if (radioInputs.length === 0) {
    document.querySelectorAll(
      `${SELECTORS.QUESTION_PAGE}.${SELECTORS.CURRENT_PAGE}`
    ).forEach((page) => {
      const pageRadios = page.querySelectorAll(SELECTORS.RADIO_INPUT);
      if (pageRadios.length > 0) {
        initializeInputListeners(
          pageRadios,
          updateRadioHighlighting
        );
      }
    });
  } else {
    initializeInputListeners(radioInputs, updateRadioHighlighting);
  }
  const radioQuestionCheckboxes = document.querySelectorAll(
    `${SELECTORS.RADIO_QUESTION_CONTAINER} ${SELECTORS.CHECKBOX_INPUT}`
  );
  if (radioQuestionCheckboxes.length > 0) {
    initializeInputListeners(radioQuestionCheckboxes, updateCheckboxHighlighting);
  }
  initializeOtherOptionForRadioQuestions();
}
function isHTMLButtonElement(element) {
  return isHTMLElementLike(element) && element.tagName.toLowerCase() === "button";
}
function removeSelectedClassFromButtons(buttons) {
  buttons.forEach((btn) => {
    if (isHTMLButtonElement(btn)) {
      btn.classList.remove(DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED);
    }
  });
}
const processedQuizIds = /* @__PURE__ */ new Set();
function buildScopeAttribute(storageScope) {
  return storageScope ? ` data-storage-scope="${storageScope}"` : "";
}
function appendScopeAttribute(html, scopeAttr) {
  if (!scopeAttr) {
    return html;
  }
  return html.replace(/>/, `${scopeAttr}>`);
}
function parseOptions(placeholder) {
  return placeholder.split(MULTI_INPUT_CONSTANTS.OPTION_SEPARATOR).map((option) => option.trim()).filter((option) => option !== "");
}
function parseCommaSeparatedValues(value) {
  return value.split(MULTI_INPUT_CONSTANTS.MULTI_SELECT_SEPARATOR).map((v) => v.trim()).filter((v) => v !== "");
}
function escapeHtmlAttr(value) {
  return String(value || "").replace(/&/g, HTML_ENTITIES.AMPERSAND).replace(/"/g, HTML_ENTITIES.QUOTE).replace(/'/g, HTML_ENTITIES.APOSTROPHE).replace(/</g, HTML_ENTITIES.LESS_THAN).replace(/>/g, HTML_ENTITIES.GREATER_THAN);
}
function replaceTemplatePlaceholders(template, replacements) {
  let result = template;
  Object.keys(replacements).forEach((key) => {
    const regexPattern = new RegExp(
      `${MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_REGEX_PATTERN}${key}${MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_REGEX_SUFFIX}`,
      "g"
    );
    result = result.replace(regexPattern, replacements[key]);
  });
  return result;
}
function getInputValue(inputName, defaultValue, quizId, storageScope) {
  if (!quizId) {
    return defaultValue;
  }
  const quizData = getQuizData(quizId);
  const savedValue = storageScope === STORAGE_TARGET_TYPES.GLOBAL ? quizData.GlobalObject[inputName] : quizData.EntitiesObject && quizData.EntitiesObject.length > 0 ? quizData.EntitiesObject[quizData.EntitiesObject.length - MULTI_INPUT_CONSTANTS.LAST_ELEMENT_OFFSET]?.[inputName] : void 0;
  return isDefined(savedValue) && savedValue !== "" ? String(savedValue) : defaultValue;
}
function createSelectHtml(inputId, inputName, inputSize, placeholder, inputValue = "") {
  const options = parseOptions(placeholder);
  let html = `<select id="${inputId}" name="${inputName}" class="${DYNAMIC_CLASS_NAMES.INLINE_INPUT} ${inputSize}">`;
  if (!inputValue) {
    html += `<option${HTML_ATTR_STRINGS.EMPTY_VALUE}>${HTML_ATTRIBUTES.PLACEHOLDER_CHOOSE}</option>`;
  }
  options.forEach((option) => {
    const escapedOption = escapeHtmlAttr(option);
    html += `<option value="${escapedOption}"${option === inputValue ? HTML_ATTR_STRINGS.SELECTED : ""}>${escapedOption}</option>`;
  });
  html += `</select>`;
  return html;
}
function createAutocompleteHtml(inputId, inputName, inputSize, placeholder, inputValue = "", customPlaceholder = "") {
  const options = parseOptions(placeholder);
  const datalistId = `${TEXT_TEMPLATES.DATALIST_PREFIX}${inputId}`;
  const placeholderText = customPlaceholder || HTML_ATTRIBUTES.PLACEHOLDER_TYPE_TO_SEARCH;
  let html = `<input type="text" id="${inputId}" name="${inputName}" class="${DYNAMIC_CLASS_NAMES.INLINE_INPUT} ${inputSize}" placeholder="${inputValue ? "" : escapeHtmlAttr(placeholderText)}" value="${escapeHtmlAttr(inputValue)}" list="${datalistId}">`;
  html += `<datalist id="${datalistId}">`;
  options.forEach((option) => {
    const escapedOption = escapeHtmlAttr(option);
    html += `<option value="${escapedOption}">${escapedOption}</option>`;
  });
  html += `</datalist>`;
  return html;
}
function createButtonGroupHtml(inputId, inputName, placeholder, storageScope, inputValue = "", multiSelect = "", specialOption = "") {
  const options = parseOptions(placeholder);
  const isMultiSelect = multiSelect.toLowerCase() === MULTI_INPUT_CONSTANTS.MULTI_SELECT_VALUE;
  const savedValues = isMultiSelect && inputValue ? parseCommaSeparatedValues(inputValue) : [];
  const allOptions = [...options];
  if (specialOption && !options.some((opt) => opt.toLowerCase() === specialOption.toLowerCase())) {
    allOptions.push(specialOption);
  }
  const groupAttributes = `class="inline-button-group"${isMultiSelect ? ` data-multi-select="${MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE}"` : ""}${specialOption ? ` data-special-option="${escapeHtmlAttr(specialOption)}"` : ""}`;
  let html = `<div ${groupAttributes}>`;
  allOptions.forEach((option, index) => {
    const escapedOption = escapeHtmlAttr(option);
    const isSpecialOption = specialOption && option.toLowerCase() === specialOption.toLowerCase();
    const isSelected = isMultiSelect ? savedValues.includes(option) : option === inputValue;
    const selectedClass = isSelected ? ` ${DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED}` : "";
    let buttonHtml = HTML_TEMPLATES.BUTTON_INPUT.replace(
      MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_ID,
      `${inputId}-${index}`
    ).replace(MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_NAME, inputName).replace(MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_VALUE, escapedOption).replace(MULTI_INPUT_CONSTANTS.TEMPLATE_PLACEHOLDER_TEXT, escapedOption).replace(
      DYNAMIC_CLASS_NAMES.INLINE_BUTTON,
      `${DYNAMIC_CLASS_NAMES.INLINE_BUTTON}${selectedClass}`
    );
    if (isSpecialOption) {
      buttonHtml = buttonHtml.replace(
        MULTI_INPUT_CONSTANTS.BUTTON_TYPE_ATTRIBUTE,
        `${MULTI_INPUT_CONSTANTS.BUTTON_TYPE_ATTRIBUTE} data-special-option="${MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE}"`
      );
    }
    html += appendScopeAttribute(buttonHtml, buildScopeAttribute(storageScope));
  });
  html += HTML_TEMPLATES.BUTTON_GROUP_END;
  return html;
}
function createInputHtml(type, inputId, inputName, inputSize, placeholder, minValue, maxValue, storageScope, defaultValue = "", quizId = void 0, multiSelect = "", specialOption = "", placeholderText = "") {
  const scopeAttr = buildScopeAttribute(storageScope);
  const inputValue = getInputValue(inputName, defaultValue, quizId, storageScope);
  switch (type) {
    case INPUT_TYPE_VALUES.SELECT:
      return appendScopeAttribute(
        createSelectHtml(inputId, inputName, inputSize, placeholder, inputValue),
        scopeAttr
      );
    case INPUT_TYPE_VALUES.AUTOCOMPLETE:
      return appendScopeAttribute(
        createAutocompleteHtml(
          inputId,
          inputName,
          inputSize,
          placeholder,
          inputValue,
          placeholderText
        ),
        scopeAttr
      );
    case INPUT_TYPE_VALUES.BUTTON:
      return createButtonGroupHtml(
        inputId,
        inputName,
        placeholder,
        storageScope,
        inputValue,
        multiSelect,
        specialOption
      );
    case INPUT_TYPE_VALUES.TEXTAREA:
      return appendScopeAttribute(
        replaceTemplatePlaceholders(HTML_TEMPLATES.TEXTAREA, {
          id: inputId,
          name: inputName,
          size: inputSize,
          placeholder: escapeHtmlAttr(placeholder),
          value: escapeHtmlAttr(inputValue),
          rows: HTML_ATTRIBUTES.ROWS
        }),
        scopeAttr
      );
    default: {
      const isNumberOrRange = type === INPUT_TYPE_VALUES.NUMBER || type === INPUT_TYPE_VALUES.RANGE;
      const template = isNumberOrRange ? HTML_TEMPLATES.INPUT_NUMBER : type === INPUT_TYPE_VALUES.EMAIL ? HTML_TEMPLATES.INPUT_EMAIL : HTML_TEMPLATES.INPUT_TEXT;
      const replacements = {
        type,
        id: inputId,
        name: inputName,
        size: inputSize,
        placeholder: escapeHtmlAttr(inputValue ? "" : placeholder),
        value: escapeHtmlAttr(inputValue)
      };
      if (isNumberOrRange) {
        replacements.min = minValue || "";
        replacements.max = maxValue || "";
      }
      return appendScopeAttribute(
        replaceTemplatePlaceholders(template, replacements),
        scopeAttr
      );
    }
  }
}
function processInlineInputs(element, text, questionId, defaultStorageScope = MULTI_INPUT_CONSTANTS.DEFAULT_STORAGE_SCOPE_ENTITY, quizId = void 0) {
  let inputCounter = 0;
  const parts = [];
  let i = 0;
  while (i < text.length) {
    const start = text.indexOf(MULTI_INPUT_CONSTANTS.INPUT_PLACEHOLDER_PREFIX, i);
    if (start === -1) {
      parts.push(text.slice(i));
      break;
    }
    if (start > i) {
      parts.push(text.slice(i, start));
    }
    const end = text.indexOf(MULTI_INPUT_CONSTANTS.INPUT_PLACEHOLDER_SUFFIX, start);
    if (end === -1) {
      parts.push(text.slice(start));
      break;
    }
    const inside = text.slice(
      start + MULTI_INPUT_CONSTANTS.INPUT_PLACEHOLDER_PREFIX_LENGTH,
      end
    );
    const segments = inside.split(MULTI_INPUT_CONSTANTS.SEGMENT_SEPARATOR);
    const type = segments[0] || "";
    const size = segments[1] || "";
    const placeholder = segments[2] || "";
    const keyName = segments[3] || "";
    let minValue = "";
    let maxValue = "";
    let storageScope = defaultStorageScope;
    let defaultValue = "";
    let multiSelect = "";
    let specialOption = "";
    let placeholderText = "";
    if (type === INPUT_TYPE_VALUES.AUTOCOMPLETE) {
      storageScope = segments[4] || defaultStorageScope;
      placeholderText = segments[5] || "";
    } else {
      minValue = segments[4] || "";
      maxValue = segments[5] || "";
      storageScope = segments[6] || defaultStorageScope;
      defaultValue = segments[7] || "";
      multiSelect = segments[8] || "";
      specialOption = segments[9] || "";
    }
    inputCounter++;
    parts.push(
      createInputHtml(
        type,
        `${TEXT_TEMPLATES.INLINE_INPUT_PREFIX}${inputCounter}-${questionId}`,
        keyName || `${TEXT_TEMPLATES.INLINE_INPUT_NAME_PREFIX}${inputCounter}_${questionId}`,
        size || DEFAULT_SIZE_VALUES.MEDIUM,
        placeholder || "",
        minValue || "",
        maxValue || "",
        storageScope,
        defaultValue,
        quizId,
        multiSelect,
        specialOption,
        placeholderText
      )
    );
    i = end + 1;
  }
  element.innerHTML = parts.join("").replace(REGEX_PATTERNS.NEWLINE, HTML_REPLACEMENTS.NEWLINE_TO_BR);
  element.dataset.inputsProcessed = "true";
}
function initializeInputTrackingForElement(element, quizId) {
  if (!element) {
    return;
  }
  const allInputs = element.querySelectorAll(SELECTOR_STRINGS.ALL_TRACKABLE_INPUTS);
  allInputs.forEach((input) => {
    if (!isHTMLElementLike(input)) {
      return;
    }
    const inputElement = input;
    if (!inputElement.__trackingAttached) {
      addInputTracking(inputElement, quizId);
      inputElement.__trackingAttached = true;
    }
  });
}
function initializeButtonClickHandlers(element, quizId) {
  if (!element) {
    return;
  }
  const buttonGroups = element.querySelectorAll(
    `.${DYNAMIC_CLASS_NAMES.INLINE_BUTTON_GROUP}`
  );
  buttonGroups.forEach((group) => {
    const groupElement = group;
    const isMultiSelect = groupElement.dataset.multiSelect === MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE;
    const specialOption = groupElement.dataset.specialOption || "";
    const buttons = group.querySelectorAll(SELECTORS.BUTTON_INPUT);
    buttons.forEach((button) => {
      if (!isHTMLElementLike(button)) {
        return;
      }
      const buttonElement = button;
      if (buttonElement.__clickAttached) {
        return;
      }
      buttonElement.addEventListener("click", () => {
        const storageScope = getStorageScope(buttonElement);
        const keyName = buttonElement.name;
        const clickedValue = buttonElement.value;
        const isSpecialOptionButton = buttonElement.dataset.specialOption === MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE;
        if (!keyName || !clickedValue) {
          return;
        }
        const quizData = getQuizData(quizId);
        const storageTarget = storageScope === STORAGE_TARGET_TYPES.GLOBAL ? quizData.GlobalObject : quizData.EntitiesObject.length > 0 ? quizData.EntitiesObject[quizData.EntitiesObject.length - 1] : null;
        if (!storageTarget) {
          return;
        }
        if (isSpecialOptionButton && specialOption) {
          removeSelectedClassFromButtons(buttons);
          buttonElement.classList.add(
            DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
          );
          storageTarget[keyName] = clickedValue;
          saveAnswerWithContext(
            quizId,
            buttonElement,
            clickedValue,
            INPUT_TYPE_VALUES.BUTTON,
            keyName
          );
          return;
        }
        if (specialOption && !isSpecialOptionButton) {
          buttons.forEach((btn) => {
            if (isHTMLButtonElement(btn) && btn.dataset.specialOption === MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE) {
              btn.classList.remove(
                DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
              );
            }
          });
        }
        if (isMultiSelect) {
          const currentValue = storageTarget[keyName];
          let selectedValues = [];
          if (Array.isArray(currentValue)) {
            selectedValues = [...currentValue];
          } else if (typeof currentValue === "string" && currentValue) {
            selectedValues = parseCommaSeparatedValues(currentValue);
          }
          if (specialOption && !isSpecialOptionButton && selectedValues.includes(specialOption)) {
            selectedValues = selectedValues.filter((v) => v !== specialOption);
          }
          const isCurrentlySelected = buttonElement.classList.contains(
            DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
          );
          if (isCurrentlySelected) {
            selectedValues = selectedValues.filter((v) => v !== clickedValue);
            buttonElement.classList.remove(
              DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
            );
          } else {
            if (!selectedValues.includes(clickedValue)) {
              selectedValues.push(clickedValue);
            }
            buttonElement.classList.add(
              DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
            );
          }
          const finalValue = selectedValues.length > 0 ? selectedValues.join(
            MULTI_INPUT_CONSTANTS.MULTI_SELECT_SEPARATOR
          ) : "";
          storageTarget[keyName] = finalValue;
          saveAnswerWithContext(
            quizId,
            buttonElement,
            finalValue,
            INPUT_TYPE_VALUES.BUTTON,
            keyName
          );
        } else {
          removeSelectedClassFromButtons(buttons);
          buttonElement.classList.add(
            DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED
          );
          storageTarget[keyName] = clickedValue;
          saveAnswerWithContext(
            quizId,
            buttonElement,
            clickedValue,
            INPUT_TYPE_VALUES.BUTTON,
            keyName
          );
        }
      });
      buttonElement.__clickAttached = true;
    });
  });
}
function validateEmailInput(value) {
  if (!value || value.trim() === "") {
    return false;
  }
  return validator.isEmail(value.trim());
}
function validateNumberInput(value, min, max) {
  if (!value || value.trim() === "") {
    return false;
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return false;
  }
  if (isDefined(min) && min !== "" && numValue < Number(min)) {
    return false;
  }
  if (isDefined(max) && max !== "" && numValue > Number(max)) {
    return false;
  }
  return true;
}
function validateNonEmptyTextInput(value) {
  return isDefined(value) && value.trim() !== "";
}
function validateSelectInput(selectElement) {
  if (selectElement.selectedIndex < 0) {
    return false;
  }
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const hasEmptyValue = selectedOption && selectedOption.value === "";
  return !hasEmptyValue && selectElement.value.trim() !== "";
}
function validateButtonGroup(buttonGroup) {
  return isDefined(buttonGroup.querySelector(SELECTORS.SELECTED_BUTTON));
}
function validateInlineInput(inputElement) {
  const value = inputElement.value;
  const inputType = inputElement.getAttribute("type") || inputElement.tagName.toLowerCase();
  const min = inputElement.min;
  const max = inputElement.max;
  switch (inputType) {
    case INPUT_TYPE_VALUES.EMAIL:
      return validateEmailInput(value);
    case INPUT_TYPE_VALUES.NUMBER:
    case INPUT_TYPE_VALUES.RANGE:
      return validateNumberInput(value, min, max);
    case INPUT_TYPE_VALUES.SELECT:
    case HTML_TAGS.SELECT:
      return validateSelectInput(inputElement);
    case INPUT_TYPE_VALUES.TEXTAREA:
    case HTML_TAGS.TEXTAREA:
    case INPUT_TYPE_VALUES.AUTOCOMPLETE:
    case INPUT_TYPE_VALUES.TEXT:
    default:
      return validateNonEmptyTextInput(value);
  }
}
function isMultiInputQuestionAnswered(pageElement) {
  const hasMultiInputContainer = isDefined(
    pageElement.querySelector(SELECTORS.MULTI_INPUT_QUESTION_CONTAINER)
  );
  if (!hasMultiInputContainer) {
    return false;
  }
  const inlineInputs = pageElement.querySelectorAll(
    `.${DYNAMIC_CLASS_NAMES.INLINE_INPUT}`
  );
  const inlineButtonGroups = pageElement.querySelectorAll(
    `.${DYNAMIC_CLASS_NAMES.INLINE_BUTTON_GROUP}`
  );
  if (inlineInputs.length > 0) {
    const allInputsValid = Array.from(inlineInputs).every((input) => {
      if (!isHTMLElementLike(input)) {
        return false;
      }
      const inputElement = input;
      return validateInlineInput(inputElement);
    });
    if (!allInputsValid) {
      return false;
    }
  }
  if (inlineButtonGroups.length > 0) {
    const allButtonsSelected = Array.from(inlineButtonGroups).every(
      (group) => validateButtonGroup(group)
    );
    if (!allButtonsSelected) {
      return false;
    }
  }
  return true;
}
function processElementWithInlineInputs(element, originalText, questionId, defaultStorageScope, quizId) {
  processInlineInputs(
    element,
    replaceDynamicStrings(originalText),
    questionId,
    defaultStorageScope,
    quizId
  );
  if (quizId) {
    processedQuizIds.add(quizId);
    initializeListeners(quizId);
    setTimeout(() => {
      initializeInputTrackingForElement(element, quizId);
      initializeButtonClickHandlers(element, quizId);
      const currentPageEl = element.closest(`.${SELECTORS.QUESTION_PAGE}`);
      if (currentPageEl) {
        currentPageEl.querySelectorAll(SELECTORS.ALL_INPUTS).forEach((input) => {
          const inputEl = input;
          if (!inputEl.__repopulateAttached) {
            inputEl.addEventListener("blur", () => {
              repopulateInlineInputs(currentPageEl, quizId);
            });
            inputEl.__repopulateAttached = true;
          }
        });
      }
    }, MULTI_INPUT_CONSTANTS.SET_TIMEOUT_IMMEDIATE_DELAY);
  }
}
function processQuestionHeaders(question) {
  if (typeof question.querySelector !== "function") {
    return;
  }
  const titleElement = question.querySelector(SELECTORS.HEADING_3);
  if (isHTMLElementLike(titleElement)) {
    titleElement.textContent = replaceDynamicStrings(titleElement.textContent || "");
  }
  const subtitleElement = question.querySelector(SELECTORS.HEADING_4);
  if (isHTMLElementLike(subtitleElement)) {
    subtitleElement.textContent = replaceDynamicStrings(subtitleElement.textContent || "");
  }
}
function processQuestionText(question, questionId, defaultStorageScope, quizId) {
  if (typeof question.querySelector !== "function") {
    return;
  }
  const questionTextElement = question.querySelector(SELECTORS.DATA_QUESTION_TEXT);
  if (!isHTMLElementLike(questionTextElement)) {
    return;
  }
  const originalText = questionTextElement.dataset[DATA_ATTR_NAMES.QUESTION_TEXT];
  if (!originalText) {
    return;
  }
  processElementWithInlineInputs(
    questionTextElement,
    originalText,
    questionId,
    defaultStorageScope,
    quizId
  );
}
function processQuestionMessage(question, questionId, defaultStorageScope, quizId) {
  if (typeof question.querySelectorAll !== "function") {
    return;
  }
  const messageElements = question.querySelectorAll(SELECTORS.DATA_QUESTION_TEXT);
  if (messageElements.length <= MULTI_INPUT_CONSTANTS.MESSAGE_ELEMENT_INDEX) {
    return;
  }
  const messageElement = messageElements[MULTI_INPUT_CONSTANTS.MESSAGE_ELEMENT_INDEX];
  if (!isHTMLElementLike(messageElement)) {
    return;
  }
  const originalMessageText = messageElement.dataset[DATA_ATTR_NAMES.QUESTION_TEXT];
  if (originalMessageText) {
    processElementWithInlineInputs(
      messageElement,
      originalMessageText,
      questionId,
      defaultStorageScope,
      quizId
    );
  } else {
    messageElement.innerHTML = replaceDynamicStrings(messageElement.textContent || "");
    messageElement.dataset.inputsProcessed = "true";
  }
}
function processSingleMultiInputQuestion(question) {
  if (!question.dataset) {
    return;
  }
  const quizData = getQuizDataFromElement(question);
  const quizId = quizData?.quizId;
  if (!quizId) {
    console.error("Quiz not found");
    return;
  }
  processedQuizIds.add(quizId);
  if (question.dataset[DATA_ATTR_NAMES.INITIALIZED]) {
    return;
  }
  question.dataset[DATA_ATTR_NAMES.INITIALIZED] = BOOLEAN_VALUES.TRUE;
  const defaultStorageScope = getStorageScope(question);
  const questionId = question.dataset[DATA_ATTRIBUTES.QUESTION_ID] || "";
  if (typeof question.querySelector === "function") {
    processQuestionHeaders(question);
  }
  processQuestionText(question, questionId, defaultStorageScope, quizId);
  processQuestionMessage(question, questionId, defaultStorageScope, quizId);
}
function initializeProcessedQuizListeners() {
  processedQuizIds.forEach((quizId) => {
    initializeListeners(quizId);
    initializeInputTracking(quizId);
    const dataQuizIdSelector = SELECTOR_TEMPLATES.QUIZ_SECTION_BY_DATA_QUIZ_ID(quizId);
    const idSelector = SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId);
    const quizElement = document.querySelector(`${dataQuizIdSelector}, ${idSelector}`);
    if (quizElement) {
      initializeButtonClickHandlers(quizElement, quizId);
    }
  });
}
function getValueFromStorageScope(quizData, keyName, storageScope, quizId) {
  if (storageScope === STORAGE_TARGET_TYPES.GLOBAL) {
    return quizData.GlobalObject[keyName];
  }
  if (quizData.EntitiesObject.length > 0) {
    const entityIndex = quizId ? getCurrentEntityObjectIndex(quizId) : quizData.EntitiesObject.length - 1;
    return quizData.EntitiesObject[entityIndex]?.[keyName];
  }
  return void 0;
}
function repopulateInlineInputs(currentPageEl, quizId) {
  const quizData = getQuizData(quizId);
  if (!quizData) {
    console.warn(`${ERROR_MESSAGES$2.NO_QUIZ_DATA_FOUND} ${quizId}`);
    return;
  }
  const inlineInputs = currentPageEl.querySelectorAll(
    `.${DYNAMIC_CLASS_NAMES.INLINE_INPUT}`
  );
  inlineInputs.forEach((input) => {
    const element = input;
    const keyName = element.name || element.id;
    if (!keyName) {
      return;
    }
    const storageScope = getStorageScope(element);
    const value = getValueFromStorageScope(quizData, keyName, storageScope, quizId);
    if (!isDefined(value)) {
      return;
    }
    if (element.tagName === HTML_TAGS.SELECT) {
      element.value = String(value);
    } else {
      element.value = String(value);
    }
  });
  const inlineButtonGroups = currentPageEl.querySelectorAll(
    `.${DYNAMIC_CLASS_NAMES.INLINE_BUTTON_GROUP}`
  );
  inlineButtonGroups.forEach((group) => {
    const groupElement = group;
    const isMultiSelect = groupElement.dataset.multiSelect === MULTI_INPUT_CONSTANTS.DATASET_TRUE_VALUE;
    const buttons = group.querySelectorAll(SELECTORS.BUTTON_INPUT);
    const firstButton = buttons[0];
    if (!isHTMLButtonElement(firstButton)) {
      return;
    }
    const keyName = firstButton.name;
    if (!keyName) {
      return;
    }
    const storageScope = getStorageScope(firstButton);
    const value = getValueFromStorageScope(quizData, keyName, storageScope, quizId);
    if (!isDefined(value)) {
      return;
    }
    if (isMultiSelect) {
      const selectedValues = parseCommaSeparatedValues(String(value));
      buttons.forEach((button) => {
        if (!isHTMLButtonElement(button)) {
          return;
        }
        if (selectedValues.includes(button.value)) {
          button.classList.add(DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED);
        } else {
          button.classList.remove(DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED);
        }
      });
    } else {
      buttons.forEach((button) => {
        if (!isHTMLButtonElement(button)) {
          return;
        }
        if (button.value === String(value)) {
          button.classList.add(DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED);
        } else {
          button.classList.remove(DYNAMIC_CLASS_NAMES.INLINE_BUTTON_SELECTED);
        }
      });
    }
  });
}
function initializeMultiInputQuestions() {
  const multiInputQuestions = document.querySelectorAll(
    ELEMENT_SELECTORS.MULTI_INPUT_QUESTION
  );
  processedQuizIds.clear();
  initializeInputListeners(
    document.querySelectorAll(
      SELECTOR_COMPOSITES.MULTI_INPUT_CHECKBOX(
        ELEMENT_SELECTORS.MULTI_INPUT_QUESTION
      )
    ),
    updateCheckboxHighlighting
  );
  multiInputQuestions.forEach((question) => {
    if (isHTMLElementLike(question)) {
      processSingleMultiInputQuestion(question);
    }
  });
  initializeProcessedQuizListeners();
}
function isHTMLInputElementLike$1(element) {
  if (element instanceof HTMLInputElement) return true;
  return "value" in element && "min" in element && typeof element.value === "string";
}
function isHTMLTextAreaElementLike(element) {
  if (element instanceof HTMLTextAreaElement) return true;
  return "value" in element && typeof element.value === "string" && "rows" in element;
}
function isHTMLSelectElementLike(element) {
  if (element instanceof HTMLSelectElement) return true;
  return "value" in element && typeof element.value === "string" && "options" in element;
}
function isSliderQuestionAnswered(pageElement) {
  if (!isDefined(pageElement.querySelector(SELECTORS.SLIDER_QUESTION_CONTAINER))) {
    return false;
  }
  return Array.from(pageElement.querySelectorAll(SELECTORS.SLIDER_INPUT)).some(
    (input) => {
      if (!isHTMLInputElementLike$1(input)) return false;
      return input.value && input.value !== "" && input.value !== input.min;
    }
  );
}
function isTextInputQuestionAnswered(pageElement) {
  const textInputs = pageElement.querySelectorAll(SELECTORS.TEXT_INPUTS_SELECTOR);
  if (textInputs.length === 0) {
    return false;
  }
  return Array.from(textInputs).some((input) => {
    if (!isHTMLInputElementLike$1(input) && !isHTMLTextAreaElementLike(input) && !isHTMLSelectElementLike(input))
      return false;
    return (input.value?.trim() || "") !== "";
  });
}
function hasQuestionContainers(pageElement) {
  return isDefined(pageElement.querySelector(SELECTORS.RADIO_QUESTION_CONTAINER)) || isDefined(pageElement.querySelector(SELECTORS.RATING_QUESTION_CONTAINER)) || isDefined(pageElement.querySelector(SELECTORS.SLIDER_QUESTION_CONTAINER)) || isDefined(
    pageElement.querySelector(SELECTORS.MULTI_INPUT_QUESTION_CONTAINER)
  ) || pageElement.querySelectorAll(SELECTORS.TEXT_INPUTS_SELECTOR).length > 0;
}
function isRequiredQuestionAnswered(pageElement) {
  if (!pageElement || !pageElement.dataset) {
    return true;
  }
  const requiredValue = pageElement.dataset[DATA_ATTRIBUTES.REQUIRED];
  const isRequired = requiredValue === BOOLEAN_VALUES.TRUE;
  if (!isRequired) {
    return true;
  }
  if (!hasQuestionContainers(pageElement)) {
    return true;
  }
  const hasRadioQuestion = isDefined(
    pageElement.querySelector(SELECTORS.RADIO_QUESTION_CONTAINER)
  );
  const hasRatingQuestion = isDefined(
    pageElement.querySelector(SELECTORS.RATING_QUESTION_CONTAINER)
  );
  const hasSliderQuestion = isDefined(
    pageElement.querySelector(SELECTORS.SLIDER_QUESTION_CONTAINER)
  );
  const hasMultiInputQuestion = isDefined(
    pageElement.querySelector(SELECTORS.MULTI_INPUT_QUESTION_CONTAINER)
  );
  const hasTextInputs = pageElement.querySelectorAll(SELECTORS.TEXT_INPUTS_SELECTOR).length > 0;
  if (hasRadioQuestion && !isRadioQuestionAnswered(pageElement)) {
    return false;
  }
  if (hasRatingQuestion && !isRatingQuestionAnswered(pageElement)) {
    return false;
  }
  if (hasSliderQuestion && !isSliderQuestionAnswered(pageElement)) {
    return false;
  }
  if (hasMultiInputQuestion && !isMultiInputQuestionAnswered(pageElement)) {
    return false;
  }
  if (hasTextInputs && !isTextInputQuestionAnswered(pageElement)) {
    return false;
  }
  return true;
}
function validateRequiredFields(quizId) {
  const currentPageEl = getCurrentPageElement(quizId);
  if (!isHTMLElementLike(currentPageEl)) {
    return true;
  }
  return isRequiredQuestionAnswered(currentPageEl);
}
function updateContinueButtonState(quizId, isDeactive) {
  const quizElement = document.querySelector(
    SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)
  );
  if (!quizElement) {
    return;
  }
  const continueButtons = quizElement.querySelectorAll(
    ELEMENT_SELECTORS.CONTINUE_BTN
  );
  continueButtons.forEach((btn) => {
    if (!isHTMLElementLike(btn)) return;
    if (isDeactive) {
      btn.classList.add(CLASS_NAMES.CONTINUE_BTN_DEACTIVE);
      btn.setAttribute(
        HTML_ATTRIBUTES.ARIA_DISABLED,
        BOOLEAN_VALUES.TRUE
      );
    } else {
      btn.classList.remove(CLASS_NAMES.CONTINUE_BTN_DEACTIVE);
      btn.removeAttribute(HTML_ATTRIBUTES.ARIA_DISABLED);
    }
  });
}
function removeExistingValidationError(pageElement) {
  const existingError = pageElement.querySelector(SELECTORS.VALIDATION_ERROR);
  if (existingError) {
    existingError.remove();
  }
}
function getValidationErrorText(quizId) {
  const quizElement = getQuizElement(quizId);
  return quizElement?.dataset[DATA_ATTRIBUTES.VALIDATION_ERROR_TEXT] || ERROR_MESSAGES$2.REQUIRED_FIELD_NOT_ANSWERED;
}
function createValidationErrorElement(text) {
  const errorElement = document.createElement("div");
  errorElement.className = SELECTORS.VALIDATION_ERROR.startsWith(
    CSS_SELECTOR_PREFIX.CLASS
  ) ? SELECTORS.VALIDATION_ERROR.substring(1) : SELECTORS.VALIDATION_ERROR;
  errorElement.textContent = text;
  return errorElement;
}
function insertErrorElement(pageElement, errorElement) {
  if (pageElement.firstElementChild) {
    pageElement.insertBefore(errorElement, pageElement.firstElementChild);
  } else {
    pageElement.appendChild(errorElement);
  }
}
function showValidationError(quizId) {
  const currentPageEl = getCurrentPageElement(quizId);
  if (!isHTMLElementLike(currentPageEl)) {
    return;
  }
  updateContinueButtonState(quizId, true);
  removeExistingValidationError(currentPageEl);
  const errorElement = createValidationErrorElement(getValidationErrorText(quizId));
  insertErrorElement(currentPageEl, errorElement);
  errorElement.scrollIntoView?.({
    behavior: SCROLL_BEHAVIOR.SMOOTH,
    block: SCROLL_BLOCK.CENTER
  });
}
function hideValidationError(quizId) {
  const currentPageEl = getCurrentPageElement(quizId);
  if (!currentPageEl) {
    return;
  }
  updateContinueButtonState(quizId, !validateRequiredFields(quizId));
  removeExistingValidationError(currentPageEl);
}
function isRatingQuestionAnswered(pageElement) {
  const ratingContainer = pageElement.querySelector(
    SELECTORS.RATING_QUESTION_CONTAINER
  );
  if (!isDefined(ratingContainer)) {
    return false;
  }
  if (isDefined(pageElement.querySelector(SELECTOR_STRINGS.RATING_CHECKED_RADIO))) {
    return true;
  }
  const hiddenInputs = Array.from(
    pageElement.querySelectorAll(SELECTOR_STRINGS.RATING_HIDDEN_INPUTS)
  ).filter(isHTMLElementLike);
  const hasSelectedHiddenInput = hiddenInputs.some((input) => {
    const value = input.value?.trim() || "";
    const dataSelected = input.getAttribute(HTML_ATTRIBUTES.DATA_SELECTED);
    return value !== "" && dataSelected === BOOLEAN_VALUES.TRUE;
  });
  if (hasSelectedHiddenInput) {
    return true;
  }
  const starRatingContainer = ratingContainer.querySelector(SELECTORS.STAR_RATING);
  if (starRatingContainer && isHTMLElementLike(starRatingContainer)) {
    const ratingValue = starRatingContainer.getAttribute(
      `data-${DATA_ATTRIBUTES.RATING}`
    );
    if (ratingValue && ratingValue !== "" && ratingValue !== "0") {
      return true;
    }
  }
  return false;
}
function updateStarVisualState(stars, ratingValue) {
  stars.forEach((star, index) => {
    if (!isHTMLElementLike(star) && !("classList" in star && star.classList && "add" in star.classList && "remove" in star.classList)) {
      return;
    }
    const starElement = star;
    if (index < ratingValue) {
      starElement.classList.add(RATING_CLASS_NAMES.ACTIVE);
    } else {
      starElement.classList.remove(RATING_CLASS_NAMES.ACTIVE);
    }
  });
}
function getRatingQuestionElements(questionId) {
  const starContainerElement = document.querySelector(
    buildStarRatingSelector(questionId)
  );
  const starContainer = starContainerElement && (isHTMLElementLike(starContainerElement) || "querySelectorAll" in starContainerElement && "setAttribute" in starContainerElement) ? starContainerElement : null;
  const stars = starContainer?.querySelectorAll(SELECTORS.STAR);
  const ratingValueInputElement = document.getElementById(
    buildRatingInputId(questionId)
  );
  const ratingValueInput = ratingValueInputElement && (isHTMLElementLike(ratingValueInputElement) || "value" in ratingValueInputElement && "setAttribute" in ratingValueInputElement) ? ratingValueInputElement : null;
  const selectedTextElement = document.getElementById(
    buildRatingSelectedTextId(questionId)
  );
  const selectedText = isHTMLElementLike(selectedTextElement) ? selectedTextElement : null;
  return {
    starContainer,
    stars: stars || [],
    ratingValueInput,
    selectedText
  };
}
function saveRatingAnswerAndTrack(quizId, ratingValue, pageId, pageIndex, keyName, storageScope, maxRating) {
  saveAnswer(quizId, pageId, ratingValue, STRING_VALUES.RATING, {
    keyName,
    targetObject: storageScope
  });
  const trackEventsQuizData = createTrackEventsQuizData(quizId);
  trackOptionSelection(
    STRING_VALUES.RATING,
    ratingValue.toString(),
    keyName,
    trackEventsQuizData,
    pageIndex,
    null
  );
  sendTrackingEvent(EVENT_NAMES$2.RATING_SELECTED, trackEventsQuizData, {
    field_key: keyName,
    rating_value: ratingValue,
    max_rating: maxRating,
    selection_type: STRING_VALUES.RATING,
    question_index: pageIndex,
    event_trigger: EVENT_PROPERTIES.EVENT_TRIGGER.USER_SELECTED
  });
}
function setStarRating(questionId, ratingValue) {
  const { starContainer, stars, ratingValueInput, selectedText } = getRatingQuestionElements(questionId);
  if (!starContainer) {
    console.error(`Star container not found for questionId: ${questionId}`);
    return;
  }
  if (!ratingValueInput) {
    console.error(`Hidden input not found for questionId: ${questionId}`);
    return;
  }
  updateStarVisualState(stars, ratingValue);
  starContainer.setAttribute(
    `data-${DATA_ATTRIBUTES.RATING}`,
    ratingValue.toString()
  );
  ratingValueInput.value = ratingValue.toString();
  ratingValueInput.setAttribute(
    HTML_ATTRIBUTES.DATA_SELECTED,
    BOOLEAN_VALUES.TRUE
  );
  if (selectedText) {
    selectedText.textContent = buildRatingDisplayText(
      ratingValue,
      RATING_TEXT_VALUES[ratingValue] || RATING_TEXT_VALUES[NUMERIC_CONSTANTS.DEFAULT_FALLBACK_RATING_INDEX]
    );
  }
  const elementQuizData = getQuizDataFromElement(starContainer);
  if (!elementQuizData || !elementQuizData.state) {
    console.error("Quiz data not found for star container:", starContainer);
    return;
  }
  const { quizId, state: state2 } = elementQuizData;
  const pageIndex = getPageIndex(state2);
  state2.answers[questionId] = ratingValue;
  const currentPageEl = getCurrentPageElement(quizId);
  if (!isHTMLElementLike(currentPageEl)) {
    console.error("Current page element not found or invalid for quizId:", quizId);
    return;
  }
  const pageId = extractPageId(currentPageEl, questionId);
  const storageScope = getStorageScopeWithFallback(
    [ratingValueInput, starContainer],
    STORAGE_TARGET_TYPES.GLOBAL
  );
  const keyName = ratingValueInput?.name || questionId;
  saveRatingAnswerAndTrack(
    quizId,
    ratingValue,
    pageId,
    pageIndex,
    keyName,
    storageScope,
    stars.length
  );
  hideValidationError(quizId);
}
function updateStarHoverState(stars, hoverIndex) {
  stars.forEach((star, index) => {
    if (!isHTMLElementLike(star) && !("classList" in star && star.classList && "add" in star.classList && "remove" in star.classList)) {
      return;
    }
    const starElement = star;
    if (index <= hoverIndex) {
      starElement.classList.add(RATING_CLASS_NAMES.HOVER);
    } else {
      starElement.classList.remove(RATING_CLASS_NAMES.HOVER);
    }
  });
}
function clearStarHoverState(stars) {
  stars.forEach((star) => {
    if (isHTMLElementLike(star) || "classList" in star && star.classList && "remove" in star.classList) {
      const starElement = star;
      starElement.classList.remove(RATING_CLASS_NAMES.HOVER);
    }
  });
}
function initializeRatingQuestions() {
  const starRatings = document.querySelectorAll(SELECTORS.STAR_RATING);
  if (!starRatings || starRatings.length === 0) {
    return;
  }
  starRatings.forEach((ratingElement) => {
    if (!ratingElement) {
      console.error("Invalid star rating element:", ratingElement);
      return;
    }
    const stars = ratingElement.querySelectorAll(SELECTORS.STAR);
    stars.forEach((star, index) => {
      star.addEventListener(DOM_EVENT_NAMES.MOUSEENTER, function() {
        updateStarHoverState(stars, index);
      });
      star.addEventListener(DOM_EVENT_NAMES.MOUSELEAVE, function() {
        clearStarHoverState(stars);
      });
    });
  });
}
function updateSelectionHighlighting(currentPageEl) {
  const pageRadios = currentPageEl.querySelectorAll(SELECTORS.RADIO_INPUT);
  pageRadios.forEach((radio) => {
    if (radio.checked) {
      const container = radio.closest(ELEMENT_SELECTORS.RADIO_QUESTION);
      if (container) {
        container.querySelectorAll(SELECTORS.QUIZ_OPTION_BTN).forEach((btn) => btn.classList.remove(CLASS_NAMES.SELECTED));
        const parentBtn = radio.closest(SELECTORS.QUIZ_OPTION_BTN);
        if (parentBtn) {
          parentBtn.classList.add(CLASS_NAMES.SELECTED);
        }
      }
    }
  });
  const pageCheckboxes = currentPageEl.querySelectorAll(SELECTORS.CHECKBOX_INPUT);
  pageCheckboxes.forEach((checkbox) => {
    const parentBtn = checkbox.closest(SELECTORS.QUIZ_OPTION_BTN);
    if (parentBtn) {
      if (checkbox.checked) {
        parentBtn.classList.add(CLASS_NAMES.SELECTED);
      } else {
        parentBtn.classList.remove(CLASS_NAMES.SELECTED);
      }
    }
  });
}
function populateRatingFields(currentPageEl, quizData) {
  const ratingInputs = currentPageEl.querySelectorAll(SELECTOR_STRINGS.RATING_HIDDEN_INPUTS);
  ratingInputs.forEach((input) => {
    const ratingInput = input;
    const keyName = ratingInput.name || ratingInput.id;
    if (!keyName) {
      return;
    }
    const value = getFieldValueFromStorage(quizData, keyName);
    if (value === void 0 || value === null) {
      return;
    }
    const questionId = ratingInput.id.replace(STRING_VALUES.RATING_INPUT_ID_PREFIX, "");
    const ratingValue = typeof value === "number" ? value : parseInt(String(value), 10);
    if (!isNaN(ratingValue) && ratingValue > 0) {
      setStarRating(questionId, ratingValue);
    }
  });
}
function populateCurrentPageFields(quizId) {
  const currentPageEl = getCurrentPageElement(quizId);
  if (!currentPageEl) {
    return;
  }
  const quizData = getQuizData(quizId);
  if (!quizData) {
    return;
  }
  const inputs = currentPageEl.querySelectorAll(SELECTORS.ALL_INPUTS);
  populateStandardInputs(inputs, quizData);
  updateSelectionHighlighting(currentPageEl);
  populateRatingFields(currentPageEl, quizData);
}
function getInputKeyName(inputElement) {
  const keyName = HTML_ATTRIBUTES.NAME in inputElement && inputElement.name || HTML_ATTRIBUTES.ID in inputElement && inputElement.id;
  if (!keyName) {
    console.error("Input element missing both name and id attributes:", inputElement);
  }
  return keyName || null;
}
function extractInputValue(inputElement, keyName, storageScope, inputValues) {
  if (HTML_ATTRIBUTES.TYPE in inputElement && inputElement.type === INPUT_TYPES.CHECKBOX) {
    if (inputElement.checked) {
      if (!inputValues[keyName]) {
        inputValues[keyName] = { value: [], storageScope };
      }
      inputValues[keyName].value.push(inputElement.value);
    }
  } else if (HTML_ATTRIBUTES.TYPE in inputElement && inputElement.type === INPUT_TYPES.RADIO) {
    if (inputElement.checked) {
      inputValues[keyName] = {
        value: inputElement.value,
        storageScope
      };
    }
  } else {
    const value = inputElement.value || null;
    if (value != null) {
      inputValues[keyName] = { value, storageScope };
    }
  }
}
function saveAnswerWithContext(quizId, element, value, questionType, keyName) {
  const currentPageEl = getCurrentPageElement(quizId);
  const pageId = extractPageId(currentPageEl, keyName);
  const storageScope = getStorageScope(element);
  saveAnswer(quizId, pageId, value, questionType, {
    keyName,
    targetObject: storageScope
  });
}
function saveCurrentPageAnswer(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2) {
    return;
  }
  const currentPageEl = requireCurrentPageElement(quizId);
  if (!currentPageEl) {
    return;
  }
  const pageId = extractPageId(currentPageEl, DEFAULT_FALLBACK_VALUES.UNKNOWN_PAGE_ID);
  const inputValues = {};
  currentPageEl.querySelectorAll(SELECTORS.ALL_INPUTS).forEach((input) => {
    const inputElement = input;
    const keyName = getInputKeyName(inputElement);
    if (!keyName) {
      return;
    }
    const storageScope = getStorageScope(inputElement);
    extractInputValue(inputElement, keyName, storageScope, inputValues);
  });
  Object.keys(inputValues).forEach((keyName) => {
    const { value, storageScope } = inputValues[keyName];
    if (Array.isArray(value) && value.length === 0) {
      return;
    }
    state2.answers[keyName] = value;
    saveAnswer(
      quizId,
      pageId,
      value,
      Array.isArray(value) ? QUESTION_TYPE_VALUES.CHECKBOX : QUESTION_TYPE_VALUES.TEXT,
      {
        keyName,
        targetObject: storageScope
      }
    );
  });
}
class Storage {
  #storageKey;
  constructor(key) {
    this.#storageKey = key;
  }
  /** Saves data to localStorage. */
  save(data) {
    try {
      localStorage.setItem(this.#storageKey, JSON.stringify(data));
    } catch (error) {
      console.error(`Failed to save to localStorage (${this.#storageKey}):`, error);
    }
  }
  /** Retrieves and parses data from localStorage. */
  get() {
    try {
      const data = localStorage.getItem(this.#storageKey);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Failed to read from localStorage (${this.#storageKey}):`, error);
      return null;
    }
  }
  /** Retrieves a specific top-level property from the stored object. */
  getValue(key) {
    const data = this.get();
    return data?.[key];
  }
  /**
   * Removes the stored data from localStorage.
   */
  clear() {
    try {
      localStorage.removeItem(this.#storageKey);
    } catch (error) {
      console.error(`Failed to clear localStorage (${this.#storageKey}):`, error);
    }
  }
}
const configStorage = new Storage(STORAGE_KEYS.CONFIG);
const saveConfig = (data) => configStorage.save(data);
const getConfig = () => configStorage.get();
const getConfigValue = (key) => configStorage.getValue(key);
window.getConfig = getConfig;
window.getConfigValue = getConfigValue;
const collectQuizConfig = (quizElement) => {
  const exportUrl = quizElement?.dataset?.quizConfig?.trim();
  if (!exportUrl) {
    return void 0;
  }
  return { exportUrl };
};
async function processSubscriptionActions() {
  for (const action of subscriptionActions) {
    if (!action.hasParams()) {
      continue;
    }
    try {
      const result = await action.execute();
      if (result.success) {
        console.debug(`${action.successMessage}:`, result.data);
      } else {
        console.error(`${action.errorMessage}:`, result.error);
      }
    } catch (error) {
      console.error(`${action.errorMessage}:`, error);
    }
  }
}
async function loadSubscriptionData() {
  try {
    const subscriptionId = new URLSearchParams(window.location.search).get(
      URL_PARAM_NAMES.SUBSCRIPTION_ID
    );
    if (subscriptionId) {
      const subscriptionData = await getSubscriptionData(subscriptionId);
      if (subscriptionData) {
        saveConfig(subscriptionData);
      }
    }
  } catch (error) {
    console.error("Failed to fetch subscription data from backend:", error);
  }
}
function isSubscriptionActionsEnabled() {
  const quizSection = document.querySelector(`[${DATA_ATTRIBUTES.ENABLE_SUBSCRIPTION_ACTIONS}]`);
  return quizSection?.getAttribute(DATA_ATTRIBUTES.ENABLE_SUBSCRIPTION_ACTIONS) === ATTRIBUTE_VALUES.TRUE;
}
const previewEventHandlers = /* @__PURE__ */ new Map();
function updatePreviewProgress(sectionId, stepNumber, totalSteps) {
  if (totalSteps === 0) {
    return;
  }
  const percentage = Math.round(stepNumber / totalSteps * NUMERIC_CONSTANTS.MAX_PERCENTAGE);
  const progressFill = document.getElementById(`${ID_PREFIXES.PROGRESS_FILL}-${sectionId}`);
  if (progressFill) {
    progressFill.style.width = `${percentage}${STRING_VALUES.PERCENTAGE_SYMBOL}`;
  }
  const progressText = document.getElementById(`${ID_PREFIXES.PROGRESS_TEXT}-${sectionId}`);
  if (progressText) {
    const currentStepSpan = progressText.querySelector(`.${SELECTORS.CURRENT_PAGE}`);
    const totalStepsSpan = progressText.querySelector(`.${SELECTORS.TOTAL_PAGES}`);
    if (currentStepSpan) {
      currentStepSpan.textContent = String(stepNumber);
    }
    if (totalStepsSpan) {
      totalStepsSpan.textContent = String(totalSteps);
    }
  }
  const progressPercentage = document.getElementById(
    `${ID_PREFIXES.PROGRESS_PERCENTAGE}-${sectionId}`
  );
  if (progressPercentage) {
    progressPercentage.textContent = `${percentage}${STRING_VALUES.PERCENTAGE_SYMBOL}`;
  }
}
function initializeQuizPreview(sectionId) {
  const questionsContainer = document.getElementById(
    `${ID_PREFIXES.QUIZ_QUESTIONS}-${sectionId}`
  );
  if (!questionsContainer) {
    console.warn(`Questions container not found for section: ${sectionId}`);
    return;
  }
  const existingHandler = previewEventHandlers.get(sectionId);
  if (existingHandler) {
    document.removeEventListener(SHOPIFY_EVENTS.QUESTION_SELECT, existingHandler);
  }
  const handler = (event) => {
    if (!event.target.closest(`#${ID_PREFIXES.QUIZ_SECTION}-${sectionId}`)) {
      return;
    }
    const selectedBlock = questionsContainer.querySelector(
      SELECTOR_FUNCTIONS.DATA_BLOCK_ID_SELECTOR(
        event.detail.blockId
      )
    );
    if (!selectedBlock) {
      return;
    }
    const allBlocks = questionsContainer.querySelectorAll(
      `.${SELECTORS.QUESTION_PAGE}`
    );
    allBlocks.forEach((block) => {
      setElementDisplay(block, DISPLAY_VALUES.NONE);
    });
    setElementDisplay(selectedBlock, DISPLAY_VALUES.BLOCK);
    const stepNumber = parseInt(
      selectedBlock.getAttribute(DATA_ATTRIBUTES.STEP) || String(NUMERIC_CONSTANTS.DEFAULT_STEP_NUMBER),
      10
    );
    if (stepNumber != null && allBlocks.length > 0) {
      updatePreviewProgress(sectionId, stepNumber, allBlocks.length);
    }
    window.parent.postMessage(
      { type: SHOPIFY_POST_MESSAGES.SCROLL_TO_TOP },
      WINDOW_ORIGINS.WILDCARD
    );
  };
  previewEventHandlers.set(sectionId, handler);
  document.addEventListener(SHOPIFY_EVENTS.QUESTION_SELECT, handler);
}
function clearLoadingTimers(quizId) {
  const timers = window.loadingTimers;
  if (timers) {
    Object.keys(timers).forEach((key) => {
      if (key.startsWith(getTimerKeyPrefix(quizId))) {
        clearTimeout(timers[key]);
        delete timers[key];
      }
    });
  }
  updateContinueButtonState(quizId, !validateRequiredFields(quizId));
}
function setContinueButtonsVisibility(quizId, visible) {
  const quizElement = document.querySelector(
    SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)
  );
  if (!quizElement) return;
  quizElement.querySelectorAll(ELEMENT_SELECTORS.CONTINUE_BTN).forEach((btn) => {
    setElementDisplay(btn, visible ? "" : DISPLAY_VALUES.NONE);
  });
}
function isTimedInfoPage(currentPageEl) {
  return currentPageEl.classList.contains(CLASS_NAMES.INFO_PAGE_STEP) && currentPageEl.dataset[DATA_ATTRIBUTES.ENABLE_TIMER] === ATTRIBUTE_VALUES.TRUE;
}
function parseTimerConfig(currentPageEl) {
  const timerAttr = currentPageEl.dataset[DATA_ATTRIBUTES.TIMER];
  const duration = timerAttr ? parseInt(timerAttr, 10) : parseInt(DEFAULT_VALUES.DEFAULT_TIMER_DURATION_SECONDS, 10);
  const questionId = currentPageEl.dataset[DATA_ATTRIBUTES.QUESTION_ID] || "";
  const hideButtonAttr = currentPageEl.dataset[DATA_ATTRIBUTES.HIDE_BUTTON_DURING_TIMER];
  const hideButtonDuringTimer = hideButtonAttr !== ATTRIBUTE_VALUES.FALSE;
  return { duration, questionId, hideButtonDuringTimer };
}
function startPageTimer(config) {
  const hideButtons = config.hideButtons ?? false;
  if (!window.loadingTimers) {
    window.loadingTimers = {};
  }
  const timerKey = `${getTimerKeyPrefix(config.quizId)}${config.timerType}-${config.questionId}`;
  if (window.loadingTimers[timerKey]) {
    clearTimeout(window.loadingTimers[timerKey]);
  }
  if (hideButtons) {
    setContinueButtonsVisibility(config.quizId, false);
  }
  window.loadingTimers[timerKey] = window.setTimeout(() => {
    if (window.loadingTimers) {
      delete window.loadingTimers[timerKey];
    }
    const pageBeforeNav = window.quizStates[config.quizId]?.currentPage;
    if (window.nextPage) {
      window.nextPage(config.quizId);
    }
    const pageAfterNav = window.quizStates[config.quizId]?.currentPage;
    if (hideButtons && pageBeforeNav === pageAfterNav) {
      setContinueButtonsVisibility(config.quizId, true);
    }
  }, config.duration * DEFAULT_VALUES.MILLISECONDS_PER_SECOND);
}
function startLoadingTimerIfNeeded(quizId) {
  if (!window.quizStates[quizId]) {
    console.error(`Quiz state not found in window.quizStates for quizId: ${quizId}`);
    return;
  }
  const currentPageEl = getCurrentPageElement(quizId);
  if (!isHTMLElementLike(currentPageEl) || !currentPageEl.classList) {
    return;
  }
  const isInfoPage = isTimedInfoPage(currentPageEl);
  const isLoadingPage = currentPageEl.classList.contains(
    CLASS_NAMES.LOADING_PAGE_STEP
  );
  if (!isInfoPage && !isLoadingPage) {
    return;
  }
  const pageType = isInfoPage ? INFO_PAGE_TYPE : LOADING_PAGE_TYPE;
  const quizData = createTrackEventsQuizData(quizId);
  trackPageView(quizData, pageType);
  const { duration, questionId, hideButtonDuringTimer } = parseTimerConfig(currentPageEl);
  sendTrackingEvent(EVENT_NAMES.PAGE_VIEW, quizData, {
    page_type: pageType,
    duration,
    question_id: questionId,
    ...isInfoPage && { auto_advance: true }
  });
  startPageTimer({
    quizId,
    questionId,
    duration,
    timerType: isInfoPage ? INFO_PAGE_TYPE : LOADING_PAGE_TYPE,
    hideButtons: isInfoPage && hideButtonDuringTimer
  });
}
function isHTMLInputElementLike(element) {
  if (!isDefined(element)) {
    return false;
  }
  if (element instanceof HTMLInputElement) {
    return true;
  }
  return "value" in element && typeof element.value === "string";
}
function getQuestionContainers(currentPageEl) {
  return [
    currentPageEl.querySelector(SELECTORS.RATING_QUESTION_CONTAINER),
    currentPageEl.querySelector(SELECTORS.SLIDER_QUESTION_CONTAINER),
    currentPageEl.querySelector(SELECTORS.MULTI_INPUT_QUESTION_CONTAINER),
    currentPageEl.querySelector(SELECTORS.RADIO_QUESTION_CONTAINER)
  ].filter((el) => isDefined(el));
}
function getTrimmedDatasetAttribute(element, attribute) {
  const value = element.dataset[attribute];
  if (!isDefined(value)) {
    return null;
  }
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}
function getSelectionAttribute(currentPageEl, attributeName) {
  const selectedRadioInputElement = currentPageEl.querySelector(
    SELECTORS.CHECKED_RADIO_INPUT
  );
  if (isHTMLInputElementLike(selectedRadioInputElement)) {
    const attribute = getTrimmedDatasetAttribute(selectedRadioInputElement, attributeName);
    if (attribute) return attribute;
  }
  const checkedCheckboxInputElement = currentPageEl.querySelector(
    SELECTORS.CHECKED_CHECKBOX_INPUT
  );
  if (isHTMLInputElementLike(checkedCheckboxInputElement)) {
    const attribute = getTrimmedDatasetAttribute(checkedCheckboxInputElement, attributeName);
    if (attribute) return attribute;
    const questionContainer = checkedCheckboxInputElement.closest(
      SELECTORS.RADIO_QUESTION_CONTAINER
    );
    if (isHTMLElementLike(questionContainer)) {
      const containerAttribute = getTrimmedDatasetAttribute(questionContainer, attributeName);
      if (containerAttribute) return containerAttribute;
    }
  }
  return null;
}
function buildButtonIds(prefixes, quizId) {
  return prefixes.map((prefix) => `${prefix}${TEMPLATE_SEPARATORS.ID_SEPARATOR}${quizId}`);
}
function getButtonsByPrefixes(prefixes, quizId) {
  return collectElements(buildButtonIds(prefixes, quizId));
}
function findPageNumberByBlockId(quizId, blockId) {
  const quizSection = document.getElementById(
    `${SELECTORS.QUIZ_SECTION}${TEMPLATE_SEPARATORS.ID_SEPARATOR}${quizId}`
  );
  if (!quizSection) {
    console.error(`Quiz section not found for quizId: ${quizId}`);
    return null;
  }
  const pages = quizSection.querySelectorAll(
    `${CSS_SELECTOR_PREFIX.CLASS}${SELECTORS.QUESTION_PAGE}`
  );
  let foundPageNumber = null;
  Array.from(pages).forEach((page, index) => {
    if (isDefined(foundPageNumber)) {
      return;
    }
    if (!isHTMLElementLike(page)) return;
    const pageElement = page;
    const pageBlockId = pageElement.dataset[DATA_ATTRIBUTES.QUESTION_ID];
    const customBlockIdElement = pageElement.querySelector(
      SELECTORS.DATA_BLOCK_CUSTOM_ID
    );
    const customBlockId = pageElement.dataset[DATA_ATTRIBUTES.BLOCK_CUSTOM_ID] || (isHTMLElementLike(customBlockIdElement) ? customBlockIdElement.dataset[DATA_ATTRIBUTES.BLOCK_CUSTOM_ID] : void 0);
    if (customBlockId && customBlockId === blockId || pageBlockId === blockId) {
      foundPageNumber = index + NUMERIC_CONSTANTS.MIN_PAGE;
    }
  });
  return foundPageNumber;
}
function getTargetFromContainer(quizId, attribute, transform) {
  const currentPageEl = requireCurrentPageElement(quizId);
  if (!currentPageEl) {
    return void 0;
  }
  const questionContainers = getQuestionContainers(currentPageEl);
  for (const container of questionContainers) {
    const attributeValue = getTrimmedDatasetAttribute(container, attribute);
    if (attributeValue) {
      const result = transform(attributeValue);
      if (isDefined(result)) {
        return result;
      }
    }
  }
  return void 0;
}
function getTargetUrlFromContainer(quizId) {
  return getTargetFromContainer(quizId, DATA_ATTRIBUTES.NEXT_URL, (value) => value) ?? null;
}
function getTargetPageFromContainer(quizId) {
  const result = getTargetFromContainer(
    quizId,
    DATA_ATTRIBUTES.NEXT_QUESTION,
    (blockId) => {
      const pageNumber = findPageNumberByBlockId(quizId, blockId);
      return pageNumber ?? void 0;
    }
  );
  return result ?? void 0;
}
function getTargetFromSelection(quizId, attribute, transform) {
  const currentPageEl = requireCurrentPageElement(quizId);
  if (!currentPageEl) {
    return null;
  }
  const attributeValue = getSelectionAttribute(currentPageEl, attribute);
  if (!attributeValue) return null;
  return transform(attributeValue);
}
function getTargetUrlFromSelection(quizId) {
  return getTargetFromSelection(quizId, DATA_ATTRIBUTES.NEXT_URL, (value) => value);
}
function getTargetPageFromSelection(quizId) {
  return getTargetFromSelection(
    quizId,
    DATA_ATTRIBUTES.NEXT_QUESTION,
    (blockId) => findPageNumberByBlockId(quizId, blockId)
  );
}
function switchToPage(quizId, targetPage) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return;
  }
  const currentPageElement = getCurrentPageElement(quizId);
  if (isHTMLElementLike(currentPageElement)) {
    togglePageVisibility(currentPageElement, false);
  }
  state2.currentPage = targetPage;
  const newPageElement = getCurrentPageElement(quizId);
  if (isHTMLElementLike(newPageElement)) {
    togglePageVisibility(newPageElement, true);
  }
  initializePageDisplay(quizId);
}
function navigateToPage(quizId, targetPage) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return;
  }
  if (targetPage < NUMERIC_CONSTANTS.MIN_PAGE || targetPage > state2.totalPages) {
    console.error(
      `${ERROR_MESSAGES$2.INVALID_TARGET_PAGE}${TEMPLATE_SEPARATORS.SPACE}${targetPage}.${TEMPLATE_SEPARATORS.SPACE}${ERROR_MESSAGES$2.MUST_BE_BETWEEN}${TEMPLATE_SEPARATORS.SPACE}${NUMERIC_CONSTANTS.MIN_PAGE}${TEMPLATE_SEPARATORS.SPACE}and${TEMPLATE_SEPARATORS.SPACE}${state2.totalPages}`
    );
    return;
  }
  clearLoadingTimers(quizId);
  saveCurrentPageAnswer(quizId);
  switchToPage(quizId, targetPage);
}
function nextPage(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2) {
    initializeQuiz(quizId);
    return;
  }
  const currentPageEl = getCurrentPageElement(quizId);
  if (currentPageEl && !validateRequiredFields(quizId)) {
    showValidationError(quizId);
    return;
  }
  hideValidationError(quizId);
  const quizData = createTrackEventsQuizData(quizId);
  if (state2) {
    const questionId = (isHTMLElementLike(currentPageEl) ? currentPageEl.dataset?.blockId : void 0) || `page_${state2.currentPage}`;
    trackContinueClick(
      state2.currentPage - NUMERIC_CONSTANTS.DEFAULT_PAGE_INDEX_OFFSET,
      questionId,
      quizData
    );
  }
  const targetUrl = getTargetUrlFromSelection(quizId) ?? getTargetUrlFromContainer(quizId);
  if (targetUrl) {
    saveCurrentPageAnswer(quizId);
    if (navigateToUrl(targetUrl)) {
      trackQuizResults(quizData);
      return;
    }
  }
  const targetPage = getTargetPageFromSelection(quizId) ?? getTargetPageFromContainer(quizId);
  if (isDefined(targetPage) && targetPage >= NUMERIC_CONSTANTS.MIN_PAGE && targetPage <= state2.totalPages) {
    state2.pageHistory.push(state2.currentPage);
    navigateToPage(quizId, targetPage);
  } else if (state2.currentPage < state2.totalPages) {
    state2.pageHistory.push(state2.currentPage);
    navigateToPage(quizId, state2.currentPage + NUMERIC_CONSTANTS.PAGE_INCREMENT);
  }
}
function previousPage(quizId) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return;
  }
  const isFirstPage = state2.currentPage === NUMERIC_CONSTANTS.MIN_PAGE;
  const canGoBack = state2.currentPage > NUMERIC_CONSTANTS.MIN_PAGE || state2.pageHistory.length > 0;
  if (isFirstPage && !canGoBack) {
    const quizElementForUrl = document.querySelector(
      SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)
    );
    const firstPageUrl = isHTMLElementLike(quizElementForUrl) && (quizElementForUrl.dataset?.backButtonFirstPageUrl?.trim() || "");
    if (firstPageUrl) {
      const quizData2 = createTrackEventsQuizData(quizId);
      sendTrackingEvent(EVENT_NAMES.BACK_CLICKED, quizData2, {
        question_index: state2.currentPage - NUMERIC_CONSTANTS.DEFAULT_PAGE_INDEX_OFFSET
      });
      navigateToUrl(firstPageUrl);
      return;
    }
    console.error(
      `${ERROR_MESSAGES$2.CANNOT_GO_BACK_FIRST_PAGE}${TEMPLATE_SEPARATORS.SPACE}${quizId},${TEMPLATE_SEPARATORS.SPACE}currentPage:${TEMPLATE_SEPARATORS.SPACE}${state2.currentPage}`
    );
    return;
  }
  const quizData = createTrackEventsQuizData(quizId);
  if (state2) {
    sendTrackingEvent(EVENT_NAMES.BACK_CLICKED, quizData, {
      question_index: state2.currentPage - NUMERIC_CONSTANTS.DEFAULT_PAGE_INDEX_OFFSET
    });
  }
  if (state2.pageHistory.length > 0) {
    const previousPage2 = state2.pageHistory.pop();
    if (isDefined(previousPage2)) {
      navigateToPage(quizId, previousPage2);
    }
  } else {
    navigateToPage(quizId, state2.currentPage - NUMERIC_CONSTANTS.PAGE_DECREMENT);
  }
}
function updateNavigation(quizId) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    return;
  }
  const quizElement = document.querySelector(
    SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)
  );
  const backButtons = getButtonsByPrefixes(BACK_BUTTON_ID_PREFIXES, quizId);
  backButtons.forEach((btn) => {
    if (state2.currentPage > NUMERIC_CONSTANTS.MIN_PAGE || state2.pageHistory && state2.pageHistory.length > 0) {
      setElementDisplay(btn, DISPLAY_VALUES.BLOCK);
    } else if (state2.currentPage === NUMERIC_CONSTANTS.MIN_PAGE && isHTMLElementLike(quizElement) && quizElement.dataset?.hideBackButtonFirstPage === BOOLEAN_VALUES.TRUE) {
      setElementDisplay(btn, DISPLAY_VALUES.NONE);
    } else {
      setElementDisplay(btn, DISPLAY_VALUES.BLOCK);
    }
  });
  const setupButtonHandler = (btn) => {
    if (btn.classList?.contains(SUBMIT_LOADING.CSS_CLASS)) {
      return;
    }
    setElementDisplay(btn, DISPLAY_VALUES.BLOCK);
    if (state2.currentPage === state2.totalPages) {
      btn.textContent = btn.getAttribute(DATA_ATTRIBUTES.SUBMIT_TEXT) || DEFAULT_VALUES.SUBMIT_TEXT;
      btn.onclick = function() {
        if (window.submitQuiz) {
          window.submitQuiz(quizId);
        }
      };
    } else {
      btn.textContent = btn.getAttribute(DATA_ATTRIBUTES.NEXT_TEXT) || DEFAULT_VALUES.NEXT_TEXT;
      btn.onclick = function() {
        if (window.nextPage) {
          window.nextPage(quizId);
        }
      };
    }
  };
  const continueButtons = getButtonsByPrefixes(CONTINUE_BUTTON_ID_PREFIXES, quizId);
  continueButtons.forEach(setupButtonHandler);
  if (quizElement) {
    const continueButtonsByAttribute = Array.from(
      quizElement.querySelectorAll(ELEMENT_SELECTORS.CONTINUE_BTN)
    ).filter((btn) => isHTMLElementLike(btn));
    continueButtonsByAttribute.forEach(setupButtonHandler);
  }
}
const submittingQuizzes = /* @__PURE__ */ new Set();
function createTrackEventsQuizData(quizId) {
  return {
    quizId
  };
}
function getSubmitButtons(quizId) {
  return collectElements(
    buildButtonIds(CONTINUE_BUTTON_ID_PREFIXES, quizId),
    SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId),
    ELEMENT_SELECTORS.CONTINUE_BTN
  );
}
function setButtonsLoading(buttons, loading2) {
  if (loading2) {
    const savedMarkup = buttons.map((btn) => btn.innerHTML);
    buttons.forEach((btn, i) => {
      btn.setAttribute(DATA_ATTR_NAMES.ORIGINAL_TEXT, savedMarkup[i]);
      btn.innerHTML = SUBMIT_LOADING.DOTS_HTML;
      btn.classList.add(SUBMIT_LOADING.CSS_CLASS);
      btn.setAttribute(HTML_ATTRIBUTES.DISABLED, "");
    });
  } else {
    const savedMarkup = buttons.map((btn) => btn.getAttribute(DATA_ATTR_NAMES.ORIGINAL_TEXT));
    buttons.forEach((btn, i) => {
      const markup = savedMarkup[i];
      if (markup !== null && markup !== void 0) {
        btn.innerHTML = markup;
        btn.removeAttribute(DATA_ATTR_NAMES.ORIGINAL_TEXT);
      }
      btn.classList.remove(SUBMIT_LOADING.CSS_CLASS);
      btn.removeAttribute(HTML_ATTRIBUTES.DISABLED);
    });
  }
}
async function submitQuiz(quizId) {
  if (submittingQuizzes.has(quizId)) {
    return;
  }
  if (!validateRequiredFields(quizId)) {
    showValidationError(quizId);
    return;
  }
  saveCurrentPageAnswer(quizId);
  const state2 = getQuizState(quizId);
  if (!state2) {
    return;
  }
  submittingQuizzes.add(quizId);
  const buttons = getSubmitButtons(quizId);
  setButtonsLoading(buttons, true);
  let navigating = false;
  try {
    await exportData(quizId);
    const quizData = createTrackEventsQuizData(quizId);
    trackQuizEnded(
      quizData,
      state2.totalPages,
      state2.startTime ? Date.now() - state2.startTime : null
    );
    trackQuizResults(quizData, null);
    let serverPostFailed = false;
    const quizElement = getQuizElement(quizId);
    const submitUrl = quizElement?.dataset?.[DATASET_PROPERTIES.SUBMIT_URL];
    if (isNotEmpty(submitUrl)) {
      const payload = stringify(getQuizResultsPayload(quizId));
      if (payload) {
        try {
          await fetch(submitUrl, {
            method: HTTP_METHODS.POST,
            headers: {
              [HTTP_HEADERS.CONTENT_TYPE]: CONTENT_TYPES.APPLICATION_JSON
            },
            body: payload,
            keepalive: FETCH_OPTIONS.KEEPALIVE
          });
        } catch (error) {
          serverPostFailed = true;
          console.error("Failed to post quiz data to submit URL:", error);
        }
      } else {
        serverPostFailed = true;
      }
      if (!serverPostFailed) {
        markCompleted(quizId);
      }
      navigating = navigateToUrl(submitUrl);
    } else {
      markCompleted(quizId);
    }
  } catch (error) {
    console.error("Quiz submission failed:", error);
  } finally {
    if (!navigating) {
      submittingQuizzes.delete(quizId);
      setButtonsLoading(buttons, false);
    } else {
      setTimeout(() => {
        submittingQuizzes.delete(quizId);
        setButtonsLoading(buttons, false);
      }, SUBMIT_LOADING.NAVIGATION_CLEANUP_TIMEOUT_MS);
    }
  }
}
const DEFAULT_STEP_SIZE = 1;
function getSliderElements(questionId) {
  return {
    slider: document.getElementById(
      buildSliderId(questionId)
    ),
    currentValue: document.getElementById(buildSliderCurrentValueId(questionId))
  };
}
function updateSliderValueDisplay(currentValue, value) {
  currentValue.textContent = value.toString();
}
function updateSliderPosition(slider, value, min, max) {
  const denominator = max - min;
  if (denominator !== 0) {
    slider.style.setProperty(
      STRING_VALUES.VALUE_PERCENT_CSS_VAR,
      `${(value - min) / denominator * NUMERIC_CONSTANTS.MAX_PERCENTAGE}%`
    );
  }
}
function applySliderVisualFeedback(valueDisplay) {
  valueDisplay.style.borderColor = CSS_VALUES.SLIDER_ACTIVE_BORDER_COLOR;
  valueDisplay.style.backgroundColor = CSS_VALUES.SLIDER_ACTIVE_BACKGROUND_COLOR;
  setTimeout(() => {
    valueDisplay.style.borderColor = CSS_VALUES.SLIDER_DEFAULT_BORDER_COLOR;
    valueDisplay.style.backgroundColor = CSS_VALUES.SLIDER_DEFAULT_BACKGROUND_COLOR;
  }, NUMERIC_CONSTANTS.SLIDER_VISUAL_FEEDBACK_DELAY_MS);
}
function getSliderValueDisplay(currentValue) {
  return typeof currentValue.closest === "function" ? currentValue.closest(SELECTORS.SLIDER_VALUE_DISPLAY) : null;
}
function saveSliderAnswerAndTrack(quizId, sliderValue, pageIndex, keyName, slider) {
  const trackEventsQuizData = createTrackEventsQuizData(quizId);
  trackOptionSelection(
    STRING_VALUES.SLIDER,
    sliderValue.toString(),
    keyName,
    trackEventsQuizData,
    pageIndex,
    null
  );
  const minValue = parseFloat(slider.min) || NUMERIC_CONSTANTS.MIN_PERCENTAGE;
  const maxValue = parseFloat(slider.max) || NUMERIC_CONSTANTS.MAX_PERCENTAGE;
  sendTrackingEvent(EVENT_NAMES$2.SLIDER_CHANGED, trackEventsQuizData, {
    field_key: keyName,
    slider_value: sliderValue,
    min_value: minValue,
    max_value: maxValue,
    selection_type: STRING_VALUES.SLIDER,
    question_index: pageIndex,
    event_trigger: EVENT_PROPERTIES.EVENT_TRIGGER.USER_SELECTED
  });
}
function updateSliderValue(questionId) {
  const { slider, currentValue } = getSliderElements(questionId);
  if (!slider || !currentValue) {
    return;
  }
  const value = parseFloat(slider.value);
  const min = parseFloat(slider.min);
  const max = parseFloat(slider.max);
  updateSliderValueDisplay(currentValue, value);
  updateSliderPosition(slider, value, min, max);
  const valueDisplay = getSliderValueDisplay(currentValue);
  if (valueDisplay) {
    applySliderVisualFeedback(valueDisplay);
  }
  const elementQuizData = getQuizDataFromElement(slider);
  if (!elementQuizData || !elementQuizData.state) {
    return;
  }
  const { quizId, state: state2 } = elementQuizData;
  const pageIndex = getPageIndex(state2);
  const keyName = slider.name || questionId;
  saveAnswerWithContext(
    quizId,
    slider,
    value,
    STRING_VALUES.SLIDER,
    keyName
  );
  saveSliderAnswerAndTrack(quizId, value, pageIndex, keyName, slider);
  hideValidationError(quizId);
}
function handleSliderKeyboardNavigation(e, sliderInput, questionId) {
  const stepSize = parseFloat(sliderInput.step) || DEFAULT_STEP_SIZE;
  const currentVal = parseFloat(sliderInput.value);
  const minVal = parseFloat(sliderInput.min);
  const maxVal = parseFloat(sliderInput.max);
  switch (e.key) {
    case KEYBOARD_KEYS.ARROW_LEFT:
    case KEYBOARD_KEYS.ARROW_DOWN:
      e.preventDefault();
      sliderInput.value = Math.max(minVal, currentVal - stepSize).toString();
      updateSliderValue(questionId);
      break;
    case KEYBOARD_KEYS.ARROW_RIGHT:
    case KEYBOARD_KEYS.ARROW_UP:
      e.preventDefault();
      sliderInput.value = Math.min(maxVal, currentVal + stepSize).toString();
      updateSliderValue(questionId);
      break;
    case KEYBOARD_KEYS.HOME:
      e.preventDefault();
      sliderInput.value = sliderInput.min;
      updateSliderValue(questionId);
      break;
    case KEYBOARD_KEYS.END:
      e.preventDefault();
      sliderInput.value = sliderInput.max;
      updateSliderValue(questionId);
      break;
  }
}
function initializeSliderQuestions() {
  document.querySelectorAll(ELEMENT_SELECTORS.SLIDER_INPUT_RANGE).forEach((slider) => {
    const sliderInput = slider;
    if (!sliderInput.id) {
      return;
    }
    const questionId = sliderInput.id.replace(`${STRING_VALUES.SLIDER}-`, "");
    updateSliderValue(questionId);
    sliderInput.addEventListener(DOM_EVENT_NAMES.INPUT, function() {
      updateSliderValue(questionId);
    });
    sliderInput.addEventListener(
      DOM_EVENT_NAMES.KEYDOWN,
      function(e) {
        handleSliderKeyboardNavigation(e, sliderInput, questionId);
      }
    );
  });
}
const ENTITY_ROUTING_CONSTANTS = {
  URL_PARAM_NAME: "entity",
  ENTITY_NOT_FOUND_INDEX: -1
};
function getEntityIdFromUrl() {
  if (typeof window === "undefined" || !window.location) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  return params.get(ENTITY_ROUTING_CONSTANTS.URL_PARAM_NAME);
}
function updateUrlWithEntityId(entityId) {
  if (typeof window === "undefined" || !window.history) {
    return;
  }
  const url = new URL(window.location.href);
  url.searchParams.set(ENTITY_ROUTING_CONSTANTS.URL_PARAM_NAME, entityId);
  window.history.replaceState({}, "", url.toString());
}
function findEntityIndexById(quizData, entityId) {
  if (!quizData.EntitiesObject || !Array.isArray(quizData.EntitiesObject)) {
    return ENTITY_ROUTING_CONSTANTS.ENTITY_NOT_FOUND_INDEX;
  }
  return quizData.EntitiesObject.findIndex((entity) => entity.id === entityId);
}
function initializeEntityFromUrl(quizId) {
  const urlEntityId = getEntityIdFromUrl();
  const quizData = getQuizData(quizId);
  if (urlEntityId) {
    const existingIndex = findEntityIndexById(quizData, urlEntityId);
    if (existingIndex >= 0) {
      return {
        entityIndex: existingIndex,
        entityId: urlEntityId,
        isNew: false
      };
    }
  }
  if (quizData.EntitiesObject.length > 0) {
    const latestIndex = quizData.EntitiesObject.length - 1;
    const latestId = quizData.EntitiesObject[latestIndex].id;
    updateUrlWithEntityId(latestId);
    return {
      entityIndex: latestIndex,
      entityId: latestId,
      isNew: false
    };
  }
  const newIndex = addNewEntity(quizId);
  const newQuizData = getQuizData(quizId);
  const newEntityId = newQuizData.EntitiesObject[newIndex].id;
  updateUrlWithEntityId(newEntityId);
  return {
    entityIndex: newIndex,
    entityId: newEntityId,
    isNew: true
  };
}
function buildProgressElementId(prefix, quizId) {
  return `${prefix}${TEMPLATE_SEPARATORS.ID_SEPARATOR}${quizId}`;
}
function getProgressFillElement(quizId) {
  const idSelector = buildProgressElementId(ID_PREFIXES.PROGRESS_FILL, quizId);
  const elementById = document.getElementById(idSelector);
  if (isHTMLElementLike(elementById)) {
    return elementById;
  }
  const quizSectionSelector = SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId);
  const selector = `${quizSectionSelector}${TEMPLATE_SEPARATORS.SPACE}${CSS_SELECTOR_PREFIX.CLASS}${SELECTORS.PROGRESS_FILL}`;
  const element = document.querySelector(selector);
  return isHTMLElementLike(element) ? element : null;
}
function shouldShowProgress(progressContainer) {
  return isDefined(progressContainer) && progressContainer.dataset[DATA_ATTRIBUTES.SHOW_PROGRESS] === BOOLEAN_VALUES.TRUE;
}
function updateProgressContainerVisibility(progressContainer, show2) {
  if (show2) {
    progressContainer.style.removeProperty(CSS_PROPERTIES.DISPLAY);
  } else {
    progressContainer.style.setProperty(
      CSS_PROPERTIES.DISPLAY,
      DISPLAY_VALUES.NONE,
      CSS_PROPERTIES.IMPORTANT
    );
  }
}
function calculateProgressPercentage(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2) {
    return 0;
  }
  if (state2.totalPages === 0) {
    return Infinity;
  }
  if (state2.totalPages === 1) {
    return NUMERIC_CONSTANTS.MAX_PERCENTAGE;
  }
  return Math.round(
    (state2.currentPage - 1) / (state2.totalPages - 1) * NUMERIC_CONSTANTS.MAX_PERCENTAGE
  );
}
function updateProgressFill(progressFill, percentage) {
  if (!progressFill) {
    console.error(ERROR_MESSAGES$2.PROGRESS_FILL_ELEMENT_NULL);
    return;
  }
  progressFill.style.width = Math.max(
    NUMERIC_CONSTANTS.MIN_PERCENTAGE,
    Math.min(NUMERIC_CONSTANTS.MAX_PERCENTAGE, percentage)
  ) + STRING_VALUES.PERCENTAGE_SYMBOL;
}
function updatePercentageDisplays(quizId, percentage) {
  const el = document.getElementById(
    buildProgressElementId(ID_PREFIXES.PROGRESS_PERCENTAGE, quizId)
  );
  if (el) {
    el.textContent = percentage + STRING_VALUES.PERCENTAGE_SYMBOL;
  }
}
function isQuestionPage(page) {
  return !page.classList.contains(CLASS_NAMES.LOADING_PAGE_STEP) && !page.classList.contains(CLASS_NAMES.INFO_PAGE_STEP);
}
function getQuestionPageCount(quizElement, actualCurrentPage) {
  const allPages = quizElement?.querySelectorAll(`.${SELECTORS.QUESTION_PAGE}`);
  if (!allPages?.length || actualCurrentPage <= 0) return 0;
  return Array.from(allPages).slice(0, Math.min(actualCurrentPage, allPages.length)).filter(isQuestionPage).length;
}
function getTotalQuestionPageCount(quizElement) {
  const allPages = quizElement?.querySelectorAll(`.${SELECTORS.QUESTION_PAGE}`);
  if (!allPages?.length) return 0;
  return Array.from(allPages).filter(isQuestionPage).length;
}
function getQuizElementAndCountMode(quizId) {
  const quizElement = document.querySelector(
    SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId)
  );
  if (!quizElement || !isHTMLElementLike(quizElement)) {
    return null;
  }
  const countQuestionsOnly = quizElement.dataset.countQuestionsOnly === "true";
  return { quizElement, countQuestionsOnly };
}
function calculateDisplayedCurrentPage(quizId, actualCurrentPage) {
  const result = getQuizElementAndCountMode(quizId);
  if (!result || !result.countQuestionsOnly) {
    return actualCurrentPage;
  }
  return getQuestionPageCount(result.quizElement, actualCurrentPage);
}
function calculateDisplayedTotalPages(quizId, actualTotalPages) {
  const result = getQuizElementAndCountMode(quizId);
  if (!result || !result.countQuestionsOnly) {
    return actualTotalPages;
  }
  return getTotalQuestionPageCount(result.quizElement);
}
function updatePageCounters(quizId, currentPage, totalPages) {
  const quizSectionSelector = SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId);
  const displayedCurrentPage = calculateDisplayedCurrentPage(quizId, currentPage);
  const displayedTotalPages = calculateDisplayedTotalPages(quizId, totalPages);
  const currentPageEl = document.querySelector(
    `${quizSectionSelector}${TEMPLATE_SEPARATORS.SPACE}${CSS_SELECTOR_PREFIX.CLASS}${SELECTORS.CURRENT_PAGE}`
  );
  if (isHTMLElementLike(currentPageEl))
    currentPageEl.textContent = displayedCurrentPage.toString();
  const totalPagesEl = document.querySelector(
    `${quizSectionSelector}${TEMPLATE_SEPARATORS.SPACE}${CSS_SELECTOR_PREFIX.CLASS}${SELECTORS.TOTAL_PAGES}`
  );
  if (isHTMLElementLike(totalPagesEl)) totalPagesEl.textContent = displayedTotalPages.toString();
}
function updateProgress(quizId) {
  const state2 = requireQuizState(quizId);
  if (!state2) {
    console.error(
      `${ERROR_MESSAGES$2.CANNOT_UPDATE_PROGRESS}${TEMPLATE_SEPARATORS.SPACE}${quizId}`
    );
    return;
  }
  const percentage = calculateProgressPercentage(quizId);
  const progressContainerElement = document.getElementById(
    buildProgressElementId(ID_PREFIXES.QUIZ_PROGRESS, quizId)
  );
  const progressContainer = isHTMLElementLike(progressContainerElement) ? progressContainerElement : null;
  if (shouldShowProgress(progressContainer) && progressContainer) {
    updateProgressContainerVisibility(progressContainer, true);
    const progressFill = getProgressFillElement(quizId);
    if (progressFill) {
      updateProgressFill(progressFill, percentage);
    }
    updatePercentageDisplays(quizId, percentage);
  } else if (progressContainer) {
    updateProgressContainerVisibility(progressContainer, false);
  }
  updatePageCounters(quizId, state2.currentPage, state2.totalPages);
}
function initializeAllQuestionTypes() {
  initializeRadioQuestions();
  initializeRatingQuestions();
  initializeSliderQuestions();
  initializeMultiInputQuestions();
  document.querySelectorAll(SELECTOR_STRINGS.QUIZ_SECTION_BY_PREFIX).forEach((quizElement) => {
    initializeInputTracking(extractQuizId(quizElement));
  });
}
function setupMutationObserver() {
  const observer2 = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === MUTATION_OBSERVER_TYPES.CHILD_LIST && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === NODE_TYPES.ELEMENT_NODE) {
            const element = node;
            if (element.matches(ELEMENT_SELECTORS.MULTI_INPUT_QUESTION) || element.querySelector(ELEMENT_SELECTORS.MULTI_INPUT_QUESTION)) {
              initializeMultiInputQuestions();
            }
          }
        });
      }
    });
  });
  observer2.observe(document.body, {
    [MUTATION_OBSERVER_TYPES.CHILD_LIST]: true,
    [MUTATION_OBSERVER_TYPES.SUBTREE]: true
  });
}
function initializePageDisplay(quizId) {
  const state2 = getQuizState(quizId);
  if (!state2) {
    console.error(`${ERROR_MESSAGES$2.CANNOT_INITIALIZE_PAGE_DISPLAY} ${quizId}`);
    return;
  }
  populateCurrentPageFields(quizId);
  const currentPageEl = getCurrentPageElement(quizId);
  if (currentPageEl) {
    updateContinueButtonState(quizId, !validateRequiredFields(quizId));
  } else {
    updateContinueButtonState(quizId, true);
  }
  updateDynamicTextInCurrentPage(quizId);
  updateNavigation(quizId);
  updateProgress(quizId);
  if (currentPageEl) {
    if (currentPageEl.getAttribute("data-send-data-on-load") === ATTRIBUTE_VALUES.TRUE) {
      void exportData(quizId);
    }
    if (currentPageEl.getAttribute("data-submit-on-load") === ATTRIBUTE_VALUES.TRUE) {
      void submitQuiz(quizId);
    }
    if (currentPageEl.getAttribute("data-apply-discount-on-load") === ATTRIBUTE_VALUES.TRUE) {
      void applyDiscountFromUrl();
    }
  }
  startLoadingTimerIfNeeded(quizId);
  if (currentPageEl) {
    const pageRadios = currentPageEl.querySelectorAll(SELECTORS.RADIO_INPUT);
    if (pageRadios.length > 0) {
      initializeInputListeners(pageRadios, updateRadioHighlighting);
    }
  }
  initializeAllQuestionTypes();
  const currentPageElAfterInit = getCurrentPageElement(quizId);
  if (currentPageElAfterInit) {
    repopulateInlineInputs(currentPageElAfterInit, quizId);
  }
  const quizData = createTrackEventsQuizData(quizId);
  trackPageView(quizData, QUESTION_PAGE_TYPE);
  sendTrackingEvent(EVENT_NAMES.QUESTION_VIEWED, quizData, {
    page_number: state2.currentPage,
    question_index: state2.currentPage - 1
  });
}
function initializeQuiz(quizId) {
  if (window.quizStates[quizId]) {
    return;
  }
  const quizElement = getQuizElement(quizId);
  if (!quizElement) {
    console.error(`Quiz element not found for quizId: ${quizId}`);
    return;
  }
  const resetOnInit = quizElement.dataset[DATASET_PROPERTIES.RESET_QUIZ_ON_INIT] === ATTRIBUTE_VALUES.TRUE;
  if (resetOnInit) {
    resetQuiz(quizId);
  }
  const entityResult = initializeEntityFromUrl(quizId);
  const allPages = quizElement.querySelectorAll(`.${SELECTORS.QUESTION_PAGE}`);
  const totalPages = allPages.length;
  if (totalPages === 0) {
    console.error(
      `Quiz has no question pages for quizId: ${quizId}. Make sure the quiz has at least one question page element.`
    );
    return;
  }
  window.quizStates[quizId] = {
    currentPage: NUMERIC_CONSTANTS.INITIAL_PAGE,
    totalPages,
    answers: {},
    startTime: Date.now(),
    pageHistory: [],
    entitiesObjectIndex: entityResult.entityIndex,
    currentEntityId: entityResult.entityId
  };
  if (hasSavedProgress(quizId)) {
    restoreAllFormFields(quizId);
  }
  initializeListeners(quizId);
  initializeQuizSession();
  const urlParamToAddToEvents = getUrlParamNameFromQuizElement(quizId);
  const eventData = {
    ...createBaseData(quizId, urlParamToAddToEvents),
    total_questions: totalPages,
    timestamp: (/* @__PURE__ */ new Date()).toISOString()
  };
  sendTrackingEvent(EVENT_NAMES.QUIZ_STARTED, createTrackEventsQuizData(quizId), eventData);
  initializeAllQuestionTypes();
  initializePageDisplay(quizId);
}
function initializeAllQuizzes() {
  document.querySelectorAll(`[id^="${SELECTORS.QUIZ_SECTION}-"]`).forEach((quizElement) => {
    const quizId = extractQuizId(quizElement);
    initializeQuiz(quizId);
  });
  initializeAllQuestionTypes();
  setupMutationObserver();
}
async function initializeQuizSystem() {
  if (window.storeURLParams) {
    await window.storeURLParams();
  }
  if (isSubscriptionActionsEnabled()) {
    await processSubscriptionActions();
  }
  await loadSubscriptionData();
  initializeAllQuizzes();
}
function setupWindowApi() {
  window.initializeQuiz = initializeQuiz;
  window.initializeQuizPreview = initializeQuizPreview;
  window.nextPage = nextPage;
  window.previousPage = previousPage;
  window.submitQuiz = submitQuiz;
  window.updateSliderValue = updateSliderValue;
  window.setStarRating = setStarRating;
  window.initializeRatingQuestions = initializeRatingQuestions;
}
function initializeOnReady() {
  if (document.readyState === DOCUMENT_READY_STATES.LOADING) {
    document.addEventListener(DOM_EVENT_NAMES.DOM_CONTENT_LOADED, initializeQuizSystem);
  } else {
    void initializeQuizSystem();
  }
}
function extractBlockId(quizId) {
  return extractBlockIdWithFn(quizId, getCurrentPageElement);
}
setupWindowApi();
initializeOnReady();
const EVENT_CATEGORY_QUIZ = "quiz";
const EVENT_QUIZ_RESULTS = "quiz_results";
const DOM_EVENT_PRODUCT_ADDED_TO_CART = "zyxel:product_added_to_cart";
const DOM_EVENT_PRODUCT_REMOVED_FROM_CART = "zyxel:product_removed_from_cart";
const FIELD_QUIZ_ANSWERS = "quiz_answers";
const FIELD_QUIZ_SESSION_ID = "quiz_session_id";
const FIELD_QUIZ_COMPLETED = "quiz_completed";
const FIELD_COMPLETED_AT = "completedAt";
const EVENT_CATEGORY$1 = EVENT_CATEGORY_QUIZ;
const QUIZ_SESSION_KEY$1 = FIELD_QUIZ_SESSION_ID;
const QUIZ_ANSWERS_KEY$1 = FIELD_QUIZ_ANSWERS;
const MISSING_KEY = "urlParamToAddToEvents";
const EVENT_NAMES$1 = {
  QUIZ_STARTED: "quiz_started",
  QUIZ_ENDED: "quiz_ended",
  QUIZ_RESULTS: EVENT_QUIZ_RESULTS,
  QUESTION_VIEWED: "question_viewed",
  CONTINUE_CLICKED: "continue_clicked",
  BACK_CLICKED: "back_clicked",
  INPUT_FOCUS: "input_focus",
  OUT_OF_INPUT_FOCUSED: "out_of_input_focused",
  INPUT_CHANGED: "input_changed",
  OPTION_SELECTED: "option_selected",
  MULTISELECT_CHANGED: "multiselect_changed",
  DROPDOWN_CHANGED: "dropdown_changed",
  AUTOCOMPLETE_SELECTED: "autocomplete_selected",
  AUTOCOMPLETE_TYPED: "autocomplete_typed",
  PAGE_VIEW: "page_view",
  CALCULATION_COMPLETE: "calculation_complete",
  CALCULATION_END: "calculation_end",
  VALIDATION_ERROR: "validation_error",
  DEFAULT_VALUE: "default_value",
  DATA_SENT_TO_DISPATCH_URL: "data_sent_to_dispatch_url",
  ERROR_SENDING_DATA: "error_sending_data"
};
const EVENT_PROPERTIES$1 = {
  INTERACTION_TYPE: {
    FOCUS: "focus",
    BLUR: "blur"
  },
  EVENT_TRIGGER: {
    USER_FOCUSED: "user_focused",
    USER_LEFT_FIELD: "user_left_field",
    USER_SELECTED: "user_selected"
  },
  ACTION: {
    CONTINUE: "continue"
  }
};
const UI_CONSTANTS$1 = {
  QUESTION_NUMBER_OFFSET: 1
};
const DEBUG_MESSAGES$1 = {
  LOCALSTORAGE_PARSE_FAILED: "Failed to parse quiz_answers from localStorage"
};
const ERROR_MESSAGES$1 = {
  QUIZ_ID_NOT_FOUND: "Quiz ID not found"
};
const DATA_PROPERTIES$1 = {
  QUESTION_ID: "question_id",
  QUIZ_ANSWERS: FIELD_QUIZ_ANSWERS,
  RESULTS_DATA: "results_data",
  QUIZ_COMPLETED: FIELD_QUIZ_COMPLETED,
  COMPLETED_AT: FIELD_COMPLETED_AT,
  INTERACTION_TYPE: "interaction_type",
  EVENT_TRIGGER: "event_trigger",
  SELECTION_TYPE: "selection_type",
  SELECTED_VALUE: "selected_value",
  FIELD_KEY: "field_key",
  FIELD_VALUE: "field_value",
  QUESTION_INDEX: "question_index",
  QUESTION_NUMBER: "question_number",
  ACTION: "action",
  PAGE_TYPE: "page_type",
  TIMESTAMP: "timestamp",
  TOTAL_QUESTIONS: "total_questions",
  TOTAL_DURATION: "total_duration"
};
const TrackEventsConstants = {
  EVENT_CATEGORY: EVENT_CATEGORY$1,
  QUIZ_SESSION_KEY: QUIZ_SESSION_KEY$1,
  QUIZ_ANSWERS_KEY: QUIZ_ANSWERS_KEY$1,
  EVENT_NAMES: EVENT_NAMES$1,
  EVENT_PROPERTIES: EVENT_PROPERTIES$1,
  UI_CONSTANTS: UI_CONSTANTS$1,
  DEBUG_MESSAGES: DEBUG_MESSAGES$1,
  ERROR_MESSAGES: ERROR_MESSAGES$1,
  DATA_PROPERTIES: DATA_PROPERTIES$1,
  MISSING_KEY
};
function generateUUID() {
  return generateId$1();
}
function getQuizId(quizData) {
  if (!quizData || typeof quizData !== "object") {
    return void 0;
  }
  return quizData.quizId;
}
function stringifyData(data) {
  return JSON.stringify(data);
}
function createTimestamp() {
  return (/* @__PURE__ */ new Date()).toISOString();
}
function createFieldInteractionData(inputType, fieldKey, fieldValue, questionIndex, additionalData = {}) {
  return {
    input_type: inputType,
    field_key: fieldKey,
    field_value: fieldValue,
    question_index: questionIndex,
    ...additionalData
  };
}
const {
  QUIZ_SESSION_KEY,
  QUIZ_ANSWERS_KEY,
  UI_CONSTANTS,
  DEBUG_MESSAGES,
  ERROR_MESSAGES,
  DATA_PROPERTIES
} = TrackEventsConstants;
const EVENT_CATEGORY = TrackEventsConstants.EVENT_CATEGORY;
const EVENT_NAMES = TrackEventsConstants.EVENT_NAMES;
const EVENT_PROPERTIES = TrackEventsConstants.EVENT_PROPERTIES;
function initializeQuizSession() {
  const newSessionId = generateUUID();
  localStorage.setItem(QUIZ_SESSION_KEY, newSessionId);
  return newSessionId;
}
function getCurrentQuizSessionId() {
  return localStorage.getItem(QUIZ_SESSION_KEY) || initializeQuizSession();
}
function createBaseData(quizId, urlParamToAddToEvents) {
  return {
    quiz_id: quizId,
    quiz_session_id: getCurrentQuizSessionId(),
    block_id: extractBlockId(quizId) ?? null,
    [urlParamToAddToEvents || TrackEventsConstants.MISSING_KEY]: urlParamToAddToEvents ? getUrlParamValue(urlParamToAddToEvents) ?? null : null,
    quiz_identifier: extractQuizIdentifier(quizId) ?? null
  };
}
function validateEvent(event) {
  return !(event && event.isTrusted === false);
}
function trackInputInteraction(inputType, fieldKey, quizData, questionIndex, fieldValue, event, interactionType, eventTrigger, eventName) {
  if (!validateEvent(event)) {
    return;
  }
  const fieldData = createFieldInteractionData(inputType, fieldKey, fieldValue, questionIndex, {
    [DATA_PROPERTIES.INTERACTION_TYPE]: interactionType,
    [DATA_PROPERTIES.EVENT_TRIGGER]: eventTrigger
  });
  sendTrackingEvent(eventName, quizData, fieldData);
}
function sendTrackingEvent(eventName, quizData, additionalData = {}) {
  const quizId = getQuizId(quizData);
  if (!quizId) {
    console.error(ERROR_MESSAGES.QUIZ_ID_NOT_FOUND);
    return;
  }
  const urlParamToAddToEvents = getUrlParamNameFromQuizElement(quizId);
  if (window.trackEvent) {
    window.trackEvent(
      EVENT_CATEGORY,
      eventName,
      stringifyData({ ...createBaseData(quizId, urlParamToAddToEvents), ...additionalData })
    );
  }
}
function trackInputFocus(inputType, fieldKey, quizData, questionIndex, fieldValue = "", event = null) {
  trackInputInteraction(
    inputType,
    fieldKey,
    quizData,
    questionIndex,
    fieldValue,
    event,
    EVENT_PROPERTIES.INTERACTION_TYPE.FOCUS,
    EVENT_PROPERTIES.EVENT_TRIGGER.USER_FOCUSED,
    EVENT_NAMES.INPUT_FOCUS
  );
}
function trackInputBlur(inputType, fieldKey, quizData, questionIndex, fieldValue = "", event = null) {
  trackInputInteraction(
    inputType,
    fieldKey,
    quizData,
    questionIndex,
    fieldValue,
    event,
    EVENT_PROPERTIES.INTERACTION_TYPE.BLUR,
    EVENT_PROPERTIES.EVENT_TRIGGER.USER_LEFT_FIELD,
    EVENT_NAMES.OUT_OF_INPUT_FOCUSED
  );
}
function trackOptionSelection(selectionType, selectedValue, fieldKey, quizData, questionIndex, event = null) {
  if (!validateEvent(event)) {
    return;
  }
  sendTrackingEvent(EVENT_NAMES.OPTION_SELECTED, quizData, {
    [DATA_PROPERTIES.SELECTION_TYPE]: selectionType,
    [DATA_PROPERTIES.SELECTED_VALUE]: selectedValue,
    [DATA_PROPERTIES.FIELD_KEY]: fieldKey,
    [DATA_PROPERTIES.FIELD_VALUE]: selectedValue,
    [DATA_PROPERTIES.QUESTION_INDEX]: questionIndex,
    [DATA_PROPERTIES.EVENT_TRIGGER]: EVENT_PROPERTIES.EVENT_TRIGGER.USER_SELECTED
  });
}
function trackContinueClick(questionIndex, questionId, quizData) {
  sendTrackingEvent(EVENT_NAMES.CONTINUE_CLICKED, quizData, {
    [DATA_PROPERTIES.QUESTION_INDEX]: questionIndex,
    [DATA_PROPERTIES.QUESTION_ID]: questionId,
    [DATA_PROPERTIES.QUESTION_NUMBER]: questionIndex + UI_CONSTANTS.QUESTION_NUMBER_OFFSET,
    [DATA_PROPERTIES.ACTION]: EVENT_PROPERTIES.ACTION.CONTINUE
  });
}
function trackPageView(quizData, pageType) {
  sendTrackingEvent(EVENT_NAMES.PAGE_VIEW, quizData, {
    [DATA_PROPERTIES.PAGE_TYPE]: pageType,
    [DATA_PROPERTIES.TIMESTAMP]: createTimestamp()
  });
}
function trackQuizResults(quizData, calculationResults = null) {
  let quizAnswers = {};
  try {
    const storedAnswers = localStorage.getItem(QUIZ_ANSWERS_KEY);
    if (storedAnswers) {
      quizAnswers = JSON.parse(storedAnswers);
    }
  } catch {
    console.error(DEBUG_MESSAGES.LOCALSTORAGE_PARSE_FAILED);
  }
  const quizId = getQuizId(quizData);
  const currentQuizAnswers = quizId ? quizAnswers[quizId] : void 0;
  const completedAt = currentQuizAnswers?.completedAt ?? null;
  sendTrackingEvent(EVENT_NAMES.QUIZ_RESULTS, quizData, {
    [DATA_PROPERTIES.QUIZ_ANSWERS]: quizAnswers,
    [DATA_PROPERTIES.RESULTS_DATA]: calculationResults,
    [DATA_PROPERTIES.QUIZ_COMPLETED]: true,
    [DATA_PROPERTIES.COMPLETED_AT]: completedAt
  });
}
function trackQuizEnded(quizData, totalQuestions = null, totalDuration = null) {
  sendTrackingEvent(EVENT_NAMES.QUIZ_ENDED, quizData, {
    [DATA_PROPERTIES.TOTAL_QUESTIONS]: totalQuestions,
    [DATA_PROPERTIES.TOTAL_DURATION]: totalDuration,
    [DATA_PROPERTIES.TIMESTAMP]: createTimestamp()
  });
}
const saveTimeouts = /* @__PURE__ */ new Map();
const pendingQuizData = /* @__PURE__ */ new Map();
function clearDebouncedSaveTimeout(quizId) {
  const existingTimeout = saveTimeouts.get(quizId);
  if (isDefined(existingTimeout)) {
    clearTimeout(existingTimeout);
  }
}
function writeToLocalStorage(key, value) {
  if (!key) {
    console.warn("Invalid key provided for localStorage write:", key);
    return false;
  }
  const stringifiedValue = stringify(value);
  if (!isDefined(stringifiedValue)) {
    console.error("Error writing to localStorage:", key, value);
    return false;
  }
  try {
    localStorage.setItem(key, stringifiedValue);
    return true;
  } catch (e) {
    console.error("Error writing to localStorage:", key, e);
    return false;
  }
}
function readFromLocalStorage(key) {
  if (!key) {
    console.warn("Invalid key provided for localStorage read:", key);
    return null;
  }
  try {
    const value = localStorage.getItem(key);
    if (!isDefined(value)) {
      return null;
    }
    try {
      return JSON.parse(value);
    } catch (parseError) {
      console.error("Error reading from localStorage:", key, parseError);
      return null;
    }
  } catch (e) {
    console.error("Error reading from localStorage:", key, e);
    return null;
  }
}
function generateId() {
  return generateId$1();
}
function getQuizzesData() {
  const data = readFromLocalStorage(QUIZ_STORAGE.STORAGE_KEY);
  if (!isDefined(data)) {
    return {};
  }
  if (typeof data === "object" && isDefined(data) && !Array.isArray(data)) {
    return data;
  }
  console.warn("Malformed quiz data in localStorage, returning empty object");
  return {};
}
function getQuizData(quizId) {
  const pendingData = pendingQuizData.get(quizId);
  if (pendingData) {
    return pendingData;
  }
  const quizzes = getQuizzesData();
  if (!quizzes[quizId]) {
    const newQuizData = {
      [STORAGE_FIELD_NAMES.QUIZ_ID]: quizId,
      GlobalObject: { [STORAGE_FIELD_NAMES.ID]: generateId() },
      EntitiesObject: []
    };
    quizzes[quizId] = newQuizData;
    writeToLocalStorage(QUIZ_STORAGE.STORAGE_KEY, quizzes);
    addNewEntity(quizId);
    return getQuizData(quizId);
  }
  return quizzes[quizId];
}
function getQuizResultsPayload(quizId) {
  const urlParams = readFromLocalStorage(STORAGE_KEYS.url_params);
  return {
    ...getQuizData(quizId),
    ...isDefined(urlParams) && { url_params: urlParams }
  };
}
function setQuizData(quizId, quizData) {
  const quizzes = getQuizzesData();
  quizzes[quizId] = quizData;
  clearDebouncedSaveTimeout(quizId);
  saveTimeouts.delete(quizId);
  pendingQuizData.delete(quizId);
  return writeToLocalStorage(QUIZ_STORAGE.STORAGE_KEY, quizzes);
}
function getQuiz(quizId) {
  const quizzes = getQuizzesData();
  if (!quizzes[quizId]) {
    console.warn("Quiz not found:", quizId);
    return null;
  }
  return quizzes[quizId];
}
function saveQuizData(quizData) {
  if (!quizData || !quizData[STORAGE_FIELD_NAMES.QUIZ_ID]) {
    console.error("QuizStorage: Missing quiz_id");
    return false;
  }
  return setQuizData(quizData[STORAGE_FIELD_NAMES.QUIZ_ID], quizData);
}
function debouncedSaveQuizData(quizId, quizData) {
  clearDebouncedSaveTimeout(quizId);
  if (quizData) {
    const existingPendingData = pendingQuizData.get(quizId);
    if (existingPendingData) {
      const maxLength = Math.max(
        existingPendingData.EntitiesObject.length,
        quizData.EntitiesObject.length
      );
      const mergedEntities = Array.from({ length: maxLength }, (_, index) => {
        const existingEntity = existingPendingData.EntitiesObject[index];
        const newEntity = quizData.EntitiesObject[index];
        if (existingEntity && newEntity) {
          return { ...existingEntity, ...newEntity };
        }
        return existingEntity || newEntity;
      }).filter(
        (entity) => isDefined(entity) && isDefined(entity.id)
      );
      const mergedData = {
        ...existingPendingData,
        ...quizData,
        GlobalObject: {
          ...existingPendingData.GlobalObject ?? {},
          ...quizData.GlobalObject ?? {}
        },
        EntitiesObject: mergedEntities
      };
      pendingQuizData.set(quizId, mergedData);
    } else {
      pendingQuizData.set(quizId, quizData);
    }
  }
  saveTimeouts.set(
    quizId,
    window.setTimeout(() => {
      const dataToSave = pendingQuizData.get(quizId) || quizData || getQuizData(quizId);
      if (saveQuizData(dataToSave)) {
        saveTimeouts.delete(quizId);
        pendingQuizData.delete(quizId);
      } else {
        console.error("Error saving quiz data for quizId:", quizId);
      }
    }, QUIZ_STORAGE.SAVE_DEBOUNCE_MS)
  );
  return true;
}
function setGlobalObjectField(quizId, fieldName, value, immediate = false) {
  const quizData = getQuizData(quizId);
  quizData.GlobalObject[fieldName] = value;
  if (immediate) {
    return setQuizData(quizId, quizData);
  }
  return debouncedSaveQuizData(quizId, quizData);
}
function setEntityObjectField(quizId, entityIndex, fieldName, value, immediate = false) {
  const quizData = getQuizData(quizId);
  if (entityIndex < STORAGE_DEFAULTS.DEFAULT_ENTITY_INDEX || entityIndex >= quizData.EntitiesObject.length) {
    console.warn("Invalid entity index:", entityIndex, "for quiz:", quizId);
    return false;
  }
  quizData.EntitiesObject[entityIndex][fieldName] = value;
  if (immediate) {
    return setQuizData(quizId, quizData);
  }
  return debouncedSaveQuizData(quizId, quizData);
}
function getCurrentEntityObjectIndex(quizId) {
  const state2 = window.quizStates?.[quizId];
  if (isDefined(state2?.entitiesObjectIndex) && state2.entitiesObjectIndex >= 0) {
    return state2.entitiesObjectIndex;
  }
  const quizData = getQuizData(quizId);
  if (quizData.EntitiesObject.length === STORAGE_DEFAULTS.EMPTY_ENTITIES_ARRAY_LENGTH) {
    return STORAGE_DEFAULTS.DEFAULT_ENTITY_INDEX;
  }
  return quizData.EntitiesObject.length - 1;
}
function addNewEntity(quizId) {
  const quizData = getQuizData(quizId);
  const newEntity = {
    [STORAGE_FIELD_NAMES.ENTITY_ID]: generateId()
  };
  quizData.EntitiesObject.push(newEntity);
  setQuizData(quizId, quizData);
  return quizData.EntitiesObject.length - 1;
}
function resetQuiz(quizId) {
  clearDebouncedSaveTimeout(quizId);
  saveTimeouts.delete(quizId);
  pendingQuizData.delete(quizId);
  const quizzes = getQuizzesData();
  const newQuizData = {
    [STORAGE_FIELD_NAMES.QUIZ_ID]: quizId,
    GlobalObject: { [STORAGE_FIELD_NAMES.ID]: generateId() },
    EntitiesObject: []
  };
  quizzes[quizId] = newQuizData;
  writeToLocalStorage(QUIZ_STORAGE.STORAGE_KEY, quizzes);
  addNewEntity(quizId);
  return true;
}
function saveAnswer(quizId, pageId, value, questionType, options = {}) {
  if (!validateParams(quizId, pageId, value)) {
    return false;
  }
  const fieldName = options.keyName || pageId;
  writeToLocalStorage(fieldName, value);
  const targetObject = options.targetObject || STORAGE_TARGET_TYPES.ENTITY;
  const immediate = isDefined(options.immediate) ? options.immediate : IMMEDIATE_SAVE_QUESTION_TYPES.includes(questionType);
  if (targetObject === STORAGE_TARGET_TYPES.GLOBAL) {
    return setGlobalObjectField(quizId, fieldName, value, immediate);
  }
  return setEntityObjectField(
    quizId,
    isDefined(options.entityIndex) ? options.entityIndex : getCurrentEntityObjectIndex(quizId),
    fieldName,
    value,
    immediate
  );
}
function hasSavedProgress(quizId) {
  const quizData = getQuiz(quizId);
  if (!quizData) {
    return false;
  }
  const hasGlobalData = Object.keys(quizData.GlobalObject).length > STORAGE_DEFAULTS.MIN_GLOBAL_OBJECT_KEYS;
  const hasEntityData = quizData.EntitiesObject.length > STORAGE_DEFAULTS.EMPTY_ENTITIES_ARRAY_LENGTH && quizData.EntitiesObject[STORAGE_DEFAULTS.FIRST_ENTITY_INDEX] && Object.keys(quizData.EntitiesObject[STORAGE_DEFAULTS.FIRST_ENTITY_INDEX]).length > STORAGE_DEFAULTS.MIN_ENTITY_OBJECT_KEYS;
  return hasGlobalData || hasEntityData || !!quizData.completedAt;
}
function restoreAllFormFields(quizId, entityIndex) {
  const quizData = getQuizData(quizId);
  Object.keys(quizData.GlobalObject).forEach((key) => {
    if (key !== STORAGE_FIELD_NAMES.ID) {
      const value = quizData.GlobalObject[key];
      writeToLocalStorage(key, value);
    }
  });
  const targetEntityIndex = isDefined(entityIndex) ? entityIndex : getCurrentEntityObjectIndex(quizId);
  if (targetEntityIndex >= 0 && targetEntityIndex < quizData.EntitiesObject.length) {
    Object.keys(quizData.EntitiesObject[targetEntityIndex]).forEach((key) => {
      if (key !== STORAGE_FIELD_NAMES.ENTITY_ID) {
        const value = quizData.EntitiesObject[targetEntityIndex][key];
        writeToLocalStorage(key, value);
      }
    });
  } else {
    console.warn("Entity index is out of bounds for quiz:", quizId);
  }
}
function getNestedStorageValue(storageKey, keyName, errorMessage, prioritizeLatest = false) {
  try {
    const data = readFromLocalStorage(storageKey);
    if (!data) {
      return void 0;
    }
    const value = prioritizeLatest ? data.latest?.[keyName] ?? data[keyName] : data[keyName];
    return !isDefined(value) ? void 0 : String(value);
  } catch (error) {
    console.error("Error getting nested storage value:", error);
    return void 0;
  }
}
function getUrlParamValueFromStorage(keyName) {
  return getNestedStorageValue(
    STORAGE_KEYS.url_params,
    keyName,
    `[getUrlParamValueFromStorage] Failed to parse URL params from localStorage for key: ${keyName}`,
    true
  );
}
function getConfigValueFromStorage(keyName) {
  return getNestedStorageValue(
    STORAGE_KEYS.CONFIG,
    keyName,
    `[getConfigValueFromStorage] Failed to parse config from localStorage for key: ${keyName}`,
    false
  );
}
function replaceTemplateVars(text, quizId) {
  if (!text) {
    return text;
  }
  const quizData = getQuizData(quizId);
  const missingVariables = [];
  const result = text.replace(
    REGEX_PATTERNS.PLACEHOLDER_REPLACEMENT,
    (match, variableName, source) => {
      const trimmedSource = source ? source.trim().toLowerCase() : PLACEHOLDER_SOURCES.LOCAL;
      if (trimmedSource === PLACEHOLDER_SOURCES.URL) {
        const trimmedKey = variableName.trim();
        const urlValue = getUrlParamValueFromStorage(trimmedKey);
        if (isDefined(urlValue)) {
          return urlValue;
        }
        console.warn(`URL param "${trimmedKey}" not found in URL_Params`, {
          quizId,
          match,
          variableName: trimmedKey
        });
        return match;
      }
      if (trimmedSource === PLACEHOLDER_SOURCES.CONFIG) {
        const trimmedKey = variableName.trim();
        const configValue = getConfigValueFromStorage(trimmedKey);
        if (isDefined(configValue)) {
          return configValue;
        }
        console.warn(`Config value "${trimmedKey}" not found in config`, {
          quizId,
          match,
          variableName: trimmedKey
        });
        return match;
      }
      const normalizedKey = variableName.trim().replace(REGEX_PATTERNS.SPACE_TO_UNDERSCORE, TEXT_TEMPLATES.UNDERSCORE_REPLACEMENT);
      let value = quizData.GlobalObject[normalizedKey];
      if (!isDefined(value) && quizData.EntitiesObject.length > 0) {
        const entity = [...quizData.EntitiesObject].reverse().find((entity2) => {
          return isDefined(entity2[normalizedKey]);
        });
        if (entity) {
          value = entity[normalizedKey];
        }
      }
      if (!isDefined(value)) {
        missingVariables.push(variableName);
        console.warn(`Template variable not found: ${variableName} in quiz ${quizId}`, {
          globalKeys: Object.keys(quizData.GlobalObject),
          entityKeys: quizData.EntitiesObject.length > 0 ? Object.keys(quizData.EntitiesObject[0]) : []
        });
        return match;
      }
      if (Array.isArray(value)) {
        return value.join(TEXT_TEMPLATES.ARRAY_JOIN_SEPARATOR);
      }
      return String(value);
    }
  );
  if (missingVariables.length > 0) {
    console.warn(
      `Template replacement completed with ${missingVariables.length} missing variables:`,
      missingVariables
    );
  }
  return result;
}
function markCompleted(quizId) {
  const quizData = getQuizData(quizId);
  quizData[STORAGE_FIELD_NAMES.COMPLETED_AT] = (/* @__PURE__ */ new Date()).toISOString();
  saveQuizData(quizData);
}
async function exportData(quizId) {
  const quizData = getQuizData(quizId);
  const quizElement = document.querySelector(SELECTOR_TEMPLATES.QUIZ_SECTION_BY_ID(quizId));
  const quizConfig = collectQuizConfig(quizElement);
  if (!quizConfig) {
    console.warn("Export data URL not found");
    return quizData;
  }
  try {
    new URL(quizConfig.exportUrl);
  } catch {
    console.error("Error: Invalid URL format", quizConfig.exportUrl);
    return quizData;
  }
  await window.storeURLParams();
  const stringifiedPayload = stringify(getQuizResultsPayload(quizId));
  if (!isDefined(stringifiedPayload)) {
    console.error("Error stringifying payload for export");
    return quizData;
  }
  try {
    const response = await window.fetch(quizConfig.exportUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: stringifiedPayload,
      keepalive: true
    });
    if (response.ok) {
      sendTrackingEvent(
        EVENT_NAMES.DATA_SENT_TO_DISPATCH_URL,
        { quizId },
        {
          dispatch_url: quizConfig.exportUrl,
          response_status: response.status
        }
      );
    } else {
      sendTrackingEvent(
        EVENT_NAMES.ERROR_SENDING_DATA,
        { quizId },
        {
          error: "Error exporting data",
          response_status: response.status
        }
      );
    }
  } catch (error) {
    console.error(`Error exporting data for quiz ${quizId}:`, error);
  }
  return quizData;
}
function getStorageScope(element) {
  if (element.dataset?.storageScope) {
    const normalizedScope = element.dataset.storageScope.trim().toLowerCase();
    if (normalizedScope === STORAGE_TARGET_TYPES.GLOBAL) {
      return STORAGE_TARGET_TYPES.GLOBAL;
    }
    if (normalizedScope === STORAGE_TARGET_TYPES.ENTITY) {
      return STORAGE_TARGET_TYPES.ENTITY;
    }
  }
  if (typeof element.closest === "function") {
    const container = element.closest(ELEMENT_SELECTORS.RADIO_QUESTION) || element.closest(ELEMENT_SELECTORS.CHECKBOX_QUESTION) || element.closest(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_SELECTOR);
    if (container) {
      const containerScope = container.dataset?.storageScope;
      if (containerScope) {
        const normalizedScope = containerScope.trim().toLowerCase();
        if (normalizedScope === STORAGE_TARGET_TYPES.GLOBAL) {
          return STORAGE_TARGET_TYPES.GLOBAL;
        }
        if (normalizedScope === STORAGE_TARGET_TYPES.ENTITY) {
          return STORAGE_TARGET_TYPES.ENTITY;
        }
      }
    }
  }
  return STORAGE_TARGET_TYPES.ENTITY;
}
function extractCheckboxValue(target) {
  const input = target;
  const container = input.closest(ELEMENT_SELECTORS.CHECKBOX_QUESTION);
  if (!container) {
    return null;
  }
  const checkedBoxes = container.querySelectorAll(
    STORAGE_MAGIC_VALUES.CHECKBOX_SELECTOR_TEMPLATE.replace(
      STORAGE_MAGIC_VALUES.CHECKBOX_NAME_PLACEHOLDER,
      input.name
    )
  );
  const values = Array.from(checkedBoxes).map((cb) => cb.value);
  return values.length === 1 ? values[0] : values;
}
function extractNumberValue(target) {
  const input = target;
  const value = parseFloat(input.value);
  return !isNaN(value) ? value : null;
}
function extractTextValue(target) {
  const input = target;
  const value = input.value?.trim();
  return value ?? null;
}
function extractStandardValue(target) {
  const input = target;
  return input.value || null;
}
function handleInputChangeWithExtractor(event, quizId, questionType, extractValue) {
  const target = event.target;
  if (!target) {
    return;
  }
  const value = extractValue(target);
  if (!isDefined(value)) {
    return;
  }
  const element = target;
  const keyName = element.name || element.id;
  const container = target.closest(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_SELECTOR);
  const actualQuestionType = container?.getAttribute(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_ATTRIBUTE) || questionType;
  const isMultiInput = actualQuestionType === STORAGE_MAGIC_VALUES.QUESTION_TYPE_MULTI_INPUT;
  const immediate = isMultiInput || IMMEDIATE_SAVE_QUESTION_TYPES.includes(actualQuestionType);
  saveAnswer(quizId, keyName, value, actualQuestionType, {
    keyName,
    targetObject: getStorageScope(target),
    immediate
  });
}
function handleCheckboxChange(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractCheckboxValue);
}
function handleNumberChange(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractNumberValue);
}
function handleRangeChange(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractStandardValue);
}
function handleSelectChange(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractStandardValue);
}
function handleTextInput(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractTextValue);
}
function handleTextareaInput(event, quizId, questionType) {
  handleInputChangeWithExtractor(event, quizId, questionType, extractTextValue);
}
function initializeListeners(quizId) {
  const quizSection = document.querySelector(
    `#${STORAGE_MAGIC_VALUES.QUIZ_SECTION_PREFIX}${quizId}`
  );
  if (!quizSection) {
    return;
  }
  const handleDelegatedInput = (e) => {
    const target = e.target;
    if (!target || !(target instanceof HTMLInputElement || target instanceof HTMLSelectElement || target instanceof HTMLTextAreaElement)) {
      return;
    }
    const element = target;
    const container = element.closest(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_SELECTOR);
    const questionType = container?.getAttribute(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_ATTRIBUTE) || element.type;
    if (element.type === INPUT_TYPE_VALUES.RADIO && e.type === DOM_EVENT_NAMES.CHANGE) {
      handleRadioChange(e, quizId, questionType);
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.CHECKBOX && e.type === DOM_EVENT_NAMES.CHANGE) {
      handleCheckboxChange(e, quizId, questionType);
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.NUMBER && e.type === DOM_EVENT_NAMES.CHANGE) {
      handleNumberChange(e, quizId, questionType);
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.RANGE && e.type === DOM_EVENT_NAMES.INPUT) {
      handleRangeChange(e, quizId, questionType);
      return;
    }
    if (element.tagName === HTML_TAGS.SELECT && e.type === DOM_EVENT_NAMES.CHANGE) {
      handleSelectChange(e, quizId, questionType);
      return;
    }
    if (element.tagName === HTML_TAGS.TEXTAREA && e.type === DOM_EVENT_NAMES.INPUT) {
      handleTextareaInput(e, quizId, questionType);
      return;
    }
    if (INPUT_TYPE_ARRAYS.INPUT_EVENT_TYPES.includes(element.type) && e.type === DOM_EVENT_NAMES.INPUT) {
      handleTextInput(e, quizId, questionType);
    }
  };
  const handleDelegatedFocusBlur = (_e) => {
  };
  quizSection.addEventListener(DOM_EVENT_NAMES.CHANGE, handleDelegatedInput);
  quizSection.addEventListener(DOM_EVENT_NAMES.INPUT, handleDelegatedInput);
  quizSection.addEventListener(DOM_EVENT_NAMES.FOCUS, handleDelegatedFocusBlur, true);
  quizSection.addEventListener(DOM_EVENT_NAMES.BLUR, handleDelegatedFocusBlur, true);
  const inputs = quizSection.querySelectorAll(STORAGE_MAGIC_VALUES.INPUT_SELECTOR);
  inputs.forEach((input) => {
    const element = input;
    const container = element.closest(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_SELECTOR);
    const questionType = container?.getAttribute(STORAGE_MAGIC_VALUES.DATA_QUESTION_TYPE_ATTRIBUTE) || element.type;
    if (element.type === INPUT_TYPE_VALUES.RADIO) {
      element.addEventListener(
        DOM_EVENT_NAMES.CHANGE,
        (e) => handleRadioChange(e, quizId, questionType)
      );
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.CHECKBOX) {
      element.addEventListener(
        DOM_EVENT_NAMES.CHANGE,
        (e) => handleCheckboxChange(e, quizId, questionType)
      );
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.NUMBER) {
      element.addEventListener(
        DOM_EVENT_NAMES.CHANGE,
        (e) => handleNumberChange(e, quizId, questionType)
      );
      return;
    }
    if (element.type === INPUT_TYPE_VALUES.RANGE) {
      element.addEventListener(
        DOM_EVENT_NAMES.INPUT,
        (e) => handleRangeChange(e, quizId, questionType)
      );
      return;
    }
    if (element.tagName === HTML_TAGS.SELECT) {
      element.addEventListener(
        DOM_EVENT_NAMES.CHANGE,
        (e) => handleSelectChange(e, quizId, questionType)
      );
      return;
    }
    if (element.tagName === HTML_TAGS.TEXTAREA) {
      element.addEventListener(DOM_EVENT_NAMES.INPUT, (e) => {
        handleTextareaInput(e, quizId, questionType);
      });
      return;
    }
    if (INPUT_TYPE_ARRAYS.INPUT_EVENT_TYPES.includes(element.type)) {
      element.addEventListener(DOM_EVENT_NAMES.INPUT, (e) => {
        handleTextInput(e, quizId, questionType);
      });
    }
  });
}
function validateParams(quizId, pageId, value) {
  if (!quizId || typeof quizId !== "string") {
    console.warn("Invalid quiz ID:", quizId);
    return false;
  }
  if (!pageId || typeof pageId !== "string") {
    console.warn("Invalid page ID:", pageId);
    return false;
  }
  if (value === void 0) {
    console.warn("validateParams: Undefined value", { quizId, pageId, value });
    return false;
  }
  return true;
}
function getFieldValueFromStorage(quizData, keyName) {
  let value = quizData.GlobalObject[keyName];
  if (!isDefined(value) && quizData.EntitiesObject.length > 0) {
    const currentEntityIndex = quizData.EntitiesObject.length - 1;
    value = quizData.EntitiesObject[currentEntityIndex][keyName];
  }
  return value;
}
function populateStandardInputs(inputs, quizData) {
  inputs.forEach((input) => {
    const element = input;
    const keyName = element.name || element.id;
    if (!keyName) {
      return;
    }
    const value = getFieldValueFromStorage(quizData, keyName);
    if (!isDefined(value)) {
      return;
    }
    if ("type" in element && element.type === INPUT_TYPE_VALUES.CHECKBOX) {
      const checkboxElement = element;
      if (Array.isArray(value)) {
        checkboxElement.checked = value.includes(checkboxElement.value);
      } else {
        checkboxElement.checked = checkboxElement.value === String(value);
      }
    } else if ("type" in element && element.type === INPUT_TYPE_VALUES.RADIO) {
      const radioElement = element;
      radioElement.checked = radioElement.value === String(value);
    } else {
      element.value = Array.isArray(value) ? value.join(TEXT_TEMPLATES.ARRAY_JOIN_SEPARATOR) : String(value);
    }
  });
}
function applyDiscount(subscriptionId, discountCode) {
  return backendPost(
    API_PATHS.SUBSCRIPTION_DISCOUNT(subscriptionId),
    { discount_code: discountCode },
    "Failed to apply discount"
  );
}
function cancelSubscription(subscriptionId, cancellationReason, agentType = 1) {
  return backendPost(
    API_PATHS.SUBSCRIPTION_CANCEL(subscriptionId),
    {
      agent_type: agentType,
      cancel_subscription_ticket_details: { cancellation_reason: cancellationReason }
    },
    "Failed to cancel subscription"
  );
}
function addFreeGiftToSubscription(subscriptionId, productVariantId, quantity) {
  return backendPost(
    API_PATHS.SUBSCRIPTION_FREE_GIFT(subscriptionId),
    { gifts: [{ product_variant_id: productVariantId, quantity }] },
    "Failed to add free gift"
  );
}
function skipNextChargeForSubscription(subscriptionId) {
  return backendPost(
    API_PATHS.SUBSCRIPTION_SKIP_NEXT_CHARGE(subscriptionId),
    {},
    "Failed to skip next charge"
  );
}
function changeNextChargeForSubscription(subscriptionId, options) {
  const requestBody = {};
  if (options.newNextChargeDate) {
    requestBody.new_next_charge_date = options.newNextChargeDate;
  }
  if (options.numOfDays !== void 0) {
    requestBody.num_of_days = options.numOfDays;
  }
  return backendPost(
    API_PATHS.SUBSCRIPTION_NEXT_CHARGE(subscriptionId),
    requestBody,
    "Failed to change next charge date"
  );
}
function changeProductForSubscription(subscriptionId, productVariantId) {
  return backendPost(
    API_PATHS.SUBSCRIPTION_PRODUCT(subscriptionId),
    { product_variant_id: productVariantId },
    "Failed to change product"
  );
}
async function getSubscriptionData(subscriptionId) {
  return await window.zygRequestGet(
    API_PATHS.SUBSCRIPTION_DATA(subscriptionId)
  );
}
const windowExports = {
  addFreeGiftToSubscription,
  applyDiscount,
  cancelSubscription,
  changeNextChargeForSubscription,
  changeProductForSubscription,
  getSubscriptionData,
  skipNextChargeForSubscription
};
Object.entries(windowExports).forEach(([key, fn]) => {
  window[key] = fn;
});
function getActionKey(actionType, subscriptionId, additionalKey) {
  return additionalKey ? `${actionType}:${subscriptionId}:${additionalKey}` : `${actionType}:${subscriptionId}`;
}
function isActionProcessed(actionType, subscriptionId, additionalKey) {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.PROCESSED_ACTIONS);
    if (!stored) {
      return false;
    }
    return !!JSON.parse(stored)[getActionKey(actionType, subscriptionId, additionalKey)]?.success;
  } catch (error) {
    console.error("Failed to check if action is processed:", error);
    return false;
  }
}
function markActionProcessed(actionType, subscriptionId, additionalKey) {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.PROCESSED_ACTIONS);
    const processedActions = stored ? JSON.parse(stored) : {};
    processedActions[getActionKey(actionType, subscriptionId, additionalKey)] = {
      processedAt: (/* @__PURE__ */ new Date()).toISOString(),
      success: true
    };
    localStorage.setItem(STORAGE_KEYS.PROCESSED_ACTIONS, JSON.stringify(processedActions));
  } catch (error) {
    console.error("Failed to mark action as processed:", error);
  }
}
function getParam(name) {
  return getUrlParamValueFromStorage(name) || null;
}
function getActionParams() {
  return {
    subscriptionId: getParam(URL_PARAM_NAMES.SUBSCRIPTION_ID),
    cancellationReason: getParam(URL_PARAM_NAMES.CANCELLATION_REASON),
    discountCode: getParam(URL_PARAM_NAMES.DISCOUNT_CODE),
    freeGiftVariantId: getParam(URL_PARAM_NAMES.FREE_GIFT_VARIANT_ID),
    freeGiftQty: getParam(URL_PARAM_NAMES.FREE_GIFT_QUANTITY),
    skipNextCharge: getParam(URL_PARAM_NAMES.SKIP_NEXT_CHARGE),
    newNextChargeDate: getParam(URL_PARAM_NAMES.NEW_NEXT_CHARGE_DATE),
    numOfDays: getParam(URL_PARAM_NAMES.NUM_OF_DAYS),
    newProductVariantId: getParam(URL_PARAM_NAMES.NEW_PRODUCT_VARIANT_ID)
  };
}
const validators = {
  cancellation: (p) => p.subscriptionId && p.cancellationReason ? { subscriptionId: p.subscriptionId, cancellationReason: p.cancellationReason } : null,
  discount: (p) => p.subscriptionId && p.discountCode ? { subscriptionId: p.subscriptionId, discountCode: p.discountCode } : null,
  freeGift: (p) => {
    const qty = p.freeGiftQty ? parseInt(p.freeGiftQty, 10) : 0;
    return p.subscriptionId && p.freeGiftVariantId && qty > 0 ? {
      subscriptionId: p.subscriptionId,
      freeGiftVariantId: p.freeGiftVariantId,
      quantity: qty
    } : null;
  },
  skipCharge: (p) => p.subscriptionId && p.skipNextCharge === "true" ? { subscriptionId: p.subscriptionId } : null,
  changeChargeDate: (p) => {
    if (!p.subscriptionId) {
      return null;
    }
    const parsedDays = p.numOfDays ? parseInt(p.numOfDays, 10) : void 0;
    const validDays = parsedDays !== void 0 && !isNaN(parsedDays) ? parsedDays : void 0;
    if (!p.newNextChargeDate && !validDays) {
      return null;
    }
    return {
      subscriptionId: p.subscriptionId,
      newNextChargeDate: p.newNextChargeDate || void 0,
      numOfDays: validDays
    };
  },
  changeProduct: (p) => p.subscriptionId && p.newProductVariantId ? { subscriptionId: p.subscriptionId, newProductVariantId: p.newProductVariantId } : null
};
function createAction(def) {
  return {
    hasParams: () => {
      const validated = def.validate(getActionParams());
      if (!validated) {
        return false;
      }
      return !isActionProcessed(
        def.actionType,
        validated.subscriptionId,
        def.getAdditionalKey?.(validated)
      );
    },
    execute: async () => {
      const validated = def.validate(getActionParams());
      if (!validated) {
        return { success: false, error: "Missing required parameters" };
      }
      const additionalKey = def.getAdditionalKey?.(validated);
      if (isActionProcessed(def.actionType, validated.subscriptionId, additionalKey)) {
        return { success: true, error: `${def.successMessage} (already processed)` };
      }
      const result = await def.call(validated);
      if (result.success) {
        markActionProcessed(def.actionType, validated.subscriptionId, additionalKey);
      }
      return result;
    },
    successMessage: def.successMessage,
    errorMessage: `Failed to execute ${def.actionType}`
  };
}
const subscriptionActions = [
  createAction({
    actionType: ACTION_TYPES.CANCELLATION,
    validate: validators.cancellation,
    call: (v) => cancelSubscription(v.subscriptionId, v.cancellationReason),
    successMessage: "Subscription cancelled successfully"
  }),
  createAction({
    actionType: ACTION_TYPES.DISCOUNT,
    validate: validators.discount,
    getAdditionalKey: (v) => v.discountCode,
    call: (v) => applyDiscount(v.subscriptionId, v.discountCode),
    successMessage: "Discount applied successfully"
  }),
  createAction({
    actionType: ACTION_TYPES.FREE_GIFT,
    validate: validators.freeGift,
    getAdditionalKey: (v) => v.freeGiftVariantId,
    call: (v) => addFreeGiftToSubscription(v.subscriptionId, v.freeGiftVariantId, v.quantity),
    successMessage: "Free gift added successfully"
  }),
  createAction({
    actionType: ACTION_TYPES.SKIP_CHARGE,
    validate: validators.skipCharge,
    call: (v) => skipNextChargeForSubscription(v.subscriptionId),
    successMessage: "Next charge skipped successfully"
  }),
  createAction({
    actionType: ACTION_TYPES.CHANGE_CHARGE_DATE,
    validate: validators.changeChargeDate,
    getAdditionalKey: (v) => v.newNextChargeDate || (v.numOfDays ? String(v.numOfDays) : void 0),
    call: (v) => changeNextChargeForSubscription(v.subscriptionId, {
      newNextChargeDate: v.newNextChargeDate,
      numOfDays: v.numOfDays
    }),
    successMessage: "Charge date changed successfully"
  }),
  createAction({
    actionType: ACTION_TYPES.CHANGE_PRODUCT,
    validate: validators.changeProduct,
    getAdditionalKey: (v) => v.newProductVariantId,
    call: (v) => changeProductForSubscription(v.subscriptionId, v.newProductVariantId),
    successMessage: "Product changed successfully"
  })
];
async function applyDiscountFromUrl() {
  return subscriptionActions[1].execute();
}
window.applyDiscountFromUrl = applyDiscountFromUrl;
const createAsyncQueue = () => {
  let tail = Promise.resolve();
  return {
    enqueue(operation) {
      const result = tail.then(operation, operation);
      tail = result.then(
        () => {
        },
        () => {
        }
      );
      return result;
    }
  };
};
const RADIX_DECIMAL = 10;
const CENTS_DIVISOR = 100;
const DECIMAL_PLACES = 2;
const FALLBACK_MONEY_PREFIX = "$";
const PERCENTAGE_MULTIPLIER = 100;
const ATTR_ARIA_EXPANDED = "aria-expanded";
const DEFAULT_LINE = 0;
const DEFAULT_QUANTITY = 1;
const FREE_GIFT_LABEL = "FREE";
const ADDED_FEEDBACK_DURATION = 2e3;
const DISPLAY_NONE = "none";
const WINDOW_TARGET_BLANK = "_blank";
const WINDOW_FEATURES_SECURE = "noopener,noreferrer";
const CHECKOUT_URL = "/checkout";
const DISCOUNT_URL_TEMPLATE = "/discount/";
const buildDiscountRedirectUrl = (code, redirectTo) => `${DISCOUNT_URL_TEMPLATE}${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectTo)}`;
const EVENT_INPUT = "input";
const EVENT_CHANGE = "change";
const EVENT_CLICK = "click";
const ATTR_ACTION = "data-action";
const ATTR_PRODUCT_ID$1 = "data-product-id";
const ATTR_SELLING_PLAN$2 = "data-selling-plan";
const ATTR_AVAILABLE = "data-available";
const ATTR_CART_FEEDBACK = "data-cart-feedback";
const ATTR_PRICE = "data-price";
const PROPERTY_SUBSCRIPTION = "_subscription";
const PROPERTY_LINE_ITEM_ID = "_line_item_id";
const PROPERTY_PARENT_LINE_ITEM_ID = "_parent_line_item_id";
const PROPERTY_UPSELL = "_upsell";
const PROPERTY_SOURCE = "_source";
const PROPERTY_INITIAL_OFFER = "_initial_offer";
const SOURCE_UPSELL = "upsell";
const SOURCE_REWARD = "reward";
const SOURCE_COMPLEMENTARY = "complementary";
const OFFER_TYPE = {
  SUBSCRIPTION: "subscription",
  ONE_TIME: "otp"
};
const CLASS_SR_ONLY = "sr-only";
const DOM_EVENT$1 = {
  VIEW: "cart-item:view",
  QUANTITY_CHANGE: "cart-item:quantity-change",
  REMOVE: "cart-item:remove",
  SUBSCRIPTION_CHANGE: "cart-item:subscription-change",
  NOTE_CHANGE: "cart-item:note-change",
  GIFT_CHANGE: "cart-item:gift-change",
  FREQUENCY_CHANGE: "cart-item:frequency-change",
  STATE_CHANGE: "cart:state-change",
  PROGRESS_UPDATED: "progress:updated",
  PROGRESS_MARKER_UPDATE: "progress:marker-update",
  PROGRESS_CONTENT_REFRESHED: "progress:content-refreshed",
  ADD: "cart:add"
};
const EVENT_SOURCE = {
  PRODUCT_FORM: "product-form-component"
};
const ANALYTICS_CATEGORY$2 = "cart";
const ANALYTICS_ACTION$1 = {
  VIEW: "item_view",
  QUANTITY_INCREASE: "item_quantity_increase",
  QUANTITY_DECREASE: "item_quantity_decrease",
  QUANTITY_UPDATE: "item_quantity_update",
  REMOVE: "item_remove",
  SUBSCRIPTION_ON: "item_subscription_on",
  SUBSCRIPTION_OFF: "item_subscription_off",
  NOTES_OPEN: "item_notes_open",
  NOTES_CLOSE: "item_notes_close",
  NOTES_SAVE: "item_notes_save",
  GIFT_ON: "item_gift_on",
  GIFT_OFF: "item_gift_off",
  GIFT_MESSAGE_SAVE: "item_gift_message_save",
  FREQUENCY_CHANGE: "item_frequency_change",
  DRAWER_OPEN: "drawer_open",
  DRAWER_CLOSE: "drawer_close",
  PROGRESS_VIEW: "progress_view"
};
const ERROR_MESSAGE = {
  UPDATE_CART: "Failed to update cart:",
  REMOVE_ITEM: "Failed to remove item:",
  UPDATE_SUBSCRIPTION: "Failed to update subscription:",
  UPDATE_NOTE: "Failed to update note:",
  UPDATE_GIFT: "Failed to update gift option:",
  UPDATE_FREQUENCY: "Failed to update delivery frequency:"
};
const ATTR_ARIA_PRESSED = "aria-pressed";
const ATTR_KEY = "data-key";
const ATTR_LINE = "data-line";
const SELECTOR_DATA_ACTION = "[data-action]";
const CART_ITEM_ACTION = {
  Increase: "increase",
  Decrease: "decrease",
  SetOtp: "set-otp",
  SetSubscription: "set-subscription",
  ToggleNotes: "toggle-notes",
  SaveNote: "save-note",
  ToggleGift: "toggle-gift",
  SaveGiftMessage: "save-gift-message",
  ChangeFrequency: "change-frequency"
};
const CART_PROPERTY = {
  SUBSCRIPTION: PROPERTY_SUBSCRIPTION,
  NOTE: "_note",
  GIFT: "_gift",
  GIFT_MESSAGE: "_gift_message",
  DELIVERY_FREQUENCY: "_delivery_frequency"
};
const PROP_VALUE_TRUE = "true";
const PROP_VALUE_FALSE = "false";
const SUMMARY_CLASS = {
  LOADING: "zyg-cart-summary--loading",
  DISCOUNT_ERROR: "zyg-cart-summary--discount-error",
  DISCOUNT_SUCCESS: "zyg-cart-summary--discount-success",
  TERMS_ERROR: "zyg-cart-summary--terms-error",
  HAS_DISCOUNT: "zyg-cart-summary--has-discount",
  FREE_SHIPPING: "zyg-cart-summary--free-shipping"
};
const SUMMARY_EVENT = {
  VIEW: "cart-summary:view",
  CHECKOUT_CLICK: "cart-summary:checkout-click",
  DISCOUNT_APPLY: "cart-summary:discount-apply",
  DISCOUNT_REMOVE: "cart-summary:discount-remove",
  NOTES_UPDATE: "cart-summary:notes-update",
  TERMS_TOGGLE: "cart-summary:terms-toggle",
  CONTINUE_SHOPPING: "cart-summary:continue-shopping"
};
const SUMMARY_ANALYTICS = {
  VIEW: "summary_view",
  CHECKOUT_CLICK: "checkout_click",
  DISCOUNT_APPLY: "discount_apply",
  DISCOUNT_ERROR: "discount_error",
  NOTES_UPDATE: "notes_update",
  NOTES_ERROR: "notes_error",
  TERMS_TOGGLE: "terms_toggle",
  CONTINUE_SHOPPING: "continue_shopping"
};
const SUMMARY_SELECTOR = {
  CHECKOUT_BTN: '[data-action="checkout"]',
  DISCOUNT_INPUT: "[data-discount-input]",
  APPLY_DISCOUNT_BTN: '[data-action="apply-discount"]',
  REMOVE_DISCOUNT_BTN: '[data-action="remove-discount"]',
  DISCOUNT_ERROR: "[data-discount-error]",
  DISCOUNT_SUCCESS: "[data-discount-success]",
  CART_NOTES: "[data-cart-notes]",
  TERMS_CHECKBOX: "[data-terms-checkbox]",
  TERMS_ERROR: "[data-terms-error]",
  CONTINUE_LINK: '[data-action="continue-shopping"]',
  SUBTOTAL: "[data-subtotal]",
  TOTAL: "[data-total]",
  SHIPPING_ROW: "[data-shipping-row]",
  SHIPPING_VALUE: "[data-shipping-value]"
};
const SUMMARY_ATTR = {
  CART_TOTAL: "data-cart-total",
  CART_COUNT: "data-cart-count",
  REQUIRE_TERMS: "data-require-terms"
};
const SUMMARY_ERROR = {
  TERMS_REQUIRED: "Please accept the terms and conditions",
  INVALID_DISCOUNT: "Invalid discount code",
  EMPTY_DISCOUNT: "Please enter a discount code"
};
const SUMMARY_SUCCESS = {
  DISCOUNT_APPLIED: "Discount applied!",
  FREE_SHIPPING: "FREE!"
};
const NOTES_DEBOUNCE_DELAY = 500;
const STORAGE_DISCOUNT_CODE = "zyg_discount_code";
const CELEBRATION_DURATION = 1e3;
const DEFAULT_MILESTONE_ID = 0;
const DEFAULT_COMPLETED_TEXT = "All rewards unlocked! 🎉";
const CSS_VAR_PROGRESS_PERCENT = "--progress-percent";
const SUBSCRIPTION_REGEX = /{subscribed\?([^:}]*):([^}]*)}/g;
const PROGRESS_ERROR = {
  CONFIG_PARSE: "Failed to parse progress bar config"
};
const PROGRESS_CLASS = {
  LOADING: "zyg-progress-bar--loading",
  COMPLETED: "zyg-progress-bar--completed",
  CELEBRATING: "zyg-progress-bar--celebrating",
  MARKER_REACHED: "zyg-progress-bar__marker--reached"
};
const PROGRESS_SELECTOR = {
  CONFIG: "[data-progress-config]",
  FILL: "[data-progress-fill]",
  MESSAGE: "[data-progress-message]",
  MESSAGE_AFTER: "[data-progress-message-after]",
  MESSAGE_BEFORE: "[data-progress-message-before]",
  CURRENT: "[data-progress-current]",
  TARGET: "[data-progress-target]",
  MARKER: "[data-milestone]",
  BAR: "[data-progress-bar]"
};
const PROGRESS_ATTR = {
  MILESTONE: "data-milestone"
};
const COMPLETION_BEHAVIOR = {
  SHOW_ALL: "show_all",
  SHOW_BAR_ONLY: "show_bar_only",
  SHOW_MESSAGE_ONLY: "show_message_only",
  HIDE_ALL: "hide_all"
};
const LOGIC_EVENT = {
  REWARD_ADDED: "cart-logic:reward-added",
  REWARD_REMOVED: "cart-logic:reward-removed",
  REWARD_SKIPPED: "cart-logic:reward-skipped",
  FREE_SHIPPING_ENABLED: "cart-logic:free-shipping-enabled",
  FREE_SHIPPING_DISABLED: "cart-logic:free-shipping-disabled"
};
const LOGIC_REWARD_ACTION = {
  ADDED: "added",
  REMOVED: "removed",
  SKIPPED: "skipped"
};
const LOGIC_ANALYTICS = {
  REWARD_ADDED: "reward_added",
  REWARD_REMOVED: "reward_removed",
  REWARD_SKIPPED: "reward_skipped",
  FREE_SHIPPING_ENABLED: "free_shipping_enabled",
  FREE_SHIPPING_DISABLED: "free_shipping_disabled"
};
const LOGIC_SELECTOR_CONFIG = "[data-cart-logic-config]";
const LOGIC_ACTION_TYPE = {
  ADD_PRODUCT: "add_product",
  FREE_SHIPPING: "free_shipping",
  ADD_PRODUCT_AND_SHIPPING: "add_product_and_shipping"
};
const LOGIC_REWARD_PROPERTY = {
  REWARD: "_zyg_reward",
  FREE_GIFT: "_zyg_free",
  FREE_GIFT_LABEL: "_zyg_free_label"
};
const LOGIC_CONDITION_TYPE = {
  AMOUNT: "amount",
  ITEM_COUNT: "item_count",
  SUBSCRIPTION: "subscription",
  ITEM_COUNT_OR_SUBSCRIPTION: "item_count_or_subscription",
  AMOUNT_OR_SUBSCRIPTION: "amount_or_subscription"
};
const LOGIC_ERROR = {
  CONFIG_PARSE: "[zyg-cart-logic] Failed to parse config",
  ADD_REWARD: "[zyg-cart-logic] Failed to add reward product:",
  REMOVE_REWARD: "[zyg-cart-logic] Failed to remove reward product:",
  ENABLE_SHIPPING: "[zyg-cart-logic] Failed to enable free shipping:",
  DISABLE_SHIPPING: "[zyg-cart-logic] Failed to disable free shipping:",
  SYNC_REWARDS: "[zyg-cart-logic] Failed to sync added rewards to storage:"
};
const LOGIC_CLASS = {
  LOADING: "zyg-cart-logic--loading"
};
const CART_URL = "/cart.js";
const CART_ADD_URL = "/cart/add.js";
const CART_CHANGE_URL = "/cart/change.js";
const CART_UPDATE_URL = "/cart/update.js";
const CART_CLEAR_URL = "/cart/clear.js";
const EVENT_CART_STATE_CHANGE = "cart:state-change";
const EVENT_CART_CHANGE_LEGACY = "cart:change";
const CART_READY_EVENT = "zyg:cart:ready";
const REQUEST_KEY_SECTIONS = "sections";
const CART_BACKEND_PATH = "cart";
const STORAGE_KEY_CART_SNAPSHOT = "zyg_cart_snapshot";
const CART_SNAPSHOT_VERSION = 1;
const BrandShopifySetupEnum = {
  NONE: "NONE",
  HEADLESS: "HEADLESS"
};
class CartError extends Error {
  constructor(response) {
    super(response.message);
    this.name = "CartError";
    this.status = response.status;
    this.description = response.description;
    this.errors = response.errors || {};
  }
}
class ShopifyAjaxCartClient {
  async get(url) {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`[cart.fetch] Failed to fetch cart: ${res.status}`);
    }
    return await res.json();
  }
  async post(url, body) {
    const res = await fetch(url, {
      method: HTTP_METHOD.POST,
      headers: { [HEADER_CONTENT_TYPE]: CONTENT_TYPE_JSON },
      body: JSON.stringify(body || {})
    });
    const data = await res.json();
    if (data.status) {
      throw new CartError(data);
    }
    return data;
  }
}
const PRODUCT_URL_TEMPLATE = "/products/";
const VARIANT_QUERY_KEY = "?variant=";
const TITLE_SEPARATOR = " - ";
const RECURRING_DELIVERIES_DEFAULT = true;
const composeTitle = (line) => {
  if (line.product_title && line.title) {
    return `${line.product_title}${TITLE_SEPARATOR}${line.title}`;
  }
  return line.product_title || line.title || "";
};
const buildSellingPlanAllocation = (line) => {
  if (!line.selling_plan_id) {
    return void 0;
  }
  return {
    price: line.final_price,
    compare_at_price: line.compare_at_price ?? line.price,
    per_delivery_price: line.final_price,
    selling_plan: {
      id: Number(line.selling_plan_id) || 0,
      name: "",
      description: null,
      options: [],
      recurring_deliveries: RECURRING_DELIVERIES_DEFAULT
    }
  };
};
const adaptLine = (line) => ({
  id: line.variant_id,
  key: line.key,
  quantity: line.quantity,
  variant_id: line.variant_id,
  product_id: line.product_id,
  title: composeTitle(line),
  product_title: line.product_title,
  variant_title: line.title || null,
  price: line.price,
  line_price: line.line_price,
  final_price: line.final_price,
  final_line_price: line.final_price * line.quantity,
  discounted_price: line.final_price,
  discounts: [],
  gift_card: false,
  requires_shipping: true,
  url: line.product_handle ? `${PRODUCT_URL_TEMPLATE}${line.product_handle}${VARIANT_QUERY_KEY}${line.variant_id}` : "",
  handle: line.product_handle ?? "",
  image: line.featured_image || null,
  featured_image: line.featured_image ? { url: line.featured_image, alt: line.title ?? "" } : null,
  variant_options: [],
  options_with_values: [],
  properties: line.properties ?? {},
  sku: line.sku,
  selling_plan_id: line.selling_plan_id,
  selling_plan_allocation: buildSellingPlanAllocation(line)
});
const adaptZygCart = (wire, previous) => {
  const items = (wire.items ?? []).map(adaptLine);
  return {
    token: wire.token,
    note: wire.note,
    attributes: wire.attributes ?? {},
    total_price: wire.total_price,
    total_discount: 0,
    item_count: wire.item_count,
    items,
    requires_shipping: true,
    currency: wire.currency || previous.currency,
    items_subtotal_price: wire.total_price,
    cart_level_discount_applications: []
  };
};
const PURCHASE_TYPE_OTP = "otp";
const PURCHASE_TYPE_SUBSCRIPTION = "subscription";
const UPSELL_TYPE_PRODUCT = "product";
const UPSELL_TYPE_UPSELL = "upsell";
const UPSELL_TYPE_CROSS_SELL = "cross_sell";
const FIELD_PURCHASE_TYPE = "purchase_type";
const FIELD_UPSELL_TYPE = "upsell_type";
const ATTR_UPSELL_TYPE = "data-upsell-type";
const LINE_PROPERTY_SOURCE = "_source";
const LINE_PROPERTY_INITIAL_OFFER = "_initial_offer";
const LINE_PROPERTY_UPSELL = "_upsell";
const LINE_PROPERTY_TRUE = "true";
const DOM_EVENT_VARIANT_ADD = "variant:add";
const ANALYTICS_CATEGORY_PRODUCT_FORM = "product_form";
const ANALYTICS_ACTION_ADD_TO_CART = "add_to_cart";
const KNOWN_UPSELL_TYPES = /* @__PURE__ */ new Set([
  UPSELL_TYPE_PRODUCT,
  UPSELL_TYPE_UPSELL,
  UPSELL_TYPE_CROSS_SELL
]);
function classifyProductAdd(input) {
  return {
    [FIELD_PURCHASE_TYPE]: purchaseTypeOf(input),
    [FIELD_UPSELL_TYPE]: upsellTypeOf(input)
  };
}
function classifyCartLine(line) {
  const classified = line ?? void 0;
  const properties = lineProperties(classified);
  return classifyProductAdd({
    hasSellingPlan: Boolean(
      classified?.sellingPlanAllocation ?? classified?.selling_plan_allocation
    ),
    initialOffer: properties[LINE_PROPERTY_INITIAL_OFFER],
    source: properties[LINE_PROPERTY_SOURCE],
    isUpsell: properties[LINE_PROPERTY_UPSELL] === LINE_PROPERTY_TRUE
  });
}
function purchaseTypeOf(input) {
  if (input.purchaseType === PURCHASE_TYPE_OTP || input.purchaseType === PURCHASE_TYPE_SUBSCRIPTION) {
    return input.purchaseType;
  }
  if (input.hasSellingPlan || input.sellingPlanId || input.initialOffer === PURCHASE_TYPE_SUBSCRIPTION) {
    return PURCHASE_TYPE_SUBSCRIPTION;
  }
  return PURCHASE_TYPE_OTP;
}
function upsellTypeOf(input) {
  if (input.upsellType && KNOWN_UPSELL_TYPES.has(input.upsellType)) {
    return input.upsellType;
  }
  if (input.source === UPSELL_TYPE_CROSS_SELL) {
    return UPSELL_TYPE_CROSS_SELL;
  }
  if (input.isUpsell || input.source === UPSELL_TYPE_UPSELL) {
    return UPSELL_TYPE_UPSELL;
  }
  return UPSELL_TYPE_PRODUCT;
}
function lineProperties(line) {
  const fromAttributes = Object.fromEntries(
    (line?.attributes ?? []).filter(
      (attribute) => Boolean(attribute.key)
    ).map((attribute) => [attribute.key, attribute.value ?? ""])
  );
  return { ...line?.properties, ...fromAttributes };
}
const CENTS_PER_UNIT = 100;
function centsToMajorUnits(cents) {
  return cents / CENTS_PER_UNIT;
}
const buildDetail = (line, quantity, currency) => {
  const classification = classifyCartLine(line);
  return {
    purchase_type: classification[FIELD_PURCHASE_TYPE],
    upsell_type: classification[FIELD_UPSELL_TYPE],
    data: {
      cartLine: {
        quantity,
        merchandise: {
          id: String(line.variant_id),
          title: line.variant_title ?? line.title,
          sku: line.sku ?? "",
          price: { amount: centsToMajorUnits(line.price), currencyCode: currency },
          product: { id: String(line.product_id), title: line.product_title }
        },
        properties: line.properties,
        selling_plan_allocation: line.selling_plan_allocation
      }
    }
  };
};
const dispatch = (name, detail) => {
  document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
};
const emitCartLineDeltas = (before, after) => {
  const beforeByKey = new Map(before.items.map((item) => [item.key, item]));
  const afterByKey = new Map(after.items.map((item) => [item.key, item]));
  after.items.forEach((item) => {
    const delta = item.quantity - (beforeByKey.get(item.key)?.quantity ?? 0);
    if (delta > 0) {
      dispatch(DOM_EVENT_PRODUCT_ADDED_TO_CART, buildDetail(item, delta, after.currency));
    }
  });
  before.items.forEach((item) => {
    const remaining = afterByKey.get(item.key)?.quantity ?? 0;
    const delta = item.quantity - remaining;
    if (delta > 0) {
      dispatch(
        DOM_EVENT_PRODUCT_REMOVED_FROM_CART,
        buildDetail(item, delta, after.currency || before.currency)
      );
    }
  });
};
const DEFAULT_ADD_QUANTITY = 1;
const QUANTITY_REMOVE = 0;
const ERROR_UNRESOLVED_LINE = "[cart] no cart line matches";
const snapshotStorage = new Storage(STORAGE_KEY_CART_SNAPSHOT);
const emptyCart = () => ({
  token: "",
  note: void 0,
  attributes: {},
  total_price: 0,
  total_discount: 0,
  item_count: 0,
  items: [],
  requires_shipping: true,
  currency: "",
  items_subtotal_price: 0,
  cart_level_discount_applications: []
});
const loadSnapshot = () => {
  const persisted = snapshotStorage.get();
  if (!persisted || persisted.v !== CART_SNAPSHOT_VERSION || !Array.isArray(persisted.cart?.items)) {
    return emptyCart();
  }
  return persisted.cart;
};
const saveSnapshot = (cart2) => {
  snapshotStorage.save({ v: CART_SNAPSHOT_VERSION, cart: cart2 });
};
const stripSections = (body) => {
  const { [REQUEST_KEY_SECTIONS]: _sections, ...rest } = body;
  return rest;
};
const toPendingLines = (cart2) => cart2.items.map((item) => ({
  key: item.key,
  input: {
    product_variant_id: String(item.variant_id),
    quantity: item.quantity,
    properties: item.properties ?? {},
    selling_plan: item.selling_plan_id ?? ""
  }
}));
const toPendingLine = (entry) => {
  const properties = entry.properties ?? {};
  return {
    key: properties[PROPERTY_LINE_ITEM_ID] ?? String(entry.id),
    input: {
      product_variant_id: String(entry.id),
      quantity: entry.quantity ?? DEFAULT_ADD_QUANTITY,
      properties,
      selling_plan: entry.selling_plan ?? ""
    }
  };
};
const resolveIndex = (lines, id) => {
  const wanted = String(id);
  const byKey = lines.findIndex((line) => line.key === wanted);
  if (byKey !== -1) {
    return byKey;
  }
  const byVariant = lines.findIndex((line) => line.input.product_variant_id === wanted);
  if (byVariant !== -1) {
    return byVariant;
  }
  const position = Number(wanted);
  if (Number.isInteger(position) && position >= 1 && position <= lines.length) {
    return position - 1;
  }
  return -1;
};
const updateInputAt = (lines, index, patch) => lines.map((line, i) => i === index ? { ...line, input: { ...line.input, ...patch } } : line);
const setQuantityAt = (lines, index, quantity) => quantity <= QUANTITY_REMOVE ? lines.filter((_line, i) => i !== index) : updateInputAt(lines, index, { quantity });
const applyAdd = (lines, body) => {
  const entries = Array.isArray(body.items) ? body.items : [body];
  return entries.reduce((acc, entry) => {
    const incoming = toPendingLine(entry);
    const existing = acc.findIndex(
      (line) => line.key === incoming.key && line.input.product_variant_id === incoming.input.product_variant_id
    );
    if (existing === -1) {
      return [...acc, incoming];
    }
    return updateInputAt(acc, existing, {
      quantity: acc[existing].input.quantity + incoming.input.quantity
    });
  }, lines);
};
const applyChange = (lines, body) => {
  const index = resolveIndex(lines, body.id);
  if (index === -1) {
    throw new Error(`${ERROR_UNRESOLVED_LINE} ${String(body.id)}`);
  }
  const withProperties = body.properties ? updateInputAt(lines, index, { properties: body.properties }) : lines;
  return setQuantityAt(withProperties, index, body.quantity);
};
const applyUpdates = (lines, updates) => Object.entries(updates).reduce((acc, [id, quantity]) => {
  const index = resolveIndex(acc, id);
  if (index === -1) {
    return acc;
  }
  return setQuantityAt(acc, index, quantity);
}, lines);
const mergeAttributes = (current, incoming) => Object.entries({ ...current, ...incoming }).reduce(
  (acc, [key, value]) => {
    if (value !== "") {
      acc[key] = value;
    }
    return acc;
  },
  {}
);
const applyDelta = (current, url, body) => {
  const snapshot = {
    token: current.token,
    note: current.note ?? "",
    attributes: current.attributes ?? {},
    items: []
  };
  const lines = toPendingLines(current);
  const withLines = (next) => ({
    ...snapshot,
    items: next.map((line) => line.input)
  });
  switch (url) {
    case CART_ADD_URL:
      return withLines(applyAdd(lines, body));
    case CART_CHANGE_URL:
      return withLines(applyChange(lines, body));
    case CART_CLEAR_URL:
      return snapshot;
    case CART_UPDATE_URL: {
      const update = body;
      if (update.discount !== void 0) {
        console.warn(
          "[cart] discount codes are unsupported by the zyg cart backend; ignoring"
        );
      }
      return {
        ...withLines(update.updates ? applyUpdates(lines, update.updates) : lines),
        note: update.note ?? snapshot.note,
        attributes: update.attributes ? mergeAttributes(snapshot.attributes, update.attributes) : snapshot.attributes
      };
    }
    default:
      throw new Error(`[cart] zyg cart transport cannot translate ${url}`);
  }
};
const ZYG_CART_ERROR_STATUS = 0;
const ERROR_REQUEST_FAILED = "[cart] zyg cart backend request failed";
const cartError = (description) => new CartError({
  status: ZYG_CART_ERROR_STATUS,
  message: ERROR_REQUEST_FAILED,
  description,
  errors: {}
});
class ZygBackendCartClient {
  /** Serves the persisted snapshot without a request. */
  async get(url) {
    if (url !== CART_URL) {
      console.warn(
        `[cart] zyg cart transport has no backend read; serving the local snapshot for ${url}`
      );
    }
    return loadSnapshot();
  }
  async post(url, body) {
    const before = loadSnapshot();
    if (url === CART_CLEAR_URL && before.items.length === 0) {
      return before;
    }
    let request;
    try {
      request = applyDelta(before, url, stripSections(body));
    } catch (error) {
      throw cartError(error instanceof Error ? error.message : ERROR_REQUEST_FAILED);
    }
    if (typeof window.zygRequestPostToPath !== "function") {
      throw cartError(ERROR_REQUEST_FAILED);
    }
    let wire;
    try {
      wire = await window.zygRequestPostToPath(CART_BACKEND_PATH, request);
    } catch (error) {
      throw cartError(error instanceof Error ? error.message : ERROR_REQUEST_FAILED);
    }
    if (!wire || !Array.isArray(wire.items)) {
      throw cartError(
        wire ? "[cart] zyg cart backend returned a malformed cart" : ERROR_REQUEST_FAILED
      );
    }
    const after = adaptZygCart(wire, before);
    saveSnapshot(after);
    emitCartLineDeltas(before, after);
    return after;
  }
}
const SHOPIFY_SETUP = BrandShopifySetupEnum;
const ZYG_TRANSPORT_SETUPS = [SHOPIFY_SETUP.NONE, SHOPIFY_SETUP.HEADLESS];
const isZygTransport = () => {
  const setup = "FULL";
  if (ZYG_TRANSPORT_SETUPS.includes(setup)) {
    return true;
  }
  return false;
};
const createCartClient = () => isZygTransport() ? new ZygBackendCartClient() : new ShopifyAjaxCartClient();
const cartTransportSupportsDiscounts = () => !isZygTransport();
const buildComplementaryItem = (id, quantity, parentLineItemId) => ({
  id,
  quantity,
  source: SOURCE_COMPLEMENTARY,
  initialOffer: OFFER_TYPE.ONE_TIME,
  parentLineItemId,
  customProperties: {
    [LOGIC_REWARD_PROPERTY.FREE_GIFT]: "true",
    [LOGIC_REWARD_PROPERTY.FREE_GIFT_LABEL]: FREE_GIFT_LABEL
  }
});
const formatAddItems = (items) => items.map((item) => ({
  id: item.id,
  quantity: item.quantity ?? 1,
  properties: {
    [PROPERTY_LINE_ITEM_ID]: item.lineItemId ?? generateId$1(),
    [PROPERTY_SOURCE]: item.source,
    [PROPERTY_INITIAL_OFFER]: item.initialOffer ?? (item.sellingPlan ? OFFER_TYPE.SUBSCRIPTION : OFFER_TYPE.ONE_TIME),
    ...item.sellingPlan && { [PROPERTY_SUBSCRIPTION]: "true" },
    ...item.isUpsell && { [PROPERTY_UPSELL]: "true" },
    ...item.parentLineItemId && { [PROPERTY_PARENT_LINE_ITEM_ID]: item.parentLineItemId },
    ...item.customProperties
  },
  ...item.sellingPlan && { selling_plan: item.sellingPlan }
}));
const REDIRECT_MANUAL = "manual";
const REDIRECT_TYPE_OPAQUE = "opaqueredirect";
const HTTP_STATUS_REDIRECT = 302;
const ATTR_DISCOUNT_CODE = "discount_code";
const warnDiscountsUnsupported = () => {
  console.warn("[cart] discount codes are not supported by the zyg cart backend; ignoring");
};
const isRedirectResponse = (response) => response.type === REDIRECT_TYPE_OPAQUE || response.status === HTTP_STATUS_REDIRECT;
const EVENT_PREPARE_BUNDLED_SECTIONS = "cart:prepare-bundled-sections";
const SOURCE_CART = "cart-singleton";
const CART_READY_TIMEOUT_MS = 5e3;
const ERROR_CART_NOT_READY = "[cart] Cart not available";
const cartClient = createCartClient();
const discountsSupported = cartTransportSupportsDiscounts();
let state;
let loading = false;
const { enqueue } = createAsyncQueue();
const emit = () => {
  if (!state) {
    return;
  }
  document.dispatchEvent(
    new CustomEvent(EVENT_CART_STATE_CHANGE, {
      bubbles: true,
      detail: { cart: state, source: SOURCE_CART }
    })
  );
  document.dispatchEvent(
    new CustomEvent(EVENT_CART_CHANGE_LEGACY, {
      bubbles: true,
      detail: { cart: state, source: SOURCE_CART, baseEvent: EVENT_CART_CHANGE_LEGACY }
    })
  );
};
const postSilent = async (url, body) => {
  await cartClient.post(url, body || {});
};
const postSilentWithState = async (url, body) => {
  loading = true;
  try {
    state = await cartClient.post(url, body || {});
    return state;
  } finally {
    loading = false;
  }
};
const postAndRefresh = async (url, body) => {
  loading = true;
  try {
    const sectionsToBundle = /* @__PURE__ */ new Set();
    document.documentElement.dispatchEvent(
      new CustomEvent(EVENT_PREPARE_BUNDLED_SECTIONS, {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    const requestBody = body || {};
    if (sectionsToBundle.size > 0) {
      requestBody[REQUEST_KEY_SECTIONS] = [...sectionsToBundle].join(",");
    }
    const data = await cartClient.post(url, requestBody);
    if (url === CART_ADD_URL) {
      state = await cartClient.get(CART_URL);
    } else {
      state = data;
    }
    emit();
    return state;
  } finally {
    loading = false;
  }
};
const fetchCartState = async (force = false, silent = false) => {
  if (state && !force) {
    return state;
  }
  loading = true;
  try {
    state = await cartClient.get(CART_URL);
    if (!silent) {
      emit();
    }
    return state;
  } finally {
    loading = false;
  }
};
const cart = {
  /** Gets the current cart state instance */
  get instance() {
    return state;
  },
  /** Gets the total number of items in the cart */
  get itemCount() {
    return state?.item_count ?? 0;
  },
  /** Gets the current loading status of cart operations */
  get isLoading() {
    return loading;
  },
  /** Fetches cart state from Shopify's `/cart.js` endpoint. */
  async fetch(force = false, silent = false) {
    return enqueue(() => fetchCartState(force, silent));
  },
  /**
   * Adds a single item to cart.
   * Throws CartError on failure.
   */
  async add(item) {
    if (!item.id) {
      throw new Error("[cart.add] Missing variant id");
    }
    return enqueue(() => postAndRefresh(CART_ADD_URL, formatAddItems([item])[0]));
  },
  /** Adds multiple items to cart in a single API call. */
  async addMultiple(items) {
    if (items.length === 0) {
      return this.instance;
    }
    return enqueue(() => postAndRefresh(CART_ADD_URL, { items: formatAddItems(items) }));
  },
  /** Adds a primary item to cart with an optional linked complementary gift in a single API call. */
  async addWithComplementary(parentItem, complementaryVariantId, complementaryQty) {
    if (!complementaryVariantId) {
      return this.addMultiple([parentItem]);
    }
    const lineItemId = parentItem.lineItemId ?? generateId$1();
    return this.addMultiple([
      { ...parentItem, lineItemId },
      buildComplementaryItem(complementaryVariantId, complementaryQty ?? 1, lineItemId)
    ]);
  },
  /** Updates quantity for a cart item by key. */
  async update(key, quantity) {
    if (!key) {
      throw new Error("[cart.update] Missing item key");
    }
    return enqueue(() => postAndRefresh(CART_CHANGE_URL, { id: key, quantity }));
  },
  /** Removes a cart item by key. */
  async remove(key) {
    return this.update(key, 0);
  },
  /** Removes a cart item by key without emitting state change events. */
  async removeSilent(key) {
    if (!key) {
      throw new Error("[cart.removeSilent] Missing item key");
    }
    return enqueue(() => postSilentWithState(CART_CHANGE_URL, { id: key, quantity: 0 }));
  },
  /** Removes multiple cart items by key in a single API call. */
  async removeMultiple(keys) {
    if (keys.length === 0) {
      return this.instance;
    }
    const updates = keys.reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { updates }));
  },
  /** Removes multiple cart items silently without emitting state change events. */
  async removeMultipleSilent(keys) {
    if (keys.length === 0) {
      return this.instance;
    }
    const updates = keys.reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
    return enqueue(() => postSilentWithState(CART_UPDATE_URL, { updates }));
  },
  /** Updates properties for a cart item by key. */
  async updateProperties(key, properties) {
    if (!key) {
      throw new Error("[cart.updateProperties] Missing item key");
    }
    return enqueue(async () => {
      const currentCart = await fetchCartState(true, true);
      const currentItem = currentCart.items.find((item) => item.key === key);
      if (!currentItem) {
        throw new Error(`[cart.updateProperties] Item with key ${key} not found`);
      }
      return postAndRefresh(CART_CHANGE_URL, {
        id: key,
        quantity: currentItem.quantity,
        properties: { ...currentItem.properties ?? {}, ...properties }
      });
    });
  },
  /** Removes all items via /cart/clear.js. */
  async clear() {
    return enqueue(() => postAndRefresh(CART_CLEAR_URL));
  },
  /** Forces a fresh fetch from Shopify API. */
  async refresh() {
    return this.fetch(true);
  },
  /** Updates cart note. */
  async updateNote(note) {
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { note }));
  },
  /** Updates cart attributes. */
  async updateAttributes(attributes) {
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { attributes }));
  },
  /** Applies or removes a discount code on the cart. */
  async setDiscount(code) {
    if (!discountsSupported) {
      warnDiscountsUnsupported();
      return this.fetch();
    }
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { discount: code }));
  },
  /** Adds multiple items silently without emitting state change events. */
  async addMultipleSilent(items) {
    if (items.length === 0) {
      return this.instance;
    }
    return enqueue(async () => {
      await postSilent(CART_ADD_URL, { items: formatAddItems(items) });
      return fetchCartState(true, true);
    });
  },
  /** Adds items for an immediate checkout redirect — POST only, no GET /cart.js, no state-change emit. */
  async addMultipleForCheckout(items) {
    if (items.length === 0) {
      return;
    }
    return enqueue(async () => {
      await postSilent(CART_ADD_URL, { items: formatAddItems(items) });
      state = void 0;
    });
  },
  /** Applies discount code silently without emitting state change events. */
  async setDiscountSilent(code) {
    if (!discountsSupported) {
      warnDiscountsUnsupported();
      return this.fetch();
    }
    return enqueue(() => postSilentWithState(CART_UPDATE_URL, { discount: code }));
  },
  /** Emits cart state change event manually. */
  emitStateChange() {
    emit();
  },
  /** Switches a cart item between subscription and one-time purchase. */
  async switchSubscription(key, variantId, sellingPlanId, options) {
    if (!key) {
      throw new Error("[cart.switchSubscription] Missing item key");
    }
    if (!variantId) {
      throw new Error("[cart.switchSubscription] Missing variant ID");
    }
    return enqueue(async () => {
      let quantity;
      let properties;
      if (options) {
        quantity = options.quantity;
        properties = options.properties ?? {};
      } else {
        let currentItem = state?.items.find((item) => item.key === key);
        if (!currentItem) {
          const currentCart = await fetchCartState(true, true);
          currentItem = currentCart.items.find((item) => item.key === key);
          if (!currentItem) {
            throw new Error(`[cart.switchSubscription] Item with key ${key} not found`);
          }
        }
        quantity = currentItem.quantity;
        properties = currentItem.properties ?? {};
      }
      const preservedProperties = Object.fromEntries(
        Object.entries(properties).filter(
          ([propKey]) => !propKey.startsWith(PROPERTY_SUBSCRIPTION)
        )
      );
      if (sellingPlanId) {
        preservedProperties[PROPERTY_SUBSCRIPTION] = "true";
      }
      if (!preservedProperties[PROPERTY_LINE_ITEM_ID]) {
        preservedProperties[PROPERTY_LINE_ITEM_ID] = generateId$1();
      }
      loading = true;
      await postSilent(CART_CHANGE_URL, { id: key, quantity: 0 });
      await postSilent(CART_ADD_URL, {
        id: variantId,
        quantity,
        properties: preservedProperties,
        ...sellingPlanId && { selling_plan: sellingPlanId }
      });
      return fetchCartState(true, false);
    });
  },
  /** Checks if a discount code is valid by attempting to apply it. */
  async checkDiscountValid(code) {
    if (!discountsSupported) {
      warnDiscountsUnsupported();
      return false;
    }
    return enqueue(async () => {
      try {
        const response = await fetch(
          `${DISCOUNT_URL_TEMPLATE}${encodeURIComponent(code)}`,
          {
            method: HTTP_METHOD.GET,
            redirect: REDIRECT_MANUAL
          }
        );
        if (isRedirectResponse(response)) {
          return true;
        }
        const freshCart = await fetchCartState(true, false);
        if (freshCart.total_discount > 0) {
          return true;
        }
        const attrResponse = await fetch(CART_UPDATE_URL, {
          method: HTTP_METHOD.POST,
          headers: { [HEADER_CONTENT_TYPE]: CONTENT_TYPE_JSON },
          body: JSON.stringify({ attributes: { [ATTR_DISCOUNT_CODE]: code } })
        });
        return attrResponse.ok;
      } catch (error) {
        console.error(
          "[cart.checkDiscountValid] Error checking discount validity:",
          error instanceof Error ? error.message : String(error)
        );
        return true;
      }
    });
  }
};
window.cart = cart;
document.dispatchEvent(new CustomEvent(CART_READY_EVENT));
const whenCartReady = (timeoutMs = CART_READY_TIMEOUT_MS) => new Promise((resolve, reject) => {
  if (window.cart) {
    resolve(window.cart);
    return;
  }
  const timeoutId = setTimeout(() => {
    document.removeEventListener(CART_READY_EVENT, onReady);
    reject(new Error(ERROR_CART_NOT_READY));
  }, timeoutMs);
  const onReady = () => {
    clearTimeout(timeoutId);
    document.removeEventListener(CART_READY_EVENT, onReady);
    if (window.cart) {
      resolve(window.cart);
    } else {
      reject(new Error(ERROR_CART_NOT_READY));
    }
  };
  document.addEventListener(CART_READY_EVENT, onReady);
});
const removeWithComplementary = async (key) => {
  const cartInstance = cart.instance;
  const removedItem = cartInstance?.items.find((item) => item.key === key);
  const parentLineItemId = removedItem?.properties?.[PROPERTY_LINE_ITEM_ID];
  const complementaryKeys = parentLineItemId && cartInstance ? cartInstance.items.filter(
    (item) => item.properties?.[PROPERTY_PARENT_LINE_ITEM_ID] === parentLineItemId
  ).map((item) => item.key) : [];
  if (complementaryKeys.length === 0) {
    await cart.remove(key);
    return;
  }
  await cart.removeMultiple([key, ...complementaryKeys]);
};
const DEFAULT_KEY_ATTR = "data-key";
const DEFAULT_LOADING_CLASS = "is-loading";
const getAttributeFromElement = (element, attr) => {
  if (!element) {
    return void 0;
  }
  const direct = element.getAttribute(attr);
  if (direct) {
    return direct;
  }
  return element.closest(`[${attr}]`)?.getAttribute(attr) ?? void 0;
};
const emitDomEvent = (eventName, detail) => {
  document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
};
const subscribeToDomEvent = (eventName, handler) => {
  document.addEventListener(eventName, handler);
  return () => document.removeEventListener(eventName, handler);
};
function Actionable(Base, config = {}) {
  const {
    keyAttr = DEFAULT_KEY_ATTR,
    loadingClass = DEFAULT_LOADING_CLASS,
    errorPrefix = "component"
  } = config;
  return class ActionableClass extends Base {
    get itemKey() {
      return this.dataset.key;
    }
    findByKey(key) {
      return this.querySelector(`[${keyAttr}="${key}"]`);
    }
    queryByKey(selector, key) {
      const container = this.findByKey(key);
      return container?.querySelector(selector) ?? this.querySelector(`${selector}[${keyAttr}="${key}"]`);
    }
    getKeyFromElement(element) {
      if (this.itemKey) {
        return this.itemKey;
      }
      const key = getAttributeFromElement(element, keyAttr);
      if (!key) {
        console.error(`[${errorPrefix}] Item key not found from element`);
      }
      return key;
    }
    notify(config2) {
      emitDomEvent(config2.eventName, config2.payload);
      this.track(config2.analyticsAction, config2.payload);
    }
    async executeWithLoading(key, operation, errorMessage) {
      const element = this.findByKey(key);
      element?.classList.add(loadingClass);
      try {
        await operation();
        return true;
      } catch (error) {
        console.error(errorMessage, error);
        return false;
      } finally {
        element?.classList.remove(loadingClass);
      }
    }
    async executeAction(config2) {
      emitDomEvent(config2.domEvent.name, config2.domEvent.detail);
      this.track(config2.analytics.action, config2.analytics.payload);
      try {
        config2.optimisticUpdate?.();
        const success = await this.executeWithLoading(
          config2.itemKey,
          config2.apiCall,
          config2.errorMessage
        );
        if (!success) {
          throw new Error(config2.errorMessage);
        }
        return true;
      } catch (error) {
        console.error(`[${errorPrefix}] ${config2.errorMessage}`, error);
        config2.revertOnFailure?.();
        return false;
      }
    }
  };
}
function isElementVisible(el) {
  for (let node = el; node; node = node.parentElement) {
    if (window.getComputedStyle(node).display === DISPLAY_NONE) {
      return false;
    }
  }
  return true;
}
function setText(el, value) {
  if (!el) {
    return;
  }
  const labels = Array.from(el.querySelectorAll(`.${CLASS_SR_ONLY}`));
  el.textContent = value || "";
  el.prepend(...labels);
}
function Trackable(Base, config) {
  const { category, errorPrefix = category } = config;
  return class TrackableClass extends Base {
    track(action, payload) {
      if (!isElementVisible(this)) {
        return;
      }
      try {
        window.safeTrackEvent?.(category, action, JSON.stringify(payload));
      } catch (error) {
        console.error(`[${errorPrefix}] Failed to track event:`, action, error);
      }
    }
  };
}
const HTML_ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
new RegExp(`[${Object.keys(HTML_ESCAPE_MAP).join("")}]`, "g");
const formatCentsDecimal = (priceInCents) => (priceInCents / CENTS_DIVISOR).toFixed(DECIMAL_PLACES);
const formatCentsToMoney = (priceInCents) => window.Shopify?.formatMoney?.(priceInCents) ?? `${FALLBACK_MONEY_PREFIX}${formatCentsDecimal(priceInCents)}`;
const STORAGE_PREFIX = "_zyg_";
const StorageKeys = {
  /** Milestone IDs where user declined (removed) their reward */
  DECLINED_REWARDS: `${STORAGE_PREFIX}declined_rewards`,
  FREE_SHIPPING_APPLIED: `${STORAGE_PREFIX}free_shipping`,
  /** Milestone IDs whose reward product has been added to cart */
  ADDED_REWARDS: `${STORAGE_PREFIX}added_rewards`
};
const getFromSession = (key) => {
  try {
    const value = sessionStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch {
  }
  return null;
};
const setInSession = (key, value) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
  }
};
const removeFromSession = (key) => {
  try {
    sessionStorage.removeItem(key);
  } catch {
  }
};
const operationQueues = /* @__PURE__ */ new Map();
const queueOperation = async (key, operation) => {
  const existingQueue = operationQueues.get(key) ?? Promise.resolve();
  const newQueue = existingQueue.then(operation, operation);
  operationQueues.set(
    key,
    newQueue.then(
      () => {
      },
      () => {
      }
    )
  );
  return newQueue;
};
const componentStorage = {
  /**
   * Gets a value from storage (sessionStorage only for performance)
   */
  get(key) {
    return getFromSession(key);
  },
  /**
   * Sets a value in storage (sessionStorage only - avoids /cart/update.js calls)
   */
  async set(key, value) {
    setInSession(key, value);
  },
  /**
   * Removes a value from storage (sessionStorage only - avoids /cart/update.js calls)
   */
  async remove(key) {
    removeFromSession(key);
  },
  /**
   * Gets a Set from storage
   */
  getSet(key) {
    const data = this.get(key);
    return new Set(Array.isArray(data) ? data : []);
  },
  /**
   * Adds a value to a stored Set (queued to prevent race conditions)
   */
  async addToSet(key, value) {
    return queueOperation(key, async () => {
      const set = this.getSet(key);
      set.add(value);
      await this.set(key, [...set]);
    });
  },
  /**
   * Adds multiple values to a stored Set (queued to prevent race conditions)
   */
  async addMultipleToSet(key, values) {
    if (values.length === 0) {
      return;
    }
    return queueOperation(key, async () => {
      const merged = /* @__PURE__ */ new Set([...this.getSet(key), ...values]);
      await this.set(key, [...merged]);
    });
  },
  /**
   * Removes a value from a stored Set (queued to prevent race conditions)
   */
  async removeFromSet(key, value) {
    return queueOperation(key, async () => {
      const set = this.getSet(key);
      set.delete(value);
      if (set.size === 0) {
        await this.remove(key);
      } else {
        await this.set(key, [...set]);
      }
    });
  }
};
const ANALYTICS_CATEGORY_LOGIC = "cart_logic";
const ERROR_PREFIX = {
  SUMMARY: "cart-summary",
  PROGRESS: "progress-bar",
  LOGIC: "cart-logic"
};
const focusFirstInputInContainer = (container, inputSelector) => {
  container?.querySelector(inputSelector)?.focus();
};
const emitSummaryEvent = (eventName, detail) => {
  emitDomEvent(eventName, detail);
};
class BaseSummaryComponent extends Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY$2,
  errorPrefix: ERROR_PREFIX.SUMMARY
}) {
  /** Emits a DOM event and tracks an analytics action in a single call. */
  notify(config) {
    emitSummaryEvent(config.eventName, config.detail);
    this.track(config.analyticsAction, config.analyticsPayload);
  }
  /** Toggles the loading state CSS class on the component. */
  setLoading(loading2) {
    this.classList.toggle(SUMMARY_CLASS.LOADING, loading2);
  }
}
const replacePlaceholders = (text, remaining, threshold, current, hasSubscription, itemCount) => {
  let result = text.replace(/{remaining}/g, formatCentsToMoney(remaining)).replace(/{threshold}/g, formatCentsToMoney(threshold)).replace(/{current}/g, formatCentsToMoney(current)).replace(SUBSCRIPTION_REGEX, (_, yesText, noText) => hasSubscription ? yesText : noText);
  if (itemCount) {
    const remainingCount = Math.max(0, itemCount.thresholdCount - itemCount.currentCount);
    result = result.replace(/{remaining:count}/g, String(remainingCount)).replace(/{threshold:count}/g, String(itemCount.thresholdCount)).replace(/{current:count}/g, String(itemCount.currentCount));
  }
  return result;
};
const emitProgressEvent = (eventName, detail) => {
  emitDomEvent(eventName, detail);
};
class BaseProgressBarComponent extends Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY$2,
  errorPrefix: ERROR_PREFIX.PROGRESS
}) {
  /** Emits a DOM event and tracks an analytics action in a single call. */
  notify(config) {
    emitProgressEvent(config.eventName, config.detail);
    this.track(config.analyticsAction, config.analyticsPayload);
  }
  /** Toggles the loading state CSS class on the component. */
  setLoading(loading2) {
    this.classList.toggle(PROGRESS_CLASS.LOADING, loading2);
  }
}
const emitLogicEvent = (eventName, detail) => {
  emitDomEvent(eventName, detail);
};
class BaseCartLogicComponent extends Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY_LOGIC,
  errorPrefix: ERROR_PREFIX.LOGIC
}) {
  /** Emits a DOM event and tracks an analytics action in a single call. */
  notify(config) {
    emitLogicEvent(config.eventName, config.detail);
    this.track(config.analyticsAction, config.analyticsPayload);
  }
  /** Toggles the loading state CSS class on the component. */
  setLoading(loading2) {
    this.classList.toggle(LOGIC_CLASS.LOADING, loading2);
  }
}
const getDeclinedRewards = () => componentStorage.getSet(StorageKeys.DECLINED_REWARDS);
const getPersistedAddedRewards = () => componentStorage.getSet(StorageKeys.ADDED_REWARDS);
const syncAddedRewardsToStorage = (rewards) => {
  try {
    if (rewards.size === 0) {
      sessionStorage.removeItem(StorageKeys.ADDED_REWARDS);
    } else {
      sessionStorage.setItem(StorageKeys.ADDED_REWARDS, JSON.stringify([...rewards]));
    }
  } catch {
    console.error(LOGIC_ERROR.SYNC_REWARDS, [...rewards]);
  }
};
const trackAddedReward = (state2, id) => {
  state2.addedRewards.add(id);
  syncAddedRewardsToStorage(state2.addedRewards);
};
const untrackAddedReward = (state2, id) => {
  state2.addedRewards.delete(id);
  syncAddedRewardsToStorage(state2.addedRewards);
};
const clearAddedRewards = (state2) => {
  state2.addedRewards.clear();
  syncAddedRewardsToStorage(state2.addedRewards);
};
const declineReward = (milestoneId) => componentStorage.addToSet(StorageKeys.DECLINED_REWARDS, milestoneId);
const declineMultipleRewards = (milestoneIds) => componentStorage.addMultipleToSet(StorageKeys.DECLINED_REWARDS, milestoneIds);
const resetDeclinedReward = (milestoneId) => componentStorage.removeFromSet(StorageKeys.DECLINED_REWARDS, milestoneId);
let cachedConfig = void 0;
const readCartLogicConfig = () => {
  if (cachedConfig !== void 0) {
    return cachedConfig;
  }
  const script = document.querySelector(LOGIC_SELECTOR_CONFIG);
  if (!script) {
    cachedConfig = null;
    return null;
  }
  try {
    if (!script.textContent) {
      cachedConfig = { milestones: [], rewardPropertyKey: "", freeGiftLabel: "" };
      return cachedConfig;
    }
    cachedConfig = JSON.parse(script.textContent);
    return cachedConfig;
  } catch {
    console.error(LOGIC_ERROR.CONFIG_PARSE);
    cachedConfig = null;
    return null;
  }
};
const readDeclinedRewards = () => componentStorage.getSet(StorageKeys.DECLINED_REWARDS);
const MILESTONE_VALUE_PREFIX = "m";
const DEFAULT_REWARD_PROPERTY_KEY = LOGIC_REWARD_PROPERTY.REWARD;
const PRODUCT_ACTION_TYPES = /* @__PURE__ */ new Set([
  LOGIC_ACTION_TYPE.ADD_PRODUCT,
  LOGIC_ACTION_TYPE.ADD_PRODUCT_AND_SHIPPING
]);
const SHIPPING_ACTION_TYPES = /* @__PURE__ */ new Set([
  LOGIC_ACTION_TYPE.FREE_SHIPPING,
  LOGIC_ACTION_TYPE.ADD_PRODUCT_AND_SHIPPING
]);
const formatMilestonePropertyValue = (id) => `${MILESTONE_VALUE_PREFIX}${id}`;
const hasProductAction = (action) => PRODUCT_ACTION_TYPES.has(action.action);
const hasShippingAction = (action) => SHIPPING_ACTION_TYPES.has(action.action) || action.enableFreeShipping;
const buildRewardItem = (action, rewardKey, freeGiftLabel) => ({
  id: action.variantId ?? 0,
  quantity: 1,
  source: SOURCE_REWARD,
  initialOffer: OFFER_TYPE.ONE_TIME,
  customProperties: {
    [rewardKey]: formatMilestonePropertyValue(action.id),
    [LOGIC_REWARD_PROPERTY.FREE_GIFT]: "true",
    [LOGIC_REWARD_PROPERTY.FREE_GIFT_LABEL]: freeGiftLabel
  }
});
const buildCartFacts = (cart2, rewardKey) => {
  let nonRewardTotal = 0;
  let nonRewardItemCount = 0;
  const subscriptionProductIds = /* @__PURE__ */ new Set();
  const rewardMilestoneIds = /* @__PURE__ */ new Set();
  (cart2.items ?? []).forEach((item) => {
    const isFreeGift = isDefined(item.properties?.[LOGIC_REWARD_PROPERTY.FREE_GIFT]);
    if (!isFreeGift) {
      nonRewardTotal += item.final_line_price ?? 0;
      nonRewardItemCount += item.quantity ?? 1;
    }
    if (item.selling_plan_allocation) {
      subscriptionProductIds.add(item.product_id);
    }
    const rewardValue = item.properties?.[rewardKey];
    if (typeof rewardValue === "string" && rewardValue.startsWith(MILESTONE_VALUE_PREFIX)) {
      const id = Number(rewardValue.slice(MILESTONE_VALUE_PREFIX.length));
      if (Number.isInteger(id) && id > 0) {
        rewardMilestoneIds.add(id);
      }
    }
  });
  return { nonRewardTotal, nonRewardItemCount, subscriptionProductIds, rewardMilestoneIds };
};
const meetsAmountCondition = (condition, facts) => isDefined(condition.amountThreshold) && facts.nonRewardTotal >= condition.amountThreshold;
const meetsItemCountCondition = (condition, facts) => isDefined(condition.itemCountThreshold) && facts.nonRewardItemCount >= condition.itemCountThreshold;
const hasSubscriptionCondition = (condition, facts) => {
  if (facts.subscriptionProductIds.size === 0) {
    return false;
  }
  if (!condition.qualifyingProductIds?.length) {
    return true;
  }
  return condition.qualifyingProductIds.some((id) => facts.subscriptionProductIds.has(id));
};
const conditionEvaluators = {
  [LOGIC_CONDITION_TYPE.AMOUNT]: meetsAmountCondition,
  [LOGIC_CONDITION_TYPE.ITEM_COUNT]: meetsItemCountCondition,
  [LOGIC_CONDITION_TYPE.SUBSCRIPTION]: hasSubscriptionCondition,
  [LOGIC_CONDITION_TYPE.ITEM_COUNT_OR_SUBSCRIPTION]: (c, facts) => meetsItemCountCondition(c, facts) || hasSubscriptionCondition(c, facts),
  [LOGIC_CONDITION_TYPE.AMOUNT_OR_SUBSCRIPTION]: (c, facts) => meetsAmountCondition(c, facts) || hasSubscriptionCondition(c, facts)
};
const evaluateCondition = (condition, facts) => conditionEvaluators[condition.type]?.(condition, facts) ?? false;
const normalizeMilestoneConfig = (config) => ({
  rewardKey: config.rewardPropertyKey || DEFAULT_REWARD_PROPERTY_KEY,
  freeGiftLabel: config.freeGiftLabel || FREE_GIFT_LABEL,
  sortedMilestones: config.milestones.filter((m) => !!m.condition).sort((a, b) => a.id - b.id)
});
const shouldAddRewardItem = (milestone, facts, ctx) => !ctx.declinedRewards.has(milestone.id) && hasProductAction(milestone) && !!milestone.variantId && !facts.rewardMilestoneIds.has(milestone.id);
const resolveReachedMilestones = (facts, milestones) => {
  const highestByType = /* @__PURE__ */ new Map();
  milestones.forEach((milestone) => {
    if (!milestone.condition) {
      return;
    }
    if (!evaluateCondition(milestone.condition, facts)) {
      return;
    }
    const type = milestone.condition.type;
    highestByType.set(type, Math.max(highestByType.get(type) ?? 0, milestone.id));
  });
  const reached = /* @__PURE__ */ new Set();
  milestones.forEach((milestone) => {
    if (!milestone.condition) {
      return;
    }
    const highest = highestByType.get(milestone.condition.type) ?? 0;
    if (milestone.id <= highest) {
      reached.add(milestone.id);
    }
  });
  return reached;
};
const computeMilestoneRewards = (cart2, config, ctx) => {
  if (!config) {
    return { rewardItems: [], freeShippingDiscountCode: null };
  }
  const { rewardKey, freeGiftLabel, sortedMilestones } = normalizeMilestoneConfig(config);
  const facts = buildCartFacts(cart2, rewardKey);
  const reached = resolveReachedMilestones(facts, sortedMilestones);
  const rewardItems = [];
  let freeShippingDiscountCode = null;
  let highestShippingId = 0;
  sortedMilestones.forEach((milestone) => {
    if (!reached.has(milestone.id)) {
      return;
    }
    if (shouldAddRewardItem(milestone, facts, ctx)) {
      rewardItems.push(buildRewardItem(milestone, rewardKey, freeGiftLabel));
    }
    if (hasShippingAction(milestone) && milestone.freeShippingDiscountCode && milestone.id > highestShippingId) {
      freeShippingDiscountCode = milestone.freeShippingDiscountCode;
      highestShippingId = milestone.id;
    }
  });
  return { rewardItems, freeShippingDiscountCode };
};
const ELEMENT_NAME$9 = "zyg-cart-logic";
const CART_SUMMARY_ELEMENT = "zyg-cart-summary";
const GLOBAL_KEY = "__zygCartLogic";
function getGlobalState() {
  if (!window[GLOBAL_KEY]) {
    window[GLOBAL_KEY] = {
      rewardLock: /* @__PURE__ */ new Set(),
      systemRemovedRewards: /* @__PURE__ */ new Set(),
      addedRewards: getPersistedAddedRewards(),
      shippingDiscountApplied: null,
      shippingOperationPromise: null
    };
  }
  return window[GLOBAL_KEY];
}
const SKIP_REASON = {
  DECLINED: "manually_removed",
  ALREADY_IN_CART: "already_in_cart",
  VARIANT_ALREADY_FREE: "variant_already_free"
};
const REWARD_ACTION = LOGIC_REWARD_ACTION;
const MAX_REWARD_RETRY_ATTEMPTS = 3;
const REWARD_PROCESSING_DELAY_MS = 50;
const shouldAddProduct = (action) => hasProductAction(action) && !!action.variantId;
const shouldEnableShipping = (action) => hasShippingAction(action) && !!action.freeShippingDiscountCode;
const MilestoneState = {
  PENDING: "pending",
  REACHED: "reached"
};
class ZygCartManagement extends BaseCartLogicComponent {
  #config = null;
  #milestoneStates = /* @__PURE__ */ new Map();
  #previousCartItems = [];
  #cleanupCartStateChange;
  #evaluationPromise = null;
  #pendingCart = null;
  #currentCart = null;
  #isProcessingRewards = false;
  #failedRewardAttempts = /* @__PURE__ */ new Map();
  connectedCallback() {
    this.#config = readCartLogicConfig();
    this.#cleanupCartStateChange = subscribeToDomEvent(
      DOM_EVENT$1.STATE_CHANGE,
      this.#handleCartStateChange.bind(this)
    );
    this.#evaluateInitialConditions();
  }
  disconnectedCallback() {
    this.#cleanupCartStateChange?.();
  }
  async #evaluateInitialConditions() {
    try {
      const cart2 = await window.cart.fetch();
      this.#previousCartItems = cart2.items ?? [];
      if (this.#hasConditionBasedMilestones()) {
        this.#queueEvaluation(cart2);
      }
    } catch (error) {
      console.error("[zyg-cart-logic] Failed to evaluate initial conditions:", error);
    }
  }
  #handleCartStateChange(event) {
    const cart2 = event.detail?.cart;
    if (!cart2) {
      return;
    }
    if (this.#isProcessingRewards) {
      this.#pendingCart = cart2;
      return;
    }
    const cartItems = cart2.items ?? [];
    this.#detectManuallyRemovedRewards(cartItems);
    this.#previousCartItems = cartItems;
    if (this.#hasConditionBasedMilestones()) {
      this.#queueEvaluation(cart2);
    }
  }
  #queueEvaluation(cart2) {
    this.#pendingCart = cart2;
    if (this.#evaluationPromise) {
      return;
    }
    this.#evaluationPromise = this.#runEvaluationLoop();
  }
  async #runEvaluationLoop() {
    try {
      while (this.#pendingCart) {
        const cart2 = this.#pendingCart;
        this.#pendingCart = null;
        await this.#evaluateMilestones(cart2);
      }
    } finally {
      this.#evaluationPromise = null;
    }
  }
  #detectManuallyRemovedRewards(currentItems) {
    const state2 = getGlobalState();
    if (this.#previousCartItems.length > 0 && currentItems.length === 0) {
      state2.systemRemovedRewards.clear();
      clearAddedRewards(state2);
      return;
    }
    const currentKeys = new Set(currentItems.map((item) => item.key));
    const declinedMilestones = this.#previousCartItems.filter((item) => !currentKeys.has(item.key)).map((item) => this.getMilestoneIdFromItem(item)).filter((id) => isDefined(id) && !state2.systemRemovedRewards.has(id));
    if (declinedMilestones.length > 0) {
      declinedMilestones.forEach((id) => {
        untrackAddedReward(state2, id);
        this.#milestoneStates.set(id, MilestoneState.PENDING);
      });
      void declineMultipleRewards(declinedMilestones);
    }
    state2.systemRemovedRewards.clear();
  }
  #hasConditionBasedMilestones() {
    return !!this.#config?.milestones.some((m) => m.condition);
  }
  async #evaluateMilestones(cart2) {
    this.#currentCart = cart2;
    const state2 = getGlobalState();
    const sortedMilestones = (this.#config?.milestones.filter(
      (m) => !!m.condition
    ) ?? []).sort((a, b) => a.id - b.id);
    const facts = buildCartFacts(cart2, this.#getRewardPropertyKey());
    const highestReachedByType = sortedMilestones.filter((m) => evaluateCondition(m.condition, facts)).reduce((map, m) => {
      const current = map.get(m.condition.type) ?? 0;
      map.set(m.condition.type, Math.max(current, m.id));
      return map;
    }, /* @__PURE__ */ new Map());
    const { milestonesToReach, milestonesToLose, hasChanges } = sortedMilestones.reduce(
      (acc, milestone) => {
        const previousState = this.#milestoneStates.get(milestone.id) ?? MilestoneState.PENDING;
        const isConditionMet = evaluateCondition(milestone.condition, facts);
        const highestForType = highestReachedByType.get(milestone.condition.type) ?? 0;
        const isReachedByCascade = milestone.id <= highestForType;
        const shouldBeReached = isConditionMet || isReachedByCascade;
        const currentState = shouldBeReached ? MilestoneState.REACHED : MilestoneState.PENDING;
        if (currentState === previousState) {
          return acc;
        }
        this.#milestoneStates.set(milestone.id, currentState);
        this.#dispatchMarkerUpdate(milestone.id, shouldBeReached);
        if (currentState === MilestoneState.REACHED) {
          acc.milestonesToReach.push(milestone);
        } else if (state2.rewardLock.has(milestone.id)) {
          this.#milestoneStates.set(milestone.id, MilestoneState.REACHED);
        } else {
          acc.milestonesToLose.push(milestone);
        }
        return { ...acc, hasChanges: true };
      },
      {
        milestonesToReach: [],
        milestonesToLose: [],
        hasChanges: false
      }
    );
    if (milestonesToReach.length > 0) {
      await this.#executeBatchMilestoneReached(milestonesToReach);
    }
    if (milestonesToLose.length > 0) {
      const cartModified = await this.#executeBatchMilestoneLost(milestonesToLose);
      if (cartModified) {
        window.cart.emitStateChange();
      }
    }
    return hasChanges;
  }
  async #executeBatchMilestoneReached(milestones) {
    const state2 = getGlobalState();
    const rewardsToAdd = milestones.filter((action) => shouldAddProduct(action) && action.variantId).reduce((acc, action) => {
      const eligibility = this.#checkRewardEligibility(action);
      if (!eligibility.eligible) {
        if (eligibility.shouldTrackInCart) {
          trackAddedReward(state2, action.id);
        }
        if (eligibility.shouldResetMilestoneState) {
          this.#milestoneStates.set(action.id, MilestoneState.PENDING);
        }
        if (eligibility.skipReason) {
          this.#notifyRewardSkipped(action, eligibility.skipReason);
        }
        return acc;
      }
      return [
        ...acc,
        {
          action,
          item: buildRewardItem(
            action,
            this.#getRewardPropertyKey(),
            this.#getFreeRewardLabel()
          )
        }
      ];
    }, []);
    const shippingMilestone = milestones.filter((m) => shouldEnableShipping(m)).sort((a, b) => b.id - a.id)[0];
    const hasRewards = rewardsToAdd.length > 0;
    const hasShipping = shippingMilestone && state2.shippingDiscountApplied !== shippingMilestone.freeShippingDiscountCode;
    if (!hasRewards && !hasShipping) {
      return;
    }
    this.#isProcessingRewards = true;
    const lockIds = rewardsToAdd.map((r) => r.action.id);
    lockIds.forEach((id) => state2.rewardLock.add(id));
    rewardsToAdd.forEach((reward) => trackAddedReward(state2, reward.action.id));
    if (hasRewards) {
      try {
        await window.cart.addMultipleSilent(rewardsToAdd.map((r) => r.item));
        rewardsToAdd.forEach((reward) => {
          this.#failedRewardAttempts.delete(reward.action.id);
          this.#notifyReward(
            reward.action,
            REWARD_ACTION.ADDED,
            LOGIC_EVENT.REWARD_ADDED,
            LOGIC_ANALYTICS.REWARD_ADDED
          );
        });
      } catch (error) {
        rewardsToAdd.forEach((reward) => {
          untrackAddedReward(state2, reward.action.id);
          const attempts = (this.#failedRewardAttempts.get(reward.action.id) ?? 0) + 1;
          this.#failedRewardAttempts.set(reward.action.id, attempts);
          if (attempts < MAX_REWARD_RETRY_ATTEMPTS) {
            this.#milestoneStates.set(reward.action.id, MilestoneState.PENDING);
            this.#dispatchMarkerUpdate(reward.action.id, false);
          }
        });
        console.error(LOGIC_ERROR.ADD_REWARD, error);
      }
    }
    if (hasShipping && shippingMilestone.freeShippingDiscountCode) {
      try {
        state2.shippingDiscountApplied = shippingMilestone.freeShippingDiscountCode;
        await window.cart.setDiscountSilent(shippingMilestone.freeShippingDiscountCode);
        this.#updateCartSummaryShipping(true);
        this.notify({
          eventName: LOGIC_EVENT.FREE_SHIPPING_ENABLED,
          detail: {
            milestoneId: shippingMilestone.id,
            variantId: 0,
            productTitle: "",
            action: REWARD_ACTION.ADDED
          },
          analyticsAction: LOGIC_ANALYTICS.FREE_SHIPPING_ENABLED,
          analyticsPayload: {
            milestoneId: shippingMilestone.id,
            discountCode: shippingMilestone.freeShippingDiscountCode
          }
        });
      } catch (error) {
        state2.shippingDiscountApplied = null;
        console.error(LOGIC_ERROR.ENABLE_SHIPPING, error);
      }
    }
    lockIds.forEach((id) => state2.rewardLock.delete(id));
    await new Promise((resolve) => setTimeout(resolve, REWARD_PROCESSING_DELAY_MS));
    this.#isProcessingRewards = false;
    if (this.#pendingCart) {
      const pendingItems = this.#pendingCart.items ?? [];
      this.#detectManuallyRemovedRewards(pendingItems);
      this.#previousCartItems = pendingItems;
      if (this.#hasConditionBasedMilestones()) {
        this.#queueEvaluation(this.#pendingCart);
      }
    } else if (window.cart?.instance) {
      this.#previousCartItems = window.cart.instance.items ?? [];
    }
    if (hasRewards || hasShipping) {
      window.cart.emitStateChange();
    }
  }
  #dispatchMarkerUpdate(milestoneId, isReached) {
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT$1.PROGRESS_MARKER_UPDATE, {
        bubbles: true,
        detail: { milestoneId, isReached }
      })
    );
  }
  #isMilestoneRewardItem(item) {
    return isDefined(item.properties?.[this.#getRewardPropertyKey()]);
  }
  async #executeBatchMilestoneLost(milestones) {
    const state2 = getGlobalState();
    await Promise.all(milestones.map((m) => resetDeclinedReward(m.id)));
    const rewardsToRemove = milestones.filter(
      (action) => hasProductAction(action) && action.removeOnLost && !state2.rewardLock.has(action.id)
    ).map((action) => {
      const itemKey = this.#findRewardItemKey(action.id);
      return { action, itemKey };
    }).filter((r) => !!r.itemKey);
    const shippingToDisable = milestones.filter(
      (action) => hasShippingAction(action) && action.removeOnLost
    );
    milestones.forEach((m) => untrackAddedReward(state2, m.id));
    let cartModified = false;
    if (rewardsToRemove.length > 0) {
      const keys = rewardsToRemove.map((r) => r.itemKey);
      rewardsToRemove.forEach((r) => {
        state2.rewardLock.add(r.action.id);
        state2.systemRemovedRewards.add(r.action.id);
      });
      try {
        await window.cart.removeMultipleSilent(keys);
        cartModified = true;
        rewardsToRemove.forEach((r) => {
          this.#notifyReward(
            r.action,
            REWARD_ACTION.REMOVED,
            LOGIC_EVENT.REWARD_REMOVED,
            LOGIC_ANALYTICS.REWARD_REMOVED
          );
        });
      } catch (error) {
        console.error(LOGIC_ERROR.REMOVE_REWARD, error);
      } finally {
        rewardsToRemove.forEach((r) => state2.rewardLock.delete(r.action.id));
      }
    }
    for (const action of shippingToDisable) {
      await this.#setFreeShipping(action, false);
      cartModified = true;
    }
    return cartModified;
  }
  static #freeShippingConfig = {
    enable: {
      event: LOGIC_EVENT.FREE_SHIPPING_ENABLED,
      analytics: LOGIC_ANALYTICS.FREE_SHIPPING_ENABLED,
      error: LOGIC_ERROR.ENABLE_SHIPPING,
      rewardAction: REWARD_ACTION.ADDED
    },
    disable: {
      event: LOGIC_EVENT.FREE_SHIPPING_DISABLED,
      analytics: LOGIC_ANALYTICS.FREE_SHIPPING_DISABLED,
      error: LOGIC_ERROR.DISABLE_SHIPPING,
      rewardAction: REWARD_ACTION.REMOVED
    }
  };
  async #setFreeShipping(action, enabled) {
    if (!action.freeShippingDiscountCode) {
      return;
    }
    const state2 = getGlobalState();
    const targetCode = enabled ? action.freeShippingDiscountCode : null;
    if (state2.shippingOperationPromise) {
      await state2.shippingOperationPromise;
    }
    if (state2.shippingDiscountApplied === targetCode) {
      return;
    }
    const config = ZygCartManagement.#freeShippingConfig[enabled ? "enable" : "disable"];
    let resolveOperation = () => {
    };
    state2.shippingOperationPromise = new Promise((resolve) => {
      resolveOperation = resolve;
    });
    try {
      state2.shippingDiscountApplied = targetCode;
      await this.#updateCartDiscount(enabled ? action.freeShippingDiscountCode : "");
      this.#updateCartSummaryShipping(enabled);
      this.notify({
        eventName: config.event,
        detail: {
          milestoneId: action.id,
          variantId: 0,
          productTitle: "",
          action: config.rewardAction
        },
        analyticsAction: config.analytics,
        analyticsPayload: {
          milestoneId: action.id,
          ...enabled && { discountCode: action.freeShippingDiscountCode }
        }
      });
    } catch (error) {
      state2.shippingDiscountApplied = enabled ? null : action.freeShippingDiscountCode;
      console.error(config.error, error);
    } finally {
      resolveOperation();
      state2.shippingOperationPromise = null;
    }
  }
  #updateCartSummaryShipping(enabled) {
    document.querySelector(CART_SUMMARY_ELEMENT)?.setFreeShipping?.(enabled);
  }
  async #updateCartDiscount(code) {
    await window.cart.setDiscountSilent(code);
  }
  #notifyReward(action, eventAction, eventName, analyticsAction) {
    this.notify({
      eventName,
      detail: {
        milestoneId: action.id,
        variantId: action.variantId || 0,
        productTitle: action.productTitle,
        action: eventAction
      },
      analyticsAction,
      analyticsPayload: {
        milestoneId: action.id,
        variantId: action.variantId || void 0,
        productTitle: action.productTitle ?? void 0,
        discountCode: action.discountCode ?? void 0
      }
    });
  }
  #notifyRewardSkipped(action, reason) {
    this.notify({
      eventName: LOGIC_EVENT.REWARD_SKIPPED,
      detail: {
        milestoneId: action.id,
        variantId: action.variantId || 0,
        productTitle: action.productTitle,
        action: REWARD_ACTION.SKIPPED,
        reason
      },
      analyticsAction: LOGIC_ANALYTICS.REWARD_SKIPPED,
      analyticsPayload: {
        milestoneId: action.id,
        variantId: action.variantId || void 0,
        reason
      }
    });
  }
  #isRewardInCart(milestoneId) {
    return isDefined(this.#findRewardItemKey(milestoneId));
  }
  #isVariantAlreadyFreeInCart(variantId) {
    return this.#currentCart?.items?.some(
      (item) => item.variant_id === variantId && this.#isMilestoneRewardItem(item)
    ) ?? false;
  }
  #checkRewardEligibility(action) {
    const state2 = getGlobalState();
    if (getDeclinedRewards().has(action.id)) {
      return { eligible: false, skipReason: SKIP_REASON.DECLINED };
    }
    if ((this.#failedRewardAttempts.get(action.id) ?? 0) >= MAX_REWARD_RETRY_ATTEMPTS) {
      return { eligible: false, skipReason: SKIP_REASON.DECLINED };
    }
    if (state2.rewardLock.has(action.id)) {
      return { eligible: false, skipReason: SKIP_REASON.ALREADY_IN_CART };
    }
    if (state2.addedRewards.has(action.id)) {
      if (this.#isRewardInCart(action.id)) {
        return { eligible: false, skipReason: SKIP_REASON.ALREADY_IN_CART };
      }
      untrackAddedReward(state2, action.id);
    }
    if (this.#isRewardInCart(action.id)) {
      return {
        eligible: false,
        skipReason: SKIP_REASON.ALREADY_IN_CART,
        shouldTrackInCart: true
      };
    }
    if (action.variantId && this.#isVariantAlreadyFreeInCart(action.variantId)) {
      return {
        eligible: false,
        skipReason: SKIP_REASON.VARIANT_ALREADY_FREE,
        shouldResetMilestoneState: true
      };
    }
    return { eligible: true };
  }
  #findRewardItemKey(milestoneId) {
    if (!this.#currentCart) {
      return null;
    }
    return this.#currentCart.items?.find(
      (item) => item.properties?.[this.#getRewardPropertyKey()] === formatMilestonePropertyValue(milestoneId)
    )?.key ?? null;
  }
  #getRewardPropertyKey() {
    return this.#config?.rewardPropertyKey || DEFAULT_REWARD_PROPERTY_KEY;
  }
  #getFreeRewardLabel() {
    return this.#config?.freeGiftLabel || FREE_GIFT_LABEL;
  }
  /** Marks a milestone as declined by user (won't auto-add again) */
  markAsDeclined(milestoneId) {
    return declineReward(milestoneId);
  }
  /** Gets the milestone ID from a cart item's properties */
  getMilestoneIdFromItem(item) {
    const propertyValue = item.properties?.[this.#getRewardPropertyKey()];
    if (!propertyValue?.startsWith(MILESTONE_VALUE_PREFIX)) {
      return null;
    }
    const parsed = parseInt(propertyValue.slice(MILESTONE_VALUE_PREFIX.length), RADIX_DECIMAL);
    return isNaN(parsed) ? null : parsed;
  }
}
if (!customElements.get(ELEMENT_NAME$9)) {
  customElements.define(ELEMENT_NAME$9, ZygCartManagement);
}
var Idiomorph = (function() {
  const noOp = () => {
  };
  const defaults = {
    morphStyle: "outerHTML",
    callbacks: {
      beforeNodeAdded: noOp,
      afterNodeAdded: noOp,
      beforeNodeMorphed: noOp,
      afterNodeMorphed: noOp,
      beforeNodeRemoved: noOp,
      afterNodeRemoved: noOp,
      beforeAttributeUpdated: noOp
    },
    head: {
      style: "merge",
      shouldPreserve: (elt) => elt.getAttribute("im-preserve") === "true",
      shouldReAppend: (elt) => elt.getAttribute("im-re-append") === "true",
      shouldRemove: noOp,
      afterHeadMorphed: noOp
    },
    restoreFocus: true
  };
  function morph(oldNode, newContent, config = {}) {
    oldNode = normalizeElement(oldNode);
    const newNode = normalizeParent(newContent);
    const ctx = createMorphContext(oldNode, newNode, config);
    const morphedNodes = saveAndRestoreFocus(ctx, () => {
      return withHeadBlocking(
        ctx,
        oldNode,
        newNode,
        /** @param {MorphContext} ctx */
        (ctx2) => {
          if (ctx2.morphStyle === "innerHTML") {
            morphChildren(ctx2, oldNode, newNode);
            return Array.from(oldNode.childNodes);
          } else {
            return morphOuterHTML(ctx2, oldNode, newNode);
          }
        }
      );
    });
    ctx.pantry.remove();
    return morphedNodes;
  }
  function morphOuterHTML(ctx, oldNode, newNode) {
    const oldParent = normalizeParent(oldNode);
    morphChildren(
      ctx,
      oldParent,
      newNode,
      // these two optional params are the secret sauce
      oldNode,
      // start point for iteration
      oldNode.nextSibling
      // end point for iteration
    );
    return Array.from(oldParent.childNodes);
  }
  function saveAndRestoreFocus(ctx, fn) {
    if (!ctx.config.restoreFocus) return fn();
    let activeElement = (
      /** @type {HTMLInputElement|HTMLTextAreaElement|null} */
      document.activeElement
    );
    if (!(activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement)) {
      return fn();
    }
    const { id: activeElementId, selectionStart, selectionEnd } = activeElement;
    const results = fn();
    if (activeElementId && activeElementId !== document.activeElement?.getAttribute("id")) {
      activeElement = ctx.target.querySelector(`[id="${activeElementId}"]`);
      activeElement?.focus();
    }
    if (activeElement && !activeElement.selectionEnd && selectionEnd) {
      activeElement.setSelectionRange(selectionStart, selectionEnd);
    }
    return results;
  }
  const morphChildren = /* @__PURE__ */ (function() {
    function morphChildren2(ctx, oldParent, newParent, insertionPoint = null, endPoint = null) {
      if (oldParent instanceof HTMLTemplateElement && newParent instanceof HTMLTemplateElement) {
        oldParent = oldParent.content;
        newParent = newParent.content;
      }
      insertionPoint ||= oldParent.firstChild;
      for (const newChild of newParent.childNodes) {
        if (insertionPoint && insertionPoint != endPoint) {
          const bestMatch = findBestMatch(
            ctx,
            newChild,
            insertionPoint,
            endPoint
          );
          if (bestMatch) {
            if (bestMatch !== insertionPoint) {
              removeNodesBetween(ctx, insertionPoint, bestMatch);
            }
            morphNode(bestMatch, newChild, ctx);
            insertionPoint = bestMatch.nextSibling;
            continue;
          }
        }
        if (newChild instanceof Element) {
          const newChildId = (
            /** @type {String} */
            newChild.getAttribute("id")
          );
          if (ctx.persistentIds.has(newChildId)) {
            const movedChild = moveBeforeById(
              oldParent,
              newChildId,
              insertionPoint,
              ctx
            );
            morphNode(movedChild, newChild, ctx);
            insertionPoint = movedChild.nextSibling;
            continue;
          }
        }
        const insertedNode = createNode(
          oldParent,
          newChild,
          insertionPoint,
          ctx
        );
        if (insertedNode) {
          insertionPoint = insertedNode.nextSibling;
        }
      }
      while (insertionPoint && insertionPoint != endPoint) {
        const tempNode = insertionPoint;
        insertionPoint = insertionPoint.nextSibling;
        removeNode(ctx, tempNode);
      }
    }
    function createNode(oldParent, newChild, insertionPoint, ctx) {
      if (ctx.callbacks.beforeNodeAdded(newChild) === false) return null;
      if (ctx.idMap.has(newChild)) {
        const newEmptyChild = document.createElement(
          /** @type {Element} */
          newChild.tagName
        );
        oldParent.insertBefore(newEmptyChild, insertionPoint);
        morphNode(newEmptyChild, newChild, ctx);
        ctx.callbacks.afterNodeAdded(newEmptyChild);
        return newEmptyChild;
      } else {
        const newClonedChild = document.importNode(newChild, true);
        oldParent.insertBefore(newClonedChild, insertionPoint);
        ctx.callbacks.afterNodeAdded(newClonedChild);
        return newClonedChild;
      }
    }
    const findBestMatch = /* @__PURE__ */ (function() {
      function findBestMatch2(ctx, node, startPoint, endPoint) {
        let softMatch = null;
        let nextSibling = node.nextSibling;
        let siblingSoftMatchCount = 0;
        let cursor = startPoint;
        while (cursor && cursor != endPoint) {
          if (isSoftMatch(cursor, node)) {
            if (isIdSetMatch(ctx, cursor, node)) {
              return cursor;
            }
            if (softMatch === null) {
              if (!ctx.idMap.has(cursor)) {
                softMatch = cursor;
              }
            }
          }
          if (softMatch === null && nextSibling && isSoftMatch(cursor, nextSibling)) {
            siblingSoftMatchCount++;
            nextSibling = nextSibling.nextSibling;
            if (siblingSoftMatchCount >= 2) {
              softMatch = void 0;
            }
          }
          if (ctx.activeElementAndParents.includes(cursor)) break;
          cursor = cursor.nextSibling;
        }
        return softMatch || null;
      }
      function isIdSetMatch(ctx, oldNode, newNode) {
        let oldSet = ctx.idMap.get(oldNode);
        let newSet = ctx.idMap.get(newNode);
        if (!newSet || !oldSet) return false;
        for (const id of oldSet) {
          if (newSet.has(id)) {
            return true;
          }
        }
        return false;
      }
      function isSoftMatch(oldNode, newNode) {
        const oldElt = (
          /** @type {Element} */
          oldNode
        );
        const newElt = (
          /** @type {Element} */
          newNode
        );
        return oldElt.nodeType === newElt.nodeType && oldElt.tagName === newElt.tagName && // If oldElt has an `id` with possible state and it doesn't match newElt.id then avoid morphing.
        // We'll still match an anonymous node with an IDed newElt, though, because if it got this far,
        // its not persistent, and new nodes can't have any hidden state.
        // We can't use .id because of form input shadowing, and we can't count on .getAttribute's presence because it could be a document-fragment
        (!oldElt.getAttribute?.("id") || oldElt.getAttribute?.("id") === newElt.getAttribute?.("id"));
      }
      return findBestMatch2;
    })();
    function removeNode(ctx, node) {
      if (ctx.idMap.has(node)) {
        moveBefore(ctx.pantry, node, null);
      } else {
        if (ctx.callbacks.beforeNodeRemoved(node) === false) return;
        node.parentNode?.removeChild(node);
        ctx.callbacks.afterNodeRemoved(node);
      }
    }
    function removeNodesBetween(ctx, startInclusive, endExclusive) {
      let cursor = startInclusive;
      while (cursor && cursor !== endExclusive) {
        let tempNode = (
          /** @type {Node} */
          cursor
        );
        cursor = cursor.nextSibling;
        removeNode(ctx, tempNode);
      }
      return cursor;
    }
    function moveBeforeById(parentNode, id, after, ctx) {
      const target = (
        /** @type {Element} - will always be found */
        // ctx.target.id unsafe because of form input shadowing
        // ctx.target could be a document fragment which doesn't have `getAttribute`
        ctx.target.getAttribute?.("id") === id && ctx.target || ctx.target.querySelector(`[id="${id}"]`) || ctx.pantry.querySelector(`[id="${id}"]`)
      );
      removeElementFromAncestorsIdMaps(target, ctx);
      moveBefore(parentNode, target, after);
      return target;
    }
    function removeElementFromAncestorsIdMaps(element, ctx) {
      const id = (
        /** @type {String} */
        element.getAttribute("id")
      );
      while (element = element.parentNode) {
        let idSet = ctx.idMap.get(element);
        if (idSet) {
          idSet.delete(id);
          if (!idSet.size) {
            ctx.idMap.delete(element);
          }
        }
      }
    }
    function moveBefore(parentNode, element, after) {
      if (parentNode.moveBefore) {
        try {
          parentNode.moveBefore(element, after);
        } catch (e) {
          parentNode.insertBefore(element, after);
        }
      } else {
        parentNode.insertBefore(element, after);
      }
    }
    return morphChildren2;
  })();
  const morphNode = /* @__PURE__ */ (function() {
    function morphNode2(oldNode, newContent, ctx) {
      if (ctx.ignoreActive && oldNode === document.activeElement) {
        return null;
      }
      if (ctx.callbacks.beforeNodeMorphed(oldNode, newContent) === false) {
        return oldNode;
      }
      if (oldNode instanceof HTMLHeadElement && ctx.head.ignore) ;
      else if (oldNode instanceof HTMLHeadElement && ctx.head.style !== "morph") {
        handleHeadElement(
          oldNode,
          /** @type {HTMLHeadElement} */
          newContent,
          ctx
        );
      } else {
        morphAttributes(oldNode, newContent, ctx);
        if (!ignoreValueOfActiveElement(oldNode, ctx)) {
          morphChildren(ctx, oldNode, newContent);
        }
      }
      ctx.callbacks.afterNodeMorphed(oldNode, newContent);
      return oldNode;
    }
    function morphAttributes(oldNode, newNode, ctx) {
      let type = newNode.nodeType;
      if (type === 1) {
        const oldElt = (
          /** @type {Element} */
          oldNode
        );
        const newElt = (
          /** @type {Element} */
          newNode
        );
        const oldAttributes = oldElt.attributes;
        const newAttributes = newElt.attributes;
        for (const newAttribute of newAttributes) {
          if (ignoreAttribute(newAttribute.name, oldElt, "update", ctx)) {
            continue;
          }
          if (oldElt.getAttribute(newAttribute.name) !== newAttribute.value) {
            oldElt.setAttribute(newAttribute.name, newAttribute.value);
          }
        }
        for (let i = oldAttributes.length - 1; 0 <= i; i--) {
          const oldAttribute = oldAttributes[i];
          if (!oldAttribute) continue;
          if (!newElt.hasAttribute(oldAttribute.name)) {
            if (ignoreAttribute(oldAttribute.name, oldElt, "remove", ctx)) {
              continue;
            }
            oldElt.removeAttribute(oldAttribute.name);
          }
        }
        if (!ignoreValueOfActiveElement(oldElt, ctx)) {
          syncInputValue(oldElt, newElt, ctx);
        }
      }
      if (type === 8 || type === 3) {
        if (oldNode.nodeValue !== newNode.nodeValue) {
          oldNode.nodeValue = newNode.nodeValue;
        }
      }
    }
    function syncInputValue(oldElement, newElement, ctx) {
      if (oldElement instanceof HTMLInputElement && newElement instanceof HTMLInputElement && newElement.type !== "file") {
        let newValue = newElement.value;
        let oldValue = oldElement.value;
        syncBooleanAttribute(oldElement, newElement, "checked", ctx);
        syncBooleanAttribute(oldElement, newElement, "disabled", ctx);
        if (!newElement.hasAttribute("value")) {
          if (!ignoreAttribute("value", oldElement, "remove", ctx)) {
            oldElement.value = "";
            oldElement.removeAttribute("value");
          }
        } else if (oldValue !== newValue) {
          if (!ignoreAttribute("value", oldElement, "update", ctx)) {
            oldElement.setAttribute("value", newValue);
            oldElement.value = newValue;
          }
        }
      } else if (oldElement instanceof HTMLOptionElement && newElement instanceof HTMLOptionElement) {
        syncBooleanAttribute(oldElement, newElement, "selected", ctx);
      } else if (oldElement instanceof HTMLTextAreaElement && newElement instanceof HTMLTextAreaElement) {
        let newValue = newElement.value;
        let oldValue = oldElement.value;
        if (ignoreAttribute("value", oldElement, "update", ctx)) {
          return;
        }
        if (newValue !== oldValue) {
          oldElement.value = newValue;
        }
        if (oldElement.firstChild && oldElement.firstChild.nodeValue !== newValue) {
          oldElement.firstChild.nodeValue = newValue;
        }
      }
    }
    function syncBooleanAttribute(oldElement, newElement, attributeName, ctx) {
      const newLiveValue = newElement[attributeName], oldLiveValue = oldElement[attributeName];
      if (newLiveValue !== oldLiveValue) {
        const ignoreUpdate = ignoreAttribute(
          attributeName,
          oldElement,
          "update",
          ctx
        );
        if (!ignoreUpdate) {
          oldElement[attributeName] = newElement[attributeName];
        }
        if (newLiveValue) {
          if (!ignoreUpdate) {
            oldElement.setAttribute(attributeName, "");
          }
        } else {
          if (!ignoreAttribute(attributeName, oldElement, "remove", ctx)) {
            oldElement.removeAttribute(attributeName);
          }
        }
      }
    }
    function ignoreAttribute(attr, element, updateType, ctx) {
      if (attr === "value" && ctx.ignoreActiveValue && element === document.activeElement) {
        return true;
      }
      return ctx.callbacks.beforeAttributeUpdated(attr, element, updateType) === false;
    }
    function ignoreValueOfActiveElement(possibleActiveElement, ctx) {
      return !!ctx.ignoreActiveValue && possibleActiveElement === document.activeElement && possibleActiveElement !== document.body;
    }
    return morphNode2;
  })();
  function withHeadBlocking(ctx, oldNode, newNode, callback) {
    if (ctx.head.block) {
      const oldHead = oldNode.querySelector("head");
      const newHead = newNode.querySelector("head");
      if (oldHead && newHead) {
        const promises = handleHeadElement(oldHead, newHead, ctx);
        return Promise.all(promises).then(() => {
          const newCtx = Object.assign(ctx, {
            head: {
              block: false,
              ignore: true
            }
          });
          return callback(newCtx);
        });
      }
    }
    return callback(ctx);
  }
  function handleHeadElement(oldHead, newHead, ctx) {
    let added = [];
    let removed = [];
    let preserved = [];
    let nodesToAppend = [];
    let srcToNewHeadNodes = /* @__PURE__ */ new Map();
    for (const newHeadChild of newHead.children) {
      srcToNewHeadNodes.set(newHeadChild.outerHTML, newHeadChild);
    }
    for (const currentHeadElt of oldHead.children) {
      let inNewContent = srcToNewHeadNodes.has(currentHeadElt.outerHTML);
      let isReAppended = ctx.head.shouldReAppend(currentHeadElt);
      let isPreserved = ctx.head.shouldPreserve(currentHeadElt);
      if (inNewContent || isPreserved) {
        if (isReAppended) {
          removed.push(currentHeadElt);
        } else {
          srcToNewHeadNodes.delete(currentHeadElt.outerHTML);
          preserved.push(currentHeadElt);
        }
      } else {
        if (ctx.head.style === "append") {
          if (isReAppended) {
            removed.push(currentHeadElt);
            nodesToAppend.push(currentHeadElt);
          }
        } else {
          if (ctx.head.shouldRemove(currentHeadElt) !== false) {
            removed.push(currentHeadElt);
          }
        }
      }
    }
    nodesToAppend.push(...srcToNewHeadNodes.values());
    let promises = [];
    for (const newNode of nodesToAppend) {
      let newElt = (
        /** @type {ChildNode} */
        document.createRange().createContextualFragment(newNode.outerHTML).firstChild
      );
      if (ctx.callbacks.beforeNodeAdded(newElt) !== false) {
        if ("href" in newElt && newElt.href || "src" in newElt && newElt.src) {
          let resolve;
          let promise = new Promise(function(_resolve) {
            resolve = _resolve;
          });
          newElt.addEventListener("load", function() {
            resolve();
          });
          promises.push(promise);
        }
        oldHead.appendChild(newElt);
        ctx.callbacks.afterNodeAdded(newElt);
        added.push(newElt);
      }
    }
    for (const removedElement of removed) {
      if (ctx.callbacks.beforeNodeRemoved(removedElement) !== false) {
        oldHead.removeChild(removedElement);
        ctx.callbacks.afterNodeRemoved(removedElement);
      }
    }
    ctx.head.afterHeadMorphed(oldHead, {
      added,
      kept: preserved,
      removed
    });
    return promises;
  }
  const createMorphContext = /* @__PURE__ */ (function() {
    function createMorphContext2(oldNode, newContent, config) {
      const { persistentIds, idMap } = createIdMaps(oldNode, newContent);
      const mergedConfig = mergeDefaults(config);
      const morphStyle = mergedConfig.morphStyle || "outerHTML";
      if (!["innerHTML", "outerHTML"].includes(morphStyle)) {
        throw `Do not understand how to morph style ${morphStyle}`;
      }
      return {
        target: oldNode,
        newContent,
        config: mergedConfig,
        morphStyle,
        ignoreActive: mergedConfig.ignoreActive,
        ignoreActiveValue: mergedConfig.ignoreActiveValue,
        restoreFocus: mergedConfig.restoreFocus,
        idMap,
        persistentIds,
        pantry: createPantry(),
        activeElementAndParents: createActiveElementAndParents(oldNode),
        callbacks: mergedConfig.callbacks,
        head: mergedConfig.head
      };
    }
    function mergeDefaults(config) {
      let finalConfig = Object.assign({}, defaults);
      Object.assign(finalConfig, config);
      finalConfig.callbacks = Object.assign(
        {},
        defaults.callbacks,
        config.callbacks
      );
      finalConfig.head = Object.assign({}, defaults.head, config.head);
      return finalConfig;
    }
    function createPantry() {
      const pantry = document.createElement("div");
      pantry.hidden = true;
      document.body.insertAdjacentElement("afterend", pantry);
      return pantry;
    }
    function createActiveElementAndParents(oldNode) {
      let activeElementAndParents = [];
      let elt = document.activeElement;
      if (elt?.tagName !== "BODY" && oldNode.contains(elt)) {
        while (elt) {
          activeElementAndParents.push(elt);
          if (elt === oldNode) break;
          elt = elt.parentElement;
        }
      }
      return activeElementAndParents;
    }
    function findIdElements(root) {
      let elements = Array.from(root.querySelectorAll("[id]"));
      if (root.getAttribute?.("id")) {
        elements.push(root);
      }
      return elements;
    }
    function populateIdMapWithTree(idMap, persistentIds, root, elements) {
      for (const elt of elements) {
        const id = (
          /** @type {String} */
          elt.getAttribute("id")
        );
        if (persistentIds.has(id)) {
          let current = elt;
          while (current) {
            let idSet = idMap.get(current);
            if (idSet == null) {
              idSet = /* @__PURE__ */ new Set();
              idMap.set(current, idSet);
            }
            idSet.add(id);
            if (current === root) break;
            current = current.parentElement;
          }
        }
      }
    }
    function createIdMaps(oldContent, newContent) {
      const oldIdElements = findIdElements(oldContent);
      const newIdElements = findIdElements(newContent);
      const persistentIds = createPersistentIds(oldIdElements, newIdElements);
      let idMap = /* @__PURE__ */ new Map();
      populateIdMapWithTree(idMap, persistentIds, oldContent, oldIdElements);
      const newRoot = newContent.__idiomorphRoot || newContent;
      populateIdMapWithTree(idMap, persistentIds, newRoot, newIdElements);
      return { persistentIds, idMap };
    }
    function createPersistentIds(oldIdElements, newIdElements) {
      let duplicateIds = /* @__PURE__ */ new Set();
      let oldIdTagNameMap = /* @__PURE__ */ new Map();
      for (const { id, tagName } of oldIdElements) {
        if (oldIdTagNameMap.has(id)) {
          duplicateIds.add(id);
        } else {
          oldIdTagNameMap.set(id, tagName);
        }
      }
      let persistentIds = /* @__PURE__ */ new Set();
      for (const { id, tagName } of newIdElements) {
        if (persistentIds.has(id)) {
          duplicateIds.add(id);
        } else if (oldIdTagNameMap.get(id) === tagName) {
          persistentIds.add(id);
        }
      }
      for (const id of duplicateIds) {
        persistentIds.delete(id);
      }
      return persistentIds;
    }
    return createMorphContext2;
  })();
  const { normalizeElement, normalizeParent } = /* @__PURE__ */ (function() {
    const generatedByIdiomorph = /* @__PURE__ */ new WeakSet();
    function normalizeElement2(content) {
      if (content instanceof Document) {
        return content.documentElement;
      } else {
        return content;
      }
    }
    function normalizeParent2(newContent) {
      if (newContent == null) {
        return document.createElement("div");
      } else if (typeof newContent === "string") {
        return normalizeParent2(parseContent(newContent));
      } else if (generatedByIdiomorph.has(
        /** @type {Element} */
        newContent
      )) {
        return (
          /** @type {Element} */
          newContent
        );
      } else if (newContent instanceof Node) {
        if (newContent.parentNode) {
          return (
            /** @type {any} */
            new SlicedParentNode(newContent)
          );
        } else {
          const dummyParent = document.createElement("div");
          dummyParent.append(newContent);
          return dummyParent;
        }
      } else {
        const dummyParent = document.createElement("div");
        for (const elt of [...newContent]) {
          dummyParent.append(elt);
        }
        return dummyParent;
      }
    }
    class SlicedParentNode {
      /** @param {Node} node */
      constructor(node) {
        this.originalNode = node;
        this.realParentNode = /** @type {Element} */
        node.parentNode;
        this.previousSibling = node.previousSibling;
        this.nextSibling = node.nextSibling;
      }
      /** @returns {Node[]} */
      get childNodes() {
        const nodes = [];
        let cursor = this.previousSibling ? this.previousSibling.nextSibling : this.realParentNode.firstChild;
        while (cursor && cursor != this.nextSibling) {
          nodes.push(cursor);
          cursor = cursor.nextSibling;
        }
        return nodes;
      }
      /**
       * @param {string} selector
       * @returns {Element[]}
       */
      querySelectorAll(selector) {
        return this.childNodes.reduce(
          (results, node) => {
            if (node instanceof Element) {
              if (node.matches(selector)) results.push(node);
              const nodeList = node.querySelectorAll(selector);
              for (let i = 0; i < nodeList.length; i++) {
                results.push(nodeList[i]);
              }
            }
            return results;
          },
          /** @type {Element[]} */
          []
        );
      }
      /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */
      insertBefore(node, referenceNode) {
        return this.realParentNode.insertBefore(node, referenceNode);
      }
      /**
       * @param {Node} node
       * @param {Node} referenceNode
       * @returns {Node}
       */
      moveBefore(node, referenceNode) {
        return this.realParentNode.moveBefore(node, referenceNode);
      }
      /**
       * for later use with populateIdMapWithTree to halt upwards iteration
       * @returns {Node}
       */
      get __idiomorphRoot() {
        return this.originalNode;
      }
    }
    function parseContent(newContent) {
      let parser = new DOMParser();
      let contentWithSvgsRemoved = newContent.replace(
        /<svg(\s[^>]*>|>)([\s\S]*?)<\/svg>/gim,
        ""
      );
      if (contentWithSvgsRemoved.match(/<\/html>/) || contentWithSvgsRemoved.match(/<\/head>/) || contentWithSvgsRemoved.match(/<\/body>/)) {
        let content = parser.parseFromString(newContent, "text/html");
        if (contentWithSvgsRemoved.match(/<\/html>/)) {
          generatedByIdiomorph.add(content);
          return content;
        } else {
          let htmlElement = content.firstChild;
          if (htmlElement) {
            generatedByIdiomorph.add(htmlElement);
          }
          return htmlElement;
        }
      } else {
        let responseDoc = parser.parseFromString(
          "<body><template>" + newContent + "</template></body>",
          "text/html"
        );
        let content = (
          /** @type {HTMLTemplateElement} */
          responseDoc.body.querySelector("template").content
        );
        generatedByIdiomorph.add(content);
        return content;
      }
    }
    return { normalizeElement: normalizeElement2, normalizeParent: normalizeParent2 };
  })();
  return {
    morph,
    defaults
  };
})();
const QTY_ELEMENT_NAME = "zyg-quantity-selector";
const QTY_SELECTOR_BTN = ".zyg-quantity-selector__btn";
const QTY_SELECTOR_INPUT = ".zyg-quantity-selector__input";
const QTY_SELECTOR_VALUE = ".zyg-quantity-selector__value";
const DRAWER_ELEMENT_NAME = "zyg-cart-drawer";
const DRAWER_SELECTOR_DIALOG = "dialog";
const ITEMS_ELEMENT_NAME = "zyg-cart-items";
const ITEMS_SELECTOR_CART_ITEM = ".zyg-cart-item";
const THEME_EVENT_CART_UPDATE = "cart:update";
const ATTR_AUTO_OPEN = "auto-open";
const ATTR_SECTION_ID = "data-section-id";
const CLASS_HIDDEN = "hidden";
const CLASS_EMPTY = "zyg-cart-drawer--empty";
const SELECTOR_INNER = ".zyg-cart-drawer__inner";
const SELECTOR_ITEM_COUNT = ".zyg-cart-drawer__item-count";
const TAG_TEMPLATE = "template";
const MORPH_STYLE_INNER_HTML = "innerHTML";
const METHOD_SHOW_MODAL = "showModal";
const METHOD_CLOSE = "close";
const ATTR_OPEN = "open";
const ATTR_STYLE = "style";
const ATTR_CLASS = "class";
const STYLE_OVERFLOW = "overflow";
const STYLE_HIDDEN = "hidden";
const ID_PREFIX_PROGRESS_MARKER = "progress-marker-";
const ID_PROGRESS_MESSAGE_AFTER = "progress-message-after";
const ID_PROGRESS_MESSAGE_BEFORE = "progress-message-before";
const LOG_PREFIX = "[zyg-cart-drawer]";
const LOG_REFRESH_FAILED = `${LOG_PREFIX} Failed to refresh cart:`;
const LOG_INNER_NOT_FOUND = `${LOG_PREFIX} Cart drawer inner elements not found, skipping refresh`;
const LOG_OPEN_FAILED = `${LOG_PREFIX} Failed to refresh cart on drawer open:`;
const DEBOUNCE_REFRESH_MS = 300;
const STABILITY_MAX_WAIT_MS = 1e3;
const STABILITY_POLL_MS = 50;
const RENDER_DELAY_MS = 50;
const OPEN_REFRESH_DELAY_MS = 100;
const EMPTY_TRACKING_DATA = "{}";
const DEFAULT_COUNT = 0;
const parseItemCount = (element) => parseInt(element?.textContent || String(DEFAULT_COUNT), RADIX_DECIMAL);
class ZygCartDrawer extends HTMLElement {
  #dialog = null;
  #itemCount = null;
  #refreshDebounceTimer = null;
  connectedCallback() {
    this.#setupRefs();
    this.#setupEventListeners();
  }
  disconnectedCallback() {
    document.removeEventListener(DOM_EVENT$1.ADD, this.#onCartAdd);
    document.removeEventListener(THEME_EVENT_CART_UPDATE, this.#onCartAdd);
    document.removeEventListener(DOM_EVENT$1.STATE_CHANGE, this.#onCartStateChange);
    if (!this.#refreshDebounceTimer) {
      return;
    }
    clearTimeout(this.#refreshDebounceTimer);
  }
  #setupRefs() {
    this.#dialog = this.querySelector(DRAWER_SELECTOR_DIALOG);
    this.#itemCount = this.querySelector(SELECTOR_ITEM_COUNT);
  }
  #setupEventListeners() {
    document.addEventListener(DOM_EVENT$1.ADD, this.#onCartAdd);
    document.addEventListener(THEME_EVENT_CART_UPDATE, this.#onCartAdd);
    document.addEventListener(DOM_EVENT$1.STATE_CHANGE, this.#onCartStateChange);
  }
  #withDialog(nativeMethod, fallback) {
    if (!this.#dialog) {
      return;
    }
    if (typeof this.#dialog[nativeMethod] === "function") {
      this.#dialog[nativeMethod]();
    } else {
      fallback(this.#dialog);
    }
  }
  showDialog() {
    this.#withDialog(METHOD_SHOW_MODAL, (dialog) => dialog.setAttribute(ATTR_OPEN, ""));
    document.body.style.setProperty(STYLE_OVERFLOW, STYLE_HIDDEN);
  }
  closeDialog() {
    this.#withDialog(METHOD_CLOSE, (dialog) => dialog.removeAttribute(ATTR_OPEN));
    document.body.style.removeProperty(STYLE_OVERFLOW);
  }
  async #waitForCartStability(startTime = Date.now()) {
    if (Date.now() - startTime >= STABILITY_MAX_WAIT_MS) {
      return;
    }
    if (!window.cart?.isLoading) {
      await new Promise((resolve) => setTimeout(resolve, STABILITY_POLL_MS));
      if (!window.cart?.isLoading) {
        return;
      }
    }
    await new Promise((resolve) => setTimeout(resolve, STABILITY_POLL_MS));
    return this.#waitForCartStability(startTime);
  }
  #onCartStateChange = (event) => {
    const detail = event.detail;
    this.#updateItemCount(detail?.cart?.item_count ?? DEFAULT_COUNT);
    this.#debouncedRefresh();
  };
  #debouncedRefresh() {
    if (this.#refreshDebounceTimer) {
      clearTimeout(this.#refreshDebounceTimer);
    }
    this.#refreshDebounceTimer = window.setTimeout(() => {
      void this.#refreshContent();
      this.#refreshDebounceTimer = null;
    }, DEBOUNCE_REFRESH_MS);
  }
  #updateItemCount(count) {
    if (this.#itemCount) {
      this.#itemCount.textContent = String(count);
      this.#itemCount.classList.toggle(CLASS_HIDDEN, count === 0);
    }
    this.#dialog?.classList.toggle(CLASS_EMPTY, count === 0);
  }
  #onCartAdd = async (event) => {
    const detail = event.detail;
    if (detail?.data?.source !== EVENT_SOURCE.PRODUCT_FORM) {
      return;
    }
    if (detail.data.skipDrawer) {
      return;
    }
    if (!this.hasAttribute(ATTR_AUTO_OPEN)) {
      return;
    }
    await this.#waitForCartStability();
    if (this.#refreshDebounceTimer) {
      clearTimeout(this.#refreshDebounceTimer);
      this.#refreshDebounceTimer = null;
    }
    await this.#refreshContent();
    await new Promise((resolve) => setTimeout(resolve, RENDER_DELAY_MS));
    this.showDialog();
  };
  #refreshContent() {
    const sectionId = this.getAttribute(ATTR_SECTION_ID);
    if (!sectionId) {
      return;
    }
    fetch(buildSectionUrl(sectionId)).then((response) => response.json()).then((sections) => this.#applySectionUpdate(sections, sectionId)).catch((error) => {
      console.error(LOG_REFRESH_FAILED, error);
      return error;
    });
  }
  #applySectionUpdate(sections, sectionId) {
    const html = sections[sectionId];
    if (!html) {
      return;
    }
    const template = document.createElement(TAG_TEMPLATE);
    template.innerHTML = html;
    const newDialog = template.content.querySelector(DRAWER_SELECTOR_DIALOG);
    if (this.#dialog && newDialog) {
      Array.from(newDialog.attributes).forEach((attr) => {
        if (attr.name !== ATTR_OPEN && attr.name !== ATTR_STYLE) {
          this.#dialog?.setAttribute(attr.name, attr.value);
        }
      });
    }
    const currentInner = this.querySelector(SELECTOR_INNER);
    const newInner = template.content.querySelector(SELECTOR_INNER);
    if (!currentInner || !newInner) {
      console.error(LOG_INNER_NOT_FOUND);
      return;
    }
    Idiomorph.morph(currentInner, newInner, {
      morphStyle: MORPH_STYLE_INNER_HTML,
      ignoreActiveValue: true,
      callbacks: {
        beforeAttributeUpdated: (attrName, element) => {
          if (attrName === ATTR_CLASS && element.id?.startsWith(ID_PREFIX_PROGRESS_MARKER)) {
            return false;
          }
          return true;
        },
        beforeNodeMorphed: (oldNode, newNode) => {
          if (!(oldNode instanceof HTMLElement && newNode instanceof HTMLElement)) {
            return true;
          }
          if (oldNode.id === ID_PROGRESS_MESSAGE_AFTER && oldNode.innerHTML) {
            newNode.innerHTML = oldNode.innerHTML;
          }
          if (oldNode.id === ID_PROGRESS_MESSAGE_BEFORE && oldNode.innerHTML) {
            newNode.innerHTML = oldNode.innerHTML;
          }
          return true;
        }
      }
    });
    this.#setupRefs();
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT$1.PROGRESS_CONTENT_REFRESHED, { bubbles: true })
    );
    const newCountEl = template.content.querySelector(SELECTOR_ITEM_COUNT);
    if (!newCountEl) {
      return;
    }
    this.#updateItemCount(parseItemCount(newCountEl));
  }
  async open() {
    try {
      await this.#waitForCartStability();
      await Promise.all([
        window.cart?.refresh().catch((error) => {
          console.error(LOG_OPEN_FAILED, error);
          return error;
        }),
        this.#refreshContent()
      ]);
      await new Promise((resolve) => setTimeout(resolve, OPEN_REFRESH_DELAY_MS));
    } catch (error) {
      console.error(LOG_OPEN_FAILED, error);
      return error instanceof Error ? error : new Error(String(error));
    }
    this.showDialog();
    window.safeTrackEvent?.(
      ANALYTICS_CATEGORY$2,
      ANALYTICS_ACTION$1.DRAWER_OPEN,
      EMPTY_TRACKING_DATA
    );
  }
  close() {
    this.closeDialog();
    window.safeTrackEvent?.(
      ANALYTICS_CATEGORY$2,
      ANALYTICS_ACTION$1.DRAWER_CLOSE,
      EMPTY_TRACKING_DATA
    );
  }
}
if (!customElements.get(DRAWER_ELEMENT_NAME)) {
  customElements.define(DRAWER_ELEMENT_NAME, ZygCartDrawer);
}
const ANALYTICS_CATEGORY$1 = "cart";
const CLASS_LOADING$1 = "zyg-cart-item--loading";
const parseLineNumberFromElement = (element) => {
  const value = getAttributeFromElement(element, ATTR_LINE);
  return value ? parseInt(value, RADIX_DECIMAL) : DEFAULT_LINE;
};
const getItemKeyFromElement = (element) => getAttributeFromElement(element, ATTR_KEY);
const TrackableElement$1 = Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY$1,
  errorPrefix: "cart"
});
const ActionableElement$1 = Actionable(TrackableElement$1, {
  keyAttr: ATTR_KEY,
  loadingClass: CLASS_LOADING$1,
  errorPrefix: "cart"
});
class BaseCartComponent extends ActionableElement$1 {
  /** Gets line number from this element */
  get lineNumber() {
    return parseLineNumberFromElement(this);
  }
  /** Gets line number from element with matching key (for event payloads) */
  getLineByKey(key) {
    return parseLineNumberFromElement(this.querySelector(`[${ATTR_KEY}="${key}"]`));
  }
}
const ELEMENT_NAME$8 = "zyg-cart-frequency";
const SELECTOR_SELECT = ".zyg-cart-frequency__select";
class ZygCartFrequency extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CHANGE, this.#handleChange);
    this.#initializePreviousValue();
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CHANGE, this.#handleChange);
  }
  #initializePreviousValue() {
    const select = this.querySelector(SELECTOR_SELECT);
    if (!select || select.dataset.previousValue) {
      return;
    }
    select.dataset.previousValue = select.value;
  }
  #handleChange = (event) => {
    const changedElement = event.target;
    if (!changedElement.matches(SELECTOR_SELECT)) {
      return;
    }
    const key = getItemKeyFromElement(changedElement);
    if (!key) {
      return;
    }
    this.#updateFrequency(key, changedElement.value);
  };
  async #updateFrequency(key, newFrequency) {
    const line = this.getLineByKey(key);
    const select = this.querySelector(SELECTOR_SELECT);
    const previousFrequency = select?.dataset.previousValue;
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.FREQUENCY_CHANGE,
        detail: {
          line,
          key,
          frequency: newFrequency,
          action: CART_ITEM_ACTION.ChangeFrequency
        }
      },
      analytics: {
        action: ANALYTICS_ACTION$1.FREQUENCY_CHANGE,
        payload: { line, key, frequency: newFrequency, previousFrequency }
      },
      apiCall: () => window.cart?.updateProperties(key, {
        [CART_PROPERTY.DELIVERY_FREQUENCY]: newFrequency
      }),
      errorMessage: ERROR_MESSAGE.UPDATE_FREQUENCY,
      optimisticUpdate: () => {
        if (!select) {
          return;
        }
        select.dataset.previousValue = newFrequency;
      },
      revertOnFailure: select && previousFrequency ? () => {
        select.value = previousFrequency;
        select.dataset.previousValue = previousFrequency;
      } : void 0
    });
  }
}
if (!customElements.get(ELEMENT_NAME$8)) {
  customElements.define(ELEMENT_NAME$8, ZygCartFrequency);
}
const ELEMENT_NAME$7 = "zyg-cart-gift";
const SELECTOR_CHECKBOX$1 = ".zyg-cart-gift__checkbox";
const SELECTOR_MESSAGE_FIELD = ".zyg-cart-gift__message-field";
const SELECTOR_MESSAGE_INPUT = ".zyg-cart-gift__message-input";
const SELECTOR_SAVE$1 = ".zyg-cart-gift__save";
class ZygCartGift extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CHANGE, this.#handleChange);
    this.addEventListener(EVENT_CLICK, this.#handleClick);
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CHANGE, this.#handleChange);
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
  }
  #handleChange = (event) => {
    const changedElement = event.target;
    if (!changedElement.matches(SELECTOR_CHECKBOX$1)) {
      return;
    }
    const key = getItemKeyFromElement(changedElement);
    if (!key) {
      return;
    }
    this.#toggleGiftOption(key, changedElement.checked, changedElement);
  };
  #handleClick = (event) => {
    const clickedElement = event.target;
    const action = clickedElement.closest(SELECTOR_DATA_ACTION)?.getAttribute(ATTR_ACTION);
    if (action !== CART_ITEM_ACTION.SaveGiftMessage) {
      return;
    }
    const saveButton = clickedElement.closest(SELECTOR_SAVE$1);
    if (!saveButton) {
      return;
    }
    event.preventDefault();
    const key = getItemKeyFromElement(clickedElement);
    if (!key) {
      return;
    }
    this.#saveGiftMessage(key);
  };
  async #toggleGiftOption(key, isGiftEnabled, checkbox) {
    const line = this.getLineByKey(key);
    const messageField = this.querySelector(SELECTOR_MESSAGE_FIELD);
    const setMessageFieldVisible = (visible) => {
      if (!messageField) {
        return;
      }
      messageField.hidden = !visible;
      if (visible) {
        focusFirstInputInContainer(messageField, SELECTOR_MESSAGE_INPUT);
      }
    };
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.GIFT_CHANGE,
        detail: { line, key, isGift: isGiftEnabled, action: CART_ITEM_ACTION.ToggleGift }
      },
      analytics: {
        action: isGiftEnabled ? ANALYTICS_ACTION$1.GIFT_ON : ANALYTICS_ACTION$1.GIFT_OFF,
        payload: { line, key }
      },
      apiCall: () => window.cart?.updateProperties(key, {
        [CART_PROPERTY.GIFT]: boolToString(isGiftEnabled)
      }),
      errorMessage: ERROR_MESSAGE.UPDATE_GIFT,
      optimisticUpdate: () => setMessageFieldVisible(isGiftEnabled),
      revertOnFailure: () => {
        checkbox.checked = !isGiftEnabled;
        setMessageFieldVisible(!isGiftEnabled);
      }
    });
  }
  async #saveGiftMessage(key) {
    const textarea = this.querySelector(SELECTOR_MESSAGE_INPUT);
    if (!textarea) {
      return;
    }
    const messageContent = textarea.value.trim();
    const line = this.getLineByKey(key);
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.GIFT_CHANGE,
        detail: {
          line,
          key,
          giftMessage: messageContent,
          action: CART_ITEM_ACTION.SaveGiftMessage
        }
      },
      analytics: {
        action: ANALYTICS_ACTION$1.GIFT_MESSAGE_SAVE,
        payload: {
          line,
          key,
          hasMessage: messageContent.length > 0,
          giftMessage: messageContent,
          messageLength: messageContent.length
        }
      },
      apiCall: () => window.cart?.updateProperties(key, {
        [CART_PROPERTY.GIFT_MESSAGE]: messageContent
      }),
      errorMessage: ERROR_MESSAGE.UPDATE_GIFT
    });
  }
}
if (!customElements.get(ELEMENT_NAME$7)) {
  customElements.define(ELEMENT_NAME$7, ZygCartGift);
}
const ELEMENT_NAME$6 = "zyg-cart-notes";
const SELECTOR_TOGGLE = ".zyg-cart-notes__toggle";
const SELECTOR_FIELD = ".zyg-cart-notes__field";
const SELECTOR_INPUT = ".zyg-cart-notes__input";
const SELECTOR_SAVE = ".zyg-cart-notes__save";
const CLASS_HAS_NOTE = "zyg-cart-notes__toggle--has-note";
class ZygCartNotes extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
  }
  #handleClick = (event) => {
    const clickedElement = event.target;
    const action = clickedElement.closest(SELECTOR_DATA_ACTION)?.getAttribute(ATTR_ACTION);
    const key = getItemKeyFromElement(clickedElement);
    if (!key) {
      return;
    }
    if (action === CART_ITEM_ACTION.ToggleNotes) {
      const toggleButton = clickedElement.closest(
        SELECTOR_TOGGLE
      );
      if (!toggleButton) {
        return;
      }
      event.preventDefault();
      this.#toggleVisibility(key, toggleButton);
      return;
    }
    if (action !== CART_ITEM_ACTION.SaveNote) {
      return;
    }
    const saveButton = clickedElement.closest(SELECTOR_SAVE);
    if (!saveButton) {
      return;
    }
    event.preventDefault();
    this.#saveNote(key);
  };
  #toggleVisibility(key, toggleButton) {
    const fieldElement = this.querySelector(SELECTOR_FIELD);
    if (!fieldElement) {
      return;
    }
    const line = this.getLineByKey(key);
    const isCurrentlyExpanded = toggleButton.getAttribute(ATTR_ARIA_EXPANDED) === PROP_VALUE_TRUE;
    toggleButton.setAttribute(ATTR_ARIA_EXPANDED, boolToString(!isCurrentlyExpanded));
    fieldElement.hidden = isCurrentlyExpanded;
    this.track(
      isCurrentlyExpanded ? ANALYTICS_ACTION$1.NOTES_CLOSE : ANALYTICS_ACTION$1.NOTES_OPEN,
      {
        line,
        key
      }
    );
    if (!isCurrentlyExpanded) {
      focusFirstInputInContainer(fieldElement, SELECTOR_INPUT);
    }
  }
  async #saveNote(key) {
    const textarea = this.querySelector(SELECTOR_INPUT);
    if (!textarea) {
      return;
    }
    const noteContent = textarea.value.trim();
    const line = this.getLineByKey(key);
    const toggleButton = this.querySelector(SELECTOR_TOGGLE);
    const success = await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.NOTE_CHANGE,
        detail: { line, key, note: noteContent, action: CART_ITEM_ACTION.SaveNote }
      },
      analytics: {
        action: ANALYTICS_ACTION$1.NOTES_SAVE,
        payload: {
          line,
          key,
          hasNote: noteContent.length > 0,
          note: noteContent,
          noteLength: noteContent.length
        }
      },
      apiCall: () => window.cart?.updateProperties(key, { [CART_PROPERTY.NOTE]: noteContent }),
      errorMessage: ERROR_MESSAGE.UPDATE_NOTE
    });
    if (!success) {
      return;
    }
    if (!toggleButton) {
      return;
    }
    toggleButton.classList.toggle(CLASS_HAS_NOTE, noteContent.length > 0);
    textarea.closest(SELECTOR_FIELD).hidden = true;
    toggleButton.setAttribute(ATTR_ARIA_EXPANDED, PROP_VALUE_FALSE);
  }
}
if (!customElements.get(ELEMENT_NAME$6)) {
  customElements.define(ELEMENT_NAME$6, ZygCartNotes);
}
const ELEMENT_NAME$5 = "zyg-cart-subscription";
const SELECTOR_TOGGLE_BTN = ".zyg-cart-subscription__toggle-btn";
const SELECTOR_TOGGLE_CONTAINER = ".zyg-cart-subscription__toggle";
const SELECTOR_SWITCH = ".zyg-cart-subscription__switch";
const CLASS_TOGGLE_ACTIVE = "zyg-cart-subscription__toggle-btn--active";
const CLASS_SWITCH_ACTIVE = "zyg-cart-subscription__switch--active";
const ATTR_VARIANT_ID$1 = "data-variant-id";
const ATTR_SELLING_PLAN_ID = "data-selling-plan-id";
const ATTR_SELLING_PLAN$1 = "data-selling-plan";
const SELECTOR_CART_ITEM = ".zyg-cart-item";
class ZygCartSubscription extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
  }
  #handleClick = (event) => {
    const clickedElement = event.target;
    const key = getItemKeyFromElement(clickedElement);
    if (!key) {
      return;
    }
    const toggleButton = clickedElement.closest(
      SELECTOR_TOGGLE_BTN
    );
    if (toggleButton) {
      event.preventDefault();
      const action = clickedElement.closest(SELECTOR_DATA_ACTION)?.getAttribute(ATTR_ACTION);
      if (action !== CART_ITEM_ACTION.SetOtp && action !== CART_ITEM_ACTION.SetSubscription) {
        return;
      }
      this.#handleButtonToggle(
        key,
        action === CART_ITEM_ACTION.SetSubscription,
        toggleButton
      );
      return;
    }
    const switchButton = clickedElement.closest(SELECTOR_SWITCH);
    if (!switchButton) {
      return;
    }
    event.preventDefault();
    const isCurrentlySubscribed = switchButton.classList.contains(CLASS_SWITCH_ACTIVE);
    this.#handleSwitchToggle(key, !isCurrentlySubscribed, switchButton);
  };
  async #handleButtonToggle(key, isSubscriptionEnabled, clickedButton) {
    const toggleContainer = clickedButton.closest(SELECTOR_TOGGLE_CONTAINER);
    const previousActiveButton = toggleContainer?.querySelector(
      `.${CLASS_TOGGLE_ACTIVE}`
    );
    const setToggleActive = (activeButton) => {
      toggleContainer?.querySelectorAll(SELECTOR_TOGGLE_BTN).forEach((button) => {
        button.classList.remove(CLASS_TOGGLE_ACTIVE);
        button.setAttribute(ATTR_ARIA_PRESSED, PROP_VALUE_FALSE);
      });
      activeButton.classList.add(CLASS_TOGGLE_ACTIVE);
      activeButton.setAttribute(ATTR_ARIA_PRESSED, PROP_VALUE_TRUE);
    };
    await this.#updateSubscription(key, isSubscriptionEnabled, {
      optimisticUpdate: () => setToggleActive(clickedButton),
      revertOnFailure: previousActiveButton ? () => setToggleActive(previousActiveButton) : void 0
    });
  }
  async #handleSwitchToggle(key, isSubscriptionEnabled, switchButton) {
    const setSwitchState = (enabled) => {
      switchButton.classList.toggle(CLASS_SWITCH_ACTIVE, enabled);
      switchButton.setAttribute(ATTR_ARIA_PRESSED, boolToString(enabled));
    };
    await this.#updateSubscription(key, isSubscriptionEnabled, {
      optimisticUpdate: () => setSwitchState(isSubscriptionEnabled),
      revertOnFailure: () => setSwitchState(!isSubscriptionEnabled)
    });
  }
  async #updateSubscription(key, isSubscriptionEnabled, uiCallbacks) {
    const line = this.getLineByKey(key);
    const action = isSubscriptionEnabled ? CART_ITEM_ACTION.SetSubscription : CART_ITEM_ACTION.SetOtp;
    const { variantId, sellingPlanId } = this.#getSubscriptionData();
    const canSwitch = variantId && (sellingPlanId || !isSubscriptionEnabled);
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.SUBSCRIPTION_CHANGE,
        detail: { line, key, isSubscription: isSubscriptionEnabled, action }
      },
      analytics: {
        action: isSubscriptionEnabled ? ANALYTICS_ACTION$1.SUBSCRIPTION_ON : ANALYTICS_ACTION$1.SUBSCRIPTION_OFF,
        payload: { line, key }
      },
      apiCall: () => {
        if (canSwitch) {
          return window.cart?.switchSubscription(
            key,
            variantId,
            isSubscriptionEnabled && sellingPlanId ? sellingPlanId : void 0
          );
        }
        console.warn(
          "[zyg-cart-subscription] Missing variant or selling plan data, subscription toggle may not work correctly"
        );
        return window.cart?.updateProperties(key, {
          [CART_PROPERTY.SUBSCRIPTION]: boolToString(isSubscriptionEnabled)
        });
      },
      errorMessage: ERROR_MESSAGE.UPDATE_SUBSCRIPTION,
      ...uiCallbacks
    });
  }
  #getSubscriptionData() {
    let variantId = this.getAttribute(ATTR_VARIANT_ID$1);
    let sellingPlanId = this.getAttribute(ATTR_SELLING_PLAN_ID) || this.getAttribute(ATTR_SELLING_PLAN$1);
    if (!variantId || !sellingPlanId) {
      const cartItem = this.closest(SELECTOR_CART_ITEM);
      if (cartItem) {
        variantId = variantId || cartItem.getAttribute(ATTR_VARIANT_ID$1);
        sellingPlanId = sellingPlanId || cartItem.getAttribute(ATTR_SELLING_PLAN_ID) || cartItem.getAttribute(ATTR_SELLING_PLAN$1);
      }
    }
    return { variantId, sellingPlanId };
  }
}
if (!customElements.get(ELEMENT_NAME$5)) {
  customElements.define(ELEMENT_NAME$5, ZygCartSubscription);
}
class ZygQuantitySelector extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
    this.addEventListener(EVENT_CHANGE, this.#handleChange);
    this.#initializePreviousValues();
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
    this.removeEventListener(EVENT_CHANGE, this.#handleChange);
  }
  #initializePreviousValues() {
    this.querySelectorAll(QTY_SELECTOR_INPUT).forEach((input) => {
      if (!input.dataset.previousValue) {
        input.dataset.previousValue = input.value;
      }
    });
  }
  #handleClick = (event) => {
    const target = event.target;
    if (!target.closest(QTY_SELECTOR_BTN)) {
      return;
    }
    event.preventDefault();
    const key = getItemKeyFromElement(target);
    if (!key) {
      return;
    }
    const action = target.closest(SELECTOR_DATA_ACTION)?.getAttribute(ATTR_ACTION);
    if (action === CART_ITEM_ACTION.Increase) {
      this.#adjustQuantityByDelta(key, 1);
    } else if (action === CART_ITEM_ACTION.Decrease) {
      this.#adjustQuantityByDelta(key, -1);
    }
  };
  #handleChange = async (event) => {
    const target = event.target;
    if (!target.matches(QTY_SELECTOR_INPUT)) {
      return;
    }
    const key = getItemKeyFromElement(target);
    if (!key) {
      return;
    }
    const newQuantity = Math.max(0, parseIntOrZero(target.value));
    if (newQuantity === 0) {
      this.#removeItem(key);
      return;
    }
    await this.#updateQuantity(key, newQuantity, parseIntOrZero(target.dataset.previousValue));
  };
  async #adjustQuantityByDelta(key, delta) {
    const currentQuantity = this.#getCurrentQuantity(key);
    if (!isDefined(currentQuantity)) {
      return;
    }
    const newQuantity = Math.max(0, currentQuantity + delta);
    if (newQuantity === 0) {
      this.#removeItem(key);
      return;
    }
    await this.#updateQuantity(key, newQuantity, currentQuantity);
  }
  #getElementByKeyAndSelector(key, selector) {
    return this.querySelector(`${selector}[${ATTR_KEY}="${key}"]`) ?? this.querySelector(`[${ATTR_KEY}="${key}"] ${selector}`);
  }
  #getQuantityInput(key) {
    return this.#getElementByKeyAndSelector(key, QTY_SELECTOR_INPUT);
  }
  #getQuantityValue(key) {
    return this.#getElementByKeyAndSelector(key, QTY_SELECTOR_VALUE);
  }
  #getCurrentQuantity(key) {
    const quantityInput = this.#getQuantityInput(key);
    if (quantityInput) {
      return parseIntOrZero(quantityInput.value);
    }
    const quantityValue = this.#getQuantityValue(key);
    if (quantityValue) {
      return parseIntOrZero(quantityValue.textContent ?? "");
    }
    return null;
  }
  #setQuantityDisplayValue(key, quantity) {
    const quantityInput = this.#getQuantityInput(key);
    if (quantityInput) {
      quantityInput.value = String(quantity);
    }
    const quantityValue = this.#getQuantityValue(key);
    if (quantityValue) {
      quantityValue.textContent = String(quantity);
    }
  }
  #getQuantityTrackingEventName(newQty, prevQty, isIncrease) {
    if (newQty !== prevQty + 1 && newQty !== prevQty - 1) {
      return ANALYTICS_ACTION$1.QUANTITY_UPDATE;
    }
    return isIncrease ? ANALYTICS_ACTION$1.QUANTITY_INCREASE : ANALYTICS_ACTION$1.QUANTITY_DECREASE;
  }
  async #updateQuantity(key, newQuantity, previousQuantity) {
    const isIncrease = newQuantity > (previousQuantity ?? 0);
    const quantityInput = this.#getQuantityInput(key);
    return this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.QUANTITY_CHANGE,
        detail: {
          line: this.getLineByKey(key),
          key,
          quantity: newQuantity,
          previousQuantity,
          action: isIncrease ? CART_ITEM_ACTION.Increase : CART_ITEM_ACTION.Decrease
        }
      },
      analytics: {
        action: this.#getQuantityTrackingEventName(
          newQuantity,
          previousQuantity ?? 0,
          isIncrease
        ),
        payload: {
          line: this.getLineByKey(key),
          key,
          quantity: newQuantity,
          previousQuantity
        }
      },
      apiCall: () => window.cart?.update(key, newQuantity),
      errorMessage: ERROR_MESSAGE.UPDATE_CART,
      optimisticUpdate: () => {
        this.#setQuantityDisplayValue(key, newQuantity);
        if (quantityInput) {
          quantityInput.dataset.previousValue = String(newQuantity);
        }
      },
      revertOnFailure: isDefined(previousQuantity) ? () => {
        this.#setQuantityDisplayValue(key, previousQuantity);
        if (quantityInput) {
          quantityInput.dataset.previousValue = String(previousQuantity);
        }
      } : void 0
    });
  }
  async #removeItem(key) {
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.REMOVE,
        detail: { line: this.getLineByKey(key), key }
      },
      analytics: {
        action: ANALYTICS_ACTION$1.REMOVE,
        payload: { line: this.getLineByKey(key), key }
      },
      apiCall: () => removeWithComplementary(key),
      errorMessage: ERROR_MESSAGE.REMOVE_ITEM
    });
  }
}
if (!customElements.get(QTY_ELEMENT_NAME)) {
  customElements.define(QTY_ELEMENT_NAME, ZygQuantitySelector);
}
const SELECTOR_REMOVE_BTN = ".zyg-cart-item__remove";
const ERROR_MISSING_KEY = "[zyg-cart-items] Cart item missing data-key attribute";
const viewedItemKeys = /* @__PURE__ */ new Set();
class ZygCartItems extends BaseCartComponent {
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
    this.#trackNewlyVisibleCartItems();
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
  }
  #trackNewlyVisibleCartItems() {
    this.querySelectorAll(ITEMS_SELECTOR_CART_ITEM).forEach((cartItemElement) => {
      const key = cartItemElement.dataset.key;
      if (!key) {
        console.error(ERROR_MISSING_KEY);
        return;
      }
      if (viewedItemKeys.has(key)) {
        return;
      }
      viewedItemKeys.add(key);
      const line = parseLineNumberFromElement(cartItemElement);
      this.notify({
        eventName: DOM_EVENT$1.VIEW,
        analyticsAction: ANALYTICS_ACTION$1.VIEW,
        payload: { line, key }
      });
    });
  }
  #handleClick = (event) => {
    const clickedElement = event.target;
    if (!clickedElement.closest(SELECTOR_REMOVE_BTN)) {
      return;
    }
    event.preventDefault();
    const key = getItemKeyFromElement(clickedElement);
    if (!key) {
      return;
    }
    this.#removeItem(key);
  };
  async #removeItem(key) {
    const cartItem = this.querySelector(`${ITEMS_SELECTOR_CART_ITEM}[${ATTR_KEY}="${key}"]`) ?? null;
    const line = cartItem ? parseLineNumberFromElement(cartItem) : null;
    if (!line) {
      return;
    }
    await this.executeAction({
      itemKey: key,
      domEvent: {
        name: DOM_EVENT$1.REMOVE,
        detail: { line, key }
      },
      analytics: {
        action: ANALYTICS_ACTION$1.REMOVE,
        payload: { line, key }
      },
      apiCall: () => removeWithComplementary(key),
      errorMessage: ERROR_MESSAGE.REMOVE_ITEM
    });
  }
}
if (!customElements.get(ITEMS_ELEMENT_NAME)) {
  customElements.define(ITEMS_ELEMENT_NAME, ZygCartItems);
}
const ELEMENT_NAME$4 = "zyg-cart-summary";
const URL_CHECKOUT = "/cart/checkout";
const DATA_CHECKOUT_URL = "data-checkout-url";
const DEFAULT_ATTR_VALUE = "0";
const DEFAULT_SHIPPING_TEXT = "Calculated at checkout";
const DATA_ATTR_DEFAULT_TEXT = "data-default-text";
const CSS_FREE_SHIPPING_ROW_ACTIVE = "zyg-cart-summary__row--free-shipping-active";
const buildDiscountSavedMessage = (code) => `Code "${code}" will be applied at checkout`;
class ZygCartSummary extends BaseSummaryComponent {
  constructor() {
    super(...arguments);
    this.#notesDebounceTimer = null;
    this.#currentDiscountCode = null;
    this.checkoutHandled = false;
    this.#handlePageShow = () => {
      this.checkoutHandled = false;
      this.setLoading(false);
    };
    this.#handleClick = (event) => {
      const target = event.target;
      if (target.closest(SUMMARY_SELECTOR.CHECKOUT_BTN)) {
        this.#handleCheckout(event);
        return;
      }
      if (target.closest(SUMMARY_SELECTOR.APPLY_DISCOUNT_BTN)) {
        event.preventDefault();
        this.#handleApplyDiscount();
        return;
      }
      if (target.closest(SUMMARY_SELECTOR.REMOVE_DISCOUNT_BTN)) {
        event.preventDefault();
        this.#handleRemoveDiscount();
        return;
      }
      if (target.closest(SUMMARY_SELECTOR.CONTINUE_LINK)) {
        this.#handleContinueShopping();
      }
    };
    this.#handleChange = (event) => {
      if (event.target.matches(SUMMARY_SELECTOR.TERMS_CHECKBOX)) {
        this.#handleTermsToggle(event.target);
      }
    };
    this.#handleInput = (event) => {
      if (event.target.matches(SUMMARY_SELECTOR.CART_NOTES)) {
        this.#handleNotesInput(event.target);
      }
    };
  }
  #notesDebounceTimer;
  #currentDiscountCode;
  /** Called when element is added to DOM */
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
    this.addEventListener(EVENT_CHANGE, this.#handleChange);
    this.addEventListener(EVENT_INPUT, this.#handleInput);
    window.addEventListener("pageshow", this.#handlePageShow);
    this.#loadSavedDiscount();
    this.#emitViewEvent();
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
    this.removeEventListener(EVENT_CHANGE, this.#handleChange);
    this.removeEventListener(EVENT_INPUT, this.#handleInput);
    window.removeEventListener("pageshow", this.#handlePageShow);
    if (this.#notesDebounceTimer) {
      clearTimeout(this.#notesDebounceTimer);
    }
  }
  #handlePageShow;
  #handleClick;
  #handleChange;
  #handleInput;
  #loadSavedDiscount() {
    const savedCode = localStorage.getItem(STORAGE_DISCOUNT_CODE);
    if (!savedCode) {
      return;
    }
    this.#currentDiscountCode = savedCode;
    this.classList.add(SUMMARY_CLASS.HAS_DISCOUNT);
    this.#showDiscountSuccess(buildDiscountSavedMessage(savedCode));
  }
  #emitViewEvent() {
    const payload = this.#buildEventPayload();
    this.notify({
      eventName: SUMMARY_EVENT.VIEW,
      detail: payload,
      analyticsAction: SUMMARY_ANALYTICS.VIEW,
      analyticsPayload: {
        cart_total: payload.cartTotal,
        cart_count: payload.cartCount
      }
    });
  }
  #buildEventPayload() {
    return {
      cartTotal: parseInt(
        this.getAttribute(SUMMARY_ATTR.CART_TOTAL) || DEFAULT_ATTR_VALUE,
        RADIX_DECIMAL
      ),
      cartCount: parseInt(
        this.getAttribute(SUMMARY_ATTR.CART_COUNT) || DEFAULT_ATTR_VALUE,
        RADIX_DECIMAL
      )
    };
  }
  #handleCheckout(event) {
    event.preventDefault();
    event.stopPropagation();
    this.checkoutHandled = true;
    if (this.hasAttribute(SUMMARY_ATTR.REQUIRE_TERMS)) {
      if (!this.querySelector(SUMMARY_SELECTOR.TERMS_CHECKBOX)?.checked) {
        this.#showTermsError();
        return;
      }
    }
    this.setLoading(true);
    this.#clearTermsError();
    const payload = this.#buildEventPayload();
    this.notify({
      eventName: SUMMARY_EVENT.CHECKOUT_CLICK,
      detail: { ...payload, success: true },
      analyticsAction: SUMMARY_ANALYTICS.CHECKOUT_CLICK,
      analyticsPayload: {
        cart_total: payload.cartTotal,
        cart_count: payload.cartCount
      }
    });
    const checkoutUrl = this.getAttribute(DATA_CHECKOUT_URL) || URL_CHECKOUT;
    window.location.href = this.#currentDiscountCode ? buildDiscountRedirectUrl(this.#currentDiscountCode, checkoutUrl) : checkoutUrl;
  }
  async #handleApplyDiscount() {
    const input = this.querySelector(SUMMARY_SELECTOR.DISCOUNT_INPUT);
    const code = input?.value.trim().toUpperCase();
    if (!code) {
      this.#showDiscountError(SUMMARY_ERROR.EMPTY_DISCOUNT);
      return;
    }
    this.setLoading(true);
    this.#clearDiscountError();
    this.#clearDiscountSuccess();
    const payload = this.#buildEventPayload();
    try {
      if (await this.#validateDiscountCode(code)) {
        localStorage.setItem(STORAGE_DISCOUNT_CODE, code);
        this.#currentDiscountCode = code;
        this.classList.add(SUMMARY_CLASS.HAS_DISCOUNT);
        this.#showDiscountSuccess(SUMMARY_SUCCESS.DISCOUNT_APPLIED);
        this.notify({
          eventName: SUMMARY_EVENT.DISCOUNT_APPLY,
          detail: { ...payload, discountCode: code, success: true },
          analyticsAction: SUMMARY_ANALYTICS.DISCOUNT_APPLY,
          analyticsPayload: {
            cart_total: payload.cartTotal,
            cart_count: payload.cartCount,
            discount_code: code
          }
        });
        if (input) {
          input.value = "";
        }
      } else {
        this.#showDiscountError(SUMMARY_ERROR.INVALID_DISCOUNT);
        emitSummaryEvent(SUMMARY_EVENT.DISCOUNT_APPLY, {
          ...payload,
          discountCode: code,
          success: false,
          error: SUMMARY_ERROR.INVALID_DISCOUNT
        });
        this.track(SUMMARY_ANALYTICS.DISCOUNT_ERROR, {
          cart_total: payload.cartTotal,
          cart_count: payload.cartCount,
          discount_code: code,
          error: SUMMARY_ERROR.INVALID_DISCOUNT
        });
      }
    } catch (error) {
      this.#showDiscountError(
        error instanceof Error ? error.message : SUMMARY_ERROR.INVALID_DISCOUNT
      );
      this.track(SUMMARY_ANALYTICS.DISCOUNT_ERROR, {
        cart_total: payload.cartTotal,
        cart_count: payload.cartCount,
        discount_code: code,
        error: error instanceof Error ? error.message : SUMMARY_ERROR.INVALID_DISCOUNT
      });
    } finally {
      this.setLoading(false);
    }
  }
  async #validateDiscountCode(code) {
    return window.cart?.checkDiscountValid(code) ?? false;
  }
  #handleRemoveDiscount() {
    localStorage.removeItem(STORAGE_DISCOUNT_CODE);
    this.#currentDiscountCode = null;
    this.classList.remove(SUMMARY_CLASS.HAS_DISCOUNT);
    this.#clearDiscountError();
    this.#clearDiscountSuccess();
    emitSummaryEvent(SUMMARY_EVENT.DISCOUNT_REMOVE, this.#buildEventPayload());
  }
  #handleNotesInput(textarea) {
    if (this.#notesDebounceTimer) {
      clearTimeout(this.#notesDebounceTimer);
    }
    this.#notesDebounceTimer = setTimeout(() => {
      this.#updateCartNotes(textarea.value);
      this.#notesDebounceTimer = null;
    }, NOTES_DEBOUNCE_DELAY);
  }
  async #updateCartNotes(notes) {
    const payload = this.#buildEventPayload();
    try {
      await window.cart.updateNote(notes);
      this.notify({
        eventName: SUMMARY_EVENT.NOTES_UPDATE,
        detail: { ...payload, notes, success: true },
        analyticsAction: SUMMARY_ANALYTICS.NOTES_UPDATE,
        analyticsPayload: {
          cart_total: payload.cartTotal,
          cart_count: payload.cartCount
        }
      });
    } catch (error) {
      console.error("[zyg-cart-summary] Failed to update cart notes:", error);
    }
  }
  #handleTermsToggle(checkbox) {
    const isAccepted = checkbox.checked;
    if (isAccepted) {
      this.#clearTermsError();
    }
    const payload = this.#buildEventPayload();
    this.notify({
      eventName: SUMMARY_EVENT.TERMS_TOGGLE,
      detail: { ...payload, termsAccepted: isAccepted },
      analyticsAction: SUMMARY_ANALYTICS.TERMS_TOGGLE,
      analyticsPayload: {
        cart_total: payload.cartTotal,
        cart_count: payload.cartCount
      }
    });
  }
  #handleContinueShopping() {
    const payload = this.#buildEventPayload();
    this.notify({
      eventName: SUMMARY_EVENT.CONTINUE_SHOPPING,
      detail: payload,
      analyticsAction: SUMMARY_ANALYTICS.CONTINUE_SHOPPING,
      analyticsPayload: {
        cart_total: payload.cartTotal,
        cart_count: payload.cartCount
      }
    });
  }
  #showDiscountError(message) {
    this.classList.add(SUMMARY_CLASS.DISCOUNT_ERROR);
    this.classList.remove(SUMMARY_CLASS.DISCOUNT_SUCCESS);
    this.#setElementText(SUMMARY_SELECTOR.DISCOUNT_ERROR, message);
  }
  #clearDiscountError() {
    this.classList.remove(SUMMARY_CLASS.DISCOUNT_ERROR);
    this.#setElementText(SUMMARY_SELECTOR.DISCOUNT_ERROR, "");
  }
  #showDiscountSuccess(message) {
    this.classList.add(SUMMARY_CLASS.DISCOUNT_SUCCESS);
    this.classList.remove(SUMMARY_CLASS.DISCOUNT_ERROR);
    this.#setElementText(SUMMARY_SELECTOR.DISCOUNT_SUCCESS, message);
  }
  #clearDiscountSuccess() {
    this.classList.remove(SUMMARY_CLASS.DISCOUNT_SUCCESS);
    this.#setElementText(SUMMARY_SELECTOR.DISCOUNT_SUCCESS, "");
  }
  #showTermsError() {
    this.classList.add(SUMMARY_CLASS.TERMS_ERROR);
    this.#setElementText(SUMMARY_SELECTOR.TERMS_ERROR, SUMMARY_ERROR.TERMS_REQUIRED);
    this.querySelector(SUMMARY_SELECTOR.TERMS_CHECKBOX)?.focus();
  }
  #clearTermsError() {
    this.classList.remove(SUMMARY_CLASS.TERMS_ERROR);
    this.#setElementText(SUMMARY_SELECTOR.TERMS_ERROR, "");
  }
  #setElementText(selector, text) {
    const el = this.querySelector(selector);
    if (el) {
      el.textContent = text;
    }
  }
  /** Updates subtotal and total display values */
  updateTotals(subtotal, total) {
    this.#setElementText(SUMMARY_SELECTOR.SUBTOTAL, subtotal);
    this.#setElementText(SUMMARY_SELECTOR.TOTAL, total);
  }
  /** Returns the currently saved discount code */
  getDiscountCode() {
    return this.#currentDiscountCode;
  }
  /** Sets free shipping state (called by zyg-cart-logic) */
  setFreeShipping(enabled) {
    const shippingValue = this.querySelector(SUMMARY_SELECTOR.SHIPPING_VALUE);
    this.classList.toggle(SUMMARY_CLASS.FREE_SHIPPING, enabled);
    this.querySelector(SUMMARY_SELECTOR.SHIPPING_ROW)?.classList.toggle(
      CSS_FREE_SHIPPING_ROW_ACTIVE,
      enabled
    );
    if (shippingValue) {
      shippingValue.textContent = enabled ? SUMMARY_SUCCESS.FREE_SHIPPING : shippingValue.getAttribute(DATA_ATTR_DEFAULT_TEXT) || DEFAULT_SHIPPING_TEXT;
    }
  }
}
if (!customElements.get(ELEMENT_NAME$4)) {
  customElements.define(ELEMENT_NAME$4, ZygCartSummary);
}
const calculateDiscount = (price, compareAtPrice) => {
  if (!compareAtPrice || compareAtPrice <= price) {
    return 0;
  }
  return Math.ceil((compareAtPrice - price) / compareAtPrice * PERCENTAGE_MULTIPLIER);
};
const calculateProgress = (current, target) => {
  if (target <= 0) {
    return 100;
  }
  return Math.min(Math.max(current / target * 100, 0), 100);
};
const ELEMENT_NAME$3 = "zyg-progress-bar";
const MESSAGE_AFTER_ITEM_CLASS = "zyg-progress-bar__message-after-item";
const PROGRESS_UPDATE_DEBOUNCE_MS = 200;
const ERROR_CART_NOT_FOUND = "Cart not found in cart state change event";
const REWARD_PROPERTY_KEY = "_zyg_free";
class ZygProgressBar extends BaseProgressBarComponent {
  #config = null;
  #reachedMilestones = /* @__PURE__ */ new Set();
  #conditionReachedMilestones = /* @__PURE__ */ new Set();
  #cartLogicControlledMilestones = /* @__PURE__ */ new Set();
  #celebrationTimer = null;
  #updateDebounceTimer = null;
  #hasSubscription = false;
  #lastCartTotal = 0;
  #lastItemCount = 0;
  /** Called when element is added to DOM */
  connectedCallback() {
    this.#parseConfig();
    this.#initializeReachedState();
    this.#hasSubscription = this.#config?.hasSubscription ?? false;
    document.addEventListener(DOM_EVENT$1.STATE_CHANGE, this.#handleCartStateChange);
    document.addEventListener(DOM_EVENT$1.PROGRESS_MARKER_UPDATE, this.#handleMarkerUpdate);
    document.addEventListener(
      DOM_EVENT$1.PROGRESS_CONTENT_REFRESHED,
      this.#handleContentRefreshed
    );
    this.#emitViewEvent();
    this.#fetchAndUpdateCart();
  }
  async #fetchAndUpdateCart() {
    try {
      const cart2 = await window.cart?.fetch();
      if (!cart2) {
        return;
      }
      this.#hasSubscription = cart2.items?.some((item) => item.selling_plan_allocation) ?? false;
      this.#lastItemCount = this.#getNonRewardItemCount(cart2.items ?? []);
      this.#updateProgress(cart2.items_subtotal_price ?? cart2.total_price);
    } catch (error) {
      console.error("[zyg-progress-bar] Failed to fetch cart:", error);
    }
  }
  #isRewardItem(item) {
    return isDefined(item.properties?.[REWARD_PROPERTY_KEY]);
  }
  #getNonRewardItemCount(items) {
    return items.filter((item) => !this.#isRewardItem(item)).reduce((sum, item) => sum + (item.quantity ?? 1), 0);
  }
  /** Called when element is removed from DOM */
  disconnectedCallback() {
    document.removeEventListener(DOM_EVENT$1.STATE_CHANGE, this.#handleCartStateChange);
    document.removeEventListener(DOM_EVENT$1.PROGRESS_MARKER_UPDATE, this.#handleMarkerUpdate);
    document.removeEventListener(
      DOM_EVENT$1.PROGRESS_CONTENT_REFRESHED,
      this.#handleContentRefreshed
    );
    if (this.#celebrationTimer) {
      clearTimeout(this.#celebrationTimer);
    }
    if (this.#updateDebounceTimer) {
      clearTimeout(this.#updateDebounceTimer);
    }
  }
  #parseConfig() {
    const scriptContent = this.querySelector(
      PROGRESS_SELECTOR.CONFIG
    )?.textContent;
    if (!scriptContent) {
      return;
    }
    try {
      this.#config = JSON.parse(scriptContent);
    } catch {
      console.error(PROGRESS_ERROR.CONFIG_PARSE);
      this.#config = null;
    }
  }
  #parseMilestoneId(marker) {
    return parseInt(
      marker.getAttribute(PROGRESS_ATTR.MILESTONE) || String(DEFAULT_MILESTONE_ID),
      RADIX_DECIMAL
    );
  }
  #initializeReachedState() {
    Array.from(this.querySelectorAll(PROGRESS_SELECTOR.MARKER)).filter((marker) => marker.classList.contains(PROGRESS_CLASS.MARKER_REACHED)).map((marker) => this.#parseMilestoneId(marker)).filter((id) => id > DEFAULT_MILESTONE_ID).forEach((id) => {
      this.#reachedMilestones.add(id);
      this.#conditionReachedMilestones.add(id);
    });
  }
  #emitViewEvent() {
    if (!this.#config) {
      return;
    }
    this.track(ANALYTICS_ACTION$1.PROGRESS_VIEW, {
      milestoneCount: this.#config.milestones.length,
      maxThreshold: this.#config.maxThreshold
    });
  }
  #handleCartStateChange = (event) => {
    const { cart: cart2 } = event.detail ?? {};
    if (!cart2) {
      console.error(ERROR_CART_NOT_FOUND);
      return;
    }
    this.#hasSubscription = cart2.items?.some((item) => item.selling_plan_allocation) ?? false;
    this.#lastItemCount = this.#getNonRewardItemCount(cart2.items ?? []);
    this.#debouncedProgressUpdate(
      cart2.items_subtotal_price ?? cart2.total_price
    );
  };
  #debouncedProgressUpdate(cartTotal) {
    if (this.#updateDebounceTimer) {
      clearTimeout(this.#updateDebounceTimer);
    }
    this.#updateDebounceTimer = window.setTimeout(() => {
      this.#updateProgress(cartTotal);
      this.#updateDebounceTimer = null;
    }, PROGRESS_UPDATE_DEBOUNCE_MS);
  }
  #handleMarkerUpdate = (event) => {
    const { milestoneId, isReached } = event.detail ?? {};
    if (!isDefined(milestoneId) || !this.#config) {
      return;
    }
    this.#cartLogicControlledMilestones.add(milestoneId);
    if (isReached && !this.#conditionReachedMilestones.has(milestoneId)) {
      this.#conditionReachedMilestones.add(milestoneId);
      this.#updateProgress(this.#lastCartTotal);
      this.#celebrate();
    } else if (!isReached && this.#conditionReachedMilestones.has(milestoneId)) {
      this.#conditionReachedMilestones.delete(milestoneId);
      this.#updateProgress(this.#lastCartTotal);
    }
  };
  #handleContentRefreshed = () => {
    this.#syncReachedStateFromDOM();
    this.#updateProgress(this.#lastCartTotal);
  };
  #syncReachedStateFromDOM() {
    Array.from(this.querySelectorAll(PROGRESS_SELECTOR.MARKER)).forEach((marker) => {
      const id = this.#parseMilestoneId(marker);
      if (id <= DEFAULT_MILESTONE_ID) {
        return;
      }
      const isReached = marker.classList.contains(PROGRESS_CLASS.MARKER_REACHED);
      if (isReached) {
        this.#reachedMilestones.add(id);
        this.#conditionReachedMilestones.add(id);
      } else {
        this.#reachedMilestones.delete(id);
        this.#conditionReachedMilestones.delete(id);
      }
    });
  }
  #calculateFillForConditions() {
    if (!this.#config) {
      return 0;
    }
    const { milestones, maxThreshold } = this.#config;
    const highestReachedThreshold = milestones.reduce(
      (max, milestone) => this.#conditionReachedMilestones.has(milestone.id) && milestone.threshold > max ? milestone.threshold : max,
      0
    );
    return Math.max(
      calculateProgress(highestReachedThreshold, maxThreshold),
      calculateProgress(this.#lastCartTotal, maxThreshold)
    );
  }
  #markMilestonesFromLogic() {
    if (!this.#config) {
      return;
    }
    const { milestones } = this.#config;
    const highestReachedThreshold = milestones.reduce(
      (max, milestone) => this.#conditionReachedMilestones.has(milestone.id) && milestone.threshold > max ? milestone.threshold : max,
      0
    );
    const markedIds = new Set(
      milestones.filter((m) => m.threshold <= highestReachedThreshold).map((m) => m.id)
    );
    milestones.map((m) => ({ id: m.id, shouldMark: markedIds.has(m.id) })).forEach(({ id, shouldMark }) => {
      this.#updateMarker(id, shouldMark);
      if (shouldMark) {
        this.#reachedMilestones.add(id);
      } else {
        this.#reachedMilestones.delete(id);
      }
    });
  }
  #evaluateAmountBasedMilestones(cartTotal) {
    if (!this.#config || this.#config.conditionBasedMarkers) {
      return;
    }
    const { milestones } = this.#config;
    milestones.forEach((milestone) => {
      if (isDefined(milestone.itemCountThreshold)) {
        return;
      }
      if (this.#cartLogicControlledMilestones.has(milestone.id)) {
        return;
      }
      if (this.#conditionReachedMilestones.has(milestone.id)) {
        return;
      }
      const amountMet = cartTotal >= milestone.threshold;
      const subscriptionMet = milestone.subscriptionUnlocks && this.#hasSubscription;
      if (amountMet || subscriptionMet) {
        this.#conditionReachedMilestones.add(milestone.id);
        this.#celebrate();
      }
    });
  }
  #updateProgress(cartTotal) {
    if (!this.#config) {
      return;
    }
    this.#lastCartTotal = cartTotal;
    const { maxThreshold, milestones } = this.#config;
    this.#evaluateAmountBasedMilestones(cartTotal);
    const progressPercent = this.#calculateFillForConditions();
    this.#updateFill(progressPercent);
    this.#updateAmounts(cartTotal, maxThreshold);
    this.#markMilestonesFromLogic();
    const { nextMilestone, allReached } = milestones.reduce(
      (acc, milestone) => {
        if (this.#conditionReachedMilestones.has(milestone.id)) {
          return acc;
        }
        return {
          nextMilestone: !acc.nextMilestone || milestone.threshold < acc.nextMilestone.threshold ? milestone : acc.nextMilestone,
          allReached: false
        };
      },
      { nextMilestone: null, allReached: true }
    );
    this.#updateMessage(nextMilestone, cartTotal, allReached);
    this.classList.toggle(PROGRESS_CLASS.COMPLETED, allReached);
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT$1.PROGRESS_UPDATED, {
        bubbles: true,
        detail: {
          cartTotal,
          progressPercent,
          reachedMilestones: Array.from(this.#reachedMilestones),
          allCompleted: allReached
        }
      })
    );
  }
  #updateFill(percent) {
    const fillElement = this.querySelector(PROGRESS_SELECTOR.FILL);
    if (fillElement) {
      fillElement.style.width = `${percent}%`;
    }
    this.style.setProperty(CSS_VAR_PROGRESS_PERCENT, `${percent}%`);
  }
  #updateAmounts(cartTotal, maxThreshold) {
    const currentElement = this.querySelector(PROGRESS_SELECTOR.CURRENT);
    const targetElement = this.querySelector(PROGRESS_SELECTOR.TARGET);
    if (currentElement) {
      currentElement.textContent = formatCentsToMoney(cartTotal);
    }
    if (targetElement) {
      targetElement.textContent = formatCentsToMoney(maxThreshold);
    }
  }
  #updateMarker(milestoneId, isReached) {
    this.querySelector(
      `[${PROGRESS_ATTR.MILESTONE}="${milestoneId}"]`
    )?.classList.toggle(PROGRESS_CLASS.MARKER_REACHED, isReached);
  }
  #buildItemCountParams(milestone) {
    if (!isDefined(milestone.itemCountThreshold)) {
      return void 0;
    }
    return {
      currentCount: this.#lastItemCount,
      thresholdCount: milestone.itemCountThreshold
    };
  }
  #buildAfterMessages(cartTotal) {
    if (!this.#config) {
      return [];
    }
    const sortedMilestones = [...this.#config.milestones].sort(
      (a, b) => a.threshold - b.threshold
    );
    const reachedMilestones = sortedMilestones.filter(
      (m) => this.#conditionReachedMilestones.has(m.id)
    );
    const highestReachedId = reachedMilestones[reachedMilestones.length - 1]?.id;
    return reachedMilestones.filter((milestone) => {
      const textAfter = milestone.textAfter || milestone.completedText;
      if (!textAfter || (milestone.showTextAfter ?? true) === false) {
        return false;
      }
      return (milestone.persistTextAfter ?? false) || milestone.id === highestReachedId;
    }).map(
      (milestone) => replacePlaceholders(
        milestone.textAfter || milestone.completedText || "",
        0,
        milestone.threshold,
        cartTotal,
        this.#hasSubscription,
        this.#buildItemCountParams(milestone)
      )
    );
  }
  #renderAfterMessages(container, messages) {
    container.innerHTML = "";
    messages.forEach((message) => {
      const div = document.createElement("div");
      div.className = MESSAGE_AFTER_ITEM_CLASS;
      div.textContent = message;
      container.appendChild(div);
    });
    toggle(container, messages.length > 0);
  }
  #updateMessage(nextMilestone, cartTotal, allReached) {
    const messageElement = this.querySelector(PROGRESS_SELECTOR.MESSAGE);
    const afterElement = this.querySelector(PROGRESS_SELECTOR.MESSAGE_AFTER);
    const beforeElement = this.querySelector(PROGRESS_SELECTOR.MESSAGE_BEFORE);
    if (allReached) {
      const completedText = this.#config?.allCompletedText || DEFAULT_COMPLETED_TEXT;
      if (afterElement) {
        afterElement.innerHTML = "";
        hide(afterElement);
      }
      if (beforeElement) {
        beforeElement.innerHTML = `<strong>${completedText}</strong>`;
        show(beforeElement);
      }
      if (messageElement) {
        if (afterElement || beforeElement) {
          messageElement.textContent = "";
        } else {
          messageElement.textContent = completedText;
        }
      }
      this.#handleCompletionBehavior(true);
    } else if (nextMilestone) {
      const afterMessages = this.#buildAfterMessages(cartTotal);
      const afterText = afterMessages.join("\n");
      if (afterElement) {
        this.#renderAfterMessages(afterElement, afterMessages);
      }
      const itemCountParams = this.#buildItemCountParams(nextMilestone);
      const remainingCount = itemCountParams ? itemCountParams.thresholdCount - itemCountParams.currentCount : 0;
      const textTemplate = remainingCount === 1 && nextMilestone.textSingular ? nextMilestone.textSingular : nextMilestone.text;
      const beforeText = replacePlaceholders(
        textTemplate || "",
        nextMilestone.threshold - cartTotal,
        nextMilestone.threshold,
        cartTotal,
        this.#hasSubscription,
        itemCountParams
      );
      if (beforeElement) {
        beforeElement.textContent = beforeText;
        toggle(beforeElement, !!beforeText);
      }
      if (messageElement) {
        if (afterElement || beforeElement) {
          messageElement.textContent = "";
        } else {
          const combined = afterText ? `${afterText}
${beforeText}` : beforeText;
          messageElement.textContent = combined;
        }
      }
      this.#handleCompletionBehavior(false);
    }
  }
  static #completionVisibility = {
    [COMPLETION_BEHAVIOR.HIDE_ALL]: [true, true, false],
    [COMPLETION_BEHAVIOR.SHOW_BAR_ONLY]: [true, false, true],
    [COMPLETION_BEHAVIOR.SHOW_MESSAGE_ONLY]: [false, true, true],
    [COMPLETION_BEHAVIOR.SHOW_ALL]: [true, true, true]
  };
  #handleCompletionBehavior(allCompleted) {
    if (!this.#config) {
      return;
    }
    const barElement = this.querySelector(PROGRESS_SELECTOR.BAR);
    const messageElement = this.querySelector(PROGRESS_SELECTOR.MESSAGE);
    const [showBar, showMessage, showSelf] = allCompleted ? ZygProgressBar.#completionVisibility[this.#config.completionBehavior || COMPLETION_BEHAVIOR.SHOW_ALL] : [true, true, true];
    if (barElement) {
      toggle(barElement, showBar);
    }
    if (messageElement) {
      toggle(messageElement, showMessage);
    }
    toggle(this, showSelf);
  }
  #celebrate() {
    if (this.#celebrationTimer) {
      clearTimeout(this.#celebrationTimer);
    }
    this.classList.add(PROGRESS_CLASS.CELEBRATING);
    this.#celebrationTimer = setTimeout(() => {
      this.classList.remove(PROGRESS_CLASS.CELEBRATING);
      this.#celebrationTimer = null;
    }, CELEBRATION_DURATION);
  }
}
if (!customElements.get(ELEMENT_NAME$3)) {
  customElements.define(ELEMENT_NAME$3, ZygProgressBar);
}
const BLOCK_ID_ATTRIBUTE = "data-zyg-block-id";
const CUSTOMER_EVENT_NAME_CARD_IMPRESSION = "card_impression";
const CUSTOMER_EVENT_NAME_WIDGET_IMPRESSION = "widget_impression";
const UPSELL_PLACEMENT = {
  PDP_SHOP_COMPONENT: "pdp_shop_component",
  PDP_CAROUSEL: "pdp_carousel",
  CART: "cart",
  OTHER: "other"
};
const ATTR_UPSELL_WIDGET = "data-upsell-widget";
const ATTR_UPSELL_ANCHOR_PRODUCT_ID = "data-upsell-anchor-product-id";
const SELECTOR_BUYBOX = ".zyg-buybox";
const SELECTOR_CART_DRAWER = "zyg-cart-drawer";
const SELECTOR_UPSELL_WIDGET = `[${ATTR_UPSELL_WIDGET}]`;
const FIELD_UPSELL_PLACEMENT = "upsell_placement";
const FIELD_UPSELL_WIDGET_ID = "upsell_widget_id";
const FIELD_UPSELL_ANCHOR_PRODUCT_ID = "upsell_anchor_product_id";
const LINE_PROPERTY_UPSELL_PLACEMENT = "_upsell_placement";
const LINE_PROPERTY_UPSELL_ANCHOR_PRODUCT_ID = "_upsell_anchor_product_id";
const UPSELL_IMPRESSION_ACTION = {
  WIDGET: CUSTOMER_EVENT_NAME_WIDGET_IMPRESSION,
  CARD: CUSTOMER_EVENT_NAME_CARD_IMPRESSION
};
const FIELD_UPSELL_POSITION = "upsell_position";
const IMPRESSION_VISIBLE_RATIO = 0.5;
const IMPRESSION_KEY_WIDGET = "widget";
const IMPRESSION_KEY_CARD = "card";
function placementOf(element, pageProductId) {
  if (element.closest(SELECTOR_CART_DRAWER)) {
    return UPSELL_PLACEMENT.CART;
  }
  if (element.closest(SELECTOR_BUYBOX)) {
    return UPSELL_PLACEMENT.PDP_SHOP_COMPONENT;
  }
  return pageProductId ? UPSELL_PLACEMENT.PDP_CAROUSEL : UPSELL_PLACEMENT.OTHER;
}
function resolveUpsellContext(element) {
  const widget = element.closest(SELECTOR_UPSELL_WIDGET);
  const pageProductId = widget?.getAttribute(ATTR_UPSELL_ANCHOR_PRODUCT_ID) || void 0;
  const placement = placementOf(element, pageProductId);
  return {
    placement,
    widgetId: widget?.getAttribute(BLOCK_ID_ATTRIBUTE) ?? "",
    anchorProductId: placement === UPSELL_PLACEMENT.CART ? void 0 : pageProductId
  };
}
function upsellEventFields(context) {
  return {
    [FIELD_UPSELL_PLACEMENT]: context.placement,
    [FIELD_UPSELL_WIDGET_ID]: context.widgetId,
    ...context.anchorProductId && {
      [FIELD_UPSELL_ANCHOR_PRODUCT_ID]: context.anchorProductId
    }
  };
}
function upsellLineProperties(context) {
  return {
    [LINE_PROPERTY_UPSELL_PLACEMENT]: context.placement,
    ...context.anchorProductId && {
      [LINE_PROPERTY_UPSELL_ANCHOR_PRODUCT_ID]: context.anchorProductId
    }
  };
}
const seenKeys = /* @__PURE__ */ new Set();
const pendingByKey = /* @__PURE__ */ new Map();
const keyByElement = /* @__PURE__ */ new WeakMap();
let observer;
function handleEntries(entries) {
  entries.filter(
    (entry) => entry.isIntersecting && entry.intersectionRatio >= IMPRESSION_VISIBLE_RATIO
  ).forEach((entry) => {
    observer?.unobserve(entry.target);
    const key = keyByElement.get(entry.target);
    const pending = key ? pendingByKey.get(key) : void 0;
    if (!key || pending?.element !== entry.target) {
      return;
    }
    pendingByKey.delete(key);
    seenKeys.add(key);
    pending.onImpression();
  });
}
function sharedObserver() {
  if (!observer && typeof IntersectionObserver !== "undefined") {
    observer = new IntersectionObserver(handleEntries, {
      threshold: IMPRESSION_VISIBLE_RATIO
    });
  }
  return observer;
}
function widgetImpressionKey(widgetId) {
  return `${IMPRESSION_KEY_WIDGET}:${widgetId}`;
}
function cardImpressionKey(widgetId, variantId) {
  return `${IMPRESSION_KEY_CARD}:${widgetId}:${variantId}`;
}
function observeImpressionOnce(element, key, onImpression) {
  const io = sharedObserver();
  if (!io || seenKeys.has(key)) {
    return;
  }
  const previous = pendingByKey.get(key);
  if (previous && previous.element !== element) {
    io.unobserve(previous.element);
  }
  pendingByKey.set(key, { element, onImpression });
  keyByElement.set(element, key);
  io.observe(element);
}
function cancelImpression(element) {
  const key = keyByElement.get(element);
  if (!key || pendingByKey.get(key)?.element !== element) {
    return;
  }
  pendingByKey.delete(key);
  observer?.unobserve(element);
}
const ANALYTICS_CATEGORY = "upsell";
const ATTR_PRODUCT_ID = "data-product-id";
const ATTR_VARIANT_ID = "data-variant-id";
const CLASS_LOADING = "zyg-upsell-card--loading";
const TrackableElement = Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY,
  errorPrefix: "upsell"
});
const ActionableElement = Actionable(TrackableElement, {
  keyAttr: ATTR_VARIANT_ID,
  loadingClass: CLASS_LOADING,
  errorPrefix: "upsell"
});
class BaseUpsellComponent extends ActionableElement {
  /** Gets variant ID from this element */
  get variantId() {
    return this.getAttribute(ATTR_VARIANT_ID) ?? void 0;
  }
  /** Gets product ID from this element */
  get productId() {
    return this.getAttribute(ATTR_PRODUCT_ID) ?? void 0;
  }
  /** Adds/removes loading state on this element */
  setLoading(loading2) {
    this.classList.toggle(CLASS_LOADING, loading2);
  }
}
const ATTR_BUTTON_ACTION = "data-button-action";
const BUTTON_ACTION_ADD_AND_CHECKOUT = "add_and_checkout";
const DOM_EVENT = {
  ADD_TO_CART: "upsell:add-to-cart",
  VIEW: "upsell:view",
  VARIANT_CHANGE: "upsell:variant-change",
  PRODUCT_CLICK: "upsell:product-click"
};
const ANALYTICS_ACTION = {
  CARD_IMPRESSION: UPSELL_IMPRESSION_ACTION.CARD,
  WIDGET_IMPRESSION: UPSELL_IMPRESSION_ACTION.WIDGET,
  ADD_TO_CART: "add_to_cart",
  ADD_TO_CART_ERROR: "add_to_cart_error",
  VARIANT_CHANGE: "variant_change",
  PRODUCT_CLICK: "product_click"
};
const CLASS_ADDED = "zyg-upsell-card--added";
const CLASS_PRICE_SALE = "zyg-upsell-card__price-current--sale";
const SELECTOR_ADD_TO_CART_BUTTON = ".zyg-upsell-card__add-btn";
const SELECTOR_PRICE_CONTAINER = "[data-price-container]";
const SELECTOR_CURRENT_PRICE = "[data-price]";
const SELECTOR_COMPARE_PRICE = ".zyg-upsell-card__price-compare";
const SELECTOR_SALE_BADGE = ".zyg-upsell-card__badge--sale";
const SELECTOR_PRODUCT_LINK = ".zyg-upsell-card__image-link, .zyg-upsell-card__title";
const ATTR_PRODUCT_TITLE = "data-product-title";
const ATTR_PRODUCT_HANDLE = "data-product-handle";
const ELEMENT_UPSELL_CARD = "zyg-upsell-card";
const sendUpsellEvent = (action, payload) => {
  window.safeTrackEvent?.(ANALYTICS_CATEGORY, action, JSON.stringify(payload));
};
function upsellPosition(element, itemSelector) {
  const items = Array.from(
    element.closest(SELECTOR_UPSELL_WIDGET)?.querySelectorAll(itemSelector) ?? []
  );
  return items.indexOf(element) + 1;
}
function trackWidgetImpression(element) {
  const widget = element.closest(SELECTOR_UPSELL_WIDGET);
  if (!widget) {
    return;
  }
  const context = resolveUpsellContext(widget);
  observeImpressionOnce(
    widget,
    widgetImpressionKey(context.widgetId),
    () => sendUpsellEvent(ANALYTICS_ACTION.WIDGET_IMPRESSION, upsellEventFields(context))
  );
}
function trackCardImpression(options) {
  if (!options.element.closest(SELECTOR_UPSELL_WIDGET)) {
    return;
  }
  const context = resolveUpsellContext(options.element);
  observeImpressionOnce(
    options.element,
    cardImpressionKey(context.widgetId, options.variantId),
    () => {
      const payload = {
        ...options.payload(),
        ...upsellEventFields(context),
        [FIELD_UPSELL_POSITION]: upsellPosition(options.element, options.itemSelector)
      };
      sendUpsellEvent(ANALYTICS_ACTION.CARD_IMPRESSION, payload);
      options.onSent?.(payload);
    }
  );
}
const PREDICTED_KEY_PREFIX = "predicted";
const buildPredictedCartItem = (input) => {
  const variantIdNum = typeof input.variantId === "string" ? Number(input.variantId) : input.variantId;
  const finalLinePrice = input.price * input.quantity;
  return {
    id: 0,
    key: `${PREDICTED_KEY_PREFIX}:${variantIdNum}:${input.productId}`,
    quantity: input.quantity,
    variant_id: variantIdNum,
    product_id: input.productId,
    title: "",
    product_title: "",
    variant_title: null,
    price: input.price,
    line_price: finalLinePrice,
    final_price: input.price,
    final_line_price: finalLinePrice,
    discounted_price: input.price,
    discounts: [],
    gift_card: false,
    requires_shipping: true,
    url: "",
    handle: "",
    image: null,
    featured_image: null,
    variant_options: [],
    options_with_values: [],
    properties: input.properties ?? {},
    selling_plan_allocation: input.sellingPlanId ? {
      price: input.price,
      compare_at_price: input.price,
      per_delivery_price: input.price,
      selling_plan: {
        id: Number(input.sellingPlanId),
        name: "",
        description: null,
        options: [],
        recurring_deliveries: true
      }
    } : void 0
  };
};
const predictCartItems = (currentItems, addedItems, replaceExisting) => {
  const baseItems = replaceExisting ? [] : currentItems ?? [];
  return [...baseItems, ...addedItems];
};
const predictCart = (currentCart, addedItems, replaceExisting) => ({
  items: predictCartItems(currentCart?.items, addedItems, replaceExisting)
});
async function addItemsWithMilestones(cartApi, predictedItems, extraItems = [], options = {}) {
  if (options.clearFirst) {
    await cartApi.clear();
  }
  const userItems = [...predictedItems.map((input) => input.item), ...extraItems];
  const addItems = (items) => options.forCheckout ? cartApi.addMultipleForCheckout(items) : cartApi.addMultiple(items);
  const config = readCartLogicConfig();
  if (!config) {
    await addItems(userItems);
    return { freeShippingDiscountCode: null };
  }
  const predictedNewItems = predictedItems.map(
    (input) => buildPredictedCartItem({
      variantId: input.item.id,
      productId: input.productId,
      quantity: input.item.quantity ?? 1,
      price: input.price,
      sellingPlanId: input.item.sellingPlan,
      properties: input.item.customProperties
    })
  );
  const predictedCart = predictCart(
    cartApi.instance,
    predictedNewItems,
    options.clearFirst === true
  );
  const milestoneResult = computeMilestoneRewards(predictedCart, config, {
    declinedRewards: readDeclinedRewards()
  });
  await addItems([...userItems, ...milestoneResult.rewardItems]);
  return { freeShippingDiscountCode: milestoneResult.freeShippingDiscountCode };
}
const DOM_EVENT_VARIANT_CHANGE = "zyg:variant:change";
class CallToActionEvent {
  /** Builds the detail object for DOM CustomEvents */
  buildEventDetail(context) {
    return {
      action: this.type,
      variantId: context.variantId,
      productId: context.productId,
      quantity: context.quantity,
      sellingPlanId: context.sellingPlanId,
      ...classifyProductAdd({
        sellingPlanId: context.sellingPlanId,
        isUpsell: context.isUpsell
      }),
      ...context.upsellContext && upsellEventFields(context.upsellContext)
    };
  }
}
const ERROR_UNKNOWN = "Unknown error";
class CartActionBase extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.domEvent = "zyg:cta:add-to-cart:success";
    this.domEventError = "zyg:cta:add-to-cart:error";
    this.analyticsAction = "cta_add_to_cart";
    this.analyticsActionError = "cta_add_to_cart_error";
    this.requiresAvailability = true;
    this.errorMissingVariant = "[cta] Missing variant ID for add to cart";
    this.errorCartNotAvailable = "[cta] Cart not available";
    this.errorAddFailed = "[cta] Failed to add to cart:";
  }
  validate(context) {
    if (!context.variantId) {
      return { valid: false, error: this.errorMissingVariant };
    }
    return { valid: true };
  }
  /** Reports cart add error - shared by all cart actions */
  reportError(context, host, error) {
    const errorMessage = error instanceof Error ? error.message : ERROR_UNKNOWN;
    console.error(`${this.errorAddFailed} ${errorMessage}`);
    const detail = { ...this.buildEventDetail(context), error: errorMessage };
    host.emitError(this.domEventError, this.analyticsActionError, detail);
  }
}
class AddToCartAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "add-to-cart";
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context);
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      host.showAddedFeedback();
    } catch (error) {
      this.reportError(context, host, error);
    } finally {
      host.setLoading(false);
    }
  }
}
class NavigateAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "go-to-page";
    this.domEvent = "zyg:cta:navigate";
    this.analyticsAction = "cta_navigate";
    this.requiresAvailability = false;
    this.errorMissingUrl = "[cta] Missing link URL for navigation";
  }
  validate(context) {
    if (!context.linkUrl) {
      return { valid: false, error: this.errorMissingUrl };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { url: context.linkUrl, newTab: context.openNewTab };
  }
  execute(context, host) {
    if (!context.linkUrl) {
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    if (context.openNewTab) {
      window.open(context.linkUrl, WINDOW_TARGET_BLANK, WINDOW_FEATURES_SECURE);
      return;
    }
    window.location.href = context.linkUrl;
  }
}
const STRAIGHT_TO_CHECKOUT_OPTIONS = {
  skipDrawer: true,
  clearFirst: true,
  forCheckout: true
};
class StraightToCheckoutAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "straight-to-checkout";
  }
  buildEventDetail(context) {
    return { ...super.buildEventDetail(context), checkout: true, replaced: true };
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context, STRAIGHT_TO_CHECKOUT_OPTIONS);
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      window.location.href = context.freeShippingDiscountCode ? buildDiscountRedirectUrl(context.freeShippingDiscountCode, CHECKOUT_URL) : CHECKOUT_URL;
    } catch (error) {
      this.reportError(context, host, error);
      host.setLoading(false);
    }
  }
}
const EASE_FACTOR = 0.12;
const ARRIVAL_TOLERANCE_PX = 2;
const MIN_STEP_PX = 1;
const MAX_SCROLL_DURATION_MS = 3e3;
const DOM_EVENT_SCROLL = "zyg:cta:scroll";
const ANALYTICS_ACTION_SCROLL_TO = "cta_scroll";
const ANALYTICS_ACTION_SCROLL_TO_SHOP = "cta_scroll_to_shop";
const ANALYTICS_ACTION_SCROLL_TO_BUYBOX = "cta_scroll_to_buybox";
const ACTION_SCROLL_TO$1 = "scroll-to";
const ACTION_SCROLL_TO_SHOP$1 = "scroll-to-shop";
const ACTION_SCROLL_TO_BUYBOX$1 = "scroll-to-buybox";
const ERROR_MISSING_SCROLL_TARGET = "[cta] Missing scroll target";
const ERROR_INVALID_SCROLL_SELECTOR = "[cta] Invalid scroll target selector:";
const ERROR_SCROLL_TARGET_NOT_FOUND = "[cta] Scroll target not found:";
const ERROR_SHOP_SECTION_NOT_FOUND = "[cta] Shop section not found on page";
const ERROR_BUYBOX_SECTION_NOT_FOUND = "[cta] Buybox section not found on page";
let activeScrollRafId = null;
function scrollToElement(element) {
  if (activeScrollRafId !== null) {
    window.cancelAnimationFrame(activeScrollRafId);
    activeScrollRafId = null;
  }
  const startTime = performance.now();
  function step() {
    if (!element.isConnected) {
      activeScrollRafId = null;
      return;
    }
    const rect = element.getBoundingClientRect();
    const offset = rect.top;
    if (Math.abs(offset) <= ARRIVAL_TOLERANCE_PX || performance.now() - startTime > MAX_SCROLL_DURATION_MS) {
      activeScrollRafId = null;
      return;
    }
    const scrollYBefore = window.scrollY;
    const raw = offset * EASE_FACTOR;
    const px = Math.abs(raw) < MIN_STEP_PX ? Math.sign(raw) * MIN_STEP_PX : Math.round(raw);
    window.scrollBy(0, px);
    if (window.scrollY === scrollYBefore) {
      activeScrollRafId = null;
      return;
    }
    activeScrollRafId = requestAnimationFrame(step);
  }
  activeScrollRafId = requestAnimationFrame(step);
}
const SHOP_SECTION_SELECTOR = '[id*="zyg-shop-section"], [id*="zyg_shop_section"]';
const BUYBOX_SECTION_SELECTOR = '[id*="zyg-buybox"], [id*="zyg_buybox"], .zyg-buybox';
function findShopSection() {
  return document.querySelector(SHOP_SECTION_SELECTOR);
}
function findBuyboxSection() {
  return document.querySelector(BUYBOX_SECTION_SELECTOR);
}
class SectionScrollAction extends CallToActionEvent {
  constructor(config) {
    super();
    this.domEvent = DOM_EVENT_SCROLL;
    this.requiresAvailability = false;
    this.type = config.type;
    this.analyticsAction = config.analyticsAction;
    this.targetSelector = config.targetSelector;
    this.findElement = config.findElement;
    this.missingTargetMessage = config.missingTargetMessage;
  }
  validate(_context) {
    return { valid: true };
  }
  buildEventDetail(_context) {
    return { target: this.targetSelector };
  }
  execute(context, host) {
    const element = this.findElement();
    if (!element) {
      console.error(this.missingTargetMessage);
      return;
    }
    host.emitAndTrack(this.domEvent, this.analyticsAction, this.buildEventDetail(context));
    scrollToElement(element);
  }
}
class ScrollToAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = ACTION_SCROLL_TO$1;
    this.domEvent = DOM_EVENT_SCROLL;
    this.analyticsAction = ANALYTICS_ACTION_SCROLL_TO;
    this.requiresAvailability = false;
    this.errorMissingTarget = ERROR_MISSING_SCROLL_TARGET;
    this.errorInvalidSelector = ERROR_INVALID_SCROLL_SELECTOR;
    this.errorTargetNotFound = ERROR_SCROLL_TARGET_NOT_FOUND;
  }
  validate(context) {
    if (!context.scrollTarget) {
      return { valid: false, error: this.errorMissingTarget };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { target: context.scrollTarget };
  }
  execute(context, host) {
    if (!context.scrollTarget) {
      return;
    }
    let element;
    try {
      element = document.querySelector(context.scrollTarget);
    } catch {
      console.error(this.errorInvalidSelector, context.scrollTarget);
      return;
    }
    if (!element) {
      console.error(this.errorTargetNotFound, context.scrollTarget);
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    scrollToElement(element);
  }
}
class ScrollToShopAction extends SectionScrollAction {
  constructor() {
    super({
      type: ACTION_SCROLL_TO_SHOP$1,
      analyticsAction: ANALYTICS_ACTION_SCROLL_TO_SHOP,
      targetSelector: SHOP_SECTION_SELECTOR,
      findElement: findShopSection,
      missingTargetMessage: ERROR_SHOP_SECTION_NOT_FOUND
    });
    this.errorShopSectionNotFound = ERROR_SHOP_SECTION_NOT_FOUND;
  }
}
class ScrollToBuyboxAction extends SectionScrollAction {
  constructor() {
    super({
      type: ACTION_SCROLL_TO_BUYBOX$1,
      analyticsAction: ANALYTICS_ACTION_SCROLL_TO_BUYBOX,
      targetSelector: BUYBOX_SECTION_SELECTOR,
      findElement: findBuyboxSection,
      missingTargetMessage: ERROR_BUYBOX_SECTION_NOT_FOUND
    });
    this.errorBuyboxSectionNotFound = ERROR_BUYBOX_SECTION_NOT_FOUND;
  }
}
class SubmitFormAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "submit-form";
    this.domEvent = "zyg:cta:submit-form";
    this.analyticsAction = "cta_submit_form";
    this.requiresAvailability = false;
  }
  validate(_context) {
    return { valid: true };
  }
  buildEventDetail(_context) {
    return { action: this.type };
  }
  /** No-op: #handleClick returns before preventDefault so the browser posts the form. */
  execute(_context, _host) {
    return;
  }
}
const HANDLEIZE_COMBINING_MARKS = /[̀-ͯ]/g;
const HANDLEIZE_SHARP_S = /ß/g;
const HANDLEIZE_SHARP_S_SPELLING = "ss";
const HANDLEIZE_DROPPED = /['"()[\]]/g;
const HANDLEIZE_NON_WORD_ASCII = /[^a-z0-9_\u0080-\u{10ffff}]+/gu;
const HANDLEIZE_EDGE_HYPHENS = /^-+|-+$/g;
const HANDLEIZE_REMOVED = "";
const HANDLEIZE_HYPHEN = "-";
const DECOMPOSED_FORM = "NFD";
function handleize(value) {
  return value.toLowerCase().normalize(DECOMPOSED_FORM).replace(HANDLEIZE_COMBINING_MARKS, HANDLEIZE_REMOVED).replace(HANDLEIZE_SHARP_S, HANDLEIZE_SHARP_S_SPELLING).replace(HANDLEIZE_DROPPED, HANDLEIZE_REMOVED).replace(HANDLEIZE_NON_WORD_ASCII, HANDLEIZE_HYPHEN).replace(HANDLEIZE_EDGE_HYPHENS, HANDLEIZE_REMOVED);
}
const ZYG_MODAL_ID_PREFIX = "zyg-modal-";
function handleizeModalId(value) {
  return handleize(value);
}
function resolveZygModalElementId(modalId) {
  return `${ZYG_MODAL_ID_PREFIX}${handleizeModalId(modalId)}`;
}
class OpenModalAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "open-modal";
    this.domEvent = "zyg:cta:open-modal";
    this.analyticsAction = "cta_open_modal";
    this.requiresAvailability = false;
    this.errorMissingModalId = "[cta] Missing modal id";
    this.errorModalNotFound = "[cta] Modal not found:";
    this.errorModalMissingShow = "[cta] Modal is missing show():";
  }
  validate(context) {
    if (!context.modalId) {
      return { valid: false, error: this.errorMissingModalId };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { modalId: context.modalId };
  }
  execute(context, host) {
    if (!context.modalId) {
      return;
    }
    const elementId = resolveZygModalElementId(context.modalId);
    const dialog = document.getElementById(elementId);
    if (!dialog) {
      console.error(this.errorModalNotFound, elementId);
      return;
    }
    if (typeof dialog.show !== "function") {
      console.error(this.errorModalMissingShow, elementId);
      return;
    }
    host.emitAndTrack(this.domEvent, this.analyticsAction, this.buildEventDetail(context));
    dialog.show();
  }
}
const ACTION_ADD_TO_CART = "add-to-cart";
const ACTION_STRAIGHT_TO_CHECKOUT = "straight-to-checkout";
const ACTION_GO_TO_PAGE = "go-to-page";
const ACTION_SCROLL_TO = "scroll-to";
const ACTION_SCROLL_TO_SHOP = "scroll-to-shop";
const ACTION_SCROLL_TO_BUYBOX = "scroll-to-buybox";
const ACTION_SUBMIT_FORM = "submit-form";
const ACTION_OPEN_MODAL = "open-modal";
({
  [ACTION_ADD_TO_CART]: new AddToCartAction(),
  [ACTION_STRAIGHT_TO_CHECKOUT]: new StraightToCheckoutAction(),
  [ACTION_GO_TO_PAGE]: new NavigateAction(),
  [ACTION_SCROLL_TO]: new ScrollToAction(),
  [ACTION_SCROLL_TO_SHOP]: new ScrollToShopAction(),
  [ACTION_SCROLL_TO_BUYBOX]: new ScrollToBuyboxAction(),
  [ACTION_SUBMIT_FORM]: new SubmitFormAction(),
  [ACTION_OPEN_MODAL]: new OpenModalAction()
});
const DOM_EVENT_CART_ADD = "cart:add";
const EVENT_SOURCE_PRODUCT_FORM = "product-form-component";
const ELEMENT_NAME$2 = "zyg-price-display";
const SALE_BADGE_TEXT_SUFFIX = "% OFF";
class ZygPriceDisplay extends HTMLElement {
  /** Updates price display for variant */
  updatePrice(variant) {
    const priceContainer = this.querySelector(SELECTOR_PRICE_CONTAINER);
    if (!priceContainer) {
      return;
    }
    const currentPriceElement = priceContainer.querySelector(SELECTOR_CURRENT_PRICE);
    const comparePriceElement = priceContainer.querySelector(SELECTOR_COMPARE_PRICE);
    if (currentPriceElement) {
      currentPriceElement.textContent = formatCentsToMoney(variant.price);
      currentPriceElement.classList.toggle(
        CLASS_PRICE_SALE,
        isDefined(variant.compare_at_price) && variant.compare_at_price > variant.price
      );
    }
    if (comparePriceElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        setText(
          comparePriceElement,
          formatCentsToMoney(variant.compare_at_price)
        );
        show(comparePriceElement);
      } else {
        hide(comparePriceElement);
      }
    }
    this.#updateSaleBadge(variant);
  }
  #updateSaleBadge(variant) {
    const saleBadge = this.querySelector(SELECTOR_SALE_BADGE);
    if (!saleBadge) {
      return;
    }
    const discount = calculateDiscount(variant.price, variant.compare_at_price);
    if (discount > 0) {
      saleBadge.textContent = `${discount}${SALE_BADGE_TEXT_SUFFIX}`;
      show(saleBadge);
    } else {
      hide(saleBadge);
    }
  }
}
if (!customElements.get(ELEMENT_NAME$2)) {
  customElements.define(ELEMENT_NAME$2, ZygPriceDisplay);
}
const ELEMENT_NAME$1 = ELEMENT_UPSELL_CARD;
const SELECTOR_PRICE_DISPLAY = "zyg-price-display";
class ZygUpsellCard extends BaseUpsellComponent {
  #addedFeedbackTimer = null;
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClickEvent);
    this.#observeImpressions();
    document.addEventListener(DOM_EVENT_VARIANT_CHANGE, this.#handleVariantChange);
  }
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClickEvent);
    document.removeEventListener(DOM_EVENT_VARIANT_CHANGE, this.#handleVariantChange);
    cancelImpression(this);
    if (this.#addedFeedbackTimer) {
      clearTimeout(this.#addedFeedbackTimer);
    }
  }
  #handleVariantChange = (event) => {
    const detail = event.detail;
    if (!detail || detail.productId !== this.getAttribute(ATTR_PRODUCT_ID)) {
      return;
    }
    const variant = detail.variant;
    this.setAttribute(ATTR_VARIANT_ID, String(variant.id));
    this.setAttribute(ATTR_AVAILABLE, String(variant.available));
    this.setAttribute(ATTR_PRICE, String(variant.price));
    this.#updatePriceDisplay(variant);
    this.#updateAddToCartButtonState(variant.available);
    this.notify({
      eventName: DOM_EVENT.VARIANT_CHANGE,
      analyticsAction: ANALYTICS_ACTION.VARIANT_CHANGE,
      payload: {
        productId: this.getAttribute(ATTR_PRODUCT_ID) ?? "",
        variantId: String(variant.id),
        productTitle: this.getAttribute(ATTR_PRODUCT_TITLE) ?? "",
        productHandle: this.getAttribute(ATTR_PRODUCT_HANDLE) ?? "",
        ...upsellEventFields(resolveUpsellContext(this))
      }
    });
  };
  #updatePriceDisplay(variant) {
    this.querySelector(SELECTOR_PRICE_DISPLAY)?.updatePrice(variant);
  }
  #observeImpressions() {
    trackWidgetImpression(this);
    trackCardImpression({
      element: this,
      variantId: this.getAttribute(ATTR_VARIANT_ID) ?? "",
      itemSelector: ELEMENT_NAME$1,
      payload: () => this.#buildEventPayload(),
      onSent: (payload) => emitDomEvent(DOM_EVENT.VIEW, payload)
    });
  }
  #buildEventPayload() {
    return {
      productId: this.getAttribute(ATTR_PRODUCT_ID) ?? "",
      variantId: this.getAttribute(ATTR_VARIANT_ID) ?? "",
      productTitle: this.getAttribute(ATTR_PRODUCT_TITLE) ?? "",
      productHandle: this.getAttribute(ATTR_PRODUCT_HANDLE) ?? "",
      ...classifyProductAdd({
        sellingPlanId: this.getAttribute(ATTR_SELLING_PLAN$2),
        upsellType: this.getAttribute(ATTR_UPSELL_TYPE) || UPSELL_TYPE_UPSELL
      }),
      ...upsellEventFields(resolveUpsellContext(this))
    };
  }
  #handleClickEvent = (event) => {
    const clickedElement = event.target;
    const addToCartButton = clickedElement.closest(SELECTOR_ADD_TO_CART_BUTTON);
    const productLink = clickedElement.closest(SELECTOR_PRODUCT_LINK);
    if (addToCartButton) {
      event.preventDefault();
      this.#addToCart();
    } else if (productLink) {
      this.#handleProductClick();
    }
  };
  #handleProductClick() {
    const payload = this.#buildEventPayload();
    this.notify({
      eventName: DOM_EVENT.PRODUCT_CLICK,
      analyticsAction: ANALYTICS_ACTION.PRODUCT_CLICK,
      payload
    });
  }
  #updateAddToCartButtonState(isAvailable) {
    const addToCartButton = this.querySelector(SELECTOR_ADD_TO_CART_BUTTON);
    if (addToCartButton) {
      addToCartButton.disabled = !isAvailable;
    }
  }
  /** Reads the per-unit price (in cents) from the element's data-price attribute. */
  get price() {
    const raw = this.getAttribute(ATTR_PRICE);
    return raw ? parseInt(raw, RADIX_DECIMAL) : 0;
  }
  async #addToCart() {
    const variantId = this.getAttribute(ATTR_VARIANT_ID);
    const isAvailable = this.getAttribute(ATTR_AVAILABLE) === "true";
    if (!variantId || !isAvailable) {
      return;
    }
    const payload = this.#buildEventPayload();
    const goToCheckout = this.getAttribute(ATTR_BUTTON_ACTION) === BUTTON_ACTION_ADD_AND_CHECKOUT;
    this.setLoading(true);
    this.classList.remove(CLASS_ADDED);
    try {
      const sellingPlanId = this.getAttribute(ATTR_SELLING_PLAN$2);
      const productIdNum = this.productId ? parseInt(this.productId, RADIX_DECIMAL) : 0;
      const cartApi = await whenCartReady();
      const result = await addItemsWithMilestones(cartApi, [
        {
          item: {
            id: variantId,
            quantity: DEFAULT_QUANTITY,
            source: SOURCE_UPSELL,
            initialOffer: sellingPlanId ? OFFER_TYPE.SUBSCRIPTION : OFFER_TYPE.ONE_TIME,
            isUpsell: true,
            sellingPlan: sellingPlanId || void 0,
            customProperties: upsellLineProperties(resolveUpsellContext(this))
          },
          productId: productIdNum,
          price: this.price
        }
      ]);
      this.notify({
        eventName: DOM_EVENT.ADD_TO_CART,
        analyticsAction: ANALYTICS_ACTION.ADD_TO_CART,
        payload: { ...payload, quantity: 1, success: true }
      });
      document.dispatchEvent(
        new CustomEvent(DOM_EVENT_CART_ADD, {
          bubbles: true,
          detail: {
            data: {
              source: EVENT_SOURCE_PRODUCT_FORM,
              skipDrawer: goToCheckout
            }
          }
        })
      );
      if (goToCheckout) {
        window.location.href = result.freeShippingDiscountCode ? buildDiscountRedirectUrl(result.freeShippingDiscountCode, CHECKOUT_URL) : CHECKOUT_URL;
        return;
      }
      if (this.hasAttribute(ATTR_CART_FEEDBACK)) {
        this.#showAddedFeedback();
      }
      this.setLoading(false);
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      console.error("[upsell-card] Failed to add to cart:", error);
      emitDomEvent(DOM_EVENT.ADD_TO_CART, {
        ...payload,
        success: false,
        error: errorMessage
      });
      this.track(ANALYTICS_ACTION.ADD_TO_CART_ERROR, {
        ...payload,
        success: false,
        error: errorMessage
      });
      this.setLoading(false);
    }
  }
  #showAddedFeedback() {
    if (this.#addedFeedbackTimer) {
      clearTimeout(this.#addedFeedbackTimer);
    }
    this.classList.add(CLASS_ADDED);
    this.#addedFeedbackTimer = setTimeout(() => {
      this.classList.remove(CLASS_ADDED);
      this.#addedFeedbackTimer = null;
    }, ADDED_FEEDBACK_DURATION);
  }
}
if (!customElements.get(ELEMENT_NAME$1)) {
  customElements.define(ELEMENT_NAME$1, ZygUpsellCard);
}
const ELEMENT_NAME = "zyg-upsell-checklist";
const SELECTOR_CHECKBOX = ".zyg-upsell-checklist__checkbox";
const SELECTOR_ADD_BTN = ".zyg-upsell-checklist__add-btn";
const SELECTOR_ITEM = ".zyg-upsell-checklist__item";
const CLASS_SELECTED = "is-selected";
const CLASS_BLOCKED = "is-blocked";
const ATTR_MAX_SELECT = "data-max-select";
const ATTR_MIN_SELECT = "data-min-select";
const ATTR_STATE = "data-state";
const ATTR_SELLING_PLAN = "data-selling-plan";
const STATE_IDLE = "idle";
const STATE_LOADING = "loading";
const STATE_ADDED = "added";
const DRAWER_ELEMENT_TAG = "zyg-cart-drawer";
const RESET_DELAY_MS = 2e3;
class ZygUpsellChecklist extends HTMLElement {
  #maxSelect = 5;
  #minSelect = 0;
  #checkboxes = [];
  #unavailable = /* @__PURE__ */ new Set();
  #addBtn = null;
  #controller = null;
  #itemObserver = null;
  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#maxSelect = parseInt(this.getAttribute(ATTR_MAX_SELECT) || "5", 10);
    this.#minSelect = parseInt(this.getAttribute(ATTR_MIN_SELECT) || "0", 10);
    this.#checkboxes = Array.from(this.querySelectorAll(SELECTOR_CHECKBOX));
    this.#addBtn = this.querySelector(SELECTOR_ADD_BTN);
    this.#checkboxes.forEach((cb) => {
      if (cb.disabled) {
        this.#unavailable.add(cb);
      }
      if (cb.checked) {
        cb.closest(SELECTOR_ITEM)?.classList.add(CLASS_SELECTED);
      }
      cb.addEventListener(
        "change",
        () => {
          cb.closest(SELECTOR_ITEM)?.classList.toggle(CLASS_SELECTED, cb.checked);
          this.#handleChange();
        },
        { signal }
      );
    });
    this.#addBtn?.addEventListener("click", () => this.#addAllToCart(), { signal });
    this.#handleChange();
    trackWidgetImpression(this);
    this.#observeItemImpressions();
    this.#itemObserver = new MutationObserver(() => this.#observeItemImpressions());
    this.#itemObserver.observe(this, { childList: true, subtree: true });
  }
  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
    this.#itemObserver?.disconnect();
    this.#itemObserver = null;
    this.querySelectorAll(SELECTOR_ITEM).forEach((item) => cancelImpression(item));
  }
  #productFields(checkbox) {
    return {
      productId: checkbox.getAttribute(ATTR_PRODUCT_ID$1) ?? "",
      variantId: checkbox.value,
      ...classifyProductAdd({
        sellingPlanId: checkbox.getAttribute(ATTR_SELLING_PLAN),
        isUpsell: true
      })
    };
  }
  #observeItemImpressions() {
    this.querySelectorAll(SELECTOR_CHECKBOX).forEach(
      (cb) => this.#observeItemImpression(cb)
    );
  }
  #observeItemImpression(checkbox) {
    const item = checkbox.closest(SELECTOR_ITEM);
    if (!item) {
      return;
    }
    trackCardImpression({
      element: item,
      variantId: checkbox.value,
      itemSelector: SELECTOR_ITEM,
      payload: () => this.#productFields(checkbox)
    });
  }
  #selected() {
    return this.#checkboxes.filter((cb) => cb.checked && !this.#unavailable.has(cb));
  }
  #handleChange() {
    const count = this.#selected().length;
    const maxReached = count >= this.#maxSelect;
    this.#checkboxes.forEach((cb) => {
      if (this.#unavailable.has(cb)) {
        return;
      }
      if (!cb.checked) {
        cb.disabled = maxReached;
        cb.closest(SELECTOR_ITEM)?.classList.toggle(CLASS_BLOCKED, maxReached);
      } else {
        cb.disabled = this.#minSelect > 0 && count <= this.#minSelect;
      }
    });
    if (this.#addBtn) {
      this.#addBtn.disabled = count === 0;
    }
  }
  async #addAllToCart() {
    const selected = this.#selected();
    if (!selected.length) {
      return;
    }
    const goToCheckout = this.getAttribute(ATTR_BUTTON_ACTION) === BUTTON_ACTION_ADD_AND_CHECKOUT;
    this.#setState(STATE_LOADING);
    try {
      const cartApi = await whenCartReady();
      const lineProperties2 = upsellLineProperties(resolveUpsellContext(this));
      const inputs = selected.map((cb) => {
        const sellingPlan = cb.getAttribute(ATTR_SELLING_PLAN) || void 0;
        const productIdRaw = cb.getAttribute(ATTR_PRODUCT_ID$1);
        const priceRaw = cb.getAttribute(ATTR_PRICE);
        return {
          item: {
            id: cb.value,
            quantity: DEFAULT_QUANTITY,
            source: SOURCE_UPSELL,
            initialOffer: sellingPlan ? OFFER_TYPE.SUBSCRIPTION : OFFER_TYPE.ONE_TIME,
            isUpsell: true,
            sellingPlan,
            customProperties: lineProperties2
          },
          productId: productIdRaw ? parseInt(productIdRaw, RADIX_DECIMAL) : 0,
          price: priceRaw ? parseInt(priceRaw, RADIX_DECIMAL) : 0
        };
      });
      const result = await addItemsWithMilestones(cartApi, inputs);
      selected.forEach((checkbox) => this.#trackAdded(checkbox));
      if (goToCheckout) {
        this.#dispatchCartAdd({ skipDrawer: true });
        window.location.href = result.freeShippingDiscountCode ? buildDiscountRedirectUrl(result.freeShippingDiscountCode, CHECKOUT_URL) : CHECKOUT_URL;
        return;
      }
      this.#setState(STATE_ADDED);
      this.#openCartDrawerIfOutside();
      setTimeout(() => this.#reset(), RESET_DELAY_MS);
    } catch (err) {
      console.error("[zyg-upsell-checklist] Failed to add items to cart:", err);
      this.#setState(STATE_IDLE);
    }
  }
  #trackAdded(checkbox) {
    window.safeTrackEvent?.(
      ANALYTICS_CATEGORY,
      ANALYTICS_ACTION.ADD_TO_CART,
      JSON.stringify({
        ...this.#productFields(checkbox),
        quantity: DEFAULT_QUANTITY,
        success: true,
        ...upsellEventFields(resolveUpsellContext(this))
      })
    );
  }
  #openCartDrawerIfOutside() {
    if (this.closest(DRAWER_ELEMENT_TAG)) {
      return;
    }
    this.#dispatchCartAdd({ skipDrawer: false });
  }
  #dispatchCartAdd({ skipDrawer }) {
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT_CART_ADD, {
        bubbles: true,
        detail: { data: { source: EVENT_SOURCE_PRODUCT_FORM, skipDrawer } }
      })
    );
  }
  #reset() {
    this.#setState(STATE_IDLE);
    this.#handleChange();
  }
  #setState(state2) {
    if (!this.#addBtn) {
      return;
    }
    this.#addBtn.setAttribute(ATTR_STATE, state2);
    this.#addBtn.disabled = state2 === STATE_LOADING || state2 === STATE_ADDED;
  }
}
if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, ZygUpsellChecklist);
}
const INSTALLED = /* @__PURE__ */ Symbol.for("zyg.product-form-add-tracking");
const CROSS_SELL_CLASS = "product-cross-sell";
const CROSS_SELL_SELECTOR = `.${CROSS_SELL_CLASS}`;
function trackProductFormAdd(event) {
  const items = event.detail?.items ?? [];
  const form = event.target instanceof Element ? event.target : null;
  const inCrossSell = Boolean(form?.closest(CROSS_SELL_SELECTOR));
  items.forEach((item) => {
    const classification = classifyCartLine(item);
    if (inCrossSell) {
      classification[FIELD_UPSELL_TYPE] = UPSELL_TYPE_CROSS_SELL;
    }
    window.safeTrackEvent?.(
      ANALYTICS_CATEGORY_PRODUCT_FORM,
      ANALYTICS_ACTION_ADD_TO_CART,
      JSON.stringify({
        productId: String(item.product_id ?? ""),
        variantId: String(item.variant_id ?? ""),
        quantity: item.quantity ?? DEFAULT_QUANTITY,
        success: true,
        ...classification
      })
    );
  });
}
function installProductFormAddTracking() {
  const host = globalThis;
  if (host[INSTALLED]) {
    return;
  }
  host[INSTALLED] = true;
  document.addEventListener(DOM_EVENT_VARIANT_ADD, trackProductFormAdd);
}
installProductFormAddTracking();
if (typeof window !== "undefined") {
  if (!window.cart) {
    console.error("[zyg-cart-bundle] CRITICAL: window.cart not initialized!");
  }
  if (!window.zygGet) {
    console.error("[zyg-cart-bundle] CRITICAL: Backend API not initialized!");
  }
}
